export default [
  {
    name: "Southern Nations, Nationalities, and Peoples' Region",
    value: 'ET',
    isoCode: 'SN',
  },
  {
    name: 'Somali Region',
    value: 'ET',
    isoCode: 'SO',
  },
  {
    name: 'Amhara Region',
    value: 'ET',
    isoCode: 'AM',
  },
  {
    name: 'Tigray Region',
    value: 'ET',
    isoCode: 'TI',
  },
  {
    name: 'Oromia Region',
    value: 'ET',
    isoCode: 'OR',
  },
  {
    name: 'Afar Region',
    value: 'ET',
    isoCode: 'AF',
  },
  {
    name: 'Harari Region',
    value: 'ET',
    isoCode: 'HA',
  },
  {
    name: 'Dire Dawa',
    value: 'ET',
    isoCode: 'DD',
  },
  {
    name: 'Benishangul-Gumuz Region',
    value: 'ET',
    isoCode: 'BE',
  },
  {
    name: 'Gambela Region',
    value: 'ET',
    isoCode: 'GA',
  },
  {
    name: 'Addis Ababa',
    value: 'ET',
    isoCode: 'AA',
  },
  {
    name: 'Petnjica Municipality',
    value: 'ME',
    isoCode: '23',
  },
  {
    name: 'Bar Municipality',
    value: 'ME',
    isoCode: '02',
  },
  {
    name: 'Danilovgrad Municipality',
    value: 'ME',
    isoCode: '07',
  },
  {
    name: 'Rožaje Municipality',
    value: 'ME',
    isoCode: '17',
  },
  {
    name: 'Plužine Municipality',
    value: 'ME',
    isoCode: '15',
  },
  {
    name: 'Nikšić Municipality',
    value: 'ME',
    isoCode: '12',
  },
  {
    name: 'Šavnik Municipality',
    value: 'ME',
    isoCode: '18',
  },
  {
    name: 'Plav Municipality',
    value: 'ME',
    isoCode: '13',
  },
  {
    name: 'Pljevlja Municipality',
    value: 'ME',
    isoCode: '14',
  },
  {
    name: 'Berane Municipality',
    value: 'ME',
    isoCode: '03',
  },
  {
    name: 'Mojkovac Municipality',
    value: 'ME',
    isoCode: '11',
  },
  {
    name: 'Andrijevica Municipality',
    value: 'ME',
    isoCode: '01',
  },
  {
    name: 'Gusinje Municipality',
    value: 'ME',
    isoCode: '22',
  },
  {
    name: 'Bijelo Polje Municipality',
    value: 'ME',
    isoCode: '04',
  },
  {
    name: 'Kotor Municipality',
    value: 'ME',
    isoCode: '10',
  },
  {
    name: 'Podgorica Municipality',
    value: 'ME',
    isoCode: '16',
  },
  {
    name: 'Old Royal Capital Cetinje',
    value: 'ME',
    isoCode: '06',
  },
  {
    name: 'Tivat Municipality',
    value: 'ME',
    isoCode: '19',
  },
  {
    name: 'Budva Municipality',
    value: 'ME',
    isoCode: '05',
  },
  {
    name: 'Kolašin Municipality',
    value: 'ME',
    isoCode: '09',
  },
  {
    name: 'Žabljak Municipality',
    value: 'ME',
    isoCode: '21',
  },
  {
    name: 'Ulcinj Municipality',
    value: 'ME',
    isoCode: '20',
  },
  {
    name: 'Kunene Region',
    value: 'NA',
    isoCode: 'KU',
  },
  {
    name: 'Kavango West Region',
    value: 'NA',
    isoCode: 'KW',
  },
  {
    name: 'Kavango East Region',
    value: 'NA',
    isoCode: 'KE',
  },
  {
    name: 'Oshana Region',
    value: 'NA',
    isoCode: 'ON',
  },
  {
    name: 'Hardap Region',
    value: 'NA',
    isoCode: 'HA',
  },
  {
    name: 'Omusati Region',
    value: 'NA',
    isoCode: 'OS',
  },
  {
    name: 'Ohangwena Region',
    value: 'NA',
    isoCode: 'OW',
  },
  {
    name: 'Omaheke Region',
    value: 'NA',
    isoCode: 'OH',
  },
  {
    name: 'Oshikoto Region',
    value: 'NA',
    isoCode: 'OT',
  },
  {
    name: 'Erongo Region',
    value: 'NA',
    isoCode: 'ER',
  },
  {
    name: 'Khomas Region',
    value: 'NA',
    isoCode: 'KH',
  },
  {
    name: 'Karas Region',
    value: 'NA',
    isoCode: 'KA',
  },
  {
    name: 'Otjozondjupa Region',
    value: 'NA',
    isoCode: 'OD',
  },
  {
    name: 'Zambezi Region',
    value: 'NA',
    isoCode: 'CA',
  },
  {
    name: 'Ashanti',
    value: 'GH',
    isoCode: 'AH',
  },
  {
    name: 'Western',
    value: 'GH',
    isoCode: 'WP',
  },
  {
    name: 'Eastern',
    value: 'GH',
    isoCode: 'EP',
  },
  {
    name: 'Northern',
    value: 'GH',
    isoCode: 'NP',
  },
  {
    name: 'Central',
    value: 'GH',
    isoCode: 'CP',
  },
  {
    name: 'Ahafo',
    value: 'GH',
    isoCode: 'AF',
  },
  {
    name: 'Greater Accra',
    value: 'GH',
    isoCode: 'AA',
  },
  {
    name: 'Upper East',
    value: 'GH',
    isoCode: 'UE',
  },
  {
    name: 'Volta',
    value: 'GH',
    isoCode: 'TV',
  },
  {
    name: 'Upper West',
    value: 'GH',
    isoCode: 'UW',
  },
  {
    name: 'Bono East',
    value: 'GH',
    isoCode: 'BE',
  },
  {
    name: 'Bono',
    value: 'GH',
    isoCode: 'BO',
  },
  {
    name: 'North East',
    value: 'GH',
    isoCode: 'NE',
  },
  {
    name: 'Oti',
    value: 'GH',
    isoCode: 'OT',
  },
  {
    name: 'Savannah',
    value: 'GH',
    isoCode: 'SV',
  },
  {
    name: 'Western North',
    value: 'GH',
    isoCode: 'WN',
  },
  {
    name: 'San Marino',
    value: 'SM',
    isoCode: '07',
  },
  {
    name: 'Acquaviva',
    value: 'SM',
    isoCode: '01',
  },
  {
    name: 'Chiesanuova',
    value: 'SM',
    isoCode: '02',
  },
  {
    name: 'Borgo Maggiore',
    value: 'SM',
    isoCode: '06',
  },
  {
    name: 'Faetano',
    value: 'SM',
    isoCode: '04',
  },
  {
    name: 'Montegiardino',
    value: 'SM',
    isoCode: '08',
  },
  {
    name: 'Domagnano',
    value: 'SM',
    isoCode: '03',
  },
  {
    name: 'Serravalle',
    value: 'SM',
    isoCode: '09',
  },
  {
    name: 'Fiorentino',
    value: 'SM',
    isoCode: '05',
  },
  {
    name: 'Tillabéri Region',
    value: 'NE',
    isoCode: '6',
  },
  {
    name: 'Dosso Region',
    value: 'NE',
    isoCode: '3',
  },
  {
    name: 'Zinder Region',
    value: 'NE',
    isoCode: '7',
  },
  {
    name: 'Maradi Region',
    value: 'NE',
    isoCode: '4',
  },
  {
    name: 'Agadez Region',
    value: 'NE',
    isoCode: '1',
  },
  {
    name: 'Diffa Region',
    value: 'NE',
    isoCode: '2',
  },
  {
    name: 'Tahoua Region',
    value: 'NE',
    isoCode: '5',
  },
  {
    name: 'Mqabba',
    value: 'MT',
    isoCode: '33',
  },
  {
    name: 'San Ġwann',
    value: 'MT',
    isoCode: '49',
  },
  {
    name: 'Żurrieq',
    value: 'MT',
    isoCode: '68',
  },
  {
    name: 'Luqa',
    value: 'MT',
    isoCode: '25',
  },
  {
    name: 'Marsaxlokk',
    value: 'MT',
    isoCode: '28',
  },
  {
    name: 'Qala',
    value: 'MT',
    isoCode: '42',
  },
  {
    name: 'Żebbuġ Malta',
    value: 'MT',
    isoCode: '66',
  },
  {
    name: 'Xgħajra',
    value: 'MT',
    isoCode: '63',
  },
  {
    name: 'Kirkop',
    value: 'MT',
    isoCode: '23',
  },
  {
    name: 'Rabat',
    value: 'MT',
    isoCode: '46',
  },
  {
    name: 'Floriana',
    value: 'MT',
    isoCode: '09',
  },
  {
    name: 'Żebbuġ Gozo',
    value: 'MT',
    isoCode: '65',
  },
  {
    name: 'Swieqi',
    value: 'MT',
    isoCode: '57',
  },
  {
    name: 'Saint Lawrence',
    value: 'MT',
    isoCode: '50',
  },
  {
    name: 'Birżebbuġa',
    value: 'MT',
    isoCode: '05',
  },
  {
    name: 'Mdina',
    value: 'MT',
    isoCode: '29',
  },
  {
    name: 'Santa Venera',
    value: 'MT',
    isoCode: '54',
  },
  {
    name: 'Kerċem',
    value: 'MT',
    isoCode: '22',
  },
  {
    name: 'Għarb',
    value: 'MT',
    isoCode: '14',
  },
  {
    name: 'Iklin',
    value: 'MT',
    isoCode: '19',
  },
  {
    name: 'Santa Luċija',
    value: 'MT',
    isoCode: '53',
  },
  {
    name: 'Valletta',
    value: 'MT',
    isoCode: '60',
  },
  {
    name: 'Msida',
    value: 'MT',
    isoCode: '34',
  },
  {
    name: 'Birkirkara',
    value: 'MT',
    isoCode: '04',
  },
  {
    name: 'Siġġiewi',
    value: 'MT',
    isoCode: '55',
  },
  {
    name: 'Kalkara',
    value: 'MT',
    isoCode: '21',
  },
  {
    name: "St. Julian's",
    value: 'MT',
    isoCode: '48',
  },
  {
    name: 'Victoria',
    value: 'MT',
    isoCode: '45',
  },
  {
    name: 'Mellieħa',
    value: 'MT',
    isoCode: '30',
  },
  {
    name: 'Tarxien',
    value: 'MT',
    isoCode: '59',
  },
  {
    name: 'Sliema',
    value: 'MT',
    isoCode: '56',
  },
  {
    name: 'Ħamrun',
    value: 'MT',
    isoCode: '18',
  },
  {
    name: 'Għasri',
    value: 'MT',
    isoCode: '16',
  },
  {
    name: 'Birgu',
    value: 'MT',
    isoCode: '03',
  },
  {
    name: 'Balzan',
    value: 'MT',
    isoCode: '02',
  },
  {
    name: 'Mġarr',
    value: 'MT',
    isoCode: '31',
  },
  {
    name: 'Attard',
    value: 'MT',
    isoCode: '01',
  },
  {
    name: 'Qrendi',
    value: 'MT',
    isoCode: '44',
  },
  {
    name: 'Naxxar',
    value: 'MT',
    isoCode: '38',
  },
  {
    name: 'Gżira',
    value: 'MT',
    isoCode: '12',
  },
  {
    name: 'Xagħra',
    value: 'MT',
    isoCode: '61',
  },
  {
    name: 'Paola',
    value: 'MT',
    isoCode: '39',
  },
  {
    name: 'Sannat',
    value: 'MT',
    isoCode: '52',
  },
  {
    name: 'Dingli',
    value: 'MT',
    isoCode: '07',
  },
  {
    name: 'Gudja',
    value: 'MT',
    isoCode: '11',
  },
  {
    name: 'Qormi',
    value: 'MT',
    isoCode: '43',
  },
  {
    name: 'Għargħur',
    value: 'MT',
    isoCode: '15',
  },
  {
    name: 'Xewkija',
    value: 'MT',
    isoCode: '62',
  },
  {
    name: "Ta' Xbiex",
    value: 'MT',
    isoCode: '58',
  },
  {
    name: 'Żabbar',
    value: 'MT',
    isoCode: '64',
  },
  {
    name: 'Għaxaq',
    value: 'MT',
    isoCode: '17',
  },
  {
    name: 'Pembroke',
    value: 'MT',
    isoCode: '40',
  },
  {
    name: 'Lija',
    value: 'MT',
    isoCode: '24',
  },
  {
    name: 'Pietà',
    value: 'MT',
    isoCode: '41',
  },
  {
    name: 'Marsa',
    value: 'MT',
    isoCode: '26',
  },
  {
    name: 'Fgura',
    value: 'MT',
    isoCode: '08',
  },
  {
    name: 'Għajnsielem',
    value: 'MT',
    isoCode: '13',
  },
  {
    name: 'Mtarfa',
    value: 'MT',
    isoCode: '35',
  },
  {
    name: 'Munxar',
    value: 'MT',
    isoCode: '36',
  },
  {
    name: 'Nadur',
    value: 'MT',
    isoCode: '37',
  },
  {
    name: 'Fontana',
    value: 'MT',
    isoCode: '10',
  },
  {
    name: 'Żejtun',
    value: 'MT',
    isoCode: '67',
  },
  {
    name: 'Senglea',
    value: 'MT',
    isoCode: '20',
  },
  {
    name: 'Marsaskala',
    value: 'MT',
    isoCode: '27',
  },
  {
    name: 'Cospicua',
    value: 'MT',
    isoCode: '06',
  },
  {
    name: "St. Paul's Bay",
    value: 'MT',
    isoCode: '51',
  },
  {
    name: 'Mosta',
    value: 'MT',
    isoCode: '32',
  },
  {
    name: 'Mangystau Region',
    value: 'KZ',
    isoCode: 'MAN',
  },
  {
    name: 'Kyzylorda Region',
    value: 'KZ',
    isoCode: 'KZY',
  },
  {
    name: 'Almaty Region',
    value: 'KZ',
    isoCode: 'ALM',
  },
  {
    name: 'North Kazakhstan Region',
    value: 'KZ',
    isoCode: 'SEV',
  },
  {
    name: 'Akmola Region',
    value: 'KZ',
    isoCode: 'AKM',
  },
  {
    name: 'Pavlodar Region',
    value: 'KZ',
    isoCode: 'PAV',
  },
  {
    name: 'Jambyl Region',
    value: 'KZ',
    isoCode: 'ZHA',
  },
  {
    name: 'West Kazakhstan Province',
    value: 'KZ',
    isoCode: 'ZAP',
  },
  {
    name: 'Turkestan Region',
    value: 'KZ',
    isoCode: 'YUZ',
  },
  {
    name: 'Karaganda Region',
    value: 'KZ',
    isoCode: 'KAR',
  },
  {
    name: 'Aktobe Region',
    value: 'KZ',
    isoCode: 'AKT',
  },
  {
    name: 'Almaty',
    value: 'KZ',
    isoCode: 'ALA',
  },
  {
    name: 'Atyrau Region',
    value: 'KZ',
    isoCode: 'ATY',
  },
  {
    name: 'East Kazakhstan Region',
    value: 'KZ',
    isoCode: 'VOS',
  },
  {
    name: 'Baikonur',
    value: 'KZ',
    isoCode: 'BAY',
  },
  {
    name: 'Nur-Sultan',
    value: 'KZ',
    isoCode: 'AST',
  },
  {
    name: 'Kostanay Region',
    value: 'KZ',
    isoCode: 'KUS',
  },
  {
    name: 'Kakamega',
    value: 'KE',
    isoCode: '11',
  },
  {
    name: 'Kisii',
    value: 'KE',
    isoCode: '16',
  },
  {
    name: 'Busia',
    value: 'KE',
    isoCode: '04',
  },
  {
    name: 'Embu',
    value: 'KE',
    isoCode: '06',
  },
  {
    name: 'Laikipia',
    value: 'KE',
    isoCode: '20',
  },
  {
    name: 'Nandi',
    value: 'KE',
    isoCode: '32',
  },
  {
    name: 'Lamu',
    value: 'KE',
    isoCode: '21',
  },
  {
    name: 'Kirinyaga',
    value: 'KE',
    isoCode: '15',
  },
  {
    name: 'Bungoma',
    value: 'KE',
    isoCode: '03',
  },
  {
    name: 'Uasin Gishu',
    value: 'KE',
    isoCode: '44',
  },
  {
    name: 'Isiolo',
    value: 'KE',
    isoCode: '09',
  },
  {
    name: 'Kisumu',
    value: 'KE',
    isoCode: '17',
  },
  {
    name: 'Kwale',
    value: 'KE',
    isoCode: '19',
  },
  {
    name: 'Kilifi',
    value: 'KE',
    isoCode: '14',
  },
  {
    name: 'Narok',
    value: 'KE',
    isoCode: '33',
  },
  {
    name: 'Taita–Taveta',
    value: 'KE',
    isoCode: '39',
  },
  {
    name: "Murang'a",
    value: 'KE',
    isoCode: '29',
  },
  {
    name: 'Nyeri',
    value: 'KE',
    isoCode: '36',
  },
  {
    name: 'Baringo',
    value: 'KE',
    isoCode: '01',
  },
  {
    name: 'Wajir',
    value: 'KE',
    isoCode: '46',
  },
  {
    name: 'Trans Nzoia',
    value: 'KE',
    isoCode: '42',
  },
  {
    name: 'Machakos',
    value: 'KE',
    isoCode: '22',
  },
  {
    name: 'Tharaka-Nithi',
    value: 'KE',
    isoCode: '41',
  },
  {
    name: 'Siaya',
    value: 'KE',
    isoCode: '38',
  },
  {
    name: 'Mandera',
    value: 'KE',
    isoCode: '24',
  },
  {
    name: 'Makueni',
    value: 'KE',
    isoCode: '23',
  },
  {
    name: 'Migori',
    value: 'KE',
    isoCode: '27',
  },
  {
    name: 'Nairobi City',
    value: 'KE',
    isoCode: '30',
  },
  {
    name: 'Nyandarua',
    value: 'KE',
    isoCode: '35',
  },
  {
    name: 'Kericho',
    value: 'KE',
    isoCode: '12',
  },
  {
    name: 'Marsabit',
    value: 'KE',
    isoCode: '25',
  },
  {
    name: 'Homa Bay',
    value: 'KE',
    isoCode: '08',
  },
  {
    name: 'Garissa',
    value: 'KE',
    isoCode: '07',
  },
  {
    name: 'Kajiado',
    value: 'KE',
    isoCode: '10',
  },
  {
    name: 'Meru',
    value: 'KE',
    isoCode: '26',
  },
  {
    name: 'Kiambu',
    value: 'KE',
    isoCode: '13',
  },
  {
    name: 'Mombasa',
    value: 'KE',
    isoCode: '28',
  },
  {
    name: 'Elgeyo-Marakwet',
    value: 'KE',
    isoCode: '05',
  },
  {
    name: 'Vihiga',
    value: 'KE',
    isoCode: '45',
  },
  {
    name: 'Nakuru',
    value: 'KE',
    isoCode: '31',
  },
  {
    name: 'Tana River',
    value: 'KE',
    isoCode: '40',
  },
  {
    name: 'Turkana',
    value: 'KE',
    isoCode: '43',
  },
  {
    name: 'Samburu',
    value: 'KE',
    isoCode: '37',
  },
  {
    name: 'West Pokot',
    value: 'KE',
    isoCode: '47',
  },
  {
    name: 'Nyamira',
    value: 'KE',
    isoCode: '34',
  },
  {
    name: 'Bomet',
    value: 'KE',
    isoCode: '02',
  },
  {
    name: 'Kitui',
    value: 'KE',
    isoCode: '18',
  },
  {
    name: 'Bié Province',
    value: 'AO',
    isoCode: 'BIE',
  },
  {
    name: 'Huambo Province',
    value: 'AO',
    isoCode: 'HUA',
  },
  {
    name: 'Zaire Province',
    value: 'AO',
    isoCode: 'ZAI',
  },
  {
    name: 'Cunene Province',
    value: 'AO',
    isoCode: 'CNN',
  },
  {
    name: 'Cuanza Sul',
    value: 'AO',
    isoCode: 'CUS',
  },
  {
    name: 'Cuanza Norte Province',
    value: 'AO',
    isoCode: 'CNO',
  },
  {
    name: 'Benguela Province',
    value: 'AO',
    isoCode: 'BGU',
  },
  {
    name: 'Moxico Province',
    value: 'AO',
    isoCode: 'MOX',
  },
  {
    name: 'Lunda Sul Province',
    value: 'AO',
    isoCode: 'LSU',
  },
  {
    name: 'Bengo Province',
    value: 'AO',
    isoCode: 'BGO',
  },
  {
    name: 'Luanda Province',
    value: 'AO',
    isoCode: 'LUA',
  },
  {
    name: 'Lunda Norte Province',
    value: 'AO',
    isoCode: 'LNO',
  },
  {
    name: 'Uíge Province',
    value: 'AO',
    isoCode: 'UIG',
  },
  {
    name: 'Huíla Province',
    value: 'AO',
    isoCode: 'HUI',
  },
  {
    name: 'Cuando Cubango Province',
    value: 'AO',
    isoCode: 'CCU',
  },
  {
    name: 'Malanje Province',
    value: 'AO',
    isoCode: 'MAL',
  },
  {
    name: 'Cabinda Province',
    value: 'AO',
    isoCode: 'CAB',
  },
  {
    name: 'Gasa District',
    value: 'BT',
    isoCode: 'GA',
  },
  {
    name: 'Tsirang District',
    value: 'BT',
    isoCode: '21',
  },
  {
    name: 'Wangdue Phodrang District',
    value: 'BT',
    isoCode: '24',
  },
  {
    name: 'Haa District',
    value: 'BT',
    isoCode: '13',
  },
  {
    name: 'Zhemgang District',
    value: 'BT',
    isoCode: '34',
  },
  {
    name: 'Lhuntse District',
    value: 'BT',
    isoCode: '44',
  },
  {
    name: 'Punakha District',
    value: 'BT',
    isoCode: '23',
  },
  {
    name: 'Trashigang District',
    value: 'BT',
    isoCode: '41',
  },
  {
    name: 'Paro District',
    value: 'BT',
    isoCode: '11',
  },
  {
    name: 'Dagana District',
    value: 'BT',
    isoCode: '22',
  },
  {
    name: 'Chukha District',
    value: 'BT',
    isoCode: '12',
  },
  {
    name: 'Bumthang District',
    value: 'BT',
    isoCode: '33',
  },
  {
    name: 'Thimphu District',
    value: 'BT',
    isoCode: '15',
  },
  {
    name: 'Mongar District',
    value: 'BT',
    isoCode: '42',
  },
  {
    name: 'Samdrup Jongkhar District',
    value: 'BT',
    isoCode: '45',
  },
  {
    name: 'Pemagatshel District',
    value: 'BT',
    isoCode: '43',
  },
  {
    name: 'Trongsa District',
    value: 'BT',
    isoCode: '32',
  },
  {
    name: 'Samtse District',
    value: 'BT',
    isoCode: '14',
  },
  {
    name: 'Sarpang District',
    value: 'BT',
    isoCode: '31',
  },
  {
    name: 'Tombouctou Region',
    value: 'ML',
    isoCode: '6',
  },
  {
    name: 'Ségou Region',
    value: 'ML',
    isoCode: '4',
  },
  {
    name: 'Koulikoro Region',
    value: 'ML',
    isoCode: '2',
  },
  {
    name: 'Ménaka Region',
    value: 'ML',
    isoCode: '9',
  },
  {
    name: 'Kayes Region',
    value: 'ML',
    isoCode: '1',
  },
  {
    name: 'Bamako',
    value: 'ML',
    isoCode: 'BKO',
  },
  {
    name: 'Sikasso Region',
    value: 'ML',
    isoCode: '3',
  },
  {
    name: 'Mopti Region',
    value: 'ML',
    isoCode: '5',
  },
  {
    name: 'Taoudénit Region',
    value: 'ML',
    isoCode: '10',
  },
  {
    name: 'Kidal Region',
    value: 'ML',
    isoCode: '8',
  },
  {
    name: 'Gao Region',
    value: 'ML',
    isoCode: '7',
  },
  {
    name: 'Southern Province',
    value: 'RW',
    isoCode: '05',
  },
  {
    name: 'Western Province',
    value: 'RW',
    isoCode: '04',
  },
  {
    name: 'Eastern Province',
    value: 'RW',
    isoCode: '02',
  },
  {
    name: 'Kigali district',
    value: 'RW',
    isoCode: '01',
  },
  {
    name: 'Northern Province',
    value: 'RW',
    isoCode: '03',
  },
  {
    name: 'Belize District',
    value: 'BZ',
    isoCode: 'BZ',
  },
  {
    name: 'Stann Creek District',
    value: 'BZ',
    isoCode: 'SC',
  },
  {
    name: 'Corozal District',
    value: 'BZ',
    isoCode: 'CZL',
  },
  {
    name: 'Toledo District',
    value: 'BZ',
    isoCode: 'TOL',
  },
  {
    name: 'Orange Walk District',
    value: 'BZ',
    isoCode: 'OW',
  },
  {
    name: 'Cayo District',
    value: 'BZ',
    isoCode: 'CY',
  },
  {
    name: 'Príncipe Province',
    value: 'ST',
    isoCode: 'P',
  },
  {
    name: 'São Tomé Province',
    value: 'ST',
    isoCode: 'S',
  },
  {
    name: 'Havana Province',
    value: 'CU',
    isoCode: '03',
  },
  {
    name: 'Santiago de Cuba Province',
    value: 'CU',
    isoCode: '13',
  },
  {
    name: 'Sancti Spíritus Province',
    value: 'CU',
    isoCode: '07',
  },
  {
    name: 'Granma Province',
    value: 'CU',
    isoCode: '12',
  },
  {
    name: 'Mayabeque Province',
    value: 'CU',
    isoCode: '16',
  },
  {
    name: 'Pinar del Río Province',
    value: 'CU',
    isoCode: '01',
  },
  {
    name: 'Isla de la Juventud',
    value: 'CU',
    isoCode: '99',
  },
  {
    name: 'Holguín Province',
    value: 'CU',
    isoCode: '11',
  },
  {
    name: 'Villa Clara Province',
    value: 'CU',
    isoCode: '05',
  },
  {
    name: 'Las Tunas Province',
    value: 'CU',
    isoCode: '10',
  },
  {
    name: 'Ciego de Ávila Province',
    value: 'CU',
    isoCode: '08',
  },
  {
    name: 'Artemisa Province',
    value: 'CU',
    isoCode: '15',
  },
  {
    name: 'Matanzas Province',
    value: 'CU',
    isoCode: '04',
  },
  {
    name: 'Guantánamo Province',
    value: 'CU',
    isoCode: '14',
  },
  {
    name: 'Camagüey Province',
    value: 'CU',
    isoCode: '09',
  },
  {
    name: 'Cienfuegos Province',
    value: 'CU',
    isoCode: '06',
  },
  {
    name: 'Jigawa',
    value: 'NG',
    isoCode: 'JI',
  },
  {
    name: 'Enugu',
    value: 'NG',
    isoCode: 'EN',
  },
  {
    name: 'Kebbi',
    value: 'NG',
    isoCode: 'KE',
  },
  {
    name: 'Benue',
    value: 'NG',
    isoCode: 'BE',
  },
  {
    name: 'Sokoto',
    value: 'NG',
    isoCode: 'SO',
  },
  {
    name: 'Abuja Federal Capital Territory',
    value: 'NG',
    isoCode: 'FC',
  },
  {
    name: 'Kaduna',
    value: 'NG',
    isoCode: 'KD',
  },
  {
    name: 'Kwara',
    value: 'NG',
    isoCode: 'KW',
  },
  {
    name: 'Oyo',
    value: 'NG',
    isoCode: 'OY',
  },
  {
    name: 'Yobe',
    value: 'NG',
    isoCode: 'YO',
  },
  {
    name: 'Kogi',
    value: 'NG',
    isoCode: 'KO',
  },
  {
    name: 'Zamfara',
    value: 'NG',
    isoCode: 'ZA',
  },
  {
    name: 'Kano',
    value: 'NG',
    isoCode: 'KN',
  },
  {
    name: 'Nasarawa',
    value: 'NG',
    isoCode: 'NA',
  },
  {
    name: 'Plateau',
    value: 'NG',
    isoCode: 'PL',
  },
  {
    name: 'Abia',
    value: 'NG',
    isoCode: 'AB',
  },
  {
    name: 'Akwa Ibom',
    value: 'NG',
    isoCode: 'AK',
  },
  {
    name: 'Bayelsa',
    value: 'NG',
    isoCode: 'BY',
  },
  {
    name: 'Lagos',
    value: 'NG',
    isoCode: 'LA',
  },
  {
    name: 'Borno',
    value: 'NG',
    isoCode: 'BO',
  },
  {
    name: 'Imo',
    value: 'NG',
    isoCode: 'IM',
  },
  {
    name: 'Ekiti',
    value: 'NG',
    isoCode: 'EK',
  },
  {
    name: 'Gombe',
    value: 'NG',
    isoCode: 'GO',
  },
  {
    name: 'Ebonyi',
    value: 'NG',
    isoCode: 'EB',
  },
  {
    name: 'Bauchi',
    value: 'NG',
    isoCode: 'BA',
  },
  {
    name: 'Katsina',
    value: 'NG',
    isoCode: 'KT',
  },
  {
    name: 'Cross River',
    value: 'NG',
    isoCode: 'CR',
  },
  {
    name: 'Anambra',
    value: 'NG',
    isoCode: 'AN',
  },
  {
    name: 'Delta',
    value: 'NG',
    isoCode: 'DE',
  },
  {
    name: 'Niger',
    value: 'NG',
    isoCode: 'NI',
  },
  {
    name: 'Edo',
    value: 'NG',
    isoCode: 'ED',
  },
  {
    name: 'Taraba',
    value: 'NG',
    isoCode: 'TA',
  },
  {
    name: 'Adamawa',
    value: 'NG',
    isoCode: 'AD',
  },
  {
    name: 'Ondo',
    value: 'NG',
    isoCode: 'ON',
  },
  {
    name: 'Osun',
    value: 'NG',
    isoCode: 'OS',
  },
  {
    name: 'Ogun',
    value: 'NG',
    isoCode: 'OG',
  },
  {
    name: 'Rivers',
    value: 'NG',
    isoCode: 'RI',
  },
  {
    name: 'Rukungiri District',
    value: 'UG',
    isoCode: '412',
  },
  {
    name: 'Kyankwanzi District',
    value: 'UG',
    isoCode: '123',
  },
  {
    name: 'Kabarole District',
    value: 'UG',
    isoCode: '405',
  },
  {
    name: 'Mpigi District',
    value: 'UG',
    isoCode: '106',
  },
  {
    name: 'Apac District',
    value: 'UG',
    isoCode: '302',
  },
  {
    name: 'Abim District',
    value: 'UG',
    isoCode: '314',
  },
  {
    name: 'Yumbe District',
    value: 'UG',
    isoCode: '313',
  },
  {
    name: 'Rukiga District',
    value: 'UG',
    isoCode: '431',
  },
  {
    name: 'Northern Region',
    value: 'UG',
    isoCode: 'N',
  },
  {
    name: 'Serere District',
    value: 'UG',
    isoCode: '232',
  },
  {
    name: 'Kamuli District',
    value: 'UG',
    isoCode: '205',
  },
  {
    name: 'Amuru District',
    value: 'UG',
    isoCode: '316',
  },
  {
    name: 'Kaberamaido District',
    value: 'UG',
    isoCode: '213',
  },
  {
    name: 'Namutumba District',
    value: 'UG',
    isoCode: '224',
  },
  {
    name: 'Kibuku District',
    value: 'UG',
    isoCode: '227',
  },
  {
    name: 'Ibanda District',
    value: 'UG',
    isoCode: '417',
  },
  {
    name: 'Iganga District',
    value: 'UG',
    isoCode: '203',
  },
  {
    name: 'Dokolo District',
    value: 'UG',
    isoCode: '317',
  },
  {
    name: 'Lira District',
    value: 'UG',
    isoCode: '307',
  },
  {
    name: 'Bukedea District',
    value: 'UG',
    isoCode: '219',
  },
  {
    name: 'Alebtong District',
    value: 'UG',
    isoCode: '323',
  },
  {
    name: 'Koboko District',
    value: 'UG',
    isoCode: '319',
  },
  {
    name: 'Kiryandongo District',
    value: 'UG',
    isoCode: '421',
  },
  {
    name: 'Kiboga District',
    value: 'UG',
    isoCode: '103',
  },
  {
    name: 'Kitgum District',
    value: 'UG',
    isoCode: '305',
  },
  {
    name: 'Bududa District',
    value: 'UG',
    isoCode: '218',
  },
  {
    name: 'Mbale District',
    value: 'UG',
    isoCode: '209',
  },
  {
    name: 'Namayingo District',
    value: 'UG',
    isoCode: '230',
  },
  {
    name: 'Amuria District',
    value: 'UG',
    isoCode: '216',
  },
  {
    name: 'Amudat District',
    value: 'UG',
    isoCode: '324',
  },
  {
    name: 'Masindi District',
    value: 'UG',
    isoCode: '409',
  },
  {
    name: 'Kiruhura District',
    value: 'UG',
    isoCode: '419',
  },
  {
    name: 'Masaka District',
    value: 'UG',
    isoCode: '105',
  },
  {
    name: 'Pakwach District',
    value: 'UG',
    isoCode: '332',
  },
  {
    name: 'Rubanda District',
    value: 'UG',
    isoCode: '429',
  },
  {
    name: 'Tororo District',
    value: 'UG',
    isoCode: '212',
  },
  {
    name: 'Kamwenge District',
    value: 'UG',
    isoCode: '413',
  },
  {
    name: 'Adjumani District',
    value: 'UG',
    isoCode: '301',
  },
  {
    name: 'Wakiso District',
    value: 'UG',
    isoCode: '113',
  },
  {
    name: 'Moyo District',
    value: 'UG',
    isoCode: '309',
  },
  {
    name: 'Mityana District',
    value: 'UG',
    isoCode: '115',
  },
  {
    name: 'Butaleja District',
    value: 'UG',
    isoCode: '221',
  },
  {
    name: 'Gomba District',
    value: 'UG',
    isoCode: '121',
  },
  {
    name: 'Jinja District',
    value: 'UG',
    isoCode: '204',
  },
  {
    name: 'Kayunga District',
    value: 'UG',
    isoCode: '112',
  },
  {
    name: 'Kween District',
    value: 'UG',
    isoCode: '228',
  },
  {
    name: 'Western Region',
    value: 'UG',
    isoCode: 'W',
  },
  {
    name: 'Mubende District',
    value: 'UG',
    isoCode: '107',
  },
  {
    name: 'Eastern Region',
    value: 'UG',
    isoCode: 'E',
  },
  {
    name: 'Kanungu District',
    value: 'UG',
    isoCode: '414',
  },
  {
    name: 'Omoro District',
    value: 'UG',
    isoCode: '331',
  },
  {
    name: 'Bukomansimbi District',
    value: 'UG',
    isoCode: '118',
  },
  {
    name: 'Lyantonde District',
    value: 'UG',
    isoCode: '114',
  },
  {
    name: 'Buikwe District',
    value: 'UG',
    isoCode: '117',
  },
  {
    name: 'Nwoya District',
    value: 'UG',
    isoCode: '328',
  },
  {
    name: 'Zombo District',
    value: 'UG',
    isoCode: '330',
  },
  {
    name: 'Buyende District',
    value: 'UG',
    isoCode: '226',
  },
  {
    name: 'Bunyangabu District',
    value: 'UG',
    isoCode: '430',
  },
  {
    name: 'Kampala District',
    value: 'UG',
    isoCode: '102',
  },
  {
    name: 'Isingiro District',
    value: 'UG',
    isoCode: '418',
  },
  {
    name: 'Butambala District',
    value: 'UG',
    isoCode: '119',
  },
  {
    name: 'Bukwo District',
    value: 'UG',
    isoCode: '220',
  },
  {
    name: 'Bushenyi District',
    value: 'UG',
    isoCode: '402',
  },
  {
    name: 'Bugiri District',
    value: 'UG',
    isoCode: '201',
  },
  {
    name: 'Butebo District',
    value: 'UG',
    isoCode: '233',
  },
  {
    name: 'Buliisa District',
    value: 'UG',
    isoCode: '416',
  },
  {
    name: 'Otuke District',
    value: 'UG',
    isoCode: '329',
  },
  {
    name: 'Buhweju District',
    value: 'UG',
    isoCode: '420',
  },
  {
    name: 'Agago District',
    value: 'UG',
    isoCode: '322',
  },
  {
    name: 'Nakapiripirit District',
    value: 'UG',
    isoCode: '311',
  },
  {
    name: 'Kalungu District',
    value: 'UG',
    isoCode: '122',
  },
  {
    name: 'Moroto District',
    value: 'UG',
    isoCode: '308',
  },
  {
    name: 'Central Region',
    value: 'UG',
    isoCode: 'C',
  },
  {
    name: 'Oyam District',
    value: 'UG',
    isoCode: '321',
  },
  {
    name: 'Kaliro District',
    value: 'UG',
    isoCode: '222',
  },
  {
    name: 'Kakumiro District',
    value: 'UG',
    isoCode: '428',
  },
  {
    name: 'Namisindwa District',
    value: 'UG',
    isoCode: '234',
  },
  {
    name: 'Kole District',
    value: 'UG',
    isoCode: '325',
  },
  {
    name: 'Kyenjojo District',
    value: 'UG',
    isoCode: '415',
  },
  {
    name: 'Kagadi District',
    value: 'UG',
    isoCode: '427',
  },
  {
    name: 'Ntungamo District',
    value: 'UG',
    isoCode: '411',
  },
  {
    name: 'Kalangala District',
    value: 'UG',
    isoCode: '101',
  },
  {
    name: 'Nakasongola District',
    value: 'UG',
    isoCode: '109',
  },
  {
    name: 'Sheema District',
    value: 'UG',
    isoCode: '426',
  },
  {
    name: 'Pader District',
    value: 'UG',
    isoCode: '312',
  },
  {
    name: 'Kisoro District',
    value: 'UG',
    isoCode: '408',
  },
  {
    name: 'Mukono District',
    value: 'UG',
    isoCode: '108',
  },
  {
    name: 'Lamwo District',
    value: 'UG',
    isoCode: '326',
  },
  {
    name: 'Pallisa District',
    value: 'UG',
    isoCode: '210',
  },
  {
    name: 'Gulu District',
    value: 'UG',
    isoCode: '304',
  },
  {
    name: 'Buvuma District',
    value: 'UG',
    isoCode: '120',
  },
  {
    name: 'Mbarara District',
    value: 'UG',
    isoCode: '410',
  },
  {
    name: 'Amolatar District',
    value: 'UG',
    isoCode: '315',
  },
  {
    name: 'Lwengo District',
    value: 'UG',
    isoCode: '124',
  },
  {
    name: 'Mayuge District',
    value: 'UG',
    isoCode: '214',
  },
  {
    name: 'Bundibugyo District',
    value: 'UG',
    isoCode: '401',
  },
  {
    name: 'Katakwi District',
    value: 'UG',
    isoCode: '207',
  },
  {
    name: 'Maracha District',
    value: 'UG',
    isoCode: '320',
  },
  {
    name: 'Ntoroko District',
    value: 'UG',
    isoCode: '424',
  },
  {
    name: 'Nakaseke District',
    value: 'UG',
    isoCode: '116',
  },
  {
    name: 'Ngora District',
    value: 'UG',
    isoCode: '231',
  },
  {
    name: 'Kumi District',
    value: 'UG',
    isoCode: '208',
  },
  {
    name: 'Kabale District',
    value: 'UG',
    isoCode: '404',
  },
  {
    name: 'Sembabule District',
    value: 'UG',
    isoCode: '111',
  },
  {
    name: 'Bulambuli District',
    value: 'UG',
    isoCode: '225',
  },
  {
    name: 'Sironko District',
    value: 'UG',
    isoCode: '215',
  },
  {
    name: 'Napak District',
    value: 'UG',
    isoCode: '327',
  },
  {
    name: 'Busia District',
    value: 'UG',
    isoCode: '202',
  },
  {
    name: 'Kapchorwa District',
    value: 'UG',
    isoCode: '206',
  },
  {
    name: 'Luwero District',
    value: 'UG',
    isoCode: '104',
  },
  {
    name: 'Kaabong District',
    value: 'UG',
    isoCode: '318',
  },
  {
    name: 'Mitooma District',
    value: 'UG',
    isoCode: '423',
  },
  {
    name: 'Kibaale District',
    value: 'UG',
    isoCode: '407',
  },
  {
    name: 'Kyegegwa District',
    value: 'UG',
    isoCode: '422',
  },
  {
    name: 'Manafwa District',
    value: 'UG',
    isoCode: '223',
  },
  {
    name: 'Rakai District',
    value: 'UG',
    isoCode: '110',
  },
  {
    name: 'Kasese District',
    value: 'UG',
    isoCode: '406',
  },
  {
    name: 'Budaka District',
    value: 'UG',
    isoCode: '217',
  },
  {
    name: 'Rubirizi District',
    value: 'UG',
    isoCode: '425',
  },
  {
    name: 'Kotido District',
    value: 'UG',
    isoCode: '306',
  },
  {
    name: 'Soroti District',
    value: 'UG',
    isoCode: '211',
  },
  {
    name: 'Luuka District',
    value: 'UG',
    isoCode: '229',
  },
  {
    name: 'Nebbi District',
    value: 'UG',
    isoCode: '310',
  },
  {
    name: 'Arua District',
    value: 'UG',
    isoCode: '303',
  },
  {
    name: 'Kyotera District',
    value: 'UG',
    isoCode: '125',
  },
  {
    name: 'Schellenberg',
    value: 'LI',
    isoCode: '08',
  },
  {
    name: 'Schaan',
    value: 'LI',
    isoCode: '07',
  },
  {
    name: 'Eschen',
    value: 'LI',
    isoCode: '02',
  },
  {
    name: 'Vaduz',
    value: 'LI',
    isoCode: '11',
  },
  {
    name: 'Ruggell',
    value: 'LI',
    isoCode: '06',
  },
  {
    name: 'Planken',
    value: 'LI',
    isoCode: '05',
  },
  {
    name: 'Mauren',
    value: 'LI',
    isoCode: '04',
  },
  {
    name: 'Triesenberg',
    value: 'LI',
    isoCode: '10',
  },
  {
    name: 'Gamprin',
    value: 'LI',
    isoCode: '03',
  },
  {
    name: 'Balzers',
    value: 'LI',
    isoCode: '01',
  },
  {
    name: 'Triesen',
    value: 'LI',
    isoCode: '09',
  },
  {
    name: 'Brčko District',
    value: 'BA',
    isoCode: 'BRC',
  },
  {
    name: 'Tuzla Canton',
    value: 'BA',
    isoCode: '03',
  },
  {
    name: 'Central Bosnia Canton',
    value: 'BA',
    isoCode: '06',
  },
  {
    name: 'Herzegovina-Neretva Canton',
    value: 'BA',
    isoCode: '07',
  },
  {
    name: 'Posavina Canton',
    value: 'BA',
    isoCode: '02',
  },
  {
    name: 'Una-Sana Canton',
    value: 'BA',
    isoCode: '01',
  },
  {
    name: 'Sarajevo Canton',
    value: 'BA',
    isoCode: '09',
  },
  {
    name: 'Federation of Bosnia and Herzegovina',
    value: 'BA',
    isoCode: 'BIH',
  },
  {
    name: 'Zenica-Doboj Canton',
    value: 'BA',
    isoCode: '04',
  },
  {
    name: 'West Herzegovina Canton',
    value: 'BA',
    isoCode: '08',
  },
  {
    name: 'Republika Srpska',
    value: 'BA',
    isoCode: 'SRP',
  },
  {
    name: 'Canton 10',
    value: 'BA',
    isoCode: '10',
  },
  {
    name: 'Bosnian Podrinje Canton',
    value: 'BA',
    isoCode: '05',
  },
  {
    name: 'Dakar',
    value: 'SN',
    isoCode: 'DK',
  },
  {
    name: 'Kolda',
    value: 'SN',
    isoCode: 'KD',
  },
  {
    name: 'Kaffrine',
    value: 'SN',
    isoCode: 'KA',
  },
  {
    name: 'Matam',
    value: 'SN',
    isoCode: 'MT',
  },
  {
    name: 'Saint-Louis',
    value: 'SN',
    isoCode: 'SL',
  },
  {
    name: 'Ziguinchor',
    value: 'SN',
    isoCode: 'ZG',
  },
  {
    name: 'Fatick',
    value: 'SN',
    isoCode: 'FK',
  },
  {
    name: 'Diourbel Region',
    value: 'SN',
    isoCode: 'DB',
  },
  {
    name: 'Kédougou',
    value: 'SN',
    isoCode: 'KE',
  },
  {
    name: 'Sédhiou',
    value: 'SN',
    isoCode: 'SE',
  },
  {
    name: 'Kaolack',
    value: 'SN',
    isoCode: 'KL',
  },
  {
    name: 'Thiès Region',
    value: 'SN',
    isoCode: 'TH',
  },
  {
    name: 'Louga',
    value: 'SN',
    isoCode: 'LG',
  },
  {
    name: 'Tambacounda Region',
    value: 'SN',
    isoCode: 'TC',
  },
  {
    name: 'Encamp',
    value: 'AD',
    isoCode: '03',
  },
  {
    name: 'Andorra la Vella',
    value: 'AD',
    isoCode: '07',
  },
  {
    name: 'Canillo',
    value: 'AD',
    isoCode: '02',
  },
  {
    name: 'Sant Julià de Lòria',
    value: 'AD',
    isoCode: '06',
  },
  {
    name: 'Ordino',
    value: 'AD',
    isoCode: '05',
  },
  {
    name: 'Escaldes-Engordany',
    value: 'AD',
    isoCode: '08',
  },
  {
    name: 'La Massana',
    value: 'AD',
    isoCode: '04',
  },
  {
    name: 'Mont Buxton',
    value: 'SC',
    isoCode: '17',
  },
  {
    name: 'La Digue',
    value: 'SC',
    isoCode: '15',
  },
  {
    name: 'Saint Louis',
    value: 'SC',
    isoCode: '22',
  },
  {
    name: 'Baie Lazare',
    value: 'SC',
    isoCode: '06',
  },
  {
    name: 'Mont Fleuri',
    value: 'SC',
    isoCode: '18',
  },
  {
    name: 'Les Mamelles',
    value: 'SC',
    isoCode: '24',
  },
  {
    name: "Grand'Anse Mahé",
    value: 'SC',
    isoCode: '13',
  },
  {
    name: 'Roche Caiman',
    value: 'SC',
    isoCode: '25',
  },
  {
    name: 'Anse Royale',
    value: 'SC',
    isoCode: '05',
  },
  {
    name: 'Glacis',
    value: 'SC',
    isoCode: '12',
  },
  {
    name: "Grand'Anse Praslin",
    value: 'SC',
    isoCode: '14',
  },
  {
    name: 'Bel Ombre',
    value: 'SC',
    isoCode: '10',
  },
  {
    name: 'Anse-aux-Pins',
    value: 'SC',
    isoCode: '01',
  },
  {
    name: 'Port Glaud',
    value: 'SC',
    isoCode: '21',
  },
  {
    name: 'Au Cap',
    value: 'SC',
    isoCode: '04',
  },
  {
    name: 'Takamaka',
    value: 'SC',
    isoCode: '23',
  },
  {
    name: 'Pointe La Rue',
    value: 'SC',
    isoCode: '20',
  },
  {
    name: 'Plaisance',
    value: 'SC',
    isoCode: '19',
  },
  {
    name: 'Beau Vallon',
    value: 'SC',
    isoCode: '08',
  },
  {
    name: 'Anse Boileau',
    value: 'SC',
    isoCode: '02',
  },
  {
    name: 'Baie Sainte Anne',
    value: 'SC',
    isoCode: '07',
  },
  {
    name: 'Bel Air',
    value: 'SC',
    isoCode: '09',
  },
  {
    name: 'La Rivière Anglaise',
    value: 'SC',
    isoCode: '16',
  },
  {
    name: 'Cascade',
    value: 'SC',
    isoCode: '11',
  },
  {
    name: 'Shaki',
    value: 'AZ',
    isoCode: 'SA',
  },
  {
    name: 'Tartar District',
    value: 'AZ',
    isoCode: 'TAR',
  },
  {
    name: 'Shirvan',
    value: 'AZ',
    isoCode: 'SR',
  },
  {
    name: 'Qazakh District',
    value: 'AZ',
    isoCode: 'QAZ',
  },
  {
    name: 'Sadarak District',
    value: 'AZ',
    isoCode: 'SAD',
  },
  {
    name: 'Yevlakh District',
    value: 'AZ',
    isoCode: 'YEV',
  },
  {
    name: 'Khojali District',
    value: 'AZ',
    isoCode: 'XCI',
  },
  {
    name: 'Kalbajar District',
    value: 'AZ',
    isoCode: 'KAL',
  },
  {
    name: 'Qakh District',
    value: 'AZ',
    isoCode: 'QAX',
  },
  {
    name: 'Fizuli District',
    value: 'AZ',
    isoCode: 'FUZ',
  },
  {
    name: 'Astara District',
    value: 'AZ',
    isoCode: 'AST',
  },
  {
    name: 'Shamakhi District',
    value: 'AZ',
    isoCode: 'SMI',
  },
  {
    name: 'Neftchala District',
    value: 'AZ',
    isoCode: 'NEF',
  },
  {
    name: 'Goychay',
    value: 'AZ',
    isoCode: 'GOY',
  },
  {
    name: 'Bilasuvar District',
    value: 'AZ',
    isoCode: 'BIL',
  },
  {
    name: 'Tovuz District',
    value: 'AZ',
    isoCode: 'TOV',
  },
  {
    name: 'Ordubad District',
    value: 'AZ',
    isoCode: 'ORD',
  },
  {
    name: 'Sharur District',
    value: 'AZ',
    isoCode: 'SAR',
  },
  {
    name: 'Samukh District',
    value: 'AZ',
    isoCode: 'SMX',
  },
  {
    name: 'Khizi District',
    value: 'AZ',
    isoCode: 'XIZ',
  },
  {
    name: 'Yevlakh',
    value: 'AZ',
    isoCode: 'YE',
  },
  {
    name: 'Ujar District',
    value: 'AZ',
    isoCode: 'UCA',
  },
  {
    name: 'Absheron District',
    value: 'AZ',
    isoCode: 'ABS',
  },
  {
    name: 'Lachin District',
    value: 'AZ',
    isoCode: 'LAC',
  },
  {
    name: 'Qabala District',
    value: 'AZ',
    isoCode: 'QAB',
  },
  {
    name: 'Agstafa District',
    value: 'AZ',
    isoCode: 'AGA',
  },
  {
    name: 'Imishli District',
    value: 'AZ',
    isoCode: 'IMI',
  },
  {
    name: 'Salyan District',
    value: 'AZ',
    isoCode: 'SAL',
  },
  {
    name: 'Lerik District',
    value: 'AZ',
    isoCode: 'LER',
  },
  {
    name: 'Agsu District',
    value: 'AZ',
    isoCode: 'AGU',
  },
  {
    name: 'Qubadli District',
    value: 'AZ',
    isoCode: 'QBI',
  },
  {
    name: 'Kurdamir District',
    value: 'AZ',
    isoCode: 'KUR',
  },
  {
    name: 'Yardymli District',
    value: 'AZ',
    isoCode: 'YAR',
  },
  {
    name: 'Goranboy District',
    value: 'AZ',
    isoCode: 'GOR',
  },
  {
    name: 'Baku',
    value: 'AZ',
    isoCode: 'BA',
  },
  {
    name: 'Agdash District',
    value: 'AZ',
    isoCode: 'AGS',
  },
  {
    name: 'Beylagan District',
    value: 'AZ',
    isoCode: 'BEY',
  },
  {
    name: 'Masally District',
    value: 'AZ',
    isoCode: 'MAS',
  },
  {
    name: 'Oghuz District',
    value: 'AZ',
    isoCode: 'OGU',
  },
  {
    name: 'Saatly District',
    value: 'AZ',
    isoCode: 'SAT',
  },
  {
    name: 'Lankaran District',
    value: 'AZ',
    isoCode: 'LA',
  },
  {
    name: 'Agdam District',
    value: 'AZ',
    isoCode: 'AGM',
  },
  {
    name: 'Balakan District',
    value: 'AZ',
    isoCode: 'BAL',
  },
  {
    name: 'Dashkasan District',
    value: 'AZ',
    isoCode: 'DAS',
  },
  {
    name: 'Nakhchivan Autonomous Republic',
    value: 'AZ',
    isoCode: 'NX',
  },
  {
    name: 'Quba District',
    value: 'AZ',
    isoCode: 'QBA',
  },
  {
    name: 'Ismailli District',
    value: 'AZ',
    isoCode: 'ISM',
  },
  {
    name: 'Sabirabad District',
    value: 'AZ',
    isoCode: 'SAB',
  },
  {
    name: 'Zaqatala District',
    value: 'AZ',
    isoCode: 'ZAQ',
  },
  {
    name: 'Kangarli District',
    value: 'AZ',
    isoCode: 'KAN',
  },
  {
    name: 'Martuni',
    value: 'AZ',
    isoCode: 'XVD',
  },
  {
    name: 'Barda District',
    value: 'AZ',
    isoCode: 'BAR',
  },
  {
    name: 'Jabrayil District',
    value: 'AZ',
    isoCode: 'CAB',
  },
  {
    name: 'Hajigabul District',
    value: 'AZ',
    isoCode: 'HAC',
  },
  {
    name: 'Julfa District',
    value: 'AZ',
    isoCode: 'CUL',
  },
  {
    name: 'Gobustan District',
    value: 'AZ',
    isoCode: 'QOB',
  },
  {
    name: 'Goygol District',
    value: 'AZ',
    isoCode: 'GYG',
  },
  {
    name: 'Babek District',
    value: 'AZ',
    isoCode: 'BAB',
  },
  {
    name: 'Zardab District',
    value: 'AZ',
    isoCode: 'ZAR',
  },
  {
    name: 'Aghjabadi District',
    value: 'AZ',
    isoCode: 'AGC',
  },
  {
    name: 'Jalilabad District',
    value: 'AZ',
    isoCode: 'CAL',
  },
  {
    name: 'Shahbuz District',
    value: 'AZ',
    isoCode: 'SAH',
  },
  {
    name: 'Mingachevir',
    value: 'AZ',
    isoCode: 'MI',
  },
  {
    name: 'Zangilan District',
    value: 'AZ',
    isoCode: 'ZAN',
  },
  {
    name: 'Sumqayit',
    value: 'AZ',
    isoCode: 'SM',
  },
  {
    name: 'Shamkir District',
    value: 'AZ',
    isoCode: 'SKR',
  },
  {
    name: 'Siazan District',
    value: 'AZ',
    isoCode: 'SIY',
  },
  {
    name: 'Ganja',
    value: 'AZ',
    isoCode: 'GA',
  },
  {
    name: 'Shaki District',
    value: 'AZ',
    isoCode: 'SAK',
  },
  {
    name: 'Lankaran',
    value: 'AZ',
    isoCode: 'LAN',
  },
  {
    name: 'Qusar District',
    value: 'AZ',
    isoCode: 'QUS',
  },
  {
    name: 'Gədəbəy',
    value: 'AZ',
    isoCode: 'GAD',
  },
  {
    name: 'Khachmaz District',
    value: 'AZ',
    isoCode: 'XAC',
  },
  {
    name: 'Shabran District',
    value: 'AZ',
    isoCode: 'SBN',
  },
  {
    name: 'Shusha District',
    value: 'AZ',
    isoCode: 'SUS',
  },
  {
    name: 'Skrapar District',
    value: 'AL',
    isoCode: 'SK',
  },
  {
    name: 'Kavajë District',
    value: 'AL',
    isoCode: 'KA',
  },
  {
    name: 'Lezhë District',
    value: 'AL',
    isoCode: 'LE',
  },
  {
    name: 'Librazhd District',
    value: 'AL',
    isoCode: 'LB',
  },
  {
    name: 'Korçë District',
    value: 'AL',
    isoCode: 'KO',
  },
  {
    name: 'Elbasan County',
    value: 'AL',
    isoCode: '03',
  },
  {
    name: 'Lushnjë District',
    value: 'AL',
    isoCode: 'LU',
  },
  {
    name: 'Has District',
    value: 'AL',
    isoCode: 'HA',
  },
  {
    name: 'Kukës County',
    value: 'AL',
    isoCode: '07',
  },
  {
    name: 'Malësi e Madhe District',
    value: 'AL',
    isoCode: 'MM',
  },
  {
    name: 'Berat County',
    value: 'AL',
    isoCode: '01',
  },
  {
    name: 'Gjirokastër County',
    value: 'AL',
    isoCode: '05',
  },
  {
    name: 'Dibër District',
    value: 'AL',
    isoCode: 'DI',
  },
  {
    name: 'Pogradec District',
    value: 'AL',
    isoCode: 'PG',
  },
  {
    name: 'Bulqizë District',
    value: 'AL',
    isoCode: 'BU',
  },
  {
    name: 'Devoll District',
    value: 'AL',
    isoCode: 'DV',
  },
  {
    name: 'Lezhë County',
    value: 'AL',
    isoCode: '08',
  },
  {
    name: 'Dibër County',
    value: 'AL',
    isoCode: '09',
  },
  {
    name: 'Shkodër County',
    value: 'AL',
    isoCode: '10',
  },
  {
    name: 'Kuçovë District',
    value: 'AL',
    isoCode: 'KC',
  },
  {
    name: 'Vlorë District',
    value: 'AL',
    isoCode: 'VL',
  },
  {
    name: 'Krujë District',
    value: 'AL',
    isoCode: 'KR',
  },
  {
    name: 'Tirana County',
    value: 'AL',
    isoCode: '11',
  },
  {
    name: 'Tepelenë District',
    value: 'AL',
    isoCode: 'TE',
  },
  {
    name: 'Gramsh District',
    value: 'AL',
    isoCode: 'GR',
  },
  {
    name: 'Delvinë District',
    value: 'AL',
    isoCode: 'DL',
  },
  {
    name: 'Peqin District',
    value: 'AL',
    isoCode: 'PQ',
  },
  {
    name: 'Pukë District',
    value: 'AL',
    isoCode: 'PU',
  },
  {
    name: 'Gjirokastër District',
    value: 'AL',
    isoCode: 'GJ',
  },
  {
    name: 'Kurbin District',
    value: 'AL',
    isoCode: 'KB',
  },
  {
    name: 'Kukës District',
    value: 'AL',
    isoCode: 'KU',
  },
  {
    name: 'Sarandë District',
    value: 'AL',
    isoCode: 'SR',
  },
  {
    name: 'Përmet District',
    value: 'AL',
    isoCode: 'PR',
  },
  {
    name: 'Shkodër District',
    value: 'AL',
    isoCode: 'SH',
  },
  {
    name: 'Fier District',
    value: 'AL',
    isoCode: 'FR',
  },
  {
    name: 'Kolonjë District',
    value: 'AL',
    isoCode: 'ER',
  },
  {
    name: 'Berat District',
    value: 'AL',
    isoCode: 'BR',
  },
  {
    name: 'Korçë County',
    value: 'AL',
    isoCode: '06',
  },
  {
    name: 'Fier County',
    value: 'AL',
    isoCode: '04',
  },
  {
    name: 'Durrës County',
    value: 'AL',
    isoCode: '02',
  },
  {
    name: 'Tirana District',
    value: 'AL',
    isoCode: 'TR',
  },
  {
    name: 'Vlorë County',
    value: 'AL',
    isoCode: '12',
  },
  {
    name: 'Mat District',
    value: 'AL',
    isoCode: 'MT',
  },
  {
    name: 'Tropojë District',
    value: 'AL',
    isoCode: 'TP',
  },
  {
    name: 'Mallakastër District',
    value: 'AL',
    isoCode: 'MK',
  },
  {
    name: 'Mirditë District',
    value: 'AL',
    isoCode: 'MR',
  },
  {
    name: 'Durrës District',
    value: 'AL',
    isoCode: 'DR',
  },
  {
    name: 'Sveti Nikole Municipality',
    value: 'MK',
    isoCode: '69',
  },
  {
    name: 'Kratovo Municipality',
    value: 'MK',
    isoCode: '43',
  },
  {
    name: 'Zajas Municipality',
    value: 'MK',
    isoCode: '31',
  },
  {
    name: 'Staro Nagoričane Municipality',
    value: 'MK',
    isoCode: '71',
  },
  {
    name: 'Češinovo-Obleševo Municipality',
    value: 'MK',
    isoCode: '81',
  },
  {
    name: 'Debarca Municipality',
    value: 'MK',
    isoCode: '22',
  },
  {
    name: 'Probištip Municipality',
    value: 'MK',
    isoCode: '63',
  },
  {
    name: 'Krivogaštani Municipality',
    value: 'MK',
    isoCode: '45',
  },
  {
    name: 'Gevgelija Municipality',
    value: 'MK',
    isoCode: '18',
  },
  {
    name: 'Bogdanci Municipality',
    value: 'MK',
    isoCode: '05',
  },
  {
    name: 'Vraneštica Municipality',
    value: 'MK',
    isoCode: '15',
  },
  {
    name: 'Veles Municipality',
    value: 'MK',
    isoCode: '13',
  },
  {
    name: 'Bosilovo Municipality',
    value: 'MK',
    isoCode: '07',
  },
  {
    name: 'Mogila Municipality',
    value: 'MK',
    isoCode: '53',
  },
  {
    name: 'Tearce Municipality',
    value: 'MK',
    isoCode: '75',
  },
  {
    name: 'Demir Kapija Municipality',
    value: 'MK',
    isoCode: '24',
  },
  {
    name: 'Aračinovo Municipality',
    value: 'MK',
    isoCode: '02',
  },
  {
    name: 'Drugovo Municipality',
    value: 'MK',
    isoCode: '28',
  },
  {
    name: 'Vasilevo Municipality',
    value: 'MK',
    isoCode: '11',
  },
  {
    name: 'Lipkovo Municipality',
    value: 'MK',
    isoCode: '48',
  },
  {
    name: 'Brvenica Municipality',
    value: 'MK',
    isoCode: '08',
  },
  {
    name: 'Štip Municipality',
    value: 'MK',
    isoCode: '83',
  },
  {
    name: 'Vevčani Municipality',
    value: 'MK',
    isoCode: '12',
  },
  {
    name: 'Tetovo Municipality',
    value: 'MK',
    isoCode: '76',
  },
  {
    name: 'Negotino Municipality',
    value: 'MK',
    isoCode: '54',
  },
  {
    name: 'Konče Municipality',
    value: 'MK',
    isoCode: '41',
  },
  {
    name: 'Prilep Municipality',
    value: 'MK',
    isoCode: '62',
  },
  {
    name: 'Saraj Municipality',
    value: 'MK',
    isoCode: '68',
  },
  {
    name: 'Želino Municipality',
    value: 'MK',
    isoCode: '30',
  },
  {
    name: 'Mavrovo and Rostuša Municipality',
    value: 'MK',
    isoCode: '50',
  },
  {
    name: 'Plasnica Municipality',
    value: 'MK',
    isoCode: '61',
  },
  {
    name: 'Valandovo Municipality',
    value: 'MK',
    isoCode: '10',
  },
  {
    name: 'Vinica Municipality',
    value: 'MK',
    isoCode: '14',
  },
  {
    name: 'Zrnovci Municipality',
    value: 'MK',
    isoCode: '33',
  },
  {
    name: 'Karbinci',
    value: 'MK',
    isoCode: '37',
  },
  {
    name: 'Dolneni Municipality',
    value: 'MK',
    isoCode: '27',
  },
  {
    name: 'Čaška Municipality',
    value: 'MK',
    isoCode: '80',
  },
  {
    name: 'Kriva Palanka Municipality',
    value: 'MK',
    isoCode: '44',
  },
  {
    name: 'Jegunovce Municipality',
    value: 'MK',
    isoCode: '35',
  },
  {
    name: 'Bitola Municipality',
    value: 'MK',
    isoCode: '04',
  },
  {
    name: 'Šuto Orizari Municipality',
    value: 'MK',
    isoCode: '84',
  },
  {
    name: 'Karpoš Municipality',
    value: 'MK',
    isoCode: '38',
  },
  {
    name: 'Oslomej Municipality',
    value: 'MK',
    isoCode: '57',
  },
  {
    name: 'Kumanovo Municipality',
    value: 'MK',
    isoCode: '47',
  },
  {
    name: 'Greater Skopje',
    value: 'MK',
    isoCode: '85',
  },
  {
    name: 'Pehčevo Municipality',
    value: 'MK',
    isoCode: '60',
  },
  {
    name: 'Kisela Voda Municipality',
    value: 'MK',
    isoCode: '39',
  },
  {
    name: 'Demir Hisar Municipality',
    value: 'MK',
    isoCode: '25',
  },
  {
    name: 'Kičevo Municipality',
    value: 'MK',
    isoCode: '40',
  },
  {
    name: 'Vrapčište Municipality',
    value: 'MK',
    isoCode: '16',
  },
  {
    name: 'Ilinden Municipality',
    value: 'MK',
    isoCode: '34',
  },
  {
    name: 'Rosoman Municipality',
    value: 'MK',
    isoCode: '67',
  },
  {
    name: 'Makedonski Brod Municipality',
    value: 'MK',
    isoCode: '52',
  },
  {
    name: 'Gostivar Municipality',
    value: 'MK',
    isoCode: '19',
  },
  {
    name: 'Butel Municipality',
    value: 'MK',
    isoCode: '09',
  },
  {
    name: 'Delčevo Municipality',
    value: 'MK',
    isoCode: '23',
  },
  {
    name: 'Novaci Municipality',
    value: 'MK',
    isoCode: '55',
  },
  {
    name: 'Dojran Municipality',
    value: 'MK',
    isoCode: '26',
  },
  {
    name: 'Petrovec Municipality',
    value: 'MK',
    isoCode: '59',
  },
  {
    name: 'Ohrid Municipality',
    value: 'MK',
    isoCode: '58',
  },
  {
    name: 'Struga Municipality',
    value: 'MK',
    isoCode: '72',
  },
  {
    name: 'Makedonska Kamenica Municipality',
    value: 'MK',
    isoCode: '51',
  },
  {
    name: 'Centar Municipality',
    value: 'MK',
    isoCode: '77',
  },
  {
    name: 'Aerodrom Municipality',
    value: 'MK',
    isoCode: '01',
  },
  {
    name: 'Čair Municipality',
    value: 'MK',
    isoCode: '79',
  },
  {
    name: 'Lozovo Municipality',
    value: 'MK',
    isoCode: '49',
  },
  {
    name: 'Zelenikovo Municipality',
    value: 'MK',
    isoCode: '32',
  },
  {
    name: 'Gazi Baba Municipality',
    value: 'MK',
    isoCode: '17',
  },
  {
    name: 'Gradsko Municipality',
    value: 'MK',
    isoCode: '20',
  },
  {
    name: 'Radoviš Municipality',
    value: 'MK',
    isoCode: '64',
  },
  {
    name: 'Strumica Municipality',
    value: 'MK',
    isoCode: '73',
  },
  {
    name: 'Studeničani Municipality',
    value: 'MK',
    isoCode: '74',
  },
  {
    name: 'Resen Municipality',
    value: 'MK',
    isoCode: '66',
  },
  {
    name: 'Kavadarci Municipality',
    value: 'MK',
    isoCode: '36',
  },
  {
    name: 'Kruševo Municipality',
    value: 'MK',
    isoCode: '46',
  },
  {
    name: 'Čučer-Sandevo Municipality',
    value: 'MK',
    isoCode: '82',
  },
  {
    name: 'Berovo Municipality',
    value: 'MK',
    isoCode: '03',
  },
  {
    name: 'Rankovce Municipality',
    value: 'MK',
    isoCode: '65',
  },
  {
    name: 'Novo Selo Municipality',
    value: 'MK',
    isoCode: '56',
  },
  {
    name: 'Sopište Municipality',
    value: 'MK',
    isoCode: '70',
  },
  {
    name: 'Centar Župa Municipality',
    value: 'MK',
    isoCode: '78',
  },
  {
    name: 'Bogovinje Municipality',
    value: 'MK',
    isoCode: '06',
  },
  {
    name: 'Gjorče Petrov Municipality',
    value: 'MK',
    isoCode: '29',
  },
  {
    name: 'Kočani Municipality',
    value: 'MK',
    isoCode: '42',
  },
  {
    name: 'Požega-Slavonia County',
    value: 'HR',
    isoCode: '11',
  },
  {
    name: 'Split-Dalmatia County',
    value: 'HR',
    isoCode: '17',
  },
  {
    name: 'Međimurje County',
    value: 'HR',
    isoCode: '20',
  },
  {
    name: 'Zadar County',
    value: 'HR',
    isoCode: '13',
  },
  {
    name: 'Dubrovnik-Neretva County',
    value: 'HR',
    isoCode: '19',
  },
  {
    name: 'Krapina-Zagorje County',
    value: 'HR',
    isoCode: '02',
  },
  {
    name: 'Šibenik-Knin County',
    value: 'HR',
    isoCode: '15',
  },
  {
    name: 'Lika-Senj County',
    value: 'HR',
    isoCode: '09',
  },
  {
    name: 'Virovitica-Podravina County',
    value: 'HR',
    isoCode: '10',
  },
  {
    name: 'Sisak-Moslavina County',
    value: 'HR',
    isoCode: '03',
  },
  {
    name: 'Bjelovar-Bilogora County',
    value: 'HR',
    isoCode: '07',
  },
  {
    name: 'Primorje-Gorski Kotar County',
    value: 'HR',
    isoCode: '08',
  },
  {
    name: 'Zagreb County',
    value: 'HR',
    isoCode: '01',
  },
  {
    name: 'Brod-Posavina County',
    value: 'HR',
    isoCode: '12',
  },
  {
    name: 'Zagreb',
    value: 'HR',
    isoCode: '21',
  },
  {
    name: 'Varaždin County',
    value: 'HR',
    isoCode: '05',
  },
  {
    name: 'Osijek-Baranja County',
    value: 'HR',
    isoCode: '14',
  },
  {
    name: 'Vukovar-Syrmia County',
    value: 'HR',
    isoCode: '16',
  },
  {
    name: 'Koprivnica-Križevci County',
    value: 'HR',
    isoCode: '06',
  },
  {
    name: 'Istria County',
    value: 'HR',
    isoCode: '18',
  },
  {
    name: 'Karlovac County',
    value: 'HR',
    isoCode: '05',
  },
  {
    name: 'Kyrenia District (Keryneia)',
    value: 'CY',
    isoCode: '06',
  },
  {
    name: 'Nicosia District (Lefkoşa)',
    value: 'CY',
    isoCode: '01',
  },
  {
    name: 'Paphos District (Pafos)',
    value: 'CY',
    isoCode: '05',
  },
  {
    name: 'Larnaca District (Larnaka)',
    value: 'CY',
    isoCode: '03',
  },
  {
    name: 'Limassol District (Leymasun)',
    value: 'CY',
    isoCode: '02',
  },
  {
    name: 'Famagusta District (Mağusa)',
    value: 'CY',
    isoCode: '04',
  },
  {
    name: 'Rangpur Division',
    value: 'BD',
    isoCode: 'F',
  },
  {
    name: "Cox's Bazar District",
    value: 'BD',
    isoCode: '11',
  },
  {
    name: 'Bandarban District',
    value: 'BD',
    isoCode: '01',
  },
  {
    name: 'Rajshahi Division',
    value: 'BD',
    isoCode: 'E',
  },
  {
    name: 'Pabna District',
    value: 'BD',
    isoCode: '49',
  },
  {
    name: 'Sherpur District',
    value: 'BD',
    isoCode: '57',
  },
  {
    name: 'Bhola District',
    value: 'BD',
    isoCode: '07',
  },
  {
    name: 'Jessore District',
    value: 'BD',
    isoCode: '22',
  },
  {
    name: 'Mymensingh Division',
    value: 'BD',
    isoCode: 'H',
  },
  {
    name: 'Rangpur District',
    value: 'BD',
    isoCode: '55',
  },
  {
    name: 'Dhaka Division',
    value: 'BD',
    isoCode: 'C',
  },
  {
    name: 'Chapai Nawabganj District',
    value: 'BD',
    isoCode: '45',
  },
  {
    name: 'Faridpur District',
    value: 'BD',
    isoCode: '15',
  },
  {
    name: 'Comilla District',
    value: 'BD',
    isoCode: '08',
  },
  {
    name: 'Netrokona District',
    value: 'BD',
    isoCode: '41',
  },
  {
    name: 'Sylhet Division',
    value: 'BD',
    isoCode: 'G',
  },
  {
    name: 'Mymensingh District',
    value: 'BD',
    isoCode: '34',
  },
  {
    name: 'Sylhet District',
    value: 'BD',
    isoCode: '60',
  },
  {
    name: 'Chandpur District',
    value: 'BD',
    isoCode: '09',
  },
  {
    name: 'Narail District',
    value: 'BD',
    isoCode: '43',
  },
  {
    name: 'Narayanganj District',
    value: 'BD',
    isoCode: '40',
  },
  {
    name: 'Dhaka District',
    value: 'BD',
    isoCode: '13',
  },
  {
    name: 'Nilphamari District',
    value: 'BD',
    isoCode: '46',
  },
  {
    name: 'Rajbari District',
    value: 'BD',
    isoCode: '53',
  },
  {
    name: 'Kushtia District',
    value: 'BD',
    isoCode: '30',
  },
  {
    name: 'Khulna Division',
    value: 'BD',
    isoCode: 'D',
  },
  {
    name: 'Meherpur District',
    value: 'BD',
    isoCode: '39',
  },
  {
    name: 'Patuakhali District',
    value: 'BD',
    isoCode: '51',
  },
  {
    name: 'Jhalokati District',
    value: 'BD',
    isoCode: '25',
  },
  {
    name: 'Kishoreganj District',
    value: 'BD',
    isoCode: '26',
  },
  {
    name: 'Lalmonirhat District',
    value: 'BD',
    isoCode: '32',
  },
  {
    name: 'Sirajganj District',
    value: 'BD',
    isoCode: '59',
  },
  {
    name: 'Tangail District',
    value: 'BD',
    isoCode: '63',
  },
  {
    name: 'Dinajpur District',
    value: 'BD',
    isoCode: '14',
  },
  {
    name: 'Barguna District',
    value: 'BD',
    isoCode: '02',
  },
  {
    name: 'Chittagong District',
    value: 'BD',
    isoCode: '10',
  },
  {
    name: 'Khagrachari District',
    value: 'BD',
    isoCode: '29',
  },
  {
    name: 'Natore District',
    value: 'BD',
    isoCode: '44',
  },
  {
    name: 'Chuadanga District',
    value: 'BD',
    isoCode: '12',
  },
  {
    name: 'Jhenaidah District',
    value: 'BD',
    isoCode: '23',
  },
  {
    name: 'Munshiganj District',
    value: 'BD',
    isoCode: '35',
  },
  {
    name: 'Pirojpur District',
    value: 'BD',
    isoCode: '50',
  },
  {
    name: 'Gopalganj District',
    value: 'BD',
    isoCode: '17',
  },
  {
    name: 'Kurigram District',
    value: 'BD',
    isoCode: '28',
  },
  {
    name: 'Moulvibazar District',
    value: 'BD',
    isoCode: '38',
  },
  {
    name: 'Gaibandha District',
    value: 'BD',
    isoCode: '19',
  },
  {
    name: 'Bagerhat District',
    value: 'BD',
    isoCode: '05',
  },
  {
    name: 'Bogra District',
    value: 'BD',
    isoCode: '03',
  },
  {
    name: 'Gazipur District',
    value: 'BD',
    isoCode: '18',
  },
  {
    name: 'Satkhira District',
    value: 'BD',
    isoCode: '58',
  },
  {
    name: 'Panchagarh District',
    value: 'BD',
    isoCode: '52',
  },
  {
    name: 'Shariatpur District',
    value: 'BD',
    isoCode: '62',
  },
  {
    name: 'Bahadia',
    value: 'BD',
    isoCode: '33',
  },
  {
    name: 'Chittagong Division',
    value: 'BD',
    isoCode: 'B',
  },
  {
    name: 'Thakurgaon District',
    value: 'BD',
    isoCode: '64',
  },
  {
    name: 'Habiganj District',
    value: 'BD',
    isoCode: '20',
  },
  {
    name: 'Joypurhat District',
    value: 'BD',
    isoCode: '24',
  },
  {
    name: 'Barisal Division',
    value: 'BD',
    isoCode: 'A',
  },
  {
    name: 'Jamalpur District',
    value: 'BD',
    isoCode: '21',
  },
  {
    name: 'Rangamati Hill District',
    value: 'BD',
    isoCode: '56',
  },
  {
    name: 'Brahmanbaria District',
    value: 'BD',
    isoCode: '04',
  },
  {
    name: 'Khulna District',
    value: 'BD',
    isoCode: '27',
  },
  {
    name: 'Sunamganj District',
    value: 'BD',
    isoCode: '61',
  },
  {
    name: 'Rajshahi District',
    value: 'BD',
    isoCode: '54',
  },
  {
    name: 'Naogaon District',
    value: 'BD',
    isoCode: '48',
  },
  {
    name: 'Noakhali District',
    value: 'BD',
    isoCode: '47',
  },
  {
    name: 'Feni District',
    value: 'BD',
    isoCode: '16',
  },
  {
    name: 'Madaripur District',
    value: 'BD',
    isoCode: '36',
  },
  {
    name: 'Barisal District',
    value: 'BD',
    isoCode: '06',
  },
  {
    name: 'Lakshmipur District',
    value: 'BD',
    isoCode: '31',
  },
  {
    name: 'Okayama Prefecture',
    value: 'JP',
    isoCode: '33',
  },
  {
    name: 'Chiba Prefecture',
    value: 'JP',
    isoCode: '12',
  },
  {
    name: 'Ōita Prefecture',
    value: 'JP',
    isoCode: '44',
  },
  {
    name: 'Tokyo',
    value: 'JP',
    isoCode: '13',
  },
  {
    name: 'Nara Prefecture',
    value: 'JP',
    isoCode: '29',
  },
  {
    name: 'Shizuoka Prefecture',
    value: 'JP',
    isoCode: '22',
  },
  {
    name: 'Shimane Prefecture',
    value: 'JP',
    isoCode: '32',
  },
  {
    name: 'Aichi Prefecture',
    value: 'JP',
    isoCode: '23',
  },
  {
    name: 'Hiroshima Prefecture',
    value: 'JP',
    isoCode: '34',
  },
  {
    name: 'Akita Prefecture',
    value: 'JP',
    isoCode: '05',
  },
  {
    name: 'Ishikawa Prefecture',
    value: 'JP',
    isoCode: '17',
  },
  {
    name: 'Hyōgo Prefecture',
    value: 'JP',
    isoCode: '28',
  },
  {
    name: 'Hokkaidō Prefecture',
    value: 'JP',
    isoCode: '01',
  },
  {
    name: 'Mie Prefecture',
    value: 'JP',
    isoCode: '24',
  },
  {
    name: 'Kyōto Prefecture',
    value: 'JP',
    isoCode: '26',
  },
  {
    name: 'Yamaguchi Prefecture',
    value: 'JP',
    isoCode: '35',
  },
  {
    name: 'Tokushima Prefecture',
    value: 'JP',
    isoCode: '36',
  },
  {
    name: 'Yamagata Prefecture',
    value: 'JP',
    isoCode: '06',
  },
  {
    name: 'Toyama Prefecture',
    value: 'JP',
    isoCode: '16',
  },
  {
    name: 'Aomori Prefecture',
    value: 'JP',
    isoCode: '02',
  },
  {
    name: 'Kagoshima Prefecture',
    value: 'JP',
    isoCode: '46',
  },
  {
    name: 'Niigata Prefecture',
    value: 'JP',
    isoCode: '15',
  },
  {
    name: 'Kanagawa Prefecture',
    value: 'JP',
    isoCode: '14',
  },
  {
    name: 'Nagano Prefecture',
    value: 'JP',
    isoCode: '20',
  },
  {
    name: 'Wakayama Prefecture',
    value: 'JP',
    isoCode: '30',
  },
  {
    name: 'Shiga Prefecture',
    value: 'JP',
    isoCode: '25',
  },
  {
    name: 'Kumamoto Prefecture',
    value: 'JP',
    isoCode: '43',
  },
  {
    name: 'Fukushima Prefecture',
    value: 'JP',
    isoCode: '07',
  },
  {
    name: 'Fukui Prefecture',
    value: 'JP',
    isoCode: '18',
  },
  {
    name: 'Nagasaki Prefecture',
    value: 'JP',
    isoCode: '42',
  },
  {
    name: 'Tottori Prefecture',
    value: 'JP',
    isoCode: '31',
  },
  {
    name: 'Ibaraki Prefecture',
    value: 'JP',
    isoCode: '08',
  },
  {
    name: 'Yamanashi Prefecture',
    value: 'JP',
    isoCode: '19',
  },
  {
    name: 'Okinawa Prefecture',
    value: 'JP',
    isoCode: '47',
  },
  {
    name: 'Tochigi Prefecture',
    value: 'JP',
    isoCode: '09',
  },
  {
    name: 'Miyazaki Prefecture',
    value: 'JP',
    isoCode: '45',
  },
  {
    name: 'Iwate Prefecture',
    value: 'JP',
    isoCode: '03',
  },
  {
    name: 'Miyagi Prefecture',
    value: 'JP',
    isoCode: '04',
  },
  {
    name: 'Gifu Prefecture',
    value: 'JP',
    isoCode: '21',
  },
  {
    name: 'Ōsaka Prefecture',
    value: 'JP',
    isoCode: '27',
  },
  {
    name: 'Saitama Prefecture',
    value: 'JP',
    isoCode: '11',
  },
  {
    name: 'Fukuoka Prefecture',
    value: 'JP',
    isoCode: '40',
  },
  {
    name: 'Gunma Prefecture',
    value: 'JP',
    isoCode: '10',
  },
  {
    name: 'Saga Prefecture',
    value: 'JP',
    isoCode: '41',
  },
  {
    name: 'Kagawa Prefecture',
    value: 'JP',
    isoCode: '37',
  },
  {
    name: 'Ehime Prefecture',
    value: 'JP',
    isoCode: '38',
  },
  {
    name: 'Kōchi Prefecture',
    value: 'JP',
    isoCode: '39',
  },
  {
    name: 'Ontario',
    value: 'CA',
    isoCode: 'ON',
  },
  {
    name: 'Manitoba',
    value: 'CA',
    isoCode: 'MB',
  },
  {
    name: 'New Brunswick',
    value: 'CA',
    isoCode: 'NB',
  },
  {
    name: 'Yukon',
    value: 'CA',
    isoCode: 'YT',
  },
  {
    name: 'Saskatchewan',
    value: 'CA',
    isoCode: 'SK',
  },
  {
    name: 'Prince Edward Island',
    value: 'CA',
    isoCode: 'PE',
  },
  {
    name: 'Alberta',
    value: 'CA',
    isoCode: 'AB',
  },
  {
    name: 'Quebec',
    value: 'CA',
    isoCode: 'QC',
  },
  {
    name: 'Nova Scotia',
    value: 'CA',
    isoCode: 'NS',
  },
  {
    name: 'British Columbia',
    value: 'CA',
    isoCode: 'BC',
  },
  {
    name: 'Nunavut',
    value: 'CA',
    isoCode: 'NU',
  },
  {
    name: 'Newfoundland and Labrador',
    value: 'CA',
    isoCode: 'NL',
  },
  {
    name: 'Northwest Territories',
    value: 'CA',
    isoCode: 'NT',
  },
  {
    name: 'White Nile',
    value: 'SD',
    isoCode: 'NW',
  },
  {
    name: 'Red Sea',
    value: 'SD',
    isoCode: 'RS',
  },
  {
    name: 'Khartoum',
    value: 'SD',
    isoCode: 'KH',
  },
  {
    name: 'Sennar',
    value: 'SD',
    isoCode: 'SI',
  },
  {
    name: 'South Kordofan',
    value: 'SD',
    isoCode: 'KS',
  },
  {
    name: 'Kassala',
    value: 'SD',
    isoCode: 'KA',
  },
  {
    name: 'Al Jazirah',
    value: 'SD',
    isoCode: 'GZ',
  },
  {
    name: 'Al Qadarif',
    value: 'SD',
    isoCode: 'GD',
  },
  {
    name: 'Blue Nile',
    value: 'SD',
    isoCode: 'NB',
  },
  {
    name: 'West Darfur',
    value: 'SD',
    isoCode: 'DW',
  },
  {
    name: 'West Kordofan',
    value: 'SD',
    isoCode: 'GK',
  },
  {
    name: 'North Darfur',
    value: 'SD',
    isoCode: 'DN',
  },
  {
    name: 'River Nile',
    value: 'SD',
    isoCode: 'NR',
  },
  {
    name: 'East Darfur',
    value: 'SD',
    isoCode: 'DE',
  },
  {
    name: 'North Kordofan',
    value: 'SD',
    isoCode: 'KN',
  },
  {
    name: 'South Darfur',
    value: 'SD',
    isoCode: 'DS',
  },
  {
    name: 'Northern',
    value: 'SD',
    isoCode: 'NO',
  },
  {
    name: 'Central Darfur',
    value: 'SD',
    isoCode: 'DC',
  },
  {
    name: 'Khelvachauri Municipality',
    value: 'GE',
    isoCode: '29',
  },
  {
    name: 'Senaki Municipality',
    value: 'GE',
    isoCode: '50',
  },
  {
    name: 'Tbilisi',
    value: 'GE',
    isoCode: 'TB',
  },
  {
    name: 'Adjara',
    value: 'GE',
    isoCode: 'AJ',
  },
  {
    name: 'Autonomous Republic of Abkhazia',
    value: 'GE',
    isoCode: 'AB',
  },
  {
    name: 'Mtskheta-Mtianeti',
    value: 'GE',
    isoCode: 'MM',
  },
  {
    name: 'Shida Kartli',
    value: 'GE',
    isoCode: 'SK',
  },
  {
    name: 'Kvemo Kartli',
    value: 'GE',
    isoCode: 'KK',
  },
  {
    name: 'Imereti',
    value: 'GE',
    isoCode: 'IM',
  },
  {
    name: 'Samtskhe-Javakheti',
    value: 'GE',
    isoCode: 'SJ',
  },
  {
    name: 'Guria',
    value: 'GE',
    isoCode: 'GU',
  },
  {
    name: 'Samegrelo-Zemo Svaneti',
    value: 'GE',
    isoCode: 'SZ',
  },
  {
    name: 'Racha-Lechkhumi and Kvemo Svaneti',
    value: 'GE',
    isoCode: 'RL',
  },
  {
    name: 'Kakheti',
    value: 'GE',
    isoCode: 'KA',
  },
  {
    name: 'Northern Province',
    value: 'SL',
    isoCode: 'N',
  },
  {
    name: 'Southern Province',
    value: 'SL',
    isoCode: 'S',
  },
  {
    name: 'Western Area',
    value: 'SL',
    isoCode: 'W',
  },
  {
    name: 'Eastern Province',
    value: 'SL',
    isoCode: 'E',
  },
  {
    name: 'Hiran',
    value: 'SO',
    isoCode: 'HI',
  },
  {
    name: 'Mudug',
    value: 'SO',
    isoCode: 'MU',
  },
  {
    name: 'Bakool',
    value: 'SO',
    isoCode: 'BK',
  },
  {
    name: 'Galguduud',
    value: 'SO',
    isoCode: 'GA',
  },
  {
    name: 'Sanaag Region',
    value: 'SO',
    isoCode: 'SA',
  },
  {
    name: 'Nugal',
    value: 'SO',
    isoCode: 'NU',
  },
  {
    name: 'Lower Shebelle',
    value: 'SO',
    isoCode: 'SH',
  },
  {
    name: 'Middle Juba',
    value: 'SO',
    isoCode: 'JD',
  },
  {
    name: 'Middle Shebelle',
    value: 'SO',
    isoCode: 'SD',
  },
  {
    name: 'Lower Juba',
    value: 'SO',
    isoCode: 'JH',
  },
  {
    name: 'Awdal Region',
    value: 'SO',
    isoCode: 'AW',
  },
  {
    name: 'Bay',
    value: 'SO',
    isoCode: 'BY',
  },
  {
    name: 'Banaadir',
    value: 'SO',
    isoCode: 'BN',
  },
  {
    name: 'Gedo',
    value: 'SO',
    isoCode: 'GE',
  },
  {
    name: 'Togdheer Region',
    value: 'SO',
    isoCode: 'TO',
  },
  {
    name: 'Bari',
    value: 'SO',
    isoCode: 'BR',
  },
  {
    name: 'Northern Cape',
    value: 'ZA',
    isoCode: 'NC',
  },
  {
    name: 'Free State',
    value: 'ZA',
    isoCode: 'FS',
  },
  {
    name: 'Limpopo',
    value: 'ZA',
    isoCode: 'LP',
  },
  {
    name: 'North West',
    value: 'ZA',
    isoCode: 'NW',
  },
  {
    name: 'KwaZulu-Natal',
    value: 'ZA',
    isoCode: 'KZN',
  },
  {
    name: 'Gauteng',
    value: 'ZA',
    isoCode: 'GP',
  },
  {
    name: 'Mpumalanga',
    value: 'ZA',
    isoCode: 'MP',
  },
  {
    name: 'Eastern Cape',
    value: 'ZA',
    isoCode: 'EC',
  },
  {
    name: 'Western Cape',
    value: 'ZA',
    isoCode: 'WC',
  },
  {
    name: 'Chontales',
    value: 'NI',
    isoCode: 'CO',
  },
  {
    name: 'Managua',
    value: 'NI',
    isoCode: 'MN',
  },
  {
    name: 'Rivas',
    value: 'NI',
    isoCode: 'RI',
  },
  {
    name: 'Granada',
    value: 'NI',
    isoCode: 'GR',
  },
  {
    name: 'León',
    value: 'NI',
    isoCode: 'LE',
  },
  {
    name: 'Estelí',
    value: 'NI',
    isoCode: 'ES',
  },
  {
    name: 'Boaco',
    value: 'NI',
    isoCode: 'BO',
  },
  {
    name: 'Matagalpa',
    value: 'NI',
    isoCode: 'MT',
  },
  {
    name: 'Madriz',
    value: 'NI',
    isoCode: 'MD',
  },
  {
    name: 'Río San Juan',
    value: 'NI',
    isoCode: 'SJ',
  },
  {
    name: 'Carazo',
    value: 'NI',
    isoCode: 'CA',
  },
  {
    name: 'North Caribbean Coast',
    value: 'NI',
    isoCode: 'AN',
  },
  {
    name: 'South Caribbean Coast',
    value: 'NI',
    isoCode: 'AS',
  },
  {
    name: 'Masaya',
    value: 'NI',
    isoCode: 'MS',
  },
  {
    name: 'Chinandega',
    value: 'NI',
    isoCode: 'CI',
  },
  {
    name: 'Jinotega',
    value: 'NI',
    isoCode: 'JI',
  },
  {
    name: 'Nueva Segovia',
    value: 'NI',
    isoCode: 'NS',
  },
  {
    name: 'Karak Governorate',
    value: 'JO',
    isoCode: 'KA',
  },
  {
    name: 'Tafilah Governorate',
    value: 'JO',
    isoCode: 'AT',
  },
  {
    name: 'Madaba Governorate',
    value: 'JO',
    isoCode: 'MD',
  },
  {
    name: 'Aqaba Governorate',
    value: 'JO',
    isoCode: 'AQ',
  },
  {
    name: 'Irbid Governorate',
    value: 'JO',
    isoCode: 'IR',
  },
  {
    name: 'Balqa Governorate',
    value: 'JO',
    isoCode: 'BA',
  },
  {
    name: 'Mafraq Governorate',
    value: 'JO',
    isoCode: 'MA',
  },
  {
    name: 'Ajloun Governorate',
    value: 'JO',
    isoCode: 'AJ',
  },
  {
    name: "Ma'an Governorate",
    value: 'JO',
    isoCode: 'MN',
  },
  {
    name: 'Amman Governorate',
    value: 'JO',
    isoCode: 'AM',
  },
  {
    name: 'Jerash Governorate',
    value: 'JO',
    isoCode: 'JA',
  },
  {
    name: 'Zarqa Governorate',
    value: 'JO',
    isoCode: 'AZ',
  },
  {
    name: 'Manzini District',
    value: 'SZ',
    isoCode: 'MA',
  },
  {
    name: 'Hhohho District',
    value: 'SZ',
    isoCode: 'HH',
  },
  {
    name: 'Lubombo District',
    value: 'SZ',
    isoCode: 'LU',
  },
  {
    name: 'Shiselweni District',
    value: 'SZ',
    isoCode: 'SH',
  },
  {
    name: 'Al Jahra Governorate',
    value: 'KW',
    isoCode: 'JA',
  },
  {
    name: 'Hawalli Governorate',
    value: 'KW',
    isoCode: 'HA',
  },
  {
    name: 'Mubarak Al-Kabeer Governorate',
    value: 'KW',
    isoCode: 'MU',
  },
  {
    name: 'Al Farwaniyah Governorate',
    value: 'KW',
    isoCode: 'FA',
  },
  {
    name: 'Capital Governorate',
    value: 'KW',
    isoCode: 'KU',
  },
  {
    name: 'Al Ahmadi Governorate',
    value: 'KW',
    isoCode: 'AH',
  },
  {
    name: 'Luang Prabang Province',
    value: 'LA',
    isoCode: 'LP',
  },
  {
    name: 'Vientiane Prefecture',
    value: 'LA',
    isoCode: 'VT',
  },
  {
    name: 'Vientiane Province',
    value: 'LA',
    isoCode: 'VI',
  },
  {
    name: 'Salavan Province',
    value: 'LA',
    isoCode: 'SL',
  },
  {
    name: 'Attapeu Province',
    value: 'LA',
    isoCode: 'AT',
  },
  {
    name: 'Xaisomboun Province',
    value: 'LA',
    isoCode: 'XS',
  },
  {
    name: 'Sekong Province',
    value: 'LA',
    isoCode: 'XE',
  },
  {
    name: 'Bolikhamsai Province',
    value: 'LA',
    isoCode: 'BL',
  },
  {
    name: 'Khammouane Province',
    value: 'LA',
    isoCode: 'KH',
  },
  {
    name: 'Phongsaly Province',
    value: 'LA',
    isoCode: 'PH',
  },
  {
    name: 'Oudomxay Province',
    value: 'LA',
    isoCode: 'OU',
  },
  {
    name: 'Houaphanh Province',
    value: 'LA',
    isoCode: 'HO',
  },
  {
    name: 'Savannakhet Province',
    value: 'LA',
    isoCode: 'SV',
  },
  {
    name: 'Bokeo Province',
    value: 'LA',
    isoCode: 'BK',
  },
  {
    name: 'Luang Namtha Province',
    value: 'LA',
    isoCode: 'LM',
  },
  {
    name: 'Sainyabuli Province',
    value: 'LA',
    isoCode: 'XA',
  },
  {
    name: 'Xaisomboun',
    value: 'LA',
    isoCode: 'XN',
  },
  {
    name: 'Xiangkhouang Province',
    value: 'LA',
    isoCode: 'XI',
  },
  {
    name: 'Champasak Province',
    value: 'LA',
    isoCode: 'CH',
  },
  {
    name: 'Talas Region',
    value: 'KG',
    isoCode: 'T',
  },
  {
    name: 'Batken Region',
    value: 'KG',
    isoCode: 'B',
  },
  {
    name: 'Naryn Region',
    value: 'KG',
    isoCode: 'N',
  },
  {
    name: 'Jalal-Abad Region',
    value: 'KG',
    isoCode: 'J',
  },
  {
    name: 'Bishkek',
    value: 'KG',
    isoCode: 'GB',
  },
  {
    name: 'Issyk-Kul Region',
    value: 'KG',
    isoCode: 'Y',
  },
  {
    name: 'Osh',
    value: 'KG',
    isoCode: 'GO',
  },
  {
    name: 'Chuy Region',
    value: 'KG',
    isoCode: 'C',
  },
  {
    name: 'Osh Region',
    value: 'KG',
    isoCode: 'O',
  },
  {
    name: 'Trøndelag',
    value: 'NO',
    isoCode: '50',
  },
  {
    name: 'Oslo',
    value: 'NO',
    isoCode: '03',
  },
  {
    name: 'Vestfold',
    value: 'NO',
    isoCode: '07',
  },
  {
    name: 'Oppland',
    value: 'NO',
    isoCode: '05',
  },
  {
    name: 'Sør-Trøndelag',
    value: 'NO',
    isoCode: '16',
  },
  {
    name: 'Buskerud',
    value: 'NO',
    isoCode: '06',
  },
  {
    name: 'Nord-Trøndelag',
    value: 'NO',
    isoCode: '17',
  },
  {
    name: 'Svalbard',
    value: 'NO',
    isoCode: '21',
  },
  {
    name: 'Vest-Agder',
    value: 'NO',
    isoCode: '10',
  },
  {
    name: 'Troms',
    value: 'NO',
    isoCode: '19',
  },
  {
    name: 'Finnmark',
    value: 'NO',
    isoCode: '20',
  },
  {
    name: 'Akershus',
    value: 'NO',
    isoCode: '02',
  },
  {
    name: 'Sogn og Fjordane',
    value: 'NO',
    isoCode: '14',
  },
  {
    name: 'Hedmark',
    value: 'NO',
    isoCode: '04',
  },
  {
    name: 'Møre og Romsdal',
    value: 'NO',
    isoCode: '15',
  },
  {
    name: 'Rogaland',
    value: 'NO',
    isoCode: '11',
  },
  {
    name: 'Østfold',
    value: 'NO',
    isoCode: '01',
  },
  {
    name: 'Hordaland',
    value: 'NO',
    isoCode: '12',
  },
  {
    name: 'Telemark',
    value: 'NO',
    isoCode: '08',
  },
  {
    name: 'Nordland',
    value: 'NO',
    isoCode: '18',
  },
  {
    name: 'Jan Mayen',
    value: 'NO',
    isoCode: '22',
  },
  {
    name: 'Hódmezővásárhely',
    value: 'HU',
    isoCode: 'HV',
  },
  {
    name: 'Érd',
    value: 'HU',
    isoCode: 'ER',
  },
  {
    name: 'Szeged',
    value: 'HU',
    isoCode: 'SD',
  },
  {
    name: 'Nagykanizsa',
    value: 'HU',
    isoCode: 'NK',
  },
  {
    name: 'Csongrád County',
    value: 'HU',
    isoCode: 'CS',
  },
  {
    name: 'Debrecen',
    value: 'HU',
    isoCode: 'DE',
  },
  {
    name: 'Székesfehérvár',
    value: 'HU',
    isoCode: 'SF',
  },
  {
    name: 'Nyíregyháza',
    value: 'HU',
    isoCode: 'NY',
  },
  {
    name: 'Somogy County',
    value: 'HU',
    isoCode: 'SO',
  },
  {
    name: 'Békéscsaba',
    value: 'HU',
    isoCode: 'BC',
  },
  {
    name: 'Eger',
    value: 'HU',
    isoCode: 'EG',
  },
  {
    name: 'Tolna County',
    value: 'HU',
    isoCode: 'TO',
  },
  {
    name: 'Vas County',
    value: 'HU',
    isoCode: 'VA',
  },
  {
    name: 'Heves County',
    value: 'HU',
    isoCode: 'HE',
  },
  {
    name: 'Győr',
    value: 'HU',
    isoCode: 'GY',
  },
  {
    name: 'Győr-Moson-Sopron County',
    value: 'HU',
    isoCode: 'GS',
  },
  {
    name: 'Jász-Nagykun-Szolnok County',
    value: 'HU',
    isoCode: 'JN',
  },
  {
    name: 'Fejér County',
    value: 'HU',
    isoCode: 'FE',
  },
  {
    name: 'Szabolcs-Szatmár-Bereg County',
    value: 'HU',
    isoCode: 'SZ',
  },
  {
    name: 'Zala County',
    value: 'HU',
    isoCode: 'ZA',
  },
  {
    name: 'Szolnok',
    value: 'HU',
    isoCode: 'SK',
  },
  {
    name: 'Bács-Kiskun County',
    value: 'HU',
    isoCode: 'BK',
  },
  {
    name: 'Dunaújváros',
    value: 'HU',
    isoCode: 'DU',
  },
  {
    name: 'Zalaegerszeg',
    value: 'HU',
    isoCode: 'ZE',
  },
  {
    name: 'Nógrád County',
    value: 'HU',
    isoCode: 'NO',
  },
  {
    name: 'Szombathely',
    value: 'HU',
    isoCode: 'SH',
  },
  {
    name: 'Pécs',
    value: 'HU',
    isoCode: 'PS',
  },
  {
    name: 'Veszprém County',
    value: 'HU',
    isoCode: 'VE',
  },
  {
    name: 'Baranya County',
    value: 'HU',
    isoCode: 'BA',
  },
  {
    name: 'Kecskemét',
    value: 'HU',
    isoCode: 'KM',
  },
  {
    name: 'Sopron',
    value: 'HU',
    isoCode: 'SN',
  },
  {
    name: 'Borsod-Abaúj-Zemplén County',
    value: 'HU',
    isoCode: 'BZ',
  },
  {
    name: 'Pest County',
    value: 'HU',
    isoCode: 'PE',
  },
  {
    name: 'Békés County',
    value: 'HU',
    isoCode: 'BE',
  },
  {
    name: 'Szekszárd',
    value: 'HU',
    isoCode: 'SS',
  },
  {
    name: 'Veszprém',
    value: 'HU',
    isoCode: 'VM',
  },
  {
    name: 'Hajdú-Bihar County',
    value: 'HU',
    isoCode: 'HB',
  },
  {
    name: 'Budapest',
    value: 'HU',
    isoCode: 'BU',
  },
  {
    name: 'Miskolc',
    value: 'HU',
    isoCode: 'MI',
  },
  {
    name: 'Tatabánya',
    value: 'HU',
    isoCode: 'TB',
  },
  {
    name: 'Kaposvár',
    value: 'HU',
    isoCode: 'KV',
  },
  {
    name: 'Salgótarján',
    value: 'HU',
    isoCode: 'ST',
  },
  {
    name: 'Tipperary',
    value: 'IE',
    isoCode: 'TA',
  },
  {
    name: 'Sligo',
    value: 'IE',
    isoCode: 'SO',
  },
  {
    name: 'Donegal',
    value: 'IE',
    isoCode: 'DL',
  },
  {
    name: 'Dublin',
    value: 'IE',
    isoCode: 'D',
  },
  {
    name: 'Leinster',
    value: 'IE',
    isoCode: 'L',
  },
  {
    name: 'Cork',
    value: 'IE',
    isoCode: 'CO',
  },
  {
    name: 'Monaghan',
    value: 'IE',
    isoCode: 'MN',
  },
  {
    name: 'Longford',
    value: 'IE',
    isoCode: 'LD',
  },
  {
    name: 'Kerry',
    value: 'IE',
    isoCode: 'KY',
  },
  {
    name: 'Offaly',
    value: 'IE',
    isoCode: 'OY',
  },
  {
    name: 'Galway',
    value: 'IE',
    isoCode: 'G',
  },
  {
    name: 'Munster',
    value: 'IE',
    isoCode: 'M',
  },
  {
    name: 'Roscommon',
    value: 'IE',
    isoCode: 'RN',
  },
  {
    name: 'Kildare',
    value: 'IE',
    isoCode: 'KE',
  },
  {
    name: 'Louth',
    value: 'IE',
    isoCode: 'LH',
  },
  {
    name: 'Mayo',
    value: 'IE',
    isoCode: 'MO',
  },
  {
    name: 'Wicklow',
    value: 'IE',
    isoCode: 'WW',
  },
  {
    name: 'Ulster',
    value: 'IE',
    isoCode: 'U',
  },
  {
    name: 'Connacht',
    value: 'IE',
    isoCode: 'C',
  },
  {
    name: 'Cavan',
    value: 'IE',
    isoCode: 'CN',
  },
  {
    name: 'Waterford',
    value: 'IE',
    isoCode: 'WD',
  },
  {
    name: 'Kilkenny',
    value: 'IE',
    isoCode: 'KK',
  },
  {
    name: 'Clare',
    value: 'IE',
    isoCode: 'CE',
  },
  {
    name: 'Meath',
    value: 'IE',
    isoCode: 'MH',
  },
  {
    name: 'Wexford',
    value: 'IE',
    isoCode: 'WX',
  },
  {
    name: 'Limerick',
    value: 'IE',
    isoCode: 'LK',
  },
  {
    name: 'Carlow',
    value: 'IE',
    isoCode: 'CW',
  },
  {
    name: 'Laois',
    value: 'IE',
    isoCode: 'LS',
  },
  {
    name: 'Westmeath',
    value: 'IE',
    isoCode: 'WH',
  },
  {
    name: 'Djelfa',
    value: 'DZ',
    isoCode: '17',
  },
  {
    name: 'El Oued',
    value: 'DZ',
    isoCode: '39',
  },
  {
    name: 'El Tarf',
    value: 'DZ',
    isoCode: '36',
  },
  {
    name: 'Oran',
    value: 'DZ',
    isoCode: '31',
  },
  {
    name: 'Naama',
    value: 'DZ',
    isoCode: '45',
  },
  {
    name: 'Annaba',
    value: 'DZ',
    isoCode: '23',
  },
  {
    name: 'Bouïra',
    value: 'DZ',
    isoCode: '10',
  },
  {
    name: 'Chlef',
    value: 'DZ',
    isoCode: '02',
  },
  {
    name: 'Tiaret',
    value: 'DZ',
    isoCode: '14',
  },
  {
    name: 'Tlemcen',
    value: 'DZ',
    isoCode: '13',
  },
  {
    name: 'Béchar',
    value: 'DZ',
    isoCode: '08',
  },
  {
    name: 'Médéa',
    value: 'DZ',
    isoCode: '26',
  },
  {
    name: 'Skikda',
    value: 'DZ',
    isoCode: '21',
  },
  {
    name: 'Blida',
    value: 'DZ',
    isoCode: '09',
  },
  {
    name: 'Illizi',
    value: 'DZ',
    isoCode: '33',
  },
  {
    name: 'Jijel',
    value: 'DZ',
    isoCode: '18',
  },
  {
    name: 'Biskra',
    value: 'DZ',
    isoCode: '07',
  },
  {
    name: 'Tipasa',
    value: 'DZ',
    isoCode: '42',
  },
  {
    name: 'Bordj Bou Arréridj',
    value: 'DZ',
    isoCode: '34',
  },
  {
    name: 'Tébessa',
    value: 'DZ',
    isoCode: '12',
  },
  {
    name: 'Adrar',
    value: 'DZ',
    isoCode: '01',
  },
  {
    name: 'Aïn Defla',
    value: 'DZ',
    isoCode: '44',
  },
  {
    name: 'Tindouf',
    value: 'DZ',
    isoCode: '37',
  },
  {
    name: 'Constantine',
    value: 'DZ',
    isoCode: '25',
  },
  {
    name: 'Aïn Témouchent',
    value: 'DZ',
    isoCode: '46',
  },
  {
    name: 'Saïda',
    value: 'DZ',
    isoCode: '20',
  },
  {
    name: 'Mascara',
    value: 'DZ',
    isoCode: '29',
  },
  {
    name: 'Boumerdès',
    value: 'DZ',
    isoCode: '35',
  },
  {
    name: 'Khenchela',
    value: 'DZ',
    isoCode: '40',
  },
  {
    name: 'Ghardaïa',
    value: 'DZ',
    isoCode: '47',
  },
  {
    name: 'Béjaïa',
    value: 'DZ',
    isoCode: '06',
  },
  {
    name: 'El Bayadh',
    value: 'DZ',
    isoCode: '32',
  },
  {
    name: 'Relizane',
    value: 'DZ',
    isoCode: '48',
  },
  {
    name: 'Tizi Ouzou',
    value: 'DZ',
    isoCode: '15',
  },
  {
    name: 'Mila',
    value: 'DZ',
    isoCode: '43',
  },
  {
    name: 'Tissemsilt',
    value: 'DZ',
    isoCode: '38',
  },
  {
    name: "M'Sila",
    value: 'DZ',
    isoCode: '28',
  },
  {
    name: 'Tamanghasset',
    value: 'DZ',
    isoCode: '11',
  },
  {
    name: 'Oum El Bouaghi',
    value: 'DZ',
    isoCode: '04',
  },
  {
    name: 'Guelma',
    value: 'DZ',
    isoCode: '24',
  },
  {
    name: 'Laghouat',
    value: 'DZ',
    isoCode: '03',
  },
  {
    name: 'Ouargla',
    value: 'DZ',
    isoCode: '30',
  },
  {
    name: 'Mostaganem',
    value: 'DZ',
    isoCode: '27',
  },
  {
    name: 'Sétif',
    value: 'DZ',
    isoCode: '19',
  },
  {
    name: 'Batna',
    value: 'DZ',
    isoCode: '05',
  },
  {
    name: 'Souk Ahras',
    value: 'DZ',
    isoCode: '41',
  },
  {
    name: 'Algiers',
    value: 'DZ',
    isoCode: '16',
  },
  {
    name: 'Sidi Bel Abbès',
    value: 'DZ',
    isoCode: '22',
  },
  {
    name: "El M'ghair",
    value: 'DZ',
    isoCode: '49',
  },
  {
    name: 'El Menia',
    value: 'DZ',
    isoCode: '50',
  },
  {
    name: 'Ouled Djellal',
    value: 'DZ',
    isoCode: '51',
  },
  {
    name: 'Bordj Baji Mokhtar',
    value: 'DZ',
    isoCode: '52',
  },
  {
    name: 'Béni Abbès',
    value: 'DZ',
    isoCode: '53',
  },
  {
    name: 'Timimoun',
    value: 'DZ',
    isoCode: '54',
  },
  {
    name: 'Touggourt',
    value: 'DZ',
    isoCode: '55',
  },
  {
    name: 'Djanet',
    value: 'DZ',
    isoCode: '56',
  },
  {
    name: 'In Salah',
    value: 'DZ',
    isoCode: '57',
  },
  {
    name: 'In Guezzam',
    value: 'DZ',
    isoCode: '58',
  },
  {
    name: 'Burgos Province',
    value: 'ES',
    isoCode: 'BU',
  },
  {
    name: 'Salamanca Province',
    value: 'ES',
    isoCode: 'SA',
  },
  {
    name: 'Palencia Province',
    value: 'ES',
    isoCode: 'P',
  },
  {
    name: 'Madrid',
    value: 'ES',
    isoCode: 'MD',
  },
  {
    name: 'Melilla',
    value: 'ES',
    isoCode: 'ML',
  },
  {
    name: 'Asturias',
    value: 'ES',
    isoCode: 'AS',
  },
  {
    name: 'Zamora Province',
    value: 'ES',
    isoCode: 'ZA',
  },
  {
    name: 'Galicia',
    value: 'ES',
    isoCode: 'GA',
  },
  {
    name: 'Cantabria',
    value: 'ES',
    isoCode: 'CB',
  },
  {
    name: 'La Rioja',
    value: 'ES',
    isoCode: 'RI',
  },
  {
    name: 'Balearic Islands',
    value: 'ES',
    isoCode: 'PM',
  },
  {
    name: 'Valencia',
    value: 'ES',
    isoCode: 'VC',
  },
  {
    name: 'Murcia',
    value: 'ES',
    isoCode: 'MC',
  },
  {
    name: 'Aragon',
    value: 'ES',
    isoCode: 'AR',
  },
  {
    name: 'Valladolid Province',
    value: 'ES',
    isoCode: 'VA',
  },
  {
    name: 'Castile and León',
    value: 'ES',
    isoCode: 'CL',
  },
  {
    name: 'Canary Islands',
    value: 'ES',
    isoCode: 'CN',
  },
  {
    name: 'Ávila',
    value: 'ES',
    isoCode: 'AV',
  },
  {
    name: 'Extremadura',
    value: 'ES',
    isoCode: 'EX',
  },
  {
    name: 'Basque Country',
    value: 'ES',
    isoCode: 'PV',
  },
  {
    name: 'Segovia Province',
    value: 'ES',
    isoCode: 'SG',
  },
  {
    name: 'Andalusia',
    value: 'ES',
    isoCode: 'AN',
  },
  {
    name: 'Léon',
    value: 'ES',
    isoCode: 'LE',
  },
  {
    name: 'Catalonia',
    value: 'ES',
    isoCode: 'CT',
  },
  {
    name: 'Navarra',
    value: 'ES',
    isoCode: 'NC',
  },
  {
    name: 'Castilla La Mancha',
    value: 'ES',
    isoCode: 'CM',
  },
  {
    name: 'Ceuta',
    value: 'ES',
    isoCode: 'CE',
  },
  {
    name: 'Soria Province',
    value: 'ES',
    isoCode: 'SO',
  },
  {
    name: 'Guanacaste Province',
    value: 'CR',
    isoCode: 'G',
  },
  {
    name: 'Puntarenas Province',
    value: 'CR',
    isoCode: 'P',
  },
  {
    name: 'Provincia de Cartago',
    value: 'CR',
    isoCode: 'C',
  },
  {
    name: 'Heredia Province',
    value: 'CR',
    isoCode: 'H',
  },
  {
    name: 'Limón Province',
    value: 'CR',
    isoCode: 'L',
  },
  {
    name: 'San José Province',
    value: 'CR',
    isoCode: 'SJ',
  },
  {
    name: 'Alajuela Province',
    value: 'CR',
    isoCode: 'A',
  },
  {
    name: 'Brunei-Muara District',
    value: 'BN',
    isoCode: 'BM',
  },
  {
    name: 'Belait District',
    value: 'BN',
    isoCode: 'BE',
  },
  {
    name: 'Temburong District',
    value: 'BN',
    isoCode: 'TE',
  },
  {
    name: 'Tutong District',
    value: 'BN',
    isoCode: 'TU',
  },
  {
    name: 'Saint Philip',
    value: 'BB',
    isoCode: '10',
  },
  {
    name: 'Saint Lucy',
    value: 'BB',
    isoCode: '07',
  },
  {
    name: 'Saint Peter',
    value: 'BB',
    isoCode: '09',
  },
  {
    name: 'Saint Joseph',
    value: 'BB',
    isoCode: '06',
  },
  {
    name: 'Saint James',
    value: 'BB',
    isoCode: '04',
  },
  {
    name: 'Saint Thomas',
    value: 'BB',
    isoCode: '11',
  },
  {
    name: 'Saint George',
    value: 'BB',
    isoCode: '03',
  },
  {
    name: 'Saint John',
    value: 'BB',
    isoCode: '05',
  },
  {
    name: 'Christ Church',
    value: 'BB',
    isoCode: '01',
  },
  {
    name: 'Saint Andrew',
    value: 'BB',
    isoCode: '02',
  },
  {
    name: 'Saint Michael',
    value: 'BB',
    isoCode: '08',
  },
  {
    name: "Ta'izz Governorate",
    value: 'YE',
    isoCode: 'TA',
  },
  {
    name: "Sana'a",
    value: 'YE',
    isoCode: 'SA',
  },
  {
    name: 'Ibb Governorate',
    value: 'YE',
    isoCode: 'IB',
  },
  {
    name: "Ma'rib Governorate",
    value: 'YE',
    isoCode: 'MA',
  },
  {
    name: 'Al Mahwit Governorate',
    value: 'YE',
    isoCode: 'MW',
  },
  {
    name: "Sana'a Governorate",
    value: 'YE',
    isoCode: 'SN',
  },
  {
    name: 'Abyan Governorate',
    value: 'YE',
    isoCode: 'AB',
  },
  {
    name: 'Hadhramaut Governorate',
    value: 'YE',
    isoCode: 'HD',
  },
  {
    name: 'Socotra Governorate',
    value: 'YE',
    isoCode: 'SU',
  },
  {
    name: "Al Bayda' Governorate",
    value: 'YE',
    isoCode: 'BA',
  },
  {
    name: 'Al Hudaydah Governorate',
    value: 'YE',
    isoCode: 'HU',
  },
  {
    name: "'Adan Governorate",
    value: 'YE',
    isoCode: 'AD',
  },
  {
    name: 'Al Jawf Governorate',
    value: 'YE',
    isoCode: 'JA',
  },
  {
    name: 'Hajjah Governorate',
    value: 'YE',
    isoCode: 'HJ',
  },
  {
    name: 'Lahij Governorate',
    value: 'YE',
    isoCode: 'LA',
  },
  {
    name: 'Dhamar Governorate',
    value: 'YE',
    isoCode: 'DH',
  },
  {
    name: 'Shabwah Governorate',
    value: 'YE',
    isoCode: 'SH',
  },
  {
    name: 'Raymah Governorate',
    value: 'YE',
    isoCode: 'RA',
  },
  {
    name: 'Saada Governorate',
    value: 'YE',
    isoCode: 'SD',
  },
  {
    name: "'Amran Governorate",
    value: 'YE',
    isoCode: 'AM',
  },
  {
    name: 'Al Mahrah Governorate',
    value: 'YE',
    isoCode: 'MR',
  },
  {
    name: 'Sangha-Mbaéré',
    value: 'CF',
    isoCode: 'SE',
  },
  {
    name: 'Nana-Grébizi Economic Prefecture',
    value: 'CF',
    isoCode: 'KB',
  },
  {
    name: 'Ouham Prefecture',
    value: 'CF',
    isoCode: 'AC',
  },
  {
    name: "Ombella-M'Poko Prefecture",
    value: 'CF',
    isoCode: 'MP',
  },
  {
    name: 'Lobaye Prefecture',
    value: 'CF',
    isoCode: 'LB',
  },
  {
    name: 'Mambéré-Kadéï',
    value: 'CF',
    isoCode: 'HS',
  },
  {
    name: 'Haut-Mbomou Prefecture',
    value: 'CF',
    isoCode: 'HM',
  },
  {
    name: 'Bamingui-Bangoran Prefecture',
    value: 'CF',
    isoCode: 'BB',
  },
  {
    name: 'Nana-Mambéré Prefecture',
    value: 'CF',
    isoCode: 'NM',
  },
  {
    name: 'Vakaga Prefecture',
    value: 'CF',
    isoCode: 'VK',
  },
  {
    name: 'Bangui',
    value: 'CF',
    isoCode: 'BGF',
  },
  {
    name: 'Kémo Prefecture',
    value: 'CF',
    isoCode: 'KG',
  },
  {
    name: 'Basse-Kotto Prefecture',
    value: 'CF',
    isoCode: 'BK',
  },
  {
    name: 'Ouaka Prefecture',
    value: 'CF',
    isoCode: 'UK',
  },
  {
    name: 'Mbomou Prefecture',
    value: 'CF',
    isoCode: 'MB',
  },
  {
    name: 'Ouham-Pendé Prefecture',
    value: 'CF',
    isoCode: 'OP',
  },
  {
    name: 'Haute-Kotto Prefecture',
    value: 'CF',
    isoCode: 'HK',
  },
  {
    name: 'Romblon',
    value: 'PH',
    isoCode: 'ROM',
  },
  {
    name: 'Bukidnon',
    value: 'PH',
    isoCode: 'BUK',
  },
  {
    name: 'Rizal',
    value: 'PH',
    isoCode: 'RIZ',
  },
  {
    name: 'Bohol',
    value: 'PH',
    isoCode: 'BOH',
  },
  {
    name: 'Quirino',
    value: 'PH',
    isoCode: 'QUI',
  },
  {
    name: 'Biliran',
    value: 'PH',
    isoCode: 'BIL',
  },
  {
    name: 'Quezon',
    value: 'PH',
    isoCode: 'QUE',
  },
  {
    name: 'Siquijor',
    value: 'PH',
    isoCode: 'SIG',
  },
  {
    name: 'Sarangani',
    value: 'PH',
    isoCode: 'SAR',
  },
  {
    name: 'Bulacan',
    value: 'PH',
    isoCode: 'BUL',
  },
  {
    name: 'Cagayan',
    value: 'PH',
    isoCode: 'CAG',
  },
  {
    name: 'South Cotabato',
    value: 'PH',
    isoCode: 'SCO',
  },
  {
    name: 'Sorsogon',
    value: 'PH',
    isoCode: 'SOR',
  },
  {
    name: 'Sultan Kudarat',
    value: 'PH',
    isoCode: 'SUK',
  },
  {
    name: 'Camarines Norte',
    value: 'PH',
    isoCode: 'CAN',
  },
  {
    name: 'Southern Leyte',
    value: 'PH',
    isoCode: 'SLE',
  },
  {
    name: 'Camiguin',
    value: 'PH',
    isoCode: 'CAM',
  },
  {
    name: 'Surigao del Norte',
    value: 'PH',
    isoCode: 'SUN',
  },
  {
    name: 'Camarines Sur',
    value: 'PH',
    isoCode: 'CAS',
  },
  {
    name: 'Sulu',
    value: 'PH',
    isoCode: 'SLU',
  },
  {
    name: 'Davao Oriental',
    value: 'PH',
    isoCode: 'DAO',
  },
  {
    name: 'Eastern Samar',
    value: 'PH',
    isoCode: 'EAS',
  },
  {
    name: 'Dinagat Islands',
    value: 'PH',
    isoCode: 'DIN',
  },
  {
    name: 'Capiz',
    value: 'PH',
    isoCode: 'CAP',
  },
  {
    name: 'Tawi-Tawi',
    value: 'PH',
    isoCode: 'TAW',
  },
  {
    name: 'Calabarzon',
    value: 'PH',
    isoCode: '40',
  },
  {
    name: 'Tarlac',
    value: 'PH',
    isoCode: 'TAR',
  },
  {
    name: 'Surigao del Sur',
    value: 'PH',
    isoCode: 'SUR',
  },
  {
    name: 'Zambales',
    value: 'PH',
    isoCode: 'ZMB',
  },
  {
    name: 'Ilocos Norte',
    value: 'PH',
    isoCode: 'ILN',
  },
  {
    name: 'Mimaropa',
    value: 'PH',
    isoCode: '41',
  },
  {
    name: 'Ifugao',
    value: 'PH',
    isoCode: 'IFU',
  },
  {
    name: 'Catanduanes',
    value: 'PH',
    isoCode: 'CAT',
  },
  {
    name: 'Zamboanga del Norte',
    value: 'PH',
    isoCode: 'ZAN',
  },
  {
    name: 'Guimaras',
    value: 'PH',
    isoCode: 'GUI',
  },
  {
    name: 'Bicol Region',
    value: 'PH',
    isoCode: '05',
  },
  {
    name: 'Western Visayas',
    value: 'PH',
    isoCode: '06',
  },
  {
    name: 'Cebu',
    value: 'PH',
    isoCode: 'CEB',
  },
  {
    name: 'Cavite',
    value: 'PH',
    isoCode: 'CAV',
  },
  {
    name: 'Central Visayas',
    value: 'PH',
    isoCode: '07',
  },
  {
    name: 'Davao Occidental',
    value: 'PH',
    isoCode: 'DVO',
  },
  {
    name: 'Soccsksargen',
    value: 'PH',
    isoCode: '12',
  },
  {
    name: 'Compostela Valley',
    value: 'PH',
    isoCode: 'COM',
  },
  {
    name: 'Kalinga',
    value: 'PH',
    isoCode: 'KAL',
  },
  {
    name: 'Isabela',
    value: 'PH',
    isoCode: 'ISA',
  },
  {
    name: 'Caraga',
    value: 'PH',
    isoCode: '13',
  },
  {
    name: 'Iloilo',
    value: 'PH',
    isoCode: 'ILI',
  },
  {
    name: 'Autonomous Region in Muslim Mindanao',
    value: 'PH',
    isoCode: '14',
  },
  {
    name: 'La Union',
    value: 'PH',
    isoCode: 'LUN',
  },
  {
    name: 'Davao del Sur',
    value: 'PH',
    isoCode: 'DAS',
  },
  {
    name: 'Davao del Norte',
    value: 'PH',
    isoCode: 'DAV',
  },
  {
    name: 'Cotabato',
    value: 'PH',
    isoCode: 'NCO',
  },
  {
    name: 'Ilocos Sur',
    value: 'PH',
    isoCode: 'ILS',
  },
  {
    name: 'Eastern Visayas',
    value: 'PH',
    isoCode: '08',
  },
  {
    name: 'Agusan del Norte',
    value: 'PH',
    isoCode: 'AGN',
  },
  {
    name: 'Abra',
    value: 'PH',
    isoCode: 'ABR',
  },
  {
    name: 'Zamboanga Peninsula',
    value: 'PH',
    isoCode: '09',
  },
  {
    name: 'Agusan del Sur',
    value: 'PH',
    isoCode: 'AGS',
  },
  {
    name: 'Lanao del Norte',
    value: 'PH',
    isoCode: 'LAN',
  },
  {
    name: 'Laguna',
    value: 'PH',
    isoCode: 'LAG',
  },
  {
    name: 'Marinduque',
    value: 'PH',
    isoCode: 'MAD',
  },
  {
    name: 'Maguindanao',
    value: 'PH',
    isoCode: 'MAG',
  },
  {
    name: 'Aklan',
    value: 'PH',
    isoCode: 'AKL',
  },
  {
    name: 'Leyte',
    value: 'PH',
    isoCode: 'LEY',
  },
  {
    name: 'Lanao del Sur',
    value: 'PH',
    isoCode: 'LAS',
  },
  {
    name: 'Apayao',
    value: 'PH',
    isoCode: 'APA',
  },
  {
    name: 'Cordillera Administrative Region',
    value: 'PH',
    isoCode: '15',
  },
  {
    name: 'Antique',
    value: 'PH',
    isoCode: 'ANT',
  },
  {
    name: 'Albay',
    value: 'PH',
    isoCode: 'ALB',
  },
  {
    name: 'Masbate',
    value: 'PH',
    isoCode: 'MAS',
  },
  {
    name: 'Northern Mindanao',
    value: 'PH',
    isoCode: '10',
  },
  {
    name: 'Davao Region',
    value: 'PH',
    isoCode: '11',
  },
  {
    name: 'Aurora',
    value: 'PH',
    isoCode: 'AUR',
  },
  {
    name: 'Cagayan Valley',
    value: 'PH',
    isoCode: '02',
  },
  {
    name: 'Misamis Occidental',
    value: 'PH',
    isoCode: 'MSC',
  },
  {
    name: 'Bataan',
    value: 'PH',
    isoCode: 'BAN',
  },
  {
    name: 'Central Luzon',
    value: 'PH',
    isoCode: '03',
  },
  {
    name: 'Basilan',
    value: 'PH',
    isoCode: 'BAS',
  },
  {
    name: 'Metro Manila',
    value: 'PH',
    isoCode: 'NCR',
  },
  {
    name: 'Misamis Oriental',
    value: 'PH',
    isoCode: 'MSR',
  },
  {
    name: 'Northern Samar',
    value: 'PH',
    isoCode: 'NSA',
  },
  {
    name: 'Negros Oriental',
    value: 'PH',
    isoCode: 'NER',
  },
  {
    name: 'Negros Occidental',
    value: 'PH',
    isoCode: 'NEC',
  },
  {
    name: 'Batanes',
    value: 'PH',
    isoCode: 'BTN',
  },
  {
    name: 'Mountain Province',
    value: 'PH',
    isoCode: 'MOU',
  },
  {
    name: 'Oriental Mindoro',
    value: 'PH',
    isoCode: 'MDR',
  },
  {
    name: 'Ilocos Region',
    value: 'PH',
    isoCode: '01',
  },
  {
    name: 'Occidental Mindoro',
    value: 'PH',
    isoCode: 'MDC',
  },
  {
    name: 'Zamboanga del Sur',
    value: 'PH',
    isoCode: 'ZAS',
  },
  {
    name: 'Nueva Vizcaya',
    value: 'PH',
    isoCode: 'NUV',
  },
  {
    name: 'Batangas',
    value: 'PH',
    isoCode: 'BTG',
  },
  {
    name: 'Nueva Ecija',
    value: 'PH',
    isoCode: 'NUE',
  },
  {
    name: 'Palawan',
    value: 'PH',
    isoCode: 'PLW',
  },
  {
    name: 'Zamboanga Sibugay',
    value: 'PH',
    isoCode: 'ZSI',
  },
  {
    name: 'Benguet',
    value: 'PH',
    isoCode: 'BEN',
  },
  {
    name: 'Pangasinan',
    value: 'PH',
    isoCode: 'PAN',
  },
  {
    name: 'Pampanga',
    value: 'PH',
    isoCode: 'PAM',
  },
  {
    name: 'Northern District',
    value: 'IL',
    isoCode: 'Z',
  },
  {
    name: 'Central District',
    value: 'IL',
    isoCode: 'M',
  },
  {
    name: 'Southern District',
    value: 'IL',
    isoCode: 'D',
  },
  {
    name: 'Haifa District',
    value: 'IL',
    isoCode: 'HA',
  },
  {
    name: 'Jerusalem District',
    value: 'IL',
    isoCode: 'JM',
  },
  {
    name: 'Tel Aviv District',
    value: 'IL',
    isoCode: 'TA',
  },
  {
    name: 'Limburg',
    value: 'BE',
    isoCode: 'VLI',
  },
  {
    name: 'Flanders',
    value: 'BE',
    isoCode: 'VLG',
  },
  {
    name: 'Flemish Brabant',
    value: 'BE',
    isoCode: 'VBR',
  },
  {
    name: 'Hainaut',
    value: 'BE',
    isoCode: 'WHT',
  },
  {
    name: 'Brussels-Capital Region',
    value: 'BE',
    isoCode: 'BRU',
  },
  {
    name: 'East Flanders',
    value: 'BE',
    isoCode: 'VOV',
  },
  {
    name: 'Namur',
    value: 'BE',
    isoCode: 'WNA',
  },
  {
    name: 'Luxembourg',
    value: 'BE',
    isoCode: 'WLX',
  },
  {
    name: 'Wallonia',
    value: 'BE',
    isoCode: 'WAL',
  },
  {
    name: 'Antwerp',
    value: 'BE',
    isoCode: 'VAN',
  },
  {
    name: 'Walloon Brabant',
    value: 'BE',
    isoCode: 'WBR',
  },
  {
    name: 'West Flanders',
    value: 'BE',
    isoCode: 'VWV',
  },
  {
    name: 'Liège',
    value: 'BE',
    isoCode: 'WLG',
  },
  {
    name: 'Darién Province',
    value: 'PA',
    isoCode: '5',
  },
  {
    name: 'Colón Province',
    value: 'PA',
    isoCode: '3',
  },
  {
    name: 'Coclé Province',
    value: 'PA',
    isoCode: '2',
  },
  {
    name: 'Guna Yala',
    value: 'PA',
    isoCode: 'KY',
  },
  {
    name: 'Herrera Province',
    value: 'PA',
    isoCode: '6',
  },
  {
    name: 'Los Santos Province',
    value: 'PA',
    isoCode: '7',
  },
  {
    name: 'Ngöbe-Buglé Comarca',
    value: 'PA',
    isoCode: 'NB',
  },
  {
    name: 'Veraguas Province',
    value: 'PA',
    isoCode: '9',
  },
  {
    name: 'Bocas del Toro Province',
    value: 'PA',
    isoCode: '1',
  },
  {
    name: 'Panamá Oeste Province',
    value: 'PA',
    isoCode: '10',
  },
  {
    name: 'Panamá Province',
    value: 'PA',
    isoCode: '8',
  },
  {
    name: 'Emberá-Wounaan Comarca',
    value: 'PA',
    isoCode: 'EM',
  },
  {
    name: 'Chiriquí Province',
    value: 'PA',
    isoCode: '4',
  },
  {
    name: 'Howland Island',
    value: 'US',
    isoCode: 'UM-84',
  },
  {
    name: 'Delaware',
    value: 'US',
    isoCode: 'DE',
  },
  {
    name: 'Alaska',
    value: 'US',
    isoCode: 'AK',
  },
  {
    name: 'Maryland',
    value: 'US',
    isoCode: 'MD',
  },
  {
    name: 'Baker Island',
    value: 'US',
    isoCode: 'UM-81',
  },
  {
    name: 'Kingman Reef',
    value: 'US',
    isoCode: 'UM-89',
  },
  {
    name: 'New Hampshire',
    value: 'US',
    isoCode: 'NH',
  },
  {
    name: 'Wake Island',
    value: 'US',
    isoCode: 'UM-79',
  },
  {
    name: 'Kansas',
    value: 'US',
    isoCode: 'KS',
  },
  {
    name: 'Texas',
    value: 'US',
    isoCode: 'TX',
  },
  {
    name: 'Nebraska',
    value: 'US',
    isoCode: 'NE',
  },
  {
    name: 'Vermont',
    value: 'US',
    isoCode: 'VT',
  },
  {
    name: 'Jarvis Island',
    value: 'US',
    isoCode: 'UM-86',
  },
  {
    name: 'Hawaii',
    value: 'US',
    isoCode: 'HI',
  },
  {
    name: 'Guam',
    value: 'US',
    isoCode: 'GU',
  },
  {
    name: 'United States Virgin Islands',
    value: 'US',
    isoCode: 'VI',
  },
  {
    name: 'Utah',
    value: 'US',
    isoCode: 'UT',
  },
  {
    name: 'Oregon',
    value: 'US',
    isoCode: 'OR',
  },
  {
    name: 'California',
    value: 'US',
    isoCode: 'CA',
  },
  {
    name: 'New Jersey',
    value: 'US',
    isoCode: 'NJ',
  },
  {
    name: 'North Dakota',
    value: 'US',
    isoCode: 'ND',
  },
  {
    name: 'Kentucky',
    value: 'US',
    isoCode: 'KY',
  },
  {
    name: 'Minnesota',
    value: 'US',
    isoCode: 'MN',
  },
  {
    name: 'Oklahoma',
    value: 'US',
    isoCode: 'OK',
  },
  {
    name: 'Pennsylvania',
    value: 'US',
    isoCode: 'PA',
  },
  {
    name: 'New Mexico',
    value: 'US',
    isoCode: 'NM',
  },
  {
    name: 'American Samoa',
    value: 'US',
    isoCode: 'AS',
  },
  {
    name: 'Illinois',
    value: 'US',
    isoCode: 'IL',
  },
  {
    name: 'Michigan',
    value: 'US',
    isoCode: 'MI',
  },
  {
    name: 'Virginia',
    value: 'US',
    isoCode: 'VA',
  },
  {
    name: 'Johnston Atoll',
    value: 'US',
    isoCode: 'UM-67',
  },
  {
    name: 'West Virginia',
    value: 'US',
    isoCode: 'WV',
  },
  {
    name: 'Mississippi',
    value: 'US',
    isoCode: 'MS',
  },
  {
    name: 'Northern Mariana Islands',
    value: 'US',
    isoCode: 'MP',
  },
  {
    name: 'United States Minor Outlying Islands',
    value: 'US',
    isoCode: 'UM',
  },
  {
    name: 'Massachusetts',
    value: 'US',
    isoCode: 'MA',
  },
  {
    name: 'Arizona',
    value: 'US',
    isoCode: 'AZ',
  },
  {
    name: 'Connecticut',
    value: 'US',
    isoCode: 'CT',
  },
  {
    name: 'Florida',
    value: 'US',
    isoCode: 'FL',
  },
  {
    name: 'District of Columbia',
    value: 'US',
    isoCode: 'DC',
  },
  {
    name: 'Midway Atoll',
    value: 'US',
    isoCode: 'UM-71',
  },
  {
    name: 'Navassa Island',
    value: 'US',
    isoCode: 'UM-76',
  },
  {
    name: 'Indiana',
    value: 'US',
    isoCode: 'IN',
  },
  {
    name: 'Wisconsin',
    value: 'US',
    isoCode: 'WI',
  },
  {
    name: 'Wyoming',
    value: 'US',
    isoCode: 'WY',
  },
  {
    name: 'South Carolina',
    value: 'US',
    isoCode: 'SC',
  },
  {
    name: 'Arkansas',
    value: 'US',
    isoCode: 'AR',
  },
  {
    name: 'South Dakota',
    value: 'US',
    isoCode: 'SD',
  },
  {
    name: 'Montana',
    value: 'US',
    isoCode: 'MT',
  },
  {
    name: 'North Carolina',
    value: 'US',
    isoCode: 'NC',
  },
  {
    name: 'Palmyra Atoll',
    value: 'US',
    isoCode: 'UM-95',
  },
  {
    name: 'Puerto Rico',
    value: 'US',
    isoCode: 'PR',
  },
  {
    name: 'Colorado',
    value: 'US',
    isoCode: 'CO',
  },
  {
    name: 'Missouri',
    value: 'US',
    isoCode: 'MO',
  },
  {
    name: 'New York',
    value: 'US',
    isoCode: 'NY',
  },
  {
    name: 'Maine',
    value: 'US',
    isoCode: 'ME',
  },
  {
    name: 'Tennessee',
    value: 'US',
    isoCode: 'TN',
  },
  {
    name: 'Georgia',
    value: 'US',
    isoCode: 'GA',
  },
  {
    name: 'Alabama',
    value: 'US',
    isoCode: 'AL',
  },
  {
    name: 'Louisiana',
    value: 'US',
    isoCode: 'LA',
  },
  {
    name: 'Nevada',
    value: 'US',
    isoCode: 'NV',
  },
  {
    name: 'Iowa',
    value: 'US',
    isoCode: 'IA',
  },
  {
    name: 'Idaho',
    value: 'US',
    isoCode: 'ID',
  },
  {
    name: 'Rhode Island',
    value: 'US',
    isoCode: 'RI',
  },
  {
    name: 'Washington',
    value: 'US',
    isoCode: 'WA',
  },
  {
    name: 'Ohio',
    value: 'US',
    isoCode: 'OH',
  },
  {
    name: 'Shinyanga',
    value: 'TZ',
    isoCode: '22',
  },
  {
    name: 'Simiyu',
    value: 'TZ',
    isoCode: '30',
  },
  {
    name: 'Kagera',
    value: 'TZ',
    isoCode: '05',
  },
  {
    name: 'Dodoma',
    value: 'TZ',
    isoCode: '03',
  },
  {
    name: 'Kilimanjaro',
    value: 'TZ',
    isoCode: '09',
  },
  {
    name: 'Mara',
    value: 'TZ',
    isoCode: '13',
  },
  {
    name: 'Tabora',
    value: 'TZ',
    isoCode: '24',
  },
  {
    name: 'Morogoro',
    value: 'TZ',
    isoCode: '16',
  },
  {
    name: 'Zanzibar South',
    value: 'TZ',
    isoCode: '11',
  },
  {
    name: 'Pemba South',
    value: 'TZ',
    isoCode: '10',
  },
  {
    name: 'Zanzibar North',
    value: 'TZ',
    isoCode: '07',
  },
  {
    name: 'Singida',
    value: 'TZ',
    isoCode: '23',
  },
  {
    name: 'Zanzibar West',
    value: 'TZ',
    isoCode: '15',
  },
  {
    name: 'Mtwara',
    value: 'TZ',
    isoCode: '17',
  },
  {
    name: 'Rukwa',
    value: 'TZ',
    isoCode: '20',
  },
  {
    name: 'Kigoma',
    value: 'TZ',
    isoCode: '08',
  },
  {
    name: 'Mwanza',
    value: 'TZ',
    isoCode: '18',
  },
  {
    name: 'Njombe',
    value: 'TZ',
    isoCode: '29',
  },
  {
    name: 'Geita',
    value: 'TZ',
    isoCode: '27',
  },
  {
    name: 'Katavi',
    value: 'TZ',
    isoCode: '28',
  },
  {
    name: 'Lindi',
    value: 'TZ',
    isoCode: '12',
  },
  {
    name: 'Manyara',
    value: 'TZ',
    isoCode: '26',
  },
  {
    name: 'Pwani',
    value: 'TZ',
    isoCode: '19',
  },
  {
    name: 'Ruvuma',
    value: 'TZ',
    isoCode: '21',
  },
  {
    name: 'Tanga',
    value: 'TZ',
    isoCode: '25',
  },
  {
    name: 'Pemba North',
    value: 'TZ',
    isoCode: '06',
  },
  {
    name: 'Iringa',
    value: 'TZ',
    isoCode: '04',
  },
  {
    name: 'Dar es Salaam',
    value: 'TZ',
    isoCode: '02',
  },
  {
    name: 'Arusha',
    value: 'TZ',
    isoCode: '01',
  },
  {
    name: 'Mbeya',
    value: 'TZ',
    isoCode: '14',
  },
  {
    name: 'Songwe',
    value: 'TZ',
    isoCode: '31',
  },
  {
    name: 'Eastern Finland Province',
    value: 'FI',
    isoCode: 'IS',
  },
  {
    name: 'Tavastia Proper',
    value: 'FI',
    isoCode: '06',
  },
  {
    name: 'Central Ostrobothnia',
    value: 'FI',
    isoCode: '07',
  },
  {
    name: 'Southern Savonia',
    value: 'FI',
    isoCode: '04',
  },
  {
    name: 'Kainuu',
    value: 'FI',
    isoCode: '05',
  },
  {
    name: 'South Karelia',
    value: 'FI',
    isoCode: '02',
  },
  {
    name: 'Southern Ostrobothnia',
    value: 'FI',
    isoCode: '03',
  },
  {
    name: 'Oulu Province',
    value: 'FI',
    isoCode: 'OL',
  },
  {
    name: 'Lapland',
    value: 'FI',
    isoCode: 'LL',
  },
  {
    name: 'Satakunta',
    value: 'FI',
    isoCode: '17',
  },
  {
    name: 'Päijänne Tavastia',
    value: 'FI',
    isoCode: '16',
  },
  {
    name: 'Northern Savonia',
    value: 'FI',
    isoCode: '15',
  },
  {
    name: 'North Karelia',
    value: 'FI',
    isoCode: '13',
  },
  {
    name: 'Northern Ostrobothnia',
    value: 'FI',
    isoCode: '14',
  },
  {
    name: 'Pirkanmaa',
    value: 'FI',
    isoCode: '11',
  },
  {
    name: 'Finland Proper',
    value: 'FI',
    isoCode: '19',
  },
  {
    name: 'Ostrobothnia',
    value: 'FI',
    isoCode: '12',
  },
  {
    name: 'Åland Islands',
    value: 'FI',
    isoCode: '01',
  },
  {
    name: 'Uusimaa',
    value: 'FI',
    isoCode: '18',
  },
  {
    name: 'Central Finland',
    value: 'FI',
    isoCode: '08',
  },
  {
    name: 'Kymenlaakso',
    value: 'FI',
    isoCode: '09',
  },
  {
    name: 'Canton of Diekirch',
    value: 'LU',
    isoCode: 'DI',
  },
  {
    name: 'Luxembourg District',
    value: 'LU',
    isoCode: 'L',
  },
  {
    name: 'Canton of Echternach',
    value: 'LU',
    isoCode: 'EC',
  },
  {
    name: 'Canton of Redange',
    value: 'LU',
    isoCode: 'RD',
  },
  {
    name: 'Canton of Esch-sur-Alzette',
    value: 'LU',
    isoCode: 'ES',
  },
  {
    name: 'Canton of Capellen',
    value: 'LU',
    isoCode: 'CA',
  },
  {
    name: 'Canton of Remich',
    value: 'LU',
    isoCode: 'RM',
  },
  {
    name: 'Grevenmacher District',
    value: 'LU',
    isoCode: 'G',
  },
  {
    name: 'Canton of Clervaux',
    value: 'LU',
    isoCode: 'CL',
  },
  {
    name: 'Canton of Mersch',
    value: 'LU',
    isoCode: 'ME',
  },
  {
    name: 'Canton of Vianden',
    value: 'LU',
    isoCode: 'VD',
  },
  {
    name: 'Diekirch District',
    value: 'LU',
    isoCode: 'D',
  },
  {
    name: 'Canton of Grevenmacher',
    value: 'LU',
    isoCode: 'GR',
  },
  {
    name: 'Canton of Wiltz',
    value: 'LU',
    isoCode: 'WI',
  },
  {
    name: 'Canton of Luxembourg',
    value: 'LU',
    isoCode: 'LU',
  },
  {
    name: 'Region Zealand',
    value: 'DK',
    isoCode: '85',
  },
  {
    name: 'Region of Southern Denmark',
    value: 'DK',
    isoCode: '83',
  },
  {
    name: 'Capital Region of Denmark',
    value: 'DK',
    isoCode: '84',
  },
  {
    name: 'Central Denmark Region',
    value: 'DK',
    isoCode: '82',
  },
  {
    name: 'North Denmark Region',
    value: 'DK',
    isoCode: '81',
  },
  {
    name: 'Gävleborg County',
    value: 'SE',
    isoCode: 'X',
  },
  {
    name: 'Dalarna County',
    value: 'SE',
    isoCode: 'W',
  },
  {
    name: 'Värmland County',
    value: 'SE',
    isoCode: 'S',
  },
  {
    name: 'Östergötland County',
    value: 'SE',
    isoCode: 'E',
  },
  {
    name: 'Blekinge',
    value: 'SE',
    isoCode: 'K',
  },
  {
    name: 'Norrbotten County',
    value: 'SE',
    isoCode: 'BD',
  },
  {
    name: 'Örebro County',
    value: 'SE',
    isoCode: 'T',
  },
  {
    name: 'Södermanland County',
    value: 'SE',
    isoCode: 'D',
  },
  {
    name: 'Skåne County',
    value: 'SE',
    isoCode: 'M',
  },
  {
    name: 'Kronoberg County',
    value: 'SE',
    isoCode: 'G',
  },
  {
    name: 'Västerbotten County',
    value: 'SE',
    isoCode: 'AC',
  },
  {
    name: 'Kalmar County',
    value: 'SE',
    isoCode: 'H',
  },
  {
    name: 'Uppsala County',
    value: 'SE',
    isoCode: 'C',
  },
  {
    name: 'Gotland County',
    value: 'SE',
    isoCode: 'I',
  },
  {
    name: 'Västra Götaland County',
    value: 'SE',
    isoCode: 'O',
  },
  {
    name: 'Halland County',
    value: 'SE',
    isoCode: 'N',
  },
  {
    name: 'Västmanland County',
    value: 'SE',
    isoCode: 'U',
  },
  {
    name: 'Jönköping County',
    value: 'SE',
    isoCode: 'F',
  },
  {
    name: 'Stockholm County',
    value: 'SE',
    isoCode: 'AB',
  },
  {
    name: 'Västernorrland County',
    value: 'SE',
    isoCode: 'Y',
  },
  {
    name: 'Plungė District Municipality',
    value: 'LT',
    isoCode: '35',
  },
  {
    name: 'Šiauliai District Municipality',
    value: 'LT',
    isoCode: '44',
  },
  {
    name: 'Jurbarkas District Municipality',
    value: 'LT',
    isoCode: '12',
  },
  {
    name: 'Kaunas County',
    value: 'LT',
    isoCode: 'KU',
  },
  {
    name: 'Mažeikiai District Municipality',
    value: 'LT',
    isoCode: '26',
  },
  {
    name: 'Panevėžys County',
    value: 'LT',
    isoCode: 'PN',
  },
  {
    name: 'Elektrėnai municipality',
    value: 'LT',
    isoCode: '08',
  },
  {
    name: 'Švenčionys District Municipality',
    value: 'LT',
    isoCode: '49',
  },
  {
    name: 'Akmenė District Municipality',
    value: 'LT',
    isoCode: '01',
  },
  {
    name: 'Ignalina District Municipality',
    value: 'LT',
    isoCode: '09',
  },
  {
    name: 'Neringa Municipality',
    value: 'LT',
    isoCode: '28',
  },
  {
    name: 'Visaginas Municipality',
    value: 'LT',
    isoCode: '59',
  },
  {
    name: 'Kaunas District Municipality',
    value: 'LT',
    isoCode: '16',
  },
  {
    name: 'Biržai District Municipality',
    value: 'LT',
    isoCode: '06',
  },
  {
    name: 'Jonava District Municipality',
    value: 'LT',
    isoCode: '10',
  },
  {
    name: 'Radviliškis District Municipality',
    value: 'LT',
    isoCode: '37',
  },
  {
    name: 'Telšiai County',
    value: 'LT',
    isoCode: 'TE',
  },
  {
    name: 'Marijampolė County',
    value: 'LT',
    isoCode: 'MR',
  },
  {
    name: 'Kretinga District Municipality',
    value: 'LT',
    isoCode: '22',
  },
  {
    name: 'Tauragė District Municipality',
    value: 'LT',
    isoCode: '50',
  },
  {
    name: 'Tauragė County',
    value: 'LT',
    isoCode: 'TA',
  },
  {
    name: 'Alytus County',
    value: 'LT',
    isoCode: 'AL',
  },
  {
    name: 'Kazlų Rūda municipality',
    value: 'LT',
    isoCode: '17',
  },
  {
    name: 'Šakiai District Municipality',
    value: 'LT',
    isoCode: '41',
  },
  {
    name: 'Šalčininkai District Municipality',
    value: 'LT',
    isoCode: '42',
  },
  {
    name: 'Prienai District Municipality',
    value: 'LT',
    isoCode: '36',
  },
  {
    name: 'Druskininkai municipality',
    value: 'LT',
    isoCode: '07',
  },
  {
    name: 'Kaunas City Municipality',
    value: 'LT',
    isoCode: '15',
  },
  {
    name: 'Joniškis District Municipality',
    value: 'LT',
    isoCode: '11',
  },
  {
    name: 'Molėtai District Municipality',
    value: 'LT',
    isoCode: '27',
  },
  {
    name: 'Kaišiadorys District Municipality',
    value: 'LT',
    isoCode: '13',
  },
  {
    name: 'Kėdainiai District Municipality',
    value: 'LT',
    isoCode: '18',
  },
  {
    name: 'Kupiškis District Municipality',
    value: 'LT',
    isoCode: '23',
  },
  {
    name: 'Šiauliai County',
    value: 'LT',
    isoCode: 'SA',
  },
  {
    name: 'Raseiniai District Municipality',
    value: 'LT',
    isoCode: '38',
  },
  {
    name: 'Palanga City Municipality',
    value: 'LT',
    isoCode: '31',
  },
  {
    name: 'Panevėžys City Municipality',
    value: 'LT',
    isoCode: '32',
  },
  {
    name: 'Rietavas municipality',
    value: 'LT',
    isoCode: '39',
  },
  {
    name: 'Kalvarija municipality',
    value: 'LT',
    isoCode: '14',
  },
  {
    name: 'Vilnius District Municipality',
    value: 'LT',
    isoCode: '58',
  },
  {
    name: 'Trakai District Municipality',
    value: 'LT',
    isoCode: '52',
  },
  {
    name: 'Širvintos District Municipality',
    value: 'LT',
    isoCode: '47',
  },
  {
    name: 'Pakruojis District Municipality',
    value: 'LT',
    isoCode: '30',
  },
  {
    name: 'Ukmergė District Municipality',
    value: 'LT',
    isoCode: '53',
  },
  {
    name: 'Klaipeda City Municipality',
    value: 'LT',
    isoCode: '20',
  },
  {
    name: 'Utena District Municipality',
    value: 'LT',
    isoCode: '54',
  },
  {
    name: 'Alytus District Municipality',
    value: 'LT',
    isoCode: '03',
  },
  {
    name: 'Klaipėda County',
    value: 'LT',
    isoCode: 'KL',
  },
  {
    name: 'Vilnius County',
    value: 'LT',
    isoCode: 'VL',
  },
  {
    name: 'Varėna District Municipality',
    value: 'LT',
    isoCode: '55',
  },
  {
    name: 'Birštonas Municipality',
    value: 'LT',
    isoCode: '05',
  },
  {
    name: 'Klaipėda District Municipality',
    value: 'LT',
    isoCode: '21',
  },
  {
    name: 'Alytus City Municipality',
    value: 'LT',
    isoCode: '02',
  },
  {
    name: 'Vilnius City Municipality',
    value: 'LT',
    isoCode: '57',
  },
  {
    name: 'Šilutė District Municipality',
    value: 'LT',
    isoCode: '46',
  },
  {
    name: 'Telšiai District Municipality',
    value: 'LT',
    isoCode: '51',
  },
  {
    name: 'Šiauliai City Municipality',
    value: 'LT',
    isoCode: '43',
  },
  {
    name: 'Marijampolė Municipality',
    value: 'LT',
    isoCode: '25',
  },
  {
    name: 'Lazdijai District Municipality',
    value: 'LT',
    isoCode: '24',
  },
  {
    name: 'Pagėgiai municipality',
    value: 'LT',
    isoCode: '29',
  },
  {
    name: 'Šilalė District Municipality',
    value: 'LT',
    isoCode: '45',
  },
  {
    name: 'Panevėžys District Municipality',
    value: 'LT',
    isoCode: '33',
  },
  {
    name: 'Rokiškis District Municipality',
    value: 'LT',
    isoCode: '40',
  },
  {
    name: 'Pasvalys District Municipality',
    value: 'LT',
    isoCode: '34',
  },
  {
    name: 'Skuodas District Municipality',
    value: 'LT',
    isoCode: '48',
  },
  {
    name: 'Kelmė District Municipality',
    value: 'LT',
    isoCode: '19',
  },
  {
    name: 'Zarasai District Municipality',
    value: 'LT',
    isoCode: '60',
  },
  {
    name: 'Vilkaviškis District Municipality',
    value: 'LT',
    isoCode: '56',
  },
  {
    name: 'Utena County',
    value: 'LT',
    isoCode: 'UT',
  },
  {
    name: 'Opole Voivodeship',
    value: 'PL',
    isoCode: 'OP',
  },
  {
    name: 'Silesian Voivodeship',
    value: 'PL',
    isoCode: 'SL',
  },
  {
    name: 'Pomeranian Voivodeship',
    value: 'PL',
    isoCode: 'PM',
  },
  {
    name: 'Kuyavian-Pomeranian Voivodeship',
    value: 'PL',
    isoCode: 'KP',
  },
  {
    name: 'Podkarpackie Voivodeship',
    value: 'PL',
    isoCode: 'PK',
  },
  {
    name: 'Warmian-Masurian Voivodeship',
    value: 'PL',
    isoCode: 'WN',
  },
  {
    name: 'Lower Silesian Voivodeship',
    value: 'PL',
    isoCode: 'DS',
  },
  {
    name: 'Świętokrzyskie Voivodeship',
    value: 'PL',
    isoCode: 'SK',
  },
  {
    name: 'Lubusz Voivodeship',
    value: 'PL',
    isoCode: 'LB',
  },
  {
    name: 'Podlaskie Voivodeship',
    value: 'PL',
    isoCode: 'PD',
  },
  {
    name: 'West Pomeranian Voivodeship',
    value: 'PL',
    isoCode: 'ZP',
  },
  {
    name: 'Greater Poland Voivodeship',
    value: 'PL',
    isoCode: 'WP',
  },
  {
    name: 'Lesser Poland Voivodeship',
    value: 'PL',
    isoCode: 'MA',
  },
  {
    name: 'Łódź Voivodeship',
    value: 'PL',
    isoCode: 'LD',
  },
  {
    name: 'Masovian Voivodeship',
    value: 'PL',
    isoCode: 'MZ',
  },
  {
    name: 'Lublin Voivodeship',
    value: 'PL',
    isoCode: 'LU',
  },
  {
    name: 'Aargau',
    value: 'CH',
    isoCode: 'AG',
  },
  {
    name: 'Fribourg',
    value: 'CH',
    isoCode: 'FR',
  },
  {
    name: 'Basel-Land',
    value: 'CH',
    isoCode: 'BL',
  },
  {
    name: 'Uri',
    value: 'CH',
    isoCode: 'UR',
  },
  {
    name: 'Ticino',
    value: 'CH',
    isoCode: 'TI',
  },
  {
    name: 'St. Gallen',
    value: 'CH',
    isoCode: 'SG',
  },
  {
    name: 'Bern',
    value: 'CH',
    isoCode: 'BE',
  },
  {
    name: 'Zug',
    value: 'CH',
    isoCode: 'ZG',
  },
  {
    name: 'Geneva',
    value: 'CH',
    isoCode: 'GE',
  },
  {
    name: 'Valais',
    value: 'CH',
    isoCode: 'VS',
  },
  {
    name: 'Appenzell Innerrhoden',
    value: 'CH',
    isoCode: 'AI',
  },
  {
    name: 'Obwalden',
    value: 'CH',
    isoCode: 'OW',
  },
  {
    name: 'Vaud',
    value: 'CH',
    isoCode: 'VD',
  },
  {
    name: 'Nidwalden',
    value: 'CH',
    isoCode: 'NW',
  },
  {
    name: 'Schwyz',
    value: 'CH',
    isoCode: 'SZ',
  },
  {
    name: 'Schaffhausen',
    value: 'CH',
    isoCode: 'SH',
  },
  {
    name: 'Appenzell Ausserrhoden',
    value: 'CH',
    isoCode: 'AR',
  },
  {
    name: 'Zürich',
    value: 'CH',
    isoCode: 'ZH',
  },
  {
    name: 'Thurgau',
    value: 'CH',
    isoCode: 'TG',
  },
  {
    name: 'Jura',
    value: 'CH',
    isoCode: 'JU',
  },
  {
    name: 'Neuchâtel',
    value: 'CH',
    isoCode: 'NE',
  },
  {
    name: 'Graubünden',
    value: 'CH',
    isoCode: 'GR',
  },
  {
    name: 'Glarus',
    value: 'CH',
    isoCode: 'GL',
  },
  {
    name: 'Solothurn',
    value: 'CH',
    isoCode: 'SO',
  },
  {
    name: 'Lucerne',
    value: 'CH',
    isoCode: 'LU',
  },
  {
    name: 'Basel-Stadt',
    value: 'CH',
    isoCode: 'BS',
  },
  {
    name: 'Tuscany',
    value: 'IT',
    isoCode: '52',
  },
  {
    name: 'Province of Padua',
    value: 'IT',
    isoCode: 'PD',
  },
  {
    name: 'Province of Parma',
    value: 'IT',
    isoCode: 'PR',
  },
  {
    name: 'Libero consorzio comunale di Siracusa',
    value: 'IT',
    isoCode: 'SR',
  },
  {
    name: 'Metropolitan City of Palermo',
    value: 'IT',
    isoCode: 'PA',
  },
  {
    name: 'Campania',
    value: 'IT',
    isoCode: '72',
  },
  {
    name: 'Marche',
    value: 'IT',
    isoCode: '57',
  },
  {
    name: 'Metropolitan City of Reggio Calabria',
    value: 'IT',
    isoCode: 'RC',
  },
  {
    name: 'Province of Ancona',
    value: 'IT',
    isoCode: 'AN',
  },
  {
    name: 'Metropolitan City of Venice',
    value: 'IT',
    isoCode: 'VE',
  },
  {
    name: 'Province of Latina',
    value: 'IT',
    isoCode: 'LT',
  },
  {
    name: 'Province of Lecce',
    value: 'IT',
    isoCode: 'LE',
  },
  {
    name: 'Province of Pavia',
    value: 'IT',
    isoCode: 'PV',
  },
  {
    name: 'Province of Lecco',
    value: 'IT',
    isoCode: 'LC',
  },
  {
    name: 'Lazio',
    value: 'IT',
    isoCode: '62',
  },
  {
    name: 'Abruzzo',
    value: 'IT',
    isoCode: '65',
  },
  {
    name: 'Metropolitan City of Florence',
    value: 'IT',
    isoCode: 'FI',
  },
  {
    name: 'Province of Ascoli Piceno',
    value: 'IT',
    isoCode: 'AP',
  },
  {
    name: 'Metropolitan City of Cagliari',
    value: 'IT',
    isoCode: 'CA',
  },
  {
    name: 'Umbria',
    value: 'IT',
    isoCode: '55',
  },
  {
    name: 'Metropolitan City of Bologna',
    value: 'IT',
    isoCode: 'BO',
  },
  {
    name: 'Province of Pisa',
    value: 'IT',
    isoCode: 'PI',
  },
  {
    name: 'Province of Barletta-Andria-Trani',
    value: 'IT',
    isoCode: 'BT',
  },
  {
    name: 'Province of Pistoia',
    value: 'IT',
    isoCode: 'PT',
  },
  {
    name: 'Apulia',
    value: 'IT',
    isoCode: '75',
  },
  {
    name: 'Province of Belluno',
    value: 'IT',
    isoCode: 'BL',
  },
  {
    name: 'Province of Pordenone',
    value: 'IT',
    isoCode: 'PN',
  },
  {
    name: 'Province of Perugia',
    value: 'IT',
    isoCode: 'PG',
  },
  {
    name: 'Province of Avellino',
    value: 'IT',
    isoCode: 'AV',
  },
  {
    name: 'Pesaro and Urbino Province',
    value: 'IT',
    isoCode: 'PU',
  },
  {
    name: 'Province of Pescara',
    value: 'IT',
    isoCode: 'PE',
  },
  {
    name: 'Molise',
    value: 'IT',
    isoCode: '67',
  },
  {
    name: 'Province of Piacenza',
    value: 'IT',
    isoCode: 'PC',
  },
  {
    name: 'Province of Potenza',
    value: 'IT',
    isoCode: 'PZ',
  },
  {
    name: 'Metropolitan City of Milan',
    value: 'IT',
    isoCode: 'MI',
  },
  {
    name: 'Metropolitan City of Genoa',
    value: 'IT',
    isoCode: 'GE',
  },
  {
    name: 'Province of Prato',
    value: 'IT',
    isoCode: 'PO',
  },
  {
    name: 'Benevento Province',
    value: 'IT',
    isoCode: 'BN',
  },
  {
    name: 'Piedmont',
    value: 'IT',
    isoCode: '21',
  },
  {
    name: 'Calabria',
    value: 'IT',
    isoCode: '78',
  },
  {
    name: 'Province of Bergamo',
    value: 'IT',
    isoCode: 'BG',
  },
  {
    name: 'Lombardy',
    value: 'IT',
    isoCode: '25',
  },
  {
    name: 'Basilicata',
    value: 'IT',
    isoCode: '77',
  },
  {
    name: 'Province of Ravenna',
    value: 'IT',
    isoCode: 'RA',
  },
  {
    name: 'Province of Reggio Emilia',
    value: 'IT',
    isoCode: 'RE',
  },
  {
    name: 'Sicily',
    value: 'IT',
    isoCode: '82',
  },
  {
    name: 'Metropolitan City of Turin',
    value: 'IT',
    isoCode: 'TO',
  },
  {
    name: 'Metropolitan City of Rome',
    value: 'IT',
    isoCode: 'RM',
  },
  {
    name: 'Province of Rieti',
    value: 'IT',
    isoCode: 'RI',
  },
  {
    name: 'Province of Rimini',
    value: 'IT',
    isoCode: 'RN',
  },
  {
    name: 'Province of Brindisi',
    value: 'IT',
    isoCode: 'BR',
  },
  {
    name: 'Sardinia',
    value: 'IT',
    isoCode: '88',
  },
  {
    name: 'Aosta Valley',
    value: 'IT',
    isoCode: '23',
  },
  {
    name: 'Province of Brescia',
    value: 'IT',
    isoCode: 'BS',
  },
  {
    name: 'Libero consorzio comunale di Caltanissetta',
    value: 'IT',
    isoCode: 'CL',
  },
  {
    name: 'Province of Rovigo',
    value: 'IT',
    isoCode: 'RO',
  },
  {
    name: 'Province of Salerno',
    value: 'IT',
    isoCode: 'SA',
  },
  {
    name: 'Province of Campobasso',
    value: 'IT',
    isoCode: 'CB',
  },
  {
    name: 'Province of Sassari',
    value: 'IT',
    isoCode: 'SS',
  },
  {
    name: 'Libero consorzio comunale di Enna',
    value: 'IT',
    isoCode: 'EN',
  },
  {
    name: 'Metropolitan City of Naples',
    value: 'IT',
    isoCode: 'NA',
  },
  {
    name: 'Trentino-South Tyrol',
    value: 'IT',
    isoCode: '32',
  },
  {
    name: 'Province of Verbano-Cusio-Ossola',
    value: 'IT',
    isoCode: 'VB',
  },
  {
    name: 'Libero consorzio comunale di Agrigento',
    value: 'IT',
    isoCode: 'AG',
  },
  {
    name: 'Province of Catanzaro',
    value: 'IT',
    isoCode: 'CZ',
  },
  {
    name: 'Libero consorzio comunale di Ragusa',
    value: 'IT',
    isoCode: 'RG',
  },
  {
    name: 'Province of Carbonia-Iglesias',
    value: 'IT',
    isoCode: 'CI',
  },
  {
    name: 'Province of Caserta',
    value: 'IT',
    isoCode: 'CE',
  },
  {
    name: 'Province of Savona',
    value: 'IT',
    isoCode: 'SV',
  },
  {
    name: 'Libero consorzio comunale di Trapani',
    value: 'IT',
    isoCode: 'TP',
  },
  {
    name: 'Province of Siena',
    value: 'IT',
    isoCode: 'SI',
  },
  {
    name: 'Province of Viterbo',
    value: 'IT',
    isoCode: 'VT',
  },
  {
    name: 'Province of Verona',
    value: 'IT',
    isoCode: 'VR',
  },
  {
    name: 'Province of Vibo Valentia',
    value: 'IT',
    isoCode: 'VV',
  },
  {
    name: 'Province of Vicenza',
    value: 'IT',
    isoCode: 'VI',
  },
  {
    name: 'Province of Chieti',
    value: 'IT',
    isoCode: 'CH',
  },
  {
    name: 'Province of Como',
    value: 'IT',
    isoCode: 'CO',
  },
  {
    name: 'Province of Sondrio',
    value: 'IT',
    isoCode: 'SO',
  },
  {
    name: 'Province of Cosenza',
    value: 'IT',
    isoCode: 'CS',
  },
  {
    name: 'Province of Taranto',
    value: 'IT',
    isoCode: 'TA',
  },
  {
    name: 'Province of Fermo',
    value: 'IT',
    isoCode: 'FM',
  },
  {
    name: 'Province of Livorno',
    value: 'IT',
    isoCode: 'LI',
  },
  {
    name: 'Province of Ferrara',
    value: 'IT',
    isoCode: 'FE',
  },
  {
    name: 'Province of Lodi',
    value: 'IT',
    isoCode: 'LO',
  },
  {
    name: 'Trentino',
    value: 'IT',
    isoCode: 'TN',
  },
  {
    name: 'Province of Lucca',
    value: 'IT',
    isoCode: 'LU',
  },
  {
    name: 'Province of Macerata',
    value: 'IT',
    isoCode: 'MC',
  },
  {
    name: 'Province of Cremona',
    value: 'IT',
    isoCode: 'CR',
  },
  {
    name: 'Province of Teramo',
    value: 'IT',
    isoCode: 'TE',
  },
  {
    name: 'Veneto',
    value: 'IT',
    isoCode: '34',
  },
  {
    name: 'Province of Crotone',
    value: 'IT',
    isoCode: 'KR',
  },
  {
    name: 'Province of Terni',
    value: 'IT',
    isoCode: 'TR',
  },
  {
    name: 'Friuli–Venezia Giulia',
    value: 'IT',
    isoCode: '36',
  },
  {
    name: 'Province of Modena',
    value: 'IT',
    isoCode: 'MO',
  },
  {
    name: 'Province of Mantua',
    value: 'IT',
    isoCode: 'MN',
  },
  {
    name: 'Province of Massa and Carrara',
    value: 'IT',
    isoCode: 'MS',
  },
  {
    name: 'Province of Matera',
    value: 'IT',
    isoCode: 'MT',
  },
  {
    name: 'Province of Medio Campidano',
    value: 'IT',
    isoCode: 'VS',
  },
  {
    name: 'Province of Treviso',
    value: 'IT',
    isoCode: 'TV',
  },
  {
    name: 'Province of Trieste',
    value: 'IT',
    isoCode: 'TS',
  },
  {
    name: 'Province of Udine',
    value: 'IT',
    isoCode: 'UD',
  },
  {
    name: 'Province of Varese',
    value: 'IT',
    isoCode: 'VA',
  },
  {
    name: 'Metropolitan City of Catania',
    value: 'IT',
    isoCode: 'CT',
  },
  {
    name: 'South Tyrol',
    value: 'IT',
    isoCode: 'BZ',
  },
  {
    name: 'Liguria',
    value: 'IT',
    isoCode: '42',
  },
  {
    name: 'Province of Monza and Brianza',
    value: 'IT',
    isoCode: 'MB',
  },
  {
    name: 'Metropolitan City of Messina',
    value: 'IT',
    isoCode: 'ME',
  },
  {
    name: 'Province of Foggia',
    value: 'IT',
    isoCode: 'FG',
  },
  {
    name: 'Metropolitan City of Bari',
    value: 'IT',
    isoCode: 'BA',
  },
  {
    name: 'Emilia-Romagna',
    value: 'IT',
    isoCode: '45',
  },
  {
    name: 'Province of Novara',
    value: 'IT',
    isoCode: 'NO',
  },
  {
    name: 'Province of Cuneo',
    value: 'IT',
    isoCode: 'CN',
  },
  {
    name: 'Province of Frosinone',
    value: 'IT',
    isoCode: 'FR',
  },
  {
    name: 'Province of Gorizia',
    value: 'IT',
    isoCode: 'GO',
  },
  {
    name: 'Province of Biella',
    value: 'IT',
    isoCode: 'BI',
  },
  {
    name: 'Province of Forlì-Cesena',
    value: 'IT',
    isoCode: 'FC',
  },
  {
    name: 'Province of Asti',
    value: 'IT',
    isoCode: 'AT',
  },
  {
    name: "Province of L'Aquila",
    value: 'IT',
    isoCode: 'AQ',
  },
  {
    name: 'Province of Ogliastra',
    value: 'IT',
    isoCode: 'OG',
  },
  {
    name: 'Province of Alessandria',
    value: 'IT',
    isoCode: 'AL',
  },
  {
    name: 'Province of Olbia-Tempio',
    value: 'IT',
    isoCode: 'OT',
  },
  {
    name: 'Province of Vercelli',
    value: 'IT',
    isoCode: 'VC',
  },
  {
    name: 'Province of Oristano',
    value: 'IT',
    isoCode: 'OR',
  },
  {
    name: 'Province of Grosseto',
    value: 'IT',
    isoCode: 'GR',
  },
  {
    name: 'Province of Imperia',
    value: 'IT',
    isoCode: 'IM',
  },
  {
    name: 'Province of Isernia',
    value: 'IT',
    isoCode: 'IS',
  },
  {
    name: 'Province of Nuoro',
    value: 'IT',
    isoCode: 'NU',
  },
  {
    name: 'Province of La Spezia',
    value: 'IT',
    isoCode: 'SP',
  },
  {
    name: 'Sumatera Utara',
    value: 'ID',
    isoCode: 'SU',
  },
  {
    name: 'Bengkulu',
    value: 'ID',
    isoCode: 'BE',
  },
  {
    name: 'Kalimantan Tengah',
    value: 'ID',
    isoCode: 'KT',
  },
  {
    name: 'Sulawesi Selatan',
    value: 'ID',
    isoCode: 'SN',
  },
  {
    name: 'Sulawesi Tenggara',
    value: 'ID',
    isoCode: 'SG',
  },
  {
    name: 'Papua',
    value: 'ID',
    isoCode: 'PA',
  },
  {
    name: 'Papua Barat',
    value: 'ID',
    isoCode: 'PB',
  },
  {
    name: 'Maluku',
    value: 'ID',
    isoCode: 'MA',
  },
  {
    name: 'Maluku Utara',
    value: 'ID',
    isoCode: 'MU',
  },
  {
    name: 'Jawa Tengah',
    value: 'ID',
    isoCode: 'JT',
  },
  {
    name: 'Kalimantan Timur',
    value: 'ID',
    isoCode: 'KI',
  },
  {
    name: 'DKI Jakarta',
    value: 'ID',
    isoCode: 'JK',
  },
  {
    name: 'Kalimantan Barat',
    value: 'ID',
    isoCode: 'KA',
  },
  {
    name: 'Kepulauan Riau',
    value: 'ID',
    isoCode: 'KR',
  },
  {
    name: 'Sulawesi Utara',
    value: 'ID',
    isoCode: 'SA',
  },
  {
    name: 'Riau',
    value: 'ID',
    isoCode: 'RI',
  },
  {
    name: 'Banten',
    value: 'ID',
    isoCode: 'BT',
  },
  {
    name: 'Lampung',
    value: 'ID',
    isoCode: 'LA',
  },
  {
    name: 'Gorontalo',
    value: 'ID',
    isoCode: 'GO',
  },
  {
    name: 'Sulawesi Tengah',
    value: 'ID',
    isoCode: 'ST',
  },
  {
    name: 'Nusa Tenggara Barat',
    value: 'ID',
    isoCode: 'NB',
  },
  {
    name: 'Jambi',
    value: 'ID',
    isoCode: 'JA',
  },
  {
    name: 'Sumatera Selatan',
    value: 'ID',
    isoCode: 'SS',
  },
  {
    name: 'Sulawesi Barat',
    value: 'ID',
    isoCode: 'SR',
  },
  {
    name: 'Nusa Tenggara Timur',
    value: 'ID',
    isoCode: 'NT',
  },
  {
    name: 'Kalimantan Selatan',
    value: 'ID',
    isoCode: 'KS',
  },
  {
    name: 'Kepulauan Bangka Belitung',
    value: 'ID',
    isoCode: 'BB',
  },
  {
    name: 'Aceh',
    value: 'ID',
    isoCode: 'AC',
  },
  {
    name: 'Kalimantan Utara',
    value: 'ID',
    isoCode: 'KU',
  },
  {
    name: 'Jawa Barat',
    value: 'ID',
    isoCode: 'JB',
  },
  {
    name: 'Bali',
    value: 'ID',
    isoCode: 'BA',
  },
  {
    name: 'Jawa Timur',
    value: 'ID',
    isoCode: 'JI',
  },
  {
    name: 'Sumatera Barat',
    value: 'ID',
    isoCode: 'SB',
  },
  {
    name: 'DI Yogyakarta',
    value: 'ID',
    isoCode: 'YO',
  },
  {
    name: 'Phoenix Islands',
    value: 'KI',
    isoCode: 'P',
  },
  {
    name: 'Gilbert Islands',
    value: 'KI',
    isoCode: 'G',
  },
  {
    name: 'Line Islands',
    value: 'KI',
    isoCode: 'L',
  },
  {
    name: 'Primorsky Krai',
    value: 'RU',
    isoCode: 'PRI',
  },
  {
    name: 'Novgorod Oblast',
    value: 'RU',
    isoCode: 'NGR',
  },
  {
    name: 'Jewish Autonomous Oblast',
    value: 'RU',
    isoCode: 'YEV',
  },
  {
    name: 'Nenets Autonomous Okrug',
    value: 'RU',
    isoCode: 'NEN',
  },
  {
    name: 'Rostov Oblast',
    value: 'RU',
    isoCode: 'ROS',
  },
  {
    name: 'Khanty-Mansi Autonomous Okrug',
    value: 'RU',
    isoCode: 'KHM',
  },
  {
    name: 'Magadan Oblast',
    value: 'RU',
    isoCode: 'MAG',
  },
  {
    name: 'Krasnoyarsk Krai',
    value: 'RU',
    isoCode: 'KYA',
  },
  {
    name: 'Republic of Karelia',
    value: 'RU',
    isoCode: 'KR',
  },
  {
    name: 'Republic of Buryatia',
    value: 'RU',
    isoCode: 'BU',
  },
  {
    name: 'Murmansk Oblast',
    value: 'RU',
    isoCode: 'MUR',
  },
  {
    name: 'Kaluga Oblast',
    value: 'RU',
    isoCode: 'KLU',
  },
  {
    name: 'Chelyabinsk Oblast',
    value: 'RU',
    isoCode: 'CHE',
  },
  {
    name: 'Omsk Oblast',
    value: 'RU',
    isoCode: 'OMS',
  },
  {
    name: 'Yamalo-Nenets Autonomous Okrug',
    value: 'RU',
    isoCode: 'YAN',
  },
  {
    name: 'Sakha Republic',
    value: 'RU',
    isoCode: 'SA',
  },
  {
    name: 'Arkhangelsk',
    value: 'RU',
    isoCode: 'ARK',
  },
  {
    name: 'Republic of Dagestan',
    value: 'RU',
    isoCode: 'DA',
  },
  {
    name: 'Yaroslavl Oblast',
    value: 'RU',
    isoCode: 'YAR',
  },
  {
    name: 'Republic of Adygea',
    value: 'RU',
    isoCode: 'AD',
  },
  {
    name: 'Republic of North Ossetia-Alania',
    value: 'RU',
    isoCode: 'SE',
  },
  {
    name: 'Republic of Bashkortostan',
    value: 'RU',
    isoCode: 'BA',
  },
  {
    name: 'Kursk Oblast',
    value: 'RU',
    isoCode: 'KRS',
  },
  {
    name: 'Ulyanovsk Oblast',
    value: 'RU',
    isoCode: 'ULY',
  },
  {
    name: 'Nizhny Novgorod Oblast',
    value: 'RU',
    isoCode: 'NIZ',
  },
  {
    name: 'Amur Oblast',
    value: 'RU',
    isoCode: 'AMU',
  },
  {
    name: 'Chukotka Autonomous Okrug',
    value: 'RU',
    isoCode: 'CHU',
  },
  {
    name: 'Tver Oblast',
    value: 'RU',
    isoCode: 'TVE',
  },
  {
    name: 'Republic of Tatarstan',
    value: 'RU',
    isoCode: 'TA',
  },
  {
    name: 'Samara Oblast',
    value: 'RU',
    isoCode: 'SAM',
  },
  {
    name: 'Pskov Oblast',
    value: 'RU',
    isoCode: 'PSK',
  },
  {
    name: 'Ivanovo Oblast',
    value: 'RU',
    isoCode: 'IVA',
  },
  {
    name: 'Kamchatka Krai',
    value: 'RU',
    isoCode: 'KAM',
  },
  {
    name: 'Astrakhan Oblast',
    value: 'RU',
    isoCode: 'AST',
  },
  {
    name: 'Bryansk Oblast',
    value: 'RU',
    isoCode: 'BRY',
  },
  {
    name: 'Stavropol Krai',
    value: 'RU',
    isoCode: 'STA',
  },
  {
    name: 'Karachay-Cherkess Republic',
    value: 'RU',
    isoCode: 'KC',
  },
  {
    name: 'Mari El Republic',
    value: 'RU',
    isoCode: 'ME',
  },
  {
    name: 'Perm Krai',
    value: 'RU',
    isoCode: 'PER',
  },
  {
    name: 'Tomsk Oblast',
    value: 'RU',
    isoCode: 'TOM',
  },
  {
    name: 'Khabarovsk Krai',
    value: 'RU',
    isoCode: 'KHA',
  },
  {
    name: 'Vologda Oblast',
    value: 'RU',
    isoCode: 'VLG',
  },
  {
    name: 'Sakhalin',
    value: 'RU',
    isoCode: 'SAK',
  },
  {
    name: 'Altai Republic',
    value: 'RU',
    isoCode: 'AL',
  },
  {
    name: 'Republic of Khakassia',
    value: 'RU',
    isoCode: 'KK',
  },
  {
    name: 'Tambov Oblast',
    value: 'RU',
    isoCode: 'TAM',
  },
  {
    name: 'Saint Petersburg',
    value: 'RU',
    isoCode: 'SPE',
  },
  {
    name: 'Irkutsk',
    value: 'RU',
    isoCode: 'IRK',
  },
  {
    name: 'Vladimir Oblast',
    value: 'RU',
    isoCode: 'VLA',
  },
  {
    name: 'Moscow Oblast',
    value: 'RU',
    isoCode: 'MOS',
  },
  {
    name: 'Republic of Kalmykia',
    value: 'RU',
    isoCode: 'KL',
  },
  {
    name: 'Republic of Ingushetia',
    value: 'RU',
    isoCode: 'IN',
  },
  {
    name: 'Smolensk Oblast',
    value: 'RU',
    isoCode: 'SMO',
  },
  {
    name: 'Orenburg Oblast',
    value: 'RU',
    isoCode: 'ORE',
  },
  {
    name: 'Saratov Oblast',
    value: 'RU',
    isoCode: 'SAR',
  },
  {
    name: 'Novosibirsk',
    value: 'RU',
    isoCode: 'NVS',
  },
  {
    name: 'Lipetsk Oblast',
    value: 'RU',
    isoCode: 'LIP',
  },
  {
    name: 'Kirov Oblast',
    value: 'RU',
    isoCode: 'KIR',
  },
  {
    name: 'Krasnodar Krai',
    value: 'RU',
    isoCode: 'KDA',
  },
  {
    name: 'Kabardino-Balkar Republic',
    value: 'RU',
    isoCode: 'KB',
  },
  {
    name: 'Chechen Republic',
    value: 'RU',
    isoCode: 'CE',
  },
  {
    name: 'Sverdlovsk',
    value: 'RU',
    isoCode: 'SVE',
  },
  {
    name: 'Tula Oblast',
    value: 'RU',
    isoCode: 'TUL',
  },
  {
    name: 'Leningrad Oblast',
    value: 'RU',
    isoCode: 'LEN',
  },
  {
    name: 'Kemerovo Oblast',
    value: 'RU',
    isoCode: 'KEM',
  },
  {
    name: 'Republic of Mordovia',
    value: 'RU',
    isoCode: 'MO',
  },
  {
    name: 'Komi Republic',
    value: 'RU',
    isoCode: 'KO',
  },
  {
    name: 'Tuva Republic',
    value: 'RU',
    isoCode: 'TY',
  },
  {
    name: 'Moscow',
    value: 'RU',
    isoCode: 'MOW',
  },
  {
    name: 'Kaliningrad',
    value: 'RU',
    isoCode: 'KGD',
  },
  {
    name: 'Belgorod Oblast',
    value: 'RU',
    isoCode: 'BEL',
  },
  {
    name: 'Zabaykalsky Krai',
    value: 'RU',
    isoCode: 'ZAB',
  },
  {
    name: 'Ryazan Oblast',
    value: 'RU',
    isoCode: 'RYA',
  },
  {
    name: 'Voronezh Oblast',
    value: 'RU',
    isoCode: 'VOR',
  },
  {
    name: 'Tyumen Oblast',
    value: 'RU',
    isoCode: 'TYU',
  },
  {
    name: 'Oryol Oblast',
    value: 'RU',
    isoCode: 'ORL',
  },
  {
    name: 'Penza Oblast',
    value: 'RU',
    isoCode: 'PNZ',
  },
  {
    name: 'Kostroma Oblast',
    value: 'RU',
    isoCode: 'KOS',
  },
  {
    name: 'Altai Krai',
    value: 'RU',
    isoCode: 'ALT',
  },
  {
    name: 'Sevastopol',
    value: 'RU',
    isoCode: 'UA-40',
  },
  {
    name: 'Udmurt Republic',
    value: 'RU',
    isoCode: 'UD',
  },
  {
    name: 'Chuvash Republic',
    value: 'RU',
    isoCode: 'CU',
  },
  {
    name: 'Kurgan Oblast',
    value: 'RU',
    isoCode: 'KGN',
  },
  {
    name: 'Volgograd Oblast',
    value: 'RU',
    isoCode: 'VGG',
  },
  {
    name: 'Lomaiviti',
    value: 'FJ',
    isoCode: '06',
  },
  {
    name: 'Ba',
    value: 'FJ',
    isoCode: '01',
  },
  {
    name: 'Tailevu',
    value: 'FJ',
    isoCode: '14',
  },
  {
    name: 'Nadroga-Navosa',
    value: 'FJ',
    isoCode: '08',
  },
  {
    name: 'Rewa',
    value: 'FJ',
    isoCode: '12',
  },
  {
    name: 'Northern Division',
    value: 'FJ',
    isoCode: 'N',
  },
  {
    name: 'Macuata',
    value: 'FJ',
    isoCode: '07',
  },
  {
    name: 'Western Division',
    value: 'FJ',
    isoCode: 'W',
  },
  {
    name: 'Cakaudrove',
    value: 'FJ',
    isoCode: '03',
  },
  {
    name: 'Serua',
    value: 'FJ',
    isoCode: '13',
  },
  {
    name: 'Ra',
    value: 'FJ',
    isoCode: '11',
  },
  {
    name: 'Naitasiri',
    value: 'FJ',
    isoCode: '09',
  },
  {
    name: 'Namosi',
    value: 'FJ',
    isoCode: '10',
  },
  {
    name: 'Central Division',
    value: 'FJ',
    isoCode: 'C',
  },
  {
    name: 'Bua',
    value: 'FJ',
    isoCode: '02',
  },
  {
    name: 'Rotuma',
    value: 'FJ',
    isoCode: 'R',
  },
  {
    name: 'Eastern Division',
    value: 'FJ',
    isoCode: 'E',
  },
  {
    name: 'Lau',
    value: 'FJ',
    isoCode: '05',
  },
  {
    name: 'Kadavu',
    value: 'FJ',
    isoCode: '04',
  },
  {
    name: 'Labuan',
    value: 'MY',
    isoCode: '15',
  },
  {
    name: 'Sabah',
    value: 'MY',
    isoCode: '12',
  },
  {
    name: 'Sarawak',
    value: 'MY',
    isoCode: '13',
  },
  {
    name: 'Perlis',
    value: 'MY',
    isoCode: '09',
  },
  {
    name: 'Penang',
    value: 'MY',
    isoCode: '07',
  },
  {
    name: 'Pahang',
    value: 'MY',
    isoCode: '06',
  },
  {
    name: 'Malacca',
    value: 'MY',
    isoCode: '04',
  },
  {
    name: 'Terengganu',
    value: 'MY',
    isoCode: '11',
  },
  {
    name: 'Perak',
    value: 'MY',
    isoCode: '08',
  },
  {
    name: 'Selangor',
    value: 'MY',
    isoCode: '10',
  },
  {
    name: 'Putrajaya',
    value: 'MY',
    isoCode: '16',
  },
  {
    name: 'Kelantan',
    value: 'MY',
    isoCode: '03',
  },
  {
    name: 'Kedah',
    value: 'MY',
    isoCode: '02',
  },
  {
    name: 'Negeri Sembilan',
    value: 'MY',
    isoCode: '05',
  },
  {
    name: 'Kuala Lumpur',
    value: 'MY',
    isoCode: '14',
  },
  {
    name: 'Johor',
    value: 'MY',
    isoCode: '01',
  },
  {
    name: 'Mashonaland East Province',
    value: 'ZW',
    isoCode: 'ME',
  },
  {
    name: 'Matabeleland South Province',
    value: 'ZW',
    isoCode: 'MS',
  },
  {
    name: 'Mashonaland West Province',
    value: 'ZW',
    isoCode: 'MW',
  },
  {
    name: 'Matabeleland North Province',
    value: 'ZW',
    isoCode: 'MN',
  },
  {
    name: 'Mashonaland Central Province',
    value: 'ZW',
    isoCode: 'MC',
  },
  {
    name: 'Bulawayo Province',
    value: 'ZW',
    isoCode: 'BU',
  },
  {
    name: 'Midlands Province',
    value: 'ZW',
    isoCode: 'MI',
  },
  {
    name: 'Harare Province',
    value: 'ZW',
    isoCode: 'HA',
  },
  {
    name: 'Manicaland',
    value: 'ZW',
    isoCode: 'MA',
  },
  {
    name: 'Masvingo Province',
    value: 'ZW',
    isoCode: 'MV',
  },
  {
    name: 'Bulgan Province',
    value: 'MN',
    isoCode: '067',
  },
  {
    name: 'Darkhan-Uul Province',
    value: 'MN',
    isoCode: '037',
  },
  {
    name: 'Dornod Province',
    value: 'MN',
    isoCode: '061',
  },
  {
    name: 'Khovd Province',
    value: 'MN',
    isoCode: '043',
  },
  {
    name: 'Övörkhangai Province',
    value: 'MN',
    isoCode: '055',
  },
  {
    name: 'Orkhon Province',
    value: 'MN',
    isoCode: '035',
  },
  {
    name: 'Ömnögovi Province',
    value: 'MN',
    isoCode: '053',
  },
  {
    name: 'Töv Province',
    value: 'MN',
    isoCode: '047',
  },
  {
    name: 'Bayan-Ölgii Province',
    value: 'MN',
    isoCode: '071',
  },
  {
    name: 'Dundgovi Province',
    value: 'MN',
    isoCode: '059',
  },
  {
    name: 'Uvs Province',
    value: 'MN',
    isoCode: '046',
  },
  {
    name: 'Govi-Altai Province',
    value: 'MN',
    isoCode: '065',
  },
  {
    name: 'Arkhangai Province',
    value: 'MN',
    isoCode: '073',
  },
  {
    name: 'Khentii Province',
    value: 'MN',
    isoCode: '039',
  },
  {
    name: 'Khövsgöl Province',
    value: 'MN',
    isoCode: '041',
  },
  {
    name: 'Bayankhongor Province',
    value: 'MN',
    isoCode: '069',
  },
  {
    name: 'Sükhbaatar Province',
    value: 'MN',
    isoCode: '051',
  },
  {
    name: 'Govisümber Province',
    value: 'MN',
    isoCode: '064',
  },
  {
    name: 'Zavkhan Province',
    value: 'MN',
    isoCode: '057',
  },
  {
    name: 'Selenge Province',
    value: 'MN',
    isoCode: '049',
  },
  {
    name: 'Dornogovi Province',
    value: 'MN',
    isoCode: '063',
  },
  {
    name: 'Northern Province',
    value: 'ZM',
    isoCode: '05',
  },
  {
    name: 'Western Province',
    value: 'ZM',
    isoCode: '01',
  },
  {
    name: 'Copperbelt Province',
    value: 'ZM',
    isoCode: '08',
  },
  {
    name: 'Northwestern Province',
    value: 'ZM',
    isoCode: '06',
  },
  {
    name: 'Central Province',
    value: 'ZM',
    isoCode: '02',
  },
  {
    name: 'Luapula Province',
    value: 'ZM',
    isoCode: '04',
  },
  {
    name: 'Lusaka Province',
    value: 'ZM',
    isoCode: '09',
  },
  {
    name: 'Muchinga Province',
    value: 'ZM',
    isoCode: '10',
  },
  {
    name: 'Southern Province',
    value: 'ZM',
    isoCode: '07',
  },
  {
    name: 'Eastern Province',
    value: 'ZM',
    isoCode: '03',
  },
  {
    name: 'Capital Governorate',
    value: 'BH',
    isoCode: '13',
  },
  {
    name: 'Southern Governorate',
    value: 'BH',
    isoCode: '14',
  },
  {
    name: 'Northern Governorate',
    value: 'BH',
    isoCode: '17',
  },
  {
    name: 'Muharraq Governorate',
    value: 'BH',
    isoCode: '15',
  },
  {
    name: 'Central Governorate',
    value: 'BH',
    isoCode: '16',
  },
  {
    name: 'Rio de Janeiro',
    value: 'BR',
    isoCode: 'RJ',
  },
  {
    name: 'Minas Gerais',
    value: 'BR',
    isoCode: 'MG',
  },
  {
    name: 'Amapá',
    value: 'BR',
    isoCode: 'AP',
  },
  {
    name: 'Goiás',
    value: 'BR',
    isoCode: 'GO',
  },
  {
    name: 'Rio Grande do Sul',
    value: 'BR',
    isoCode: 'RS',
  },
  {
    name: 'Bahia',
    value: 'BR',
    isoCode: 'BA',
  },
  {
    name: 'Sergipe',
    value: 'BR',
    isoCode: 'SE',
  },
  {
    name: 'Amazonas',
    value: 'BR',
    isoCode: 'AM',
  },
  {
    name: 'Paraíba',
    value: 'BR',
    isoCode: 'PB',
  },
  {
    name: 'Pernambuco',
    value: 'BR',
    isoCode: 'PE',
  },
  {
    name: 'Alagoas',
    value: 'BR',
    isoCode: 'AL',
  },
  {
    name: 'Piauí',
    value: 'BR',
    isoCode: 'PI',
  },
  {
    name: 'Pará',
    value: 'BR',
    isoCode: 'PA',
  },
  {
    name: 'Mato Grosso do Sul',
    value: 'BR',
    isoCode: 'MS',
  },
  {
    name: 'Mato Grosso',
    value: 'BR',
    isoCode: 'MT',
  },
  {
    name: 'Acre',
    value: 'BR',
    isoCode: 'AC',
  },
  {
    name: 'Rondônia',
    value: 'BR',
    isoCode: 'RO',
  },
  {
    name: 'Santa Catarina',
    value: 'BR',
    isoCode: 'SC',
  },
  {
    name: 'Maranhão',
    value: 'BR',
    isoCode: 'MA',
  },
  {
    name: 'Ceará',
    value: 'BR',
    isoCode: 'CE',
  },
  {
    name: 'Distrito Federal',
    value: 'BR',
    isoCode: 'DF',
  },
  {
    name: 'Espírito Santo',
    value: 'BR',
    isoCode: 'ES',
  },
  {
    name: 'Rio Grande do Norte',
    value: 'BR',
    isoCode: 'RN',
  },
  {
    name: 'Tocantins',
    value: 'BR',
    isoCode: 'TO',
  },
  {
    name: 'São Paulo',
    value: 'BR',
    isoCode: 'SP',
  },
  {
    name: 'Paraná',
    value: 'BR',
    isoCode: 'PR',
  },
  {
    name: 'Roraima',
    value: 'BR',
    isoCode: 'RR',
  },
  {
    name: 'Aragatsotn Region',
    value: 'AM',
    isoCode: 'AG',
  },
  {
    name: 'Ararat Province',
    value: 'AM',
    isoCode: 'AR',
  },
  {
    name: 'Vayots Dzor Region',
    value: 'AM',
    isoCode: 'VD',
  },
  {
    name: 'Armavir Region',
    value: 'AM',
    isoCode: 'AV',
  },
  {
    name: 'Syunik Province',
    value: 'AM',
    isoCode: 'SU',
  },
  {
    name: 'Gegharkunik Province',
    value: 'AM',
    isoCode: 'GR',
  },
  {
    name: 'Lori Region',
    value: 'AM',
    isoCode: 'LO',
  },
  {
    name: 'Yerevan',
    value: 'AM',
    isoCode: 'ER',
  },
  {
    name: 'Shirak Region',
    value: 'AM',
    isoCode: 'SH',
  },
  {
    name: 'Tavush Region',
    value: 'AM',
    isoCode: 'TV',
  },
  {
    name: 'Kotayk Region',
    value: 'AM',
    isoCode: 'KT',
  },
  {
    name: 'Cojedes',
    value: 'VE',
    isoCode: 'H',
  },
  {
    name: 'Falcón',
    value: 'VE',
    isoCode: 'I',
  },
  {
    name: 'Portuguesa',
    value: 'VE',
    isoCode: 'P',
  },
  {
    name: 'Miranda',
    value: 'VE',
    isoCode: 'M',
  },
  {
    name: 'Lara',
    value: 'VE',
    isoCode: 'K',
  },
  {
    name: 'Bolívar',
    value: 'VE',
    isoCode: 'F',
  },
  {
    name: 'Carabobo',
    value: 'VE',
    isoCode: 'G',
  },
  {
    name: 'Yaracuy',
    value: 'VE',
    isoCode: 'U',
  },
  {
    name: 'Zulia',
    value: 'VE',
    isoCode: 'V',
  },
  {
    name: 'Trujillo',
    value: 'VE',
    isoCode: 'T',
  },
  {
    name: 'Amazonas',
    value: 'VE',
    isoCode: 'Z',
  },
  {
    name: 'Guárico',
    value: 'VE',
    isoCode: 'J',
  },
  {
    name: 'Federal Dependencies of Venezuela',
    value: 'VE',
    isoCode: 'W',
  },
  {
    name: 'Aragua',
    value: 'VE',
    isoCode: 'D',
  },
  {
    name: 'Táchira',
    value: 'VE',
    isoCode: 'S',
  },
  {
    name: 'Barinas',
    value: 'VE',
    isoCode: 'E',
  },
  {
    name: 'Anzoátegui',
    value: 'VE',
    isoCode: 'B',
  },
  {
    name: 'Delta Amacuro',
    value: 'VE',
    isoCode: 'Y',
  },
  {
    name: 'Nueva Esparta',
    value: 'VE',
    isoCode: 'O',
  },
  {
    name: 'Mérida',
    value: 'VE',
    isoCode: 'L',
  },
  {
    name: 'Monagas',
    value: 'VE',
    isoCode: 'N',
  },
  {
    name: 'La Guaira',
    value: 'VE',
    isoCode: 'X',
  },
  {
    name: 'Sucre',
    value: 'VE',
    isoCode: 'R',
  },
  {
    name: 'Distrito Capital',
    value: 'VE',
    isoCode: 'A',
  },
  {
    name: 'Apure',
    value: 'VE',
    isoCode: 'C',
  },
  {
    name: 'Carinthia',
    value: 'AT',
    isoCode: '2',
  },
  {
    name: 'Upper Austria',
    value: 'AT',
    isoCode: '4',
  },
  {
    name: 'Styria',
    value: 'AT',
    isoCode: '6',
  },
  {
    name: 'Vienna',
    value: 'AT',
    isoCode: '9',
  },
  {
    name: 'Salzburg',
    value: 'AT',
    isoCode: '5',
  },
  {
    name: 'Burgenland',
    value: 'AT',
    isoCode: '1',
  },
  {
    name: 'Vorarlberg',
    value: 'AT',
    isoCode: '8',
  },
  {
    name: 'Tyrol',
    value: 'AT',
    isoCode: '7',
  },
  {
    name: 'Lower Austria',
    value: 'AT',
    isoCode: '3',
  },
  {
    name: 'Mid-Western Region',
    value: 'NP',
    isoCode: '2',
  },
  {
    name: 'Western Region',
    value: 'NP',
    isoCode: '3',
  },
  {
    name: 'Far-Western Development Region',
    value: 'NP',
    isoCode: '5',
  },
  {
    name: 'Eastern Development Region',
    value: 'NP',
    isoCode: '4',
  },
  {
    name: 'Mechi Zone',
    value: 'NP',
    isoCode: 'ME',
  },
  {
    name: 'Bheri Zone',
    value: 'NP',
    isoCode: 'BH',
  },
  {
    name: 'Kosi Zone',
    value: 'NP',
    isoCode: 'KO',
  },
  {
    name: 'Central Region',
    value: 'NP',
    isoCode: '1',
  },
  {
    name: 'Lumbini Zone',
    value: 'NP',
    isoCode: 'LU',
  },
  {
    name: 'Narayani Zone',
    value: 'NP',
    isoCode: 'NA',
  },
  {
    name: 'Janakpur Zone',
    value: 'NP',
    isoCode: 'JA',
  },
  {
    name: 'Rapti Zone',
    value: 'NP',
    isoCode: 'RA',
  },
  {
    name: 'Seti Zone',
    value: 'NP',
    isoCode: 'SE',
  },
  {
    name: 'Karnali Zone',
    value: 'NP',
    isoCode: 'KA',
  },
  {
    name: 'Dhaulagiri Zone',
    value: 'NP',
    isoCode: 'DH',
  },
  {
    name: 'Gandaki Zone',
    value: 'NP',
    isoCode: 'GA',
  },
  {
    name: 'Bagmati Zone',
    value: 'NP',
    isoCode: 'BA',
  },
  {
    name: 'Mahakali Zone',
    value: 'NP',
    isoCode: 'MA',
  },
  {
    name: 'Sagarmatha Zone',
    value: 'NP',
    isoCode: 'SA',
  },
  {
    name: 'Unity',
    value: 'SS',
    isoCode: 'UY',
  },
  {
    name: 'Upper Nile',
    value: 'SS',
    isoCode: 'NU',
  },
  {
    name: 'Warrap',
    value: 'SS',
    isoCode: 'WR',
  },
  {
    name: 'Northern Bahr el Ghazal',
    value: 'SS',
    isoCode: 'BN',
  },
  {
    name: 'Western Equatoria',
    value: 'SS',
    isoCode: 'EW',
  },
  {
    name: 'Lakes',
    value: 'SS',
    isoCode: 'LK',
  },
  {
    name: 'Western Bahr el Ghazal',
    value: 'SS',
    isoCode: 'BW',
  },
  {
    name: 'Central Equatoria',
    value: 'SS',
    isoCode: 'EC',
  },
  {
    name: 'Eastern Equatoria',
    value: 'SS',
    isoCode: 'EE',
  },
  {
    name: 'Jonglei State',
    value: 'SS',
    isoCode: 'JG',
  },
  {
    name: 'Karditsa Regional Unit',
    value: 'GR',
    isoCode: '41',
  },
  {
    name: 'West Greece Region',
    value: 'GR',
    isoCode: 'G',
  },
  {
    name: 'Thessaloniki Regional Unit',
    value: 'GR',
    isoCode: '54',
  },
  {
    name: 'Arcadia Prefecture',
    value: 'GR',
    isoCode: '12',
  },
  {
    name: 'Imathia Regional Unit',
    value: 'GR',
    isoCode: '53',
  },
  {
    name: 'Kastoria Regional Unit',
    value: 'GR',
    isoCode: '56',
  },
  {
    name: 'Euboea',
    value: 'GR',
    isoCode: '04',
  },
  {
    name: 'Grevena Prefecture',
    value: 'GR',
    isoCode: '51',
  },
  {
    name: 'Preveza Prefecture',
    value: 'GR',
    isoCode: '34',
  },
  {
    name: 'Lefkada Regional Unit',
    value: 'GR',
    isoCode: '24',
  },
  {
    name: 'Argolis Regional Unit',
    value: 'GR',
    isoCode: '11',
  },
  {
    name: 'Laconia',
    value: 'GR',
    isoCode: '16',
  },
  {
    name: 'Pella Regional Unit',
    value: 'GR',
    isoCode: '59',
  },
  {
    name: 'West Macedonia Region',
    value: 'GR',
    isoCode: 'C',
  },
  {
    name: 'Crete Region',
    value: 'GR',
    isoCode: 'M',
  },
  {
    name: 'Epirus Region',
    value: 'GR',
    isoCode: 'D',
  },
  {
    name: 'Kilkis Regional Unit',
    value: 'GR',
    isoCode: '57',
  },
  {
    name: 'Kozani Prefecture',
    value: 'GR',
    isoCode: '58',
  },
  {
    name: 'Ioannina Regional Unit',
    value: 'GR',
    isoCode: '33',
  },
  {
    name: 'Phthiotis Prefecture',
    value: 'GR',
    isoCode: '06',
  },
  {
    name: 'Chania Regional Unit',
    value: 'GR',
    isoCode: '94',
  },
  {
    name: 'Achaea Regional Unit',
    value: 'GR',
    isoCode: '13',
  },
  {
    name: 'East Macedonia and Thrace',
    value: 'GR',
    isoCode: 'A',
  },
  {
    name: 'South Aegean',
    value: 'GR',
    isoCode: 'L',
  },
  {
    name: 'Peloponnese Region',
    value: 'GR',
    isoCode: 'J',
  },
  {
    name: 'East Attica Regional Unit',
    value: 'GR',
    isoCode: 'A2',
  },
  {
    name: 'Serres Prefecture',
    value: 'GR',
    isoCode: '62',
  },
  {
    name: 'Attica Region',
    value: 'GR',
    isoCode: 'I',
  },
  {
    name: 'Aetolia-Acarnania Regional Unit',
    value: 'GR',
    isoCode: '01',
  },
  {
    name: 'Corfu Prefecture',
    value: 'GR',
    isoCode: '22',
  },
  {
    name: 'Central Macedonia',
    value: 'GR',
    isoCode: 'B',
  },
  {
    name: 'Boeotia Regional Unit',
    value: 'GR',
    isoCode: '03',
  },
  {
    name: 'Kefalonia Prefecture',
    value: 'GR',
    isoCode: '23',
  },
  {
    name: 'Central Greece Region',
    value: 'GR',
    isoCode: 'H',
  },
  {
    name: 'Corinthia Regional Unit',
    value: 'GR',
    isoCode: '15',
  },
  {
    name: 'Drama Regional Unit',
    value: 'GR',
    isoCode: '52',
  },
  {
    name: 'Ionian Islands Region',
    value: 'GR',
    isoCode: 'F',
  },
  {
    name: 'Larissa Prefecture',
    value: 'GR',
    isoCode: '42',
  },
  {
    name: 'Kayin State',
    value: 'MM',
    isoCode: '13',
  },
  {
    name: 'Mandalay Region',
    value: 'MM',
    isoCode: '04',
  },
  {
    name: 'Yangon Region',
    value: 'MM',
    isoCode: '06',
  },
  {
    name: 'Magway Region',
    value: 'MM',
    isoCode: '03',
  },
  {
    name: 'Chin State',
    value: 'MM',
    isoCode: '14',
  },
  {
    name: 'Rakhine State',
    value: 'MM',
    isoCode: '16',
  },
  {
    name: 'Shan State',
    value: 'MM',
    isoCode: '17',
  },
  {
    name: 'Tanintharyi Region',
    value: 'MM',
    isoCode: '05',
  },
  {
    name: 'Bago',
    value: 'MM',
    isoCode: '02',
  },
  {
    name: 'Ayeyarwady Region',
    value: 'MM',
    isoCode: '07',
  },
  {
    name: 'Kachin State',
    value: 'MM',
    isoCode: '11',
  },
  {
    name: 'Kayah State',
    value: 'MM',
    isoCode: '12',
  },
  {
    name: 'Sagaing Region',
    value: 'MM',
    isoCode: '01',
  },
  {
    name: 'Naypyidaw Union Territory',
    value: 'MM',
    isoCode: '18',
  },
  {
    name: 'Mon State',
    value: 'MM',
    isoCode: '15',
  },
  {
    name: 'Bartın',
    value: 'TR',
    isoCode: '74',
  },
  {
    name: 'Kütahya',
    value: 'TR',
    isoCode: '43',
  },
  {
    name: 'Sakarya',
    value: 'TR',
    isoCode: '54',
  },
  {
    name: 'Edirne',
    value: 'TR',
    isoCode: '22',
  },
  {
    name: 'Van',
    value: 'TR',
    isoCode: '65',
  },
  {
    name: 'Bingöl',
    value: 'TR',
    isoCode: '12',
  },
  {
    name: 'Kilis',
    value: 'TR',
    isoCode: '79',
  },
  {
    name: 'Adıyaman',
    value: 'TR',
    isoCode: '02',
  },
  {
    name: 'Mersin',
    value: 'TR',
    isoCode: '33',
  },
  {
    name: 'Denizli',
    value: 'TR',
    isoCode: '20',
  },
  {
    name: 'Malatya',
    value: 'TR',
    isoCode: '44',
  },
  {
    name: 'Elazığ',
    value: 'TR',
    isoCode: '23',
  },
  {
    name: 'Erzincan',
    value: 'TR',
    isoCode: '24',
  },
  {
    name: 'Amasya',
    value: 'TR',
    isoCode: '05',
  },
  {
    name: 'Muş',
    value: 'TR',
    isoCode: '49',
  },
  {
    name: 'Bursa',
    value: 'TR',
    isoCode: '16',
  },
  {
    name: 'Eskişehir',
    value: 'TR',
    isoCode: '26',
  },
  {
    name: 'Erzurum',
    value: 'TR',
    isoCode: '25',
  },
  {
    name: 'Iğdır',
    value: 'TR',
    isoCode: '76',
  },
  {
    name: 'Tekirdağ',
    value: 'TR',
    isoCode: '59',
  },
  {
    name: 'Çankırı',
    value: 'TR',
    isoCode: '18',
  },
  {
    name: 'Antalya',
    value: 'TR',
    isoCode: '07',
  },
  {
    name: 'Istanbul',
    value: 'TR',
    isoCode: '34',
  },
  {
    name: 'Konya',
    value: 'TR',
    isoCode: '42',
  },
  {
    name: 'Bolu',
    value: 'TR',
    isoCode: '14',
  },
  {
    name: 'Çorum',
    value: 'TR',
    isoCode: '19',
  },
  {
    name: 'Ordu',
    value: 'TR',
    isoCode: '52',
  },
  {
    name: 'Balıkesir',
    value: 'TR',
    isoCode: '10',
  },
  {
    name: 'Kırklareli',
    value: 'TR',
    isoCode: '39',
  },
  {
    name: 'Bayburt',
    value: 'TR',
    isoCode: '69',
  },
  {
    name: 'Kırıkkale',
    value: 'TR',
    isoCode: '71',
  },
  {
    name: 'Afyonkarahisar',
    value: 'TR',
    isoCode: '03',
  },
  {
    name: 'Kırşehir',
    value: 'TR',
    isoCode: '40',
  },
  {
    name: 'Sivas',
    value: 'TR',
    isoCode: '58',
  },
  {
    name: 'Muğla',
    value: 'TR',
    isoCode: '48',
  },
  {
    name: 'Şanlıurfa',
    value: 'TR',
    isoCode: '63',
  },
  {
    name: 'Karaman',
    value: 'TR',
    isoCode: '70',
  },
  {
    name: 'Ardahan',
    value: 'TR',
    isoCode: '75',
  },
  {
    name: 'Giresun',
    value: 'TR',
    isoCode: '28',
  },
  {
    name: 'Aydın',
    value: 'TR',
    isoCode: '09',
  },
  {
    name: 'Yozgat',
    value: 'TR',
    isoCode: '66',
  },
  {
    name: 'Niğde',
    value: 'TR',
    isoCode: '51',
  },
  {
    name: 'Hakkâri',
    value: 'TR',
    isoCode: '30',
  },
  {
    name: 'Artvin',
    value: 'TR',
    isoCode: '08',
  },
  {
    name: 'Tunceli',
    value: 'TR',
    isoCode: '62',
  },
  {
    name: 'Ağrı',
    value: 'TR',
    isoCode: '04',
  },
  {
    name: 'Batman',
    value: 'TR',
    isoCode: '72',
  },
  {
    name: 'Kocaeli',
    value: 'TR',
    isoCode: '41',
  },
  {
    name: 'Nevşehir',
    value: 'TR',
    isoCode: '50',
  },
  {
    name: 'Kastamonu',
    value: 'TR',
    isoCode: '37',
  },
  {
    name: 'Manisa',
    value: 'TR',
    isoCode: '45',
  },
  {
    name: 'Tokat',
    value: 'TR',
    isoCode: '60',
  },
  {
    name: 'Kayseri',
    value: 'TR',
    isoCode: '38',
  },
  {
    name: 'Uşak',
    value: 'TR',
    isoCode: '64',
  },
  {
    name: 'Düzce',
    value: 'TR',
    isoCode: '81',
  },
  {
    name: 'Gaziantep',
    value: 'TR',
    isoCode: '27',
  },
  {
    name: 'Gümüşhane',
    value: 'TR',
    isoCode: '29',
  },
  {
    name: 'İzmir',
    value: 'TR',
    isoCode: '35',
  },
  {
    name: 'Trabzon',
    value: 'TR',
    isoCode: '61',
  },
  {
    name: 'Siirt',
    value: 'TR',
    isoCode: '56',
  },
  {
    name: 'Kars',
    value: 'TR',
    isoCode: '36',
  },
  {
    name: 'Burdur',
    value: 'TR',
    isoCode: '15',
  },
  {
    name: 'Aksaray',
    value: 'TR',
    isoCode: '68',
  },
  {
    name: 'Hatay',
    value: 'TR',
    isoCode: '31',
  },
  {
    name: 'Adana',
    value: 'TR',
    isoCode: '01',
  },
  {
    name: 'Zonguldak',
    value: 'TR',
    isoCode: '67',
  },
  {
    name: 'Osmaniye',
    value: 'TR',
    isoCode: '80',
  },
  {
    name: 'Bitlis',
    value: 'TR',
    isoCode: '13',
  },
  {
    name: 'Çanakkale',
    value: 'TR',
    isoCode: '17',
  },
  {
    name: 'Ankara',
    value: 'TR',
    isoCode: '06',
  },
  {
    name: 'Yalova',
    value: 'TR',
    isoCode: '77',
  },
  {
    name: 'Rize',
    value: 'TR',
    isoCode: '53',
  },
  {
    name: 'Samsun',
    value: 'TR',
    isoCode: '55',
  },
  {
    name: 'Bilecik',
    value: 'TR',
    isoCode: '11',
  },
  {
    name: 'Isparta',
    value: 'TR',
    isoCode: '32',
  },
  {
    name: 'Karabük',
    value: 'TR',
    isoCode: '78',
  },
  {
    name: 'Mardin',
    value: 'TR',
    isoCode: '47',
  },
  {
    name: 'Şırnak',
    value: 'TR',
    isoCode: '73',
  },
  {
    name: 'Diyarbakır',
    value: 'TR',
    isoCode: '21',
  },
  {
    name: 'Kahramanmaraş',
    value: 'TR',
    isoCode: '46',
  },
  {
    name: 'Sinop',
    value: 'TR',
    isoCode: '57',
  },
  {
    name: 'Lisbon',
    value: 'PT',
    isoCode: '11',
  },
  {
    name: 'Bragança',
    value: 'PT',
    isoCode: '04',
  },
  {
    name: 'Beja',
    value: 'PT',
    isoCode: '02',
  },
  {
    name: 'Madeira',
    value: 'PT',
    isoCode: '30',
  },
  {
    name: 'Portalegre',
    value: 'PT',
    isoCode: '12',
  },
  {
    name: 'Açores',
    value: 'PT',
    isoCode: '20',
  },
  {
    name: 'Vila Real',
    value: 'PT',
    isoCode: '17',
  },
  {
    name: 'Aveiro',
    value: 'PT',
    isoCode: '01',
  },
  {
    name: 'Évora',
    value: 'PT',
    isoCode: '07',
  },
  {
    name: 'Viseu',
    value: 'PT',
    isoCode: '18',
  },
  {
    name: 'Santarém',
    value: 'PT',
    isoCode: '14',
  },
  {
    name: 'Faro',
    value: 'PT',
    isoCode: '08',
  },
  {
    name: 'Leiria',
    value: 'PT',
    isoCode: '10',
  },
  {
    name: 'Castelo Branco',
    value: 'PT',
    isoCode: '05',
  },
  {
    name: 'Setúbal',
    value: 'PT',
    isoCode: '15',
  },
  {
    name: 'Porto',
    value: 'PT',
    isoCode: '13',
  },
  {
    name: 'Braga',
    value: 'PT',
    isoCode: '03',
  },
  {
    name: 'Viana do Castelo',
    value: 'PT',
    isoCode: '16',
  },
  {
    name: 'Coimbra',
    value: 'PT',
    isoCode: '06',
  },
  {
    name: 'Guarda',
    value: 'PT',
    isoCode: '09',
  },
  {
    name: 'Zhejiang',
    value: 'CN',
    isoCode: 'ZJ',
  },
  {
    name: 'Fujian',
    value: 'CN',
    isoCode: 'FJ',
  },
  {
    name: 'Shanghai',
    value: 'CN',
    isoCode: 'SH',
  },
  {
    name: 'Jiangsu',
    value: 'CN',
    isoCode: 'JS',
  },
  {
    name: 'Anhui',
    value: 'CN',
    isoCode: 'AH',
  },
  {
    name: 'Shandong',
    value: 'CN',
    isoCode: 'SD',
  },
  {
    name: 'Jilin',
    value: 'CN',
    isoCode: 'JL',
  },
  {
    name: 'Shanxi',
    value: 'CN',
    isoCode: 'SX',
  },
  {
    name: 'Taiwan',
    value: 'CN',
    isoCode: 'TW',
  },
  {
    name: 'Jiangxi',
    value: 'CN',
    isoCode: 'JX',
  },
  {
    name: 'Beijing',
    value: 'CN',
    isoCode: 'BJ',
  },
  {
    name: 'Hunan',
    value: 'CN',
    isoCode: 'HN',
  },
  {
    name: 'Henan',
    value: 'CN',
    isoCode: 'HA',
  },
  {
    name: 'Yunnan',
    value: 'CN',
    isoCode: 'YN',
  },
  {
    name: 'Guizhou',
    value: 'CN',
    isoCode: 'GZ',
  },
  {
    name: 'Ningxia Huizu',
    value: 'CN',
    isoCode: 'NX',
  },
  {
    name: 'Xinjiang',
    value: 'CN',
    isoCode: 'XJ',
  },
  {
    name: 'Xizang',
    value: 'CN',
    isoCode: 'XZ',
  },
  {
    name: 'Heilongjiang',
    value: 'CN',
    isoCode: 'HL',
  },
  {
    name: 'Macau SAR',
    value: 'CN',
    isoCode: 'MO',
  },
  {
    name: 'Hong Kong SAR',
    value: 'CN',
    isoCode: 'HK',
  },
  {
    name: 'Liaoning',
    value: 'CN',
    isoCode: 'LN',
  },
  {
    name: 'Inner Mongolia',
    value: 'CN',
    isoCode: 'NM',
  },
  {
    name: 'Qinghai',
    value: 'CN',
    isoCode: 'QH',
  },
  {
    name: 'Chongqing',
    value: 'CN',
    isoCode: 'CQ',
  },
  {
    name: 'Shaanxi',
    value: 'CN',
    isoCode: 'SN',
  },
  {
    name: 'Hainan',
    value: 'CN',
    isoCode: 'HI',
  },
  {
    name: 'Hubei',
    value: 'CN',
    isoCode: 'HB',
  },
  {
    name: 'Gansu',
    value: 'CN',
    isoCode: 'GS',
  },
  {
    name: 'Tianjin',
    value: 'CN',
    isoCode: 'TJ',
  },
  {
    name: 'Sichuan',
    value: 'CN',
    isoCode: 'SC',
  },
  {
    name: 'Guangxi Zhuang',
    value: 'CN',
    isoCode: 'GX',
  },
  {
    name: 'Guangdong',
    value: 'CN',
    isoCode: 'GD',
  },
  {
    name: 'Hebei',
    value: 'CN',
    isoCode: 'HE',
  },
  {
    name: 'South Governorate',
    value: 'LB',
    isoCode: 'JA',
  },
  {
    name: 'Mount Lebanon Governorate',
    value: 'LB',
    isoCode: 'JL',
  },
  {
    name: 'Baalbek-Hermel Governorate',
    value: 'LB',
    isoCode: 'BH',
  },
  {
    name: 'North Governorate',
    value: 'LB',
    isoCode: 'AS',
  },
  {
    name: 'Akkar Governorate',
    value: 'LB',
    isoCode: 'AK',
  },
  {
    name: 'Beirut Governorate',
    value: 'LB',
    isoCode: 'BA',
  },
  {
    name: 'Beqaa Governorate',
    value: 'LB',
    isoCode: 'BI',
  },
  {
    name: 'Nabatieh Governorate',
    value: 'LB',
    isoCode: 'NA',
  },
  {
    name: 'Isle of Wight',
    value: 'GB',
    isoCode: 'IOW',
  },
  {
    name: 'St Helens',
    value: 'GB',
    isoCode: 'SHN',
  },
  {
    name: 'London Borough of Brent',
    value: 'GB',
    isoCode: 'BEN',
  },
  {
    name: 'Walsall',
    value: 'GB',
    isoCode: 'WLL',
  },
  {
    name: 'Trafford',
    value: 'GB',
    isoCode: 'TRF',
  },
  {
    name: 'City of Southampton',
    value: 'GB',
    isoCode: 'STH',
  },
  {
    name: 'Sheffield',
    value: 'GB',
    isoCode: 'SHF',
  },
  {
    name: 'West Sussex',
    value: 'GB',
    isoCode: 'WSX',
  },
  {
    name: 'City of Peterborough',
    value: 'GB',
    isoCode: 'PTE',
  },
  {
    name: 'Caerphilly County Borough',
    value: 'GB',
    isoCode: 'CAY',
  },
  {
    name: 'Vale of Glamorgan',
    value: 'GB',
    isoCode: 'VGL',
  },
  {
    name: 'Shetland Islands',
    value: 'GB',
    isoCode: 'ZET',
  },
  {
    name: 'Rhondda Cynon Taf',
    value: 'GB',
    isoCode: 'RCT',
  },
  {
    name: 'Poole',
    value: 'GB',
    isoCode: 'POL',
  },
  {
    name: 'Central Bedfordshire',
    value: 'GB',
    isoCode: 'CBF',
  },
  {
    name: 'Down District Council',
    value: 'GB',
    isoCode: 'DOW',
  },
  {
    name: 'City of Portsmouth',
    value: 'GB',
    isoCode: 'POR',
  },
  {
    name: 'London Borough of Haringey',
    value: 'GB',
    isoCode: 'HRY',
  },
  {
    name: 'London Borough of Bexley',
    value: 'GB',
    isoCode: 'BEX',
  },
  {
    name: 'Rotherham',
    value: 'GB',
    isoCode: 'ROT',
  },
  {
    name: 'Hartlepool',
    value: 'GB',
    isoCode: 'HPL',
  },
  {
    name: 'Telford and Wrekin',
    value: 'GB',
    isoCode: 'TFW',
  },
  {
    name: 'Belfast district',
    value: 'GB',
    isoCode: 'BFS',
  },
  {
    name: 'Cornwall',
    value: 'GB',
    isoCode: 'CON',
  },
  {
    name: 'London Borough of Sutton',
    value: 'GB',
    isoCode: 'STN',
  },
  {
    name: 'Omagh District Council',
    value: 'GB',
    isoCode: 'OMH',
  },
  {
    name: 'Banbridge',
    value: 'GB',
    isoCode: 'BNB',
  },
  {
    name: 'Causeway Coast and Glens',
    value: 'GB',
    isoCode: 'CCG',
  },
  {
    name: 'Newtownabbey Borough Council',
    value: 'GB',
    isoCode: 'NTA',
  },
  {
    name: 'City of Leicester',
    value: 'GB',
    isoCode: 'LCE',
  },
  {
    name: 'London Borough of Islington',
    value: 'GB',
    isoCode: 'ISL',
  },
  {
    name: 'Metropolitan Borough of Wigan',
    value: 'GB',
    isoCode: 'WGN',
  },
  {
    name: 'Oxfordshire',
    value: 'GB',
    isoCode: 'OXF',
  },
  {
    name: 'Magherafelt District Council',
    value: 'GB',
    isoCode: 'MFT',
  },
  {
    name: 'Southend-on-Sea',
    value: 'GB',
    isoCode: 'SOS',
  },
  {
    name: 'Armagh, Banbridge and Craigavon',
    value: 'GB',
    isoCode: 'ABC',
  },
  {
    name: 'Perth and Kinross',
    value: 'GB',
    isoCode: 'PKN',
  },
  {
    name: 'London Borough of Waltham Forest',
    value: 'GB',
    isoCode: 'WFT',
  },
  {
    name: 'Rochdale',
    value: 'GB',
    isoCode: 'RCH',
  },
  {
    name: 'Merthyr Tydfil County Borough',
    value: 'GB',
    isoCode: 'MTY',
  },
  {
    name: 'Blackburn with Darwen',
    value: 'GB',
    isoCode: 'BBD',
  },
  {
    name: 'Knowsley',
    value: 'GB',
    isoCode: 'KWL',
  },
  {
    name: 'Armagh City and District Council',
    value: 'GB',
    isoCode: 'ARM',
  },
  {
    name: 'Middlesbrough',
    value: 'GB',
    isoCode: 'MDB',
  },
  {
    name: 'East Renfrewshire',
    value: 'GB',
    isoCode: 'ERW',
  },
  {
    name: 'Cumbria',
    value: 'GB',
    isoCode: 'CMA',
  },
  {
    name: 'Scotland',
    value: 'GB',
    isoCode: 'SCT',
  },
  {
    name: 'England',
    value: 'GB',
    isoCode: 'ENG',
  },
  {
    name: 'Northern Ireland',
    value: 'GB',
    isoCode: 'NIR',
  },
  {
    name: 'Wales',
    value: 'GB',
    isoCode: 'WLS',
  },
  {
    name: 'Bath and North East Somerset',
    value: 'GB',
    isoCode: 'BAS',
  },
  {
    name: 'Liverpool',
    value: 'GB',
    isoCode: 'LIV',
  },
  {
    name: 'Sandwell',
    value: 'GB',
    isoCode: 'SAW',
  },
  {
    name: 'Bournemouth',
    value: 'GB',
    isoCode: 'BMH',
  },
  {
    name: 'Isles of Scilly',
    value: 'GB',
    isoCode: 'IOS',
  },
  {
    name: 'Falkirk',
    value: 'GB',
    isoCode: 'FAL',
  },
  {
    name: 'Dorset',
    value: 'GB',
    isoCode: 'DOR',
  },
  {
    name: 'Scottish Borders',
    value: 'GB',
    isoCode: 'SCB',
  },
  {
    name: 'London Borough of Havering',
    value: 'GB',
    isoCode: 'HAV',
  },
  {
    name: 'Moyle District Council',
    value: 'GB',
    isoCode: 'MYL',
  },
  {
    name: 'London Borough of Camden',
    value: 'GB',
    isoCode: 'CMD',
  },
  {
    name: 'Newry and Mourne District Council',
    value: 'GB',
    isoCode: 'NYM',
  },
  {
    name: 'Neath Port Talbot County Borough',
    value: 'GB',
    isoCode: 'NTL',
  },
  {
    name: 'Conwy County Borough',
    value: 'GB',
    isoCode: 'CWY',
  },
  {
    name: 'Outer Hebrides',
    value: 'GB',
    isoCode: 'ELS',
  },
  {
    name: 'West Lothian',
    value: 'GB',
    isoCode: 'WLN',
  },
  {
    name: 'Lincolnshire',
    value: 'GB',
    isoCode: 'LIN',
  },
  {
    name: 'London Borough of Barking and Dagenham',
    value: 'GB',
    isoCode: 'BDG',
  },
  {
    name: 'City of Westminster',
    value: 'GB',
    isoCode: 'WSM',
  },
  {
    name: 'London Borough of Lewisham',
    value: 'GB',
    isoCode: 'LEW',
  },
  {
    name: 'City of Nottingham',
    value: 'GB',
    isoCode: 'NGM',
  },
  {
    name: 'Moray',
    value: 'GB',
    isoCode: 'MRY',
  },
  {
    name: 'Ballymoney',
    value: 'GB',
    isoCode: 'BLY',
  },
  {
    name: 'South Lanarkshire',
    value: 'GB',
    isoCode: 'SLK',
  },
  {
    name: 'Ballymena Borough',
    value: 'GB',
    isoCode: 'BLA',
  },
  {
    name: 'Doncaster',
    value: 'GB',
    isoCode: 'DNC',
  },
  {
    name: 'Northumberland',
    value: 'GB',
    isoCode: 'NBL',
  },
  {
    name: 'Fermanagh and Omagh',
    value: 'GB',
    isoCode: 'FMO',
  },
  {
    name: 'Tameside',
    value: 'GB',
    isoCode: 'TAM',
  },
  {
    name: 'Royal Borough of Kensington and Chelsea',
    value: 'GB',
    isoCode: 'KEC',
  },
  {
    name: 'Hertfordshire',
    value: 'GB',
    isoCode: 'HRT',
  },
  {
    name: 'East Riding of Yorkshire',
    value: 'GB',
    isoCode: 'ERY',
  },
  {
    name: 'Kirklees',
    value: 'GB',
    isoCode: 'KIR',
  },
  {
    name: 'City of Sunderland',
    value: 'GB',
    isoCode: 'SND',
  },
  {
    name: 'Gloucestershire',
    value: 'GB',
    isoCode: 'GLS',
  },
  {
    name: 'East Ayrshire',
    value: 'GB',
    isoCode: 'EAY',
  },
  {
    name: 'United Kingdom',
    value: 'GB',
    isoCode: 'UKM',
  },
  {
    name: 'London Borough of Hillingdon',
    value: 'GB',
    isoCode: 'HIL',
  },
  {
    name: 'South Ayrshire',
    value: 'GB',
    isoCode: 'SAY',
  },
  {
    name: 'Ascension Island',
    value: 'GB',
    isoCode: 'SH-AC',
  },
  {
    name: 'Gwynedd',
    value: 'GB',
    isoCode: 'GWN',
  },
  {
    name: 'London Borough of Hounslow',
    value: 'GB',
    isoCode: 'HNS',
  },
  {
    name: 'Medway',
    value: 'GB',
    isoCode: 'MDW',
  },
  {
    name: 'Limavady Borough Council',
    value: 'GB',
    isoCode: 'LMV',
  },
  {
    name: 'Highland',
    value: 'GB',
    isoCode: 'HLD',
  },
  {
    name: 'North East Lincolnshire',
    value: 'GB',
    isoCode: 'NEL',
  },
  {
    name: 'London Borough of Harrow',
    value: 'GB',
    isoCode: 'HRW',
  },
  {
    name: 'Somerset',
    value: 'GB',
    isoCode: 'SOM',
  },
  {
    name: 'Angus',
    value: 'GB',
    isoCode: 'ANS',
  },
  {
    name: 'Inverclyde',
    value: 'GB',
    isoCode: 'IVC',
  },
  {
    name: 'Darlington',
    value: 'GB',
    isoCode: 'DAL',
  },
  {
    name: 'London Borough of Tower Hamlets',
    value: 'GB',
    isoCode: 'TWH',
  },
  {
    name: 'Wiltshire',
    value: 'GB',
    isoCode: 'WIL',
  },
  {
    name: 'Argyll and Bute',
    value: 'GB',
    isoCode: 'AGB',
  },
  {
    name: 'Strabane District Council',
    value: 'GB',
    isoCode: 'STB',
  },
  {
    name: 'Stockport',
    value: 'GB',
    isoCode: 'SKP',
  },
  {
    name: 'Brighton and Hove',
    value: 'GB',
    isoCode: 'BNH',
  },
  {
    name: 'London Borough of Lambeth',
    value: 'GB',
    isoCode: 'LBH',
  },
  {
    name: 'London Borough of Redbridge',
    value: 'GB',
    isoCode: 'RDB',
  },
  {
    name: 'Manchester',
    value: 'GB',
    isoCode: 'MAN',
  },
  {
    name: 'Mid Ulster',
    value: 'GB',
    isoCode: 'MUL',
  },
  {
    name: 'South Gloucestershire',
    value: 'GB',
    isoCode: 'SGC',
  },
  {
    name: 'Aberdeenshire',
    value: 'GB',
    isoCode: 'ABD',
  },
  {
    name: 'Monmouthshire',
    value: 'GB',
    isoCode: 'MON',
  },
  {
    name: 'Derbyshire',
    value: 'GB',
    isoCode: 'DBY',
  },
  {
    name: 'Glasgow',
    value: 'GB',
    isoCode: 'GLG',
  },
  {
    name: 'Buckinghamshire',
    value: 'GB',
    isoCode: 'BKM',
  },
  {
    name: 'County Durham',
    value: 'GB',
    isoCode: 'DUR',
  },
  {
    name: 'Shropshire',
    value: 'GB',
    isoCode: 'SHR',
  },
  {
    name: 'Wirral',
    value: 'GB',
    isoCode: 'WRL',
  },
  {
    name: 'South Tyneside',
    value: 'GB',
    isoCode: 'STY',
  },
  {
    name: 'Essex',
    value: 'GB',
    isoCode: 'ESS',
  },
  {
    name: 'London Borough of Hackney',
    value: 'GB',
    isoCode: 'HCK',
  },
  {
    name: 'Antrim and Newtownabbey',
    value: 'GB',
    isoCode: 'ANN',
  },
  {
    name: 'City of Bristol',
    value: 'GB',
    isoCode: 'BST',
  },
  {
    name: 'East Sussex',
    value: 'GB',
    isoCode: 'ESX',
  },
  {
    name: 'Dumfries and Galloway',
    value: 'GB',
    isoCode: 'DGY',
  },
  {
    name: 'Milton Keynes',
    value: 'GB',
    isoCode: 'MIK',
  },
  {
    name: 'Derry City Council',
    value: 'GB',
    isoCode: 'DRY',
  },
  {
    name: 'London Borough of Newham',
    value: 'GB',
    isoCode: 'NWM',
  },
  {
    name: 'Wokingham',
    value: 'GB',
    isoCode: 'WOK',
  },
  {
    name: 'Warrington',
    value: 'GB',
    isoCode: 'WRT',
  },
  {
    name: 'Stockton-on-Tees',
    value: 'GB',
    isoCode: 'STT',
  },
  {
    name: 'Swindon',
    value: 'GB',
    isoCode: 'SWD',
  },
  {
    name: 'Cambridgeshire',
    value: 'GB',
    isoCode: 'CAM',
  },
  {
    name: 'City of London',
    value: 'GB',
    isoCode: 'LND',
  },
  {
    name: 'Birmingham',
    value: 'GB',
    isoCode: 'BIR',
  },
  {
    name: 'City of York',
    value: 'GB',
    isoCode: 'YOR',
  },
  {
    name: 'Slough',
    value: 'GB',
    isoCode: 'SLG',
  },
  {
    name: 'Edinburgh',
    value: 'GB',
    isoCode: 'EDH',
  },
  {
    name: 'Mid and East Antrim',
    value: 'GB',
    isoCode: 'MEA',
  },
  {
    name: 'North Somerset',
    value: 'GB',
    isoCode: 'NSM',
  },
  {
    name: 'Gateshead',
    value: 'GB',
    isoCode: 'GAT',
  },
  {
    name: 'London Borough of Southwark',
    value: 'GB',
    isoCode: 'SWK',
  },
  {
    name: 'City and County of Swansea',
    value: 'GB',
    isoCode: 'SWA',
  },
  {
    name: 'London Borough of Wandsworth',
    value: 'GB',
    isoCode: 'WND',
  },
  {
    name: 'Hampshire',
    value: 'GB',
    isoCode: 'HAM',
  },
  {
    name: 'Wrexham County Borough',
    value: 'GB',
    isoCode: 'WRX',
  },
  {
    name: 'Flintshire',
    value: 'GB',
    isoCode: 'FLN',
  },
  {
    name: 'Coventry',
    value: 'GB',
    isoCode: 'COV',
  },
  {
    name: 'Carrickfergus Borough Council',
    value: 'GB',
    isoCode: 'CKF',
  },
  {
    name: 'West Dunbartonshire',
    value: 'GB',
    isoCode: 'WDU',
  },
  {
    name: 'Powys',
    value: 'GB',
    isoCode: 'POW',
  },
  {
    name: 'Cheshire West and Chester',
    value: 'GB',
    isoCode: 'CHW',
  },
  {
    name: 'Renfrewshire',
    value: 'GB',
    isoCode: 'RFW',
  },
  {
    name: 'Cheshire East',
    value: 'GB',
    isoCode: 'CHE',
  },
  {
    name: 'Cookstown District Council',
    value: 'GB',
    isoCode: 'CKT',
  },
  {
    name: 'Derry City and Strabane',
    value: 'GB',
    isoCode: 'DRS',
  },
  {
    name: 'Staffordshire',
    value: 'GB',
    isoCode: 'STS',
  },
  {
    name: 'London Borough of Hammersmith and Fulham',
    value: 'GB',
    isoCode: 'HMF',
  },
  {
    name: 'Craigavon Borough Council',
    value: 'GB',
    isoCode: 'CGV',
  },
  {
    name: 'Clackmannanshire',
    value: 'GB',
    isoCode: 'CLK',
  },
  {
    name: 'Blackpool',
    value: 'GB',
    isoCode: 'BPL',
  },
  {
    name: 'Bridgend County Borough',
    value: 'GB',
    isoCode: 'BGE',
  },
  {
    name: 'North Lincolnshire',
    value: 'GB',
    isoCode: 'NLN',
  },
  {
    name: 'East Dunbartonshire',
    value: 'GB',
    isoCode: 'EDU',
  },
  {
    name: 'Reading',
    value: 'GB',
    isoCode: 'RDG',
  },
  {
    name: 'Nottinghamshire',
    value: 'GB',
    isoCode: 'NTT',
  },
  {
    name: 'Dudley',
    value: 'GB',
    isoCode: 'DUD',
  },
  {
    name: 'Newcastle upon Tyne',
    value: 'GB',
    isoCode: 'NET',
  },
  {
    name: 'Bury',
    value: 'GB',
    isoCode: 'BUR',
  },
  {
    name: 'Lisburn and Castlereagh',
    value: 'GB',
    isoCode: 'LBC',
  },
  {
    name: 'Coleraine Borough Council',
    value: 'GB',
    isoCode: 'CLR',
  },
  {
    name: 'East Lothian',
    value: 'GB',
    isoCode: 'ELN',
  },
  {
    name: 'Aberdeen',
    value: 'GB',
    isoCode: 'ABE',
  },
  {
    name: 'Kent',
    value: 'GB',
    isoCode: 'KEN',
  },
  {
    name: 'Wakefield',
    value: 'GB',
    isoCode: 'WKF',
  },
  {
    name: 'Halton',
    value: 'GB',
    isoCode: 'HAL',
  },
  {
    name: 'Suffolk',
    value: 'GB',
    isoCode: 'SFK',
  },
  {
    name: 'Thurrock',
    value: 'GB',
    isoCode: 'THR',
  },
  {
    name: 'Solihull',
    value: 'GB',
    isoCode: 'SOL',
  },
  {
    name: 'Bracknell Forest',
    value: 'GB',
    isoCode: 'BRC',
  },
  {
    name: 'West Berkshire',
    value: 'GB',
    isoCode: 'WBK',
  },
  {
    name: 'Rutland',
    value: 'GB',
    isoCode: 'RUT',
  },
  {
    name: 'Norfolk',
    value: 'GB',
    isoCode: 'NFK',
  },
  {
    name: 'Orkney Islands',
    value: 'GB',
    isoCode: 'ORK',
  },
  {
    name: 'City of Kingston upon Hull',
    value: 'GB',
    isoCode: 'KHL',
  },
  {
    name: 'London Borough of Enfield',
    value: 'GB',
    isoCode: 'ENF',
  },
  {
    name: 'Oldham',
    value: 'GB',
    isoCode: 'OLD',
  },
  {
    name: 'Torbay',
    value: 'GB',
    isoCode: 'TOB',
  },
  {
    name: 'Fife',
    value: 'GB',
    isoCode: 'FIF',
  },
  {
    name: 'Northamptonshire',
    value: 'GB',
    isoCode: 'NTH',
  },
  {
    name: 'Royal Borough of Kingston upon Thames',
    value: 'GB',
    isoCode: 'KTT',
  },
  {
    name: 'Windsor and Maidenhead',
    value: 'GB',
    isoCode: 'WNM',
  },
  {
    name: 'London Borough of Merton',
    value: 'GB',
    isoCode: 'MRT',
  },
  {
    name: 'Carmarthenshire',
    value: 'GB',
    isoCode: 'CMN',
  },
  {
    name: 'City of Derby',
    value: 'GB',
    isoCode: 'DER',
  },
  {
    name: 'Pembrokeshire',
    value: 'GB',
    isoCode: 'PEM',
  },
  {
    name: 'North Lanarkshire',
    value: 'GB',
    isoCode: 'NLK',
  },
  {
    name: 'Stirling',
    value: 'GB',
    isoCode: 'STG',
  },
  {
    name: 'City of Wolverhampton',
    value: 'GB',
    isoCode: 'WLV',
  },
  {
    name: 'London Borough of Bromley',
    value: 'GB',
    isoCode: 'BRY',
  },
  {
    name: 'Devon',
    value: 'GB',
    isoCode: 'DEV',
  },
  {
    name: 'Royal Borough of Greenwich',
    value: 'GB',
    isoCode: 'GRE',
  },
  {
    name: 'Salford',
    value: 'GB',
    isoCode: 'SLF',
  },
  {
    name: 'Lisburn City Council',
    value: 'GB',
    isoCode: 'LSB',
  },
  {
    name: 'Lancashire',
    value: 'GB',
    isoCode: 'LAN',
  },
  {
    name: 'Torfaen',
    value: 'GB',
    isoCode: 'TOF',
  },
  {
    name: 'Denbighshire',
    value: 'GB',
    isoCode: 'DEN',
  },
  {
    name: 'Ards',
    value: 'GB',
    isoCode: 'ARD',
  },
  {
    name: 'Barnsley',
    value: 'GB',
    isoCode: 'BNS',
  },
  {
    name: 'Herefordshire',
    value: 'GB',
    isoCode: 'HEF',
  },
  {
    name: 'London Borough of Richmond upon Thames',
    value: 'GB',
    isoCode: 'RIC',
  },
  {
    name: 'Saint Helena',
    value: 'GB',
    isoCode: 'SH-HL',
  },
  {
    name: 'Leeds',
    value: 'GB',
    isoCode: 'LDS',
  },
  {
    name: 'Bolton',
    value: 'GB',
    isoCode: 'BOL',
  },
  {
    name: 'Warwickshire',
    value: 'GB',
    isoCode: 'WAR',
  },
  {
    name: 'City of Stoke-on-Trent',
    value: 'GB',
    isoCode: 'STE',
  },
  {
    name: 'Bedford',
    value: 'GB',
    isoCode: 'BDF',
  },
  {
    name: 'Dungannon and South Tyrone Borough Council',
    value: 'GB',
    isoCode: 'DGN',
  },
  {
    name: 'Ceredigion',
    value: 'GB',
    isoCode: 'CGN',
  },
  {
    name: 'Worcestershire',
    value: 'GB',
    isoCode: 'WOR',
  },
  {
    name: 'Dundee',
    value: 'GB',
    isoCode: 'DND',
  },
  {
    name: 'London Borough of Croydon',
    value: 'GB',
    isoCode: 'CRY',
  },
  {
    name: 'North Down Borough Council',
    value: 'GB',
    isoCode: 'NDN',
  },
  {
    name: 'City of Plymouth',
    value: 'GB',
    isoCode: 'PLY',
  },
  {
    name: 'Larne Borough Council',
    value: 'GB',
    isoCode: 'LRN',
  },
  {
    name: 'Leicestershire',
    value: 'GB',
    isoCode: 'LEC',
  },
  {
    name: 'Calderdale',
    value: 'GB',
    isoCode: 'CLD',
  },
  {
    name: 'Sefton',
    value: 'GB',
    isoCode: 'SFT',
  },
  {
    name: 'Midlothian',
    value: 'GB',
    isoCode: 'MLN',
  },
  {
    name: 'London Borough of Barnet',
    value: 'GB',
    isoCode: 'BNE',
  },
  {
    name: 'North Tyneside',
    value: 'GB',
    isoCode: 'NTY',
  },
  {
    name: 'North Yorkshire',
    value: 'GB',
    isoCode: 'NYK',
  },
  {
    name: 'Ards and North Down',
    value: 'GB',
    isoCode: 'AND',
  },
  {
    name: 'Newport',
    value: 'GB',
    isoCode: 'NWP',
  },
  {
    name: 'Castlereagh',
    value: 'GB',
    isoCode: 'CSR',
  },
  {
    name: 'Surrey',
    value: 'GB',
    isoCode: 'SRY',
  },
  {
    name: 'Redcar and Cleveland',
    value: 'GB',
    isoCode: 'RCC',
  },
  {
    name: 'City and County of Cardiff',
    value: 'GB',
    isoCode: 'CRF',
  },
  {
    name: 'Bradford',
    value: 'GB',
    isoCode: 'BRD',
  },
  {
    name: 'Blaenau Gwent County Borough',
    value: 'GB',
    isoCode: 'BGW',
  },
  {
    name: 'Fermanagh District Council',
    value: 'GB',
    isoCode: 'FER',
  },
  {
    name: 'London Borough of Ealing',
    value: 'GB',
    isoCode: 'EAL',
  },
  {
    name: 'Antrim',
    value: 'GB',
    isoCode: 'ANT',
  },
  {
    name: 'Newry, Mourne and Down',
    value: 'GB',
    isoCode: 'NMD',
  },
  {
    name: 'North Ayrshire',
    value: 'GB',
    isoCode: 'NAY',
  },
  {
    name: 'Tashkent',
    value: 'UZ',
    isoCode: 'TK',
  },
  {
    name: 'Namangan Region',
    value: 'UZ',
    isoCode: 'NG',
  },
  {
    name: 'Fergana Region',
    value: 'UZ',
    isoCode: 'FA',
  },
  {
    name: 'Xorazm Region',
    value: 'UZ',
    isoCode: 'XO',
  },
  {
    name: 'Andijan Region',
    value: 'UZ',
    isoCode: 'AN',
  },
  {
    name: 'Bukhara Region',
    value: 'UZ',
    isoCode: 'BU',
  },
  {
    name: 'Navoiy Region',
    value: 'UZ',
    isoCode: 'NW',
  },
  {
    name: 'Qashqadaryo Region',
    value: 'UZ',
    isoCode: 'QA',
  },
  {
    name: 'Samarqand Region',
    value: 'UZ',
    isoCode: 'SA',
  },
  {
    name: 'Jizzakh Region',
    value: 'UZ',
    isoCode: 'JI',
  },
  {
    name: 'Surxondaryo Region',
    value: 'UZ',
    isoCode: 'SU',
  },
  {
    name: 'Sirdaryo Region',
    value: 'UZ',
    isoCode: 'SI',
  },
  {
    name: 'Karakalpakstan',
    value: 'UZ',
    isoCode: 'QR',
  },
  {
    name: 'Tashkent Region',
    value: 'UZ',
    isoCode: 'TO',
  },
  {
    name: 'Ariana Governorate',
    value: 'TN',
    isoCode: '12',
  },
  {
    name: 'Bizerte Governorate',
    value: 'TN',
    isoCode: '23',
  },
  {
    name: 'Jendouba Governorate',
    value: 'TN',
    isoCode: '32',
  },
  {
    name: 'Monastir Governorate',
    value: 'TN',
    isoCode: '52',
  },
  {
    name: 'Tunis Governorate',
    value: 'TN',
    isoCode: '11',
  },
  {
    name: 'Manouba Governorate',
    value: 'TN',
    isoCode: '14',
  },
  {
    name: 'Gafsa Governorate',
    value: 'TN',
    isoCode: '71',
  },
  {
    name: 'Sfax Governorate',
    value: 'TN',
    isoCode: '61',
  },
  {
    name: 'Gabès Governorate',
    value: 'TN',
    isoCode: '81',
  },
  {
    name: 'Tataouine Governorate',
    value: 'TN',
    isoCode: '83',
  },
  {
    name: 'Medenine Governorate',
    value: 'TN',
    isoCode: '82',
  },
  {
    name: 'Kef Governorate',
    value: 'TN',
    isoCode: '33',
  },
  {
    name: 'Kebili Governorate',
    value: 'TN',
    isoCode: '73',
  },
  {
    name: 'Siliana Governorate',
    value: 'TN',
    isoCode: '34',
  },
  {
    name: 'Kairouan Governorate',
    value: 'TN',
    isoCode: '41',
  },
  {
    name: 'Zaghouan Governorate',
    value: 'TN',
    isoCode: '22',
  },
  {
    name: 'Ben Arous Governorate',
    value: 'TN',
    isoCode: '13',
  },
  {
    name: 'Sidi Bouzid Governorate',
    value: 'TN',
    isoCode: '43',
  },
  {
    name: 'Mahdia Governorate',
    value: 'TN',
    isoCode: '53',
  },
  {
    name: 'Tozeur Governorate',
    value: 'TN',
    isoCode: '72',
  },
  {
    name: 'Kasserine Governorate',
    value: 'TN',
    isoCode: '42',
  },
  {
    name: 'Sousse Governorate',
    value: 'TN',
    isoCode: '51',
  },
  {
    name: 'Kassrine',
    value: 'TN',
    isoCode: '31',
  },
  {
    name: 'Ratak Chain',
    value: 'MH',
    isoCode: 'T',
  },
  {
    name: 'Ralik Chain',
    value: 'MH',
    isoCode: 'L',
  },
  {
    name: 'Centrale Region',
    value: 'TG',
    isoCode: 'C',
  },
  {
    name: 'Maritime',
    value: 'TG',
    isoCode: 'M',
  },
  {
    name: 'Plateaux Region',
    value: 'TG',
    isoCode: 'P',
  },
  {
    name: 'Savanes Region',
    value: 'TG',
    isoCode: 'S',
  },
  {
    name: 'Kara Region',
    value: 'TG',
    isoCode: 'K',
  },
  {
    name: 'Chuuk State',
    value: 'FM',
    isoCode: 'TRK',
  },
  {
    name: 'Pohnpei State',
    value: 'FM',
    isoCode: 'PNI',
  },
  {
    name: 'Yap State',
    value: 'FM',
    isoCode: 'YAP',
  },
  {
    name: 'Kosrae State',
    value: 'FM',
    isoCode: 'KSA',
  },
  {
    name: 'Vaavu Atoll',
    value: 'MV',
    isoCode: '04',
  },
  {
    name: 'Shaviyani Atoll',
    value: 'MV',
    isoCode: '24',
  },
  {
    name: 'Haa Alif Atoll',
    value: 'MV',
    isoCode: '07',
  },
  {
    name: 'Alif Alif Atoll',
    value: 'MV',
    isoCode: '02',
  },
  {
    name: 'North Province',
    value: 'MV',
    isoCode: 'NO',
  },
  {
    name: 'North Central Province',
    value: 'MV',
    isoCode: 'NC',
  },
  {
    name: 'Dhaalu Atoll',
    value: 'MV',
    isoCode: '17',
  },
  {
    name: 'Thaa Atoll',
    value: 'MV',
    isoCode: '08',
  },
  {
    name: 'Noonu Atoll',
    value: 'MV',
    isoCode: '25',
  },
  {
    name: 'Upper South Province',
    value: 'MV',
    isoCode: 'US',
  },
  {
    name: 'Addu Atoll',
    value: 'MV',
    isoCode: '01',
  },
  {
    name: 'Gnaviyani Atoll',
    value: 'MV',
    isoCode: '29',
  },
  {
    name: 'Kaafu Atoll',
    value: 'MV',
    isoCode: '26',
  },
  {
    name: 'Haa Dhaalu Atoll',
    value: 'MV',
    isoCode: '23',
  },
  {
    name: 'Gaafu Alif Atoll',
    value: 'MV',
    isoCode: '27',
  },
  {
    name: 'Faafu Atoll',
    value: 'MV',
    isoCode: '14',
  },
  {
    name: 'Alif Dhaal Atoll',
    value: 'MV',
    isoCode: '00',
  },
  {
    name: 'Laamu Atoll',
    value: 'MV',
    isoCode: '05',
  },
  {
    name: 'Raa Atoll',
    value: 'MV',
    isoCode: '13',
  },
  {
    name: 'Gaafu Dhaalu Atoll',
    value: 'MV',
    isoCode: '28',
  },
  {
    name: 'Central Province',
    value: 'MV',
    isoCode: 'CE',
  },
  {
    name: 'South Province',
    value: 'MV',
    isoCode: 'SU',
  },
  {
    name: 'South Central Province',
    value: 'MV',
    isoCode: 'SC',
  },
  {
    name: 'Lhaviyani Atoll',
    value: 'MV',
    isoCode: '03',
  },
  {
    name: 'Meemu Atoll',
    value: 'MV',
    isoCode: '12',
  },
  {
    name: 'Malé',
    value: 'MV',
    isoCode: 'MLE',
  },
  {
    name: 'Utrecht',
    value: 'NL',
    isoCode: 'UT',
  },
  {
    name: 'Gelderland',
    value: 'NL',
    isoCode: 'GE',
  },
  {
    name: 'North Holland',
    value: 'NL',
    isoCode: 'NH',
  },
  {
    name: 'Drenthe',
    value: 'NL',
    isoCode: 'DR',
  },
  {
    name: 'South Holland',
    value: 'NL',
    isoCode: 'ZH',
  },
  {
    name: 'Limburg',
    value: 'NL',
    isoCode: 'LI',
  },
  {
    name: 'Sint Eustatius',
    value: 'NL',
    isoCode: 'BQ3',
  },
  {
    name: 'Groningen',
    value: 'NL',
    isoCode: 'GR',
  },
  {
    name: 'Overijssel',
    value: 'NL',
    isoCode: 'OV',
  },
  {
    name: 'Flevoland',
    value: 'NL',
    isoCode: 'FL',
  },
  {
    name: 'Zeeland',
    value: 'NL',
    isoCode: 'ZE',
  },
  {
    name: 'Saba',
    value: 'NL',
    isoCode: 'BQ2',
  },
  {
    name: 'Friesland',
    value: 'NL',
    isoCode: 'FR',
  },
  {
    name: 'North Brabant',
    value: 'NL',
    isoCode: 'NB',
  },
  {
    name: 'Bonaire',
    value: 'NL',
    isoCode: 'BQ1',
  },
  {
    name: 'Savanes Region',
    value: 'CI',
    isoCode: '03',
  },
  {
    name: 'Agnéby',
    value: 'CI',
    isoCode: '16',
  },
  {
    name: 'Lagunes District',
    value: 'CI',
    isoCode: 'LG',
  },
  {
    name: 'Sud-Bandama',
    value: 'CI',
    isoCode: '15',
  },
  {
    name: 'Montagnes District',
    value: 'CI',
    isoCode: 'MG',
  },
  {
    name: 'Moyen-Comoé',
    value: 'CI',
    isoCode: '05',
  },
  {
    name: 'Marahoué Region',
    value: 'CI',
    isoCode: '12',
  },
  {
    name: 'Lacs District',
    value: 'CI',
    isoCode: 'LC',
  },
  {
    name: 'Fromager',
    value: 'CI',
    isoCode: '18',
  },
  {
    name: 'Abidjan',
    value: 'CI',
    isoCode: 'AB',
  },
  {
    name: 'Bas-Sassandra Region',
    value: 'CI',
    isoCode: '09',
  },
  {
    name: 'Bafing Region',
    value: 'CI',
    isoCode: '17',
  },
  {
    name: 'Vallée du Bandama District',
    value: 'CI',
    isoCode: 'VB',
  },
  {
    name: 'Haut-Sassandra',
    value: 'CI',
    isoCode: '02',
  },
  {
    name: 'Lagunes region',
    value: 'CI',
    isoCode: '01',
  },
  {
    name: 'Lacs Region',
    value: 'CI',
    isoCode: '07',
  },
  {
    name: 'Zanzan Region',
    value: 'CI',
    isoCode: 'ZZ',
  },
  {
    name: 'Denguélé Region',
    value: 'CI',
    isoCode: '10',
  },
  {
    name: 'Bas-Sassandra District',
    value: 'CI',
    isoCode: 'BS',
  },
  {
    name: 'Denguélé District',
    value: 'CI',
    isoCode: 'DN',
  },
  {
    name: 'Dix-Huit Montagnes',
    value: 'CI',
    isoCode: '06',
  },
  {
    name: 'Moyen-Cavally',
    value: 'CI',
    isoCode: '19',
  },
  {
    name: 'Vallée du Bandama Region',
    value: 'CI',
    isoCode: '04',
  },
  {
    name: 'Sassandra-Marahoué District',
    value: 'CI',
    isoCode: 'SM',
  },
  {
    name: 'Worodougou',
    value: 'CI',
    isoCode: '14',
  },
  {
    name: 'Woroba District',
    value: 'CI',
    isoCode: 'WR',
  },
  {
    name: 'Gôh-Djiboua District',
    value: 'CI',
    isoCode: 'GD',
  },
  {
    name: 'Sud-Comoé',
    value: 'CI',
    isoCode: '13',
  },
  {
    name: 'Yamoussoukro',
    value: 'CI',
    isoCode: 'YM',
  },
  {
    name: 'Comoé District',
    value: 'CI',
    isoCode: 'CM',
  },
  {
    name: "N'zi-Comoé",
    value: 'CI',
    isoCode: '11',
  },
  {
    name: 'Far North',
    value: 'CM',
    isoCode: 'EN',
  },
  {
    name: 'Northwest',
    value: 'CM',
    isoCode: 'NW',
  },
  {
    name: 'Southwest',
    value: 'CM',
    isoCode: 'SW',
  },
  {
    name: 'South',
    value: 'CM',
    isoCode: 'SU',
  },
  {
    name: 'Centre',
    value: 'CM',
    isoCode: 'CE',
  },
  {
    name: 'East',
    value: 'CM',
    isoCode: 'ES',
  },
  {
    name: 'Littoral',
    value: 'CM',
    isoCode: 'LT',
  },
  {
    name: 'Adamawa',
    value: 'CM',
    isoCode: 'AD',
  },
  {
    name: 'West',
    value: 'CM',
    isoCode: 'OU',
  },
  {
    name: 'North',
    value: 'CM',
    isoCode: 'NO',
  },
  {
    name: 'Banjul',
    value: 'GM',
    isoCode: 'B',
  },
  {
    name: 'West Coast Division',
    value: 'GM',
    isoCode: 'W',
  },
  {
    name: 'Upper River Division',
    value: 'GM',
    isoCode: 'U',
  },
  {
    name: 'Central River Division',
    value: 'GM',
    isoCode: 'M',
  },
  {
    name: 'Lower River Division',
    value: 'GM',
    isoCode: 'L',
  },
  {
    name: 'North Bank Division',
    value: 'GM',
    isoCode: 'N',
  },
  {
    name: 'Beyla Prefecture',
    value: 'GN',
    isoCode: 'BE',
  },
  {
    name: 'Mandiana Prefecture',
    value: 'GN',
    isoCode: 'MD',
  },
  {
    name: 'Yomou Prefecture',
    value: 'GN',
    isoCode: 'YO',
  },
  {
    name: 'Fria Prefecture',
    value: 'GN',
    isoCode: 'FR',
  },
  {
    name: 'Boké Region',
    value: 'GN',
    isoCode: 'B',
  },
  {
    name: 'Labé Region',
    value: 'GN',
    isoCode: 'L',
  },
  {
    name: 'Nzérékoré Prefecture',
    value: 'GN',
    isoCode: 'NZ',
  },
  {
    name: 'Dabola Prefecture',
    value: 'GN',
    isoCode: 'DB',
  },
  {
    name: 'Labé Prefecture',
    value: 'GN',
    isoCode: 'LA',
  },
  {
    name: 'Dubréka Prefecture',
    value: 'GN',
    isoCode: 'DU',
  },
  {
    name: 'Faranah Prefecture',
    value: 'GN',
    isoCode: 'FA',
  },
  {
    name: 'Forécariah Prefecture',
    value: 'GN',
    isoCode: 'FO',
  },
  {
    name: 'Nzérékoré Region',
    value: 'GN',
    isoCode: 'N',
  },
  {
    name: 'Gaoual Prefecture',
    value: 'GN',
    isoCode: 'GA',
  },
  {
    name: 'Conakry',
    value: 'GN',
    isoCode: 'C',
  },
  {
    name: 'Télimélé Prefecture',
    value: 'GN',
    isoCode: 'TE',
  },
  {
    name: 'Dinguiraye Prefecture',
    value: 'GN',
    isoCode: 'DI',
  },
  {
    name: 'Mamou Prefecture',
    value: 'GN',
    isoCode: 'MM',
  },
  {
    name: 'Lélouma Prefecture',
    value: 'GN',
    isoCode: 'LE',
  },
  {
    name: 'Kissidougou Prefecture',
    value: 'GN',
    isoCode: 'KS',
  },
  {
    name: 'Koubia Prefecture',
    value: 'GN',
    isoCode: 'KB',
  },
  {
    name: 'Kindia Prefecture',
    value: 'GN',
    isoCode: 'KD',
  },
  {
    name: 'Pita Prefecture',
    value: 'GN',
    isoCode: 'PI',
  },
  {
    name: 'Kouroussa Prefecture',
    value: 'GN',
    isoCode: 'KO',
  },
  {
    name: 'Tougué Prefecture',
    value: 'GN',
    isoCode: 'TO',
  },
  {
    name: 'Kankan Region',
    value: 'GN',
    isoCode: 'K',
  },
  {
    name: 'Mamou Region',
    value: 'GN',
    isoCode: 'M',
  },
  {
    name: 'Boffa Prefecture',
    value: 'GN',
    isoCode: 'BF',
  },
  {
    name: 'Mali Prefecture',
    value: 'GN',
    isoCode: 'ML',
  },
  {
    name: 'Kindia Region',
    value: 'GN',
    isoCode: 'D',
  },
  {
    name: 'Macenta Prefecture',
    value: 'GN',
    isoCode: 'MC',
  },
  {
    name: 'Koundara Prefecture',
    value: 'GN',
    isoCode: 'KN',
  },
  {
    name: 'Kankan Prefecture',
    value: 'GN',
    isoCode: 'KA',
  },
  {
    name: 'Coyah Prefecture',
    value: 'GN',
    isoCode: 'CO',
  },
  {
    name: 'Dalaba Prefecture',
    value: 'GN',
    isoCode: 'DL',
  },
  {
    name: 'Siguiri Prefecture',
    value: 'GN',
    isoCode: 'SI',
  },
  {
    name: 'Lola Prefecture',
    value: 'GN',
    isoCode: 'LO',
  },
  {
    name: 'Boké Prefecture',
    value: 'GN',
    isoCode: 'BK',
  },
  {
    name: 'Kérouané Prefecture',
    value: 'GN',
    isoCode: 'KE',
  },
  {
    name: 'Guéckédou Prefecture',
    value: 'GN',
    isoCode: 'GU',
  },
  {
    name: 'Tombali Region',
    value: 'GW',
    isoCode: 'TO',
  },
  {
    name: 'Cacheu Region',
    value: 'GW',
    isoCode: 'CA',
  },
  {
    name: 'Biombo Region',
    value: 'GW',
    isoCode: 'BM',
  },
  {
    name: 'Quinara Region',
    value: 'GW',
    isoCode: 'QU',
  },
  {
    name: 'Sul Province',
    value: 'GW',
    isoCode: 'S',
  },
  {
    name: 'Norte Province',
    value: 'GW',
    isoCode: 'N',
  },
  {
    name: 'Oio Region',
    value: 'GW',
    isoCode: 'OI',
  },
  {
    name: 'Gabú Region',
    value: 'GW',
    isoCode: 'GA',
  },
  {
    name: 'Bafatá',
    value: 'GW',
    isoCode: 'BA',
  },
  {
    name: 'Leste Province',
    value: 'GW',
    isoCode: 'L',
  },
  {
    name: 'Bolama Region',
    value: 'GW',
    isoCode: 'BL',
  },
  {
    name: 'Woleu-Ntem Province',
    value: 'GA',
    isoCode: '9',
  },
  {
    name: 'Ogooué-Ivindo Province',
    value: 'GA',
    isoCode: '6',
  },
  {
    name: 'Nyanga Province',
    value: 'GA',
    isoCode: '5',
  },
  {
    name: 'Haut-Ogooué Province',
    value: 'GA',
    isoCode: '2',
  },
  {
    name: 'Estuaire Province',
    value: 'GA',
    isoCode: '1',
  },
  {
    name: 'Ogooué-Maritime Province',
    value: 'GA',
    isoCode: '8',
  },
  {
    name: 'Ogooué-Lolo Province',
    value: 'GA',
    isoCode: '7',
  },
  {
    name: 'Moyen-Ogooué Province',
    value: 'GA',
    isoCode: '3',
  },
  {
    name: 'Ngounié Province',
    value: 'GA',
    isoCode: '4',
  },
  {
    name: 'Tshuapa',
    value: 'CD',
    isoCode: 'TU',
  },
  {
    name: 'Tanganyika',
    value: 'CD',
    isoCode: 'TA',
  },
  {
    name: 'Haut-Uélé',
    value: 'CD',
    isoCode: 'HU',
  },
  {
    name: 'Kasaï Oriental',
    value: 'CD',
    isoCode: 'KE',
  },
  {
    name: 'Sud-Kivu',
    value: 'CD',
    isoCode: 'SK',
  },
  {
    name: 'Nord-Ubangi',
    value: 'CD',
    isoCode: 'NU',
  },
  {
    name: 'Kwango',
    value: 'CD',
    isoCode: 'KG',
  },
  {
    name: 'Kinshasa',
    value: 'CD',
    isoCode: 'KN',
  },
  {
    name: 'Kasaï Central',
    value: 'CD',
    isoCode: 'KC',
  },
  {
    name: 'Sankuru',
    value: 'CD',
    isoCode: 'SA',
  },
  {
    name: 'Équateur',
    value: 'CD',
    isoCode: 'EQ',
  },
  {
    name: 'Maniema',
    value: 'CD',
    isoCode: 'MA',
  },
  {
    name: 'Kongo Central',
    value: 'CD',
    isoCode: 'BC',
  },
  {
    name: 'Lomami',
    value: 'CD',
    isoCode: 'LO',
  },
  {
    name: 'Sud-Ubangi',
    value: 'CD',
    isoCode: 'SU',
  },
  {
    name: 'Nord-Kivu',
    value: 'CD',
    isoCode: 'NK',
  },
  {
    name: 'Haut-Katanga',
    value: 'CD',
    isoCode: 'HK',
  },
  {
    name: 'Ituri',
    value: 'CD',
    isoCode: 'IT',
  },
  {
    name: 'Mongala',
    value: 'CD',
    isoCode: 'MO',
  },
  {
    name: 'Bas-Uélé',
    value: 'CD',
    isoCode: 'BU',
  },
  {
    name: 'Mai-Ndombe',
    value: 'CD',
    isoCode: 'MN',
  },
  {
    name: 'Tshopo',
    value: 'CD',
    isoCode: 'TO',
  },
  {
    name: 'Kasaï',
    value: 'CD',
    isoCode: 'KS',
  },
  {
    name: 'Haut-Lomami',
    value: 'CD',
    isoCode: 'HL',
  },
  {
    name: 'Kwilu',
    value: 'CD',
    isoCode: 'KL',
  },
  {
    name: 'Lualaba',
    value: 'CD',
    isoCode: 'LU',
  },
  {
    name: 'Cuyuni-Mazaruni',
    value: 'GY',
    isoCode: 'CU',
  },
  {
    name: 'Potaro-Siparuni',
    value: 'GY',
    isoCode: 'PT',
  },
  {
    name: 'Mahaica-Berbice',
    value: 'GY',
    isoCode: 'MA',
  },
  {
    name: 'Upper Demerara-Berbice',
    value: 'GY',
    isoCode: 'UD',
  },
  {
    name: 'Barima-Waini',
    value: 'GY',
    isoCode: 'BA',
  },
  {
    name: 'Pomeroon-Supenaam',
    value: 'GY',
    isoCode: 'PM',
  },
  {
    name: 'East Berbice-Corentyne',
    value: 'GY',
    isoCode: 'EB',
  },
  {
    name: 'Demerara-Mahaica',
    value: 'GY',
    isoCode: 'DE',
  },
  {
    name: 'Essequibo Islands-West Demerara',
    value: 'GY',
    isoCode: 'ES',
  },
  {
    name: 'Upper Takutu-Upper Essequibo',
    value: 'GY',
    isoCode: 'UT',
  },
  {
    name: 'Presidente Hayes Department',
    value: 'PY',
    isoCode: '15',
  },
  {
    name: 'Canindeyú',
    value: 'PY',
    isoCode: '14',
  },
  {
    name: 'Guairá Department',
    value: 'PY',
    isoCode: '4',
  },
  {
    name: 'Caaguazú',
    value: 'PY',
    isoCode: '5',
  },
  {
    name: 'Paraguarí Department',
    value: 'PY',
    isoCode: '9',
  },
  {
    name: 'Caazapá',
    value: 'PY',
    isoCode: '6',
  },
  {
    name: 'San Pedro Department',
    value: 'PY',
    isoCode: '2',
  },
  {
    name: 'Central Department',
    value: 'PY',
    isoCode: '11',
  },
  {
    name: 'Itapúa',
    value: 'PY',
    isoCode: '7',
  },
  {
    name: 'Concepción Department',
    value: 'PY',
    isoCode: '1',
  },
  {
    name: 'Boquerón Department',
    value: 'PY',
    isoCode: '19',
  },
  {
    name: 'Ñeembucú Department',
    value: 'PY',
    isoCode: '12',
  },
  {
    name: 'Amambay Department',
    value: 'PY',
    isoCode: '13',
  },
  {
    name: 'Cordillera Department',
    value: 'PY',
    isoCode: '3',
  },
  {
    name: 'Alto Paraná Department',
    value: 'PY',
    isoCode: '10',
  },
  {
    name: 'Alto Paraguay Department',
    value: 'PY',
    isoCode: '16',
  },
  {
    name: 'Misiones Department',
    value: 'PY',
    isoCode: '8',
  },
  {
    name: 'Jaffna District',
    value: 'LK',
    isoCode: '41',
  },
  {
    name: 'Kandy District',
    value: 'LK',
    isoCode: '21',
  },
  {
    name: 'Kalutara District',
    value: 'LK',
    isoCode: '13',
  },
  {
    name: 'Badulla District',
    value: 'LK',
    isoCode: '81',
  },
  {
    name: 'Hambantota District',
    value: 'LK',
    isoCode: '33',
  },
  {
    name: 'Galle District',
    value: 'LK',
    isoCode: '31',
  },
  {
    name: 'Kilinochchi District',
    value: 'LK',
    isoCode: '42',
  },
  {
    name: 'Nuwara Eliya District',
    value: 'LK',
    isoCode: '23',
  },
  {
    name: 'Trincomalee District',
    value: 'LK',
    isoCode: '53',
  },
  {
    name: 'Puttalam District',
    value: 'LK',
    isoCode: '62',
  },
  {
    name: 'Kegalle District',
    value: 'LK',
    isoCode: '92',
  },
  {
    name: 'Central Province',
    value: 'LK',
    isoCode: '2',
  },
  {
    name: 'Ampara District',
    value: 'LK',
    isoCode: '52',
  },
  {
    name: 'North Central Province',
    value: 'LK',
    isoCode: '7',
  },
  {
    name: 'Southern Province',
    value: 'LK',
    isoCode: '3',
  },
  {
    name: 'Western Province',
    value: 'LK',
    isoCode: '1',
  },
  {
    name: 'Sabaragamuwa Province',
    value: 'LK',
    isoCode: '9',
  },
  {
    name: 'Gampaha District',
    value: 'LK',
    isoCode: '12',
  },
  {
    name: 'Mannar District',
    value: 'LK',
    isoCode: '43',
  },
  {
    name: 'Matara District',
    value: 'LK',
    isoCode: '32',
  },
  {
    name: 'Ratnapura district',
    value: 'LK',
    isoCode: '91',
  },
  {
    name: 'Eastern Province',
    value: 'LK',
    isoCode: '5',
  },
  {
    name: 'Vavuniya District',
    value: 'LK',
    isoCode: '44',
  },
  {
    name: 'Matale District',
    value: 'LK',
    isoCode: '22',
  },
  {
    name: 'Uva Province',
    value: 'LK',
    isoCode: '8',
  },
  {
    name: 'Polonnaruwa District',
    value: 'LK',
    isoCode: '72',
  },
  {
    name: 'Northern Province',
    value: 'LK',
    isoCode: '4',
  },
  {
    name: 'Mullaitivu District',
    value: 'LK',
    isoCode: '45',
  },
  {
    name: 'Colombo District',
    value: 'LK',
    isoCode: '11',
  },
  {
    name: 'Anuradhapura District',
    value: 'LK',
    isoCode: '71',
  },
  {
    name: 'North Western Province',
    value: 'LK',
    isoCode: '6',
  },
  {
    name: 'Batticaloa District',
    value: 'LK',
    isoCode: '51',
  },
  {
    name: 'Monaragala District',
    value: 'LK',
    isoCode: '82',
  },
  {
    name: 'Mohéli',
    value: 'KM',
    isoCode: 'M',
  },
  {
    name: 'Anjouan',
    value: 'KM',
    isoCode: 'A',
  },
  {
    name: 'Grande Comore',
    value: 'KM',
    isoCode: 'G',
  },
  {
    name: 'Atacama',
    value: 'CL',
    isoCode: 'AT',
  },
  {
    name: 'Región Metropolitana de Santiago',
    value: 'CL',
    isoCode: 'RM',
  },
  {
    name: 'Coquimbo',
    value: 'CL',
    isoCode: 'CO',
  },
  {
    name: 'La Araucanía',
    value: 'CL',
    isoCode: 'AR',
  },
  {
    name: 'Biobío',
    value: 'CL',
    isoCode: 'BI',
  },
  {
    name: 'Aisén del General Carlos Ibañez del Campo',
    value: 'CL',
    isoCode: 'AI',
  },
  {
    name: 'Arica y Parinacota',
    value: 'CL',
    isoCode: 'AP',
  },
  {
    name: 'Valparaíso',
    value: 'CL',
    isoCode: 'VS',
  },
  {
    name: 'Ñuble',
    value: 'CL',
    isoCode: 'NB',
  },
  {
    name: 'Antofagasta',
    value: 'CL',
    isoCode: 'AN',
  },
  {
    name: 'Maule',
    value: 'CL',
    isoCode: 'ML',
  },
  {
    name: 'Los Ríos',
    value: 'CL',
    isoCode: 'LR',
  },
  {
    name: 'Los Lagos',
    value: 'CL',
    isoCode: 'LL',
  },
  {
    name: 'Magallanes y de la Antártica Chilena',
    value: 'CL',
    isoCode: 'MA',
  },
  {
    name: 'Tarapacá',
    value: 'CL',
    isoCode: 'TA',
  },
  {
    name: "Libertador General Bernardo O'Higgins",
    value: 'CL',
    isoCode: 'LI',
  },
  {
    name: 'Commewijne District',
    value: 'SR',
    isoCode: 'CM',
  },
  {
    name: 'Nickerie District',
    value: 'SR',
    isoCode: 'NI',
  },
  {
    name: 'Para District',
    value: 'SR',
    isoCode: 'PR',
  },
  {
    name: 'Coronie District',
    value: 'SR',
    isoCode: 'CR',
  },
  {
    name: 'Paramaribo District',
    value: 'SR',
    isoCode: 'PM',
  },
  {
    name: 'Wanica District',
    value: 'SR',
    isoCode: 'WA',
  },
  {
    name: 'Marowijne District',
    value: 'SR',
    isoCode: 'MA',
  },
  {
    name: 'Brokopondo District',
    value: 'SR',
    isoCode: 'BR',
  },
  {
    name: 'Sipaliwini District',
    value: 'SR',
    isoCode: 'SI',
  },
  {
    name: 'Saramacca District',
    value: 'SR',
    isoCode: 'SA',
  },
  {
    name: 'Riyadh',
    value: 'SA',
    isoCode: '01',
  },
  {
    name: 'Makkah',
    value: 'SA',
    isoCode: '02',
  },
  {
    name: 'Al Madinah',
    value: 'SA',
    isoCode: '03',
  },
  {
    name: 'Tabuk',
    value: 'SA',
    isoCode: '07',
  },
  {
    name: "'Asir",
    value: 'SA',
    isoCode: '14',
  },
  {
    name: 'Northern Borders',
    value: 'SA',
    isoCode: '08',
  },
  {
    name: "Ha'il",
    value: 'SA',
    isoCode: '06',
  },
  {
    name: 'Eastern Province',
    value: 'SA',
    isoCode: '04',
  },
  {
    name: 'Al Jawf',
    value: 'SA',
    isoCode: '12',
  },
  {
    name: 'Jizan',
    value: 'SA',
    isoCode: '09',
  },
  {
    name: 'Al Bahah',
    value: 'SA',
    isoCode: '11',
  },
  {
    name: 'Najran',
    value: 'SA',
    isoCode: '10',
  },
  {
    name: 'Al-Qassim',
    value: 'SA',
    isoCode: '05',
  },
  {
    name: 'Plateaux Department',
    value: 'CG',
    isoCode: '14',
  },
  {
    name: 'Pointe-Noire',
    value: 'CG',
    isoCode: '16',
  },
  {
    name: 'Cuvette Department',
    value: 'CG',
    isoCode: '8',
  },
  {
    name: 'Likouala Department',
    value: 'CG',
    isoCode: '7',
  },
  {
    name: 'Bouenza Department',
    value: 'CG',
    isoCode: '11',
  },
  {
    name: 'Kouilou Department',
    value: 'CG',
    isoCode: '5',
  },
  {
    name: 'Lékoumou Department',
    value: 'CG',
    isoCode: '2',
  },
  {
    name: 'Cuvette-Ouest Department',
    value: 'CG',
    isoCode: '15',
  },
  {
    name: 'Brazzaville',
    value: 'CG',
    isoCode: 'BZV',
  },
  {
    name: 'Sangha Department',
    value: 'CG',
    isoCode: '13',
  },
  {
    name: 'Niari Department',
    value: 'CG',
    isoCode: '9',
  },
  {
    name: 'Pool Department',
    value: 'CG',
    isoCode: '12',
  },
  {
    name: 'Quindío',
    value: 'CO',
    isoCode: 'QUI',
  },
  {
    name: 'Cundinamarca',
    value: 'CO',
    isoCode: 'CUN',
  },
  {
    name: 'Chocó',
    value: 'CO',
    isoCode: 'CHO',
  },
  {
    name: 'Norte de Santander',
    value: 'CO',
    isoCode: 'NSA',
  },
  {
    name: 'Meta',
    value: 'CO',
    isoCode: 'MET',
  },
  {
    name: 'Risaralda',
    value: 'CO',
    isoCode: 'RIS',
  },
  {
    name: 'Atlántico',
    value: 'CO',
    isoCode: 'ATL',
  },
  {
    name: 'Arauca',
    value: 'CO',
    isoCode: 'ARA',
  },
  {
    name: 'Guainía',
    value: 'CO',
    isoCode: 'GUA',
  },
  {
    name: 'Tolima',
    value: 'CO',
    isoCode: 'TOL',
  },
  {
    name: 'Cauca',
    value: 'CO',
    isoCode: 'CAU',
  },
  {
    name: 'Vaupés',
    value: 'CO',
    isoCode: 'VAU',
  },
  {
    name: 'Magdalena',
    value: 'CO',
    isoCode: 'MAG',
  },
  {
    name: 'Caldas',
    value: 'CO',
    isoCode: 'CAL',
  },
  {
    name: 'Guaviare',
    value: 'CO',
    isoCode: 'GUV',
  },
  {
    name: 'La Guajira',
    value: 'CO',
    isoCode: 'LAG',
  },
  {
    name: 'Antioquia',
    value: 'CO',
    isoCode: 'ANT',
  },
  {
    name: 'Caquetá',
    value: 'CO',
    isoCode: 'CAQ',
  },
  {
    name: 'Casanare',
    value: 'CO',
    isoCode: 'CAS',
  },
  {
    name: 'Bolívar',
    value: 'CO',
    isoCode: 'BOL',
  },
  {
    name: 'Vichada',
    value: 'CO',
    isoCode: 'VID',
  },
  {
    name: 'Amazonas',
    value: 'CO',
    isoCode: 'AMA',
  },
  {
    name: 'Putumayo',
    value: 'CO',
    isoCode: 'PUT',
  },
  {
    name: 'Nariño',
    value: 'CO',
    isoCode: 'NAR',
  },
  {
    name: 'Córdoba',
    value: 'CO',
    isoCode: 'COR',
  },
  {
    name: 'Cesar',
    value: 'CO',
    isoCode: 'CES',
  },
  {
    name: 'Archipiélago de San Andrés, Providencia y Santa Catalina',
    value: 'CO',
    isoCode: 'SAP',
  },
  {
    name: 'Santander',
    value: 'CO',
    isoCode: 'SAN',
  },
  {
    name: 'Sucre',
    value: 'CO',
    isoCode: 'SUC',
  },
  {
    name: 'Boyacá',
    value: 'CO',
    isoCode: 'BOY',
  },
  {
    name: 'Valle del Cauca',
    value: 'CO',
    isoCode: 'VAC',
  },
  {
    name: 'Huila',
    value: 'CO',
    isoCode: 'HUI',
  },
  {
    name: 'Bogotá D.C.',
    value: 'CO',
    isoCode: 'DC',
  },
  {
    name: 'Galápagos',
    value: 'EC',
    isoCode: 'W',
  },
  {
    name: 'Sucumbíos',
    value: 'EC',
    isoCode: 'U',
  },
  {
    name: 'Pastaza',
    value: 'EC',
    isoCode: 'Y',
  },
  {
    name: 'Tungurahua',
    value: 'EC',
    isoCode: 'T',
  },
  {
    name: 'Zamora Chinchipe',
    value: 'EC',
    isoCode: 'Z',
  },
  {
    name: 'Los Ríos',
    value: 'EC',
    isoCode: 'R',
  },
  {
    name: 'Imbabura',
    value: 'EC',
    isoCode: 'I',
  },
  {
    name: 'Santa Elena',
    value: 'EC',
    isoCode: 'SE',
  },
  {
    name: 'Manabí',
    value: 'EC',
    isoCode: 'M',
  },
  {
    name: 'Guayas',
    value: 'EC',
    isoCode: 'G',
  },
  {
    name: 'Carchi',
    value: 'EC',
    isoCode: 'C',
  },
  {
    name: 'Napo',
    value: 'EC',
    isoCode: 'N',
  },
  {
    name: 'Cañar',
    value: 'EC',
    isoCode: 'F',
  },
  {
    name: 'Morona-Santiago',
    value: 'EC',
    isoCode: 'S',
  },
  {
    name: 'Santo Domingo de los Tsáchilas',
    value: 'EC',
    isoCode: 'SD',
  },
  {
    name: 'Bolívar',
    value: 'EC',
    isoCode: 'B',
  },
  {
    name: 'Cotopaxi',
    value: 'EC',
    isoCode: 'X',
  },
  {
    name: 'Esmeraldas',
    value: 'EC',
    isoCode: 'E',
  },
  {
    name: 'Azuay',
    value: 'EC',
    isoCode: 'A',
  },
  {
    name: 'El Oro',
    value: 'EC',
    isoCode: 'O',
  },
  {
    name: 'Chimborazo',
    value: 'EC',
    isoCode: 'H',
  },
  {
    name: 'Orellana',
    value: 'EC',
    isoCode: 'D',
  },
  {
    name: 'Pichincha',
    value: 'EC',
    isoCode: 'P',
  },
  {
    name: 'Loja',
    value: 'EC',
    isoCode: 'L',
  },
  {
    name: 'Obock Region',
    value: 'DJ',
    isoCode: 'OB',
  },
  {
    name: 'Djibouti',
    value: 'DJ',
    isoCode: 'DJ',
  },
  {
    name: 'Dikhil Region',
    value: 'DJ',
    isoCode: 'DI',
  },
  {
    name: 'Tadjourah Region',
    value: 'DJ',
    isoCode: 'TA',
  },
  {
    name: 'Arta Region',
    value: 'DJ',
    isoCode: 'AR',
  },
  {
    name: 'Ali Sabieh Region',
    value: 'DJ',
    isoCode: 'AS',
  },
  {
    name: 'Hama Governorate',
    value: 'SY',
    isoCode: 'HM',
  },
  {
    name: 'Rif Dimashq Governorate',
    value: 'SY',
    isoCode: 'RD',
  },
  {
    name: 'As-Suwayda Governorate',
    value: 'SY',
    isoCode: 'SU',
  },
  {
    name: 'Deir ez-Zor Governorate',
    value: 'SY',
    isoCode: 'DY',
  },
  {
    name: 'Latakia Governorate',
    value: 'SY',
    isoCode: 'LA',
  },
  {
    name: 'Damascus Governorate',
    value: 'SY',
    isoCode: 'DI',
  },
  {
    name: 'Idlib Governorate',
    value: 'SY',
    isoCode: 'ID',
  },
  {
    name: 'Al-Hasakah Governorate',
    value: 'SY',
    isoCode: 'HA',
  },
  {
    name: 'Homs Governorate',
    value: 'SY',
    isoCode: 'HI',
  },
  {
    name: 'Quneitra Governorate',
    value: 'SY',
    isoCode: 'QU',
  },
  {
    name: 'Al-Raqqah Governorate',
    value: 'SY',
    isoCode: 'RA',
  },
  {
    name: 'Daraa Governorate',
    value: 'SY',
    isoCode: 'DR',
  },
  {
    name: 'Aleppo Governorate',
    value: 'SY',
    isoCode: 'HL',
  },
  {
    name: 'Tartus Governorate',
    value: 'SY',
    isoCode: 'TA',
  },
  {
    name: 'Fianarantsoa Province',
    value: 'MG',
    isoCode: 'F',
  },
  {
    name: 'Toliara Province',
    value: 'MG',
    isoCode: 'U',
  },
  {
    name: 'Antsiranana Province',
    value: 'MG',
    isoCode: 'D',
  },
  {
    name: 'Antananarivo Province',
    value: 'MG',
    isoCode: 'T',
  },
  {
    name: 'Toamasina Province',
    value: 'MG',
    isoCode: 'A',
  },
  {
    name: 'Mahajanga Province',
    value: 'MG',
    isoCode: 'M',
  },
  {
    name: 'Mogilev Region',
    value: 'BY',
    isoCode: 'MA',
  },
  {
    name: 'Gomel Region',
    value: 'BY',
    isoCode: 'HO',
  },
  {
    name: 'Grodno Region',
    value: 'BY',
    isoCode: 'HR',
  },
  {
    name: 'Minsk Region',
    value: 'BY',
    isoCode: 'MI',
  },
  {
    name: 'Minsk',
    value: 'BY',
    isoCode: 'HM',
  },
  {
    name: 'Brest Region',
    value: 'BY',
    isoCode: 'BR',
  },
  {
    name: 'Vitebsk Region',
    value: 'BY',
    isoCode: 'VI',
  },
  {
    name: 'Murqub',
    value: 'LY',
    isoCode: 'MB',
  },
  {
    name: 'Nuqat al Khams',
    value: 'LY',
    isoCode: 'NQ',
  },
  {
    name: 'Zawiya District',
    value: 'LY',
    isoCode: 'ZA',
  },
  {
    name: 'Al Wahat District',
    value: 'LY',
    isoCode: 'WA',
  },
  {
    name: 'Sabha District',
    value: 'LY',
    isoCode: 'SB',
  },
  {
    name: 'Derna District',
    value: 'LY',
    isoCode: 'DR',
  },
  {
    name: 'Murzuq District',
    value: 'LY',
    isoCode: 'MQ',
  },
  {
    name: 'Marj District',
    value: 'LY',
    isoCode: 'MJ',
  },
  {
    name: 'Ghat District',
    value: 'LY',
    isoCode: 'GT',
  },
  {
    name: 'Jufra',
    value: 'LY',
    isoCode: 'JU',
  },
  {
    name: 'Tripoli District',
    value: 'LY',
    isoCode: 'TB',
  },
  {
    name: 'Kufra District',
    value: 'LY',
    isoCode: 'KF',
  },
  {
    name: 'Wadi al Hayaa District',
    value: 'LY',
    isoCode: 'WD',
  },
  {
    name: 'Jabal al Gharbi District',
    value: 'LY',
    isoCode: 'JG',
  },
  {
    name: 'Wadi al Shatii District',
    value: 'LY',
    isoCode: 'WS',
  },
  {
    name: 'Nalut District',
    value: 'LY',
    isoCode: 'NL',
  },
  {
    name: 'Sirte District',
    value: 'LY',
    isoCode: 'SR',
  },
  {
    name: 'Misrata District',
    value: 'LY',
    isoCode: 'MI',
  },
  {
    name: 'Jafara',
    value: 'LY',
    isoCode: 'JI',
  },
  {
    name: 'Jabal al Akhdar',
    value: 'LY',
    isoCode: 'JA',
  },
  {
    name: 'Benghazi',
    value: 'LY',
    isoCode: 'BA',
  },
  {
    name: 'Ribeira Brava Municipality',
    value: 'CV',
    isoCode: 'RB',
  },
  {
    name: 'Tarrafal',
    value: 'CV',
    isoCode: 'TA',
  },
  {
    name: 'Ribeira Grande de Santiago',
    value: 'CV',
    isoCode: 'RS',
  },
  {
    name: 'Santa Catarina',
    value: 'CV',
    isoCode: 'CA',
  },
  {
    name: 'São Domingos',
    value: 'CV',
    isoCode: 'SD',
  },
  {
    name: 'Mosteiros',
    value: 'CV',
    isoCode: 'MO',
  },
  {
    name: 'Praia',
    value: 'CV',
    isoCode: 'PR',
  },
  {
    name: 'Porto Novo',
    value: 'CV',
    isoCode: 'PN',
  },
  {
    name: 'São Miguel',
    value: 'CV',
    isoCode: 'SM',
  },
  {
    name: 'Maio Municipality',
    value: 'CV',
    isoCode: 'MA',
  },
  {
    name: 'Sotavento Islands',
    value: 'CV',
    isoCode: 'S',
  },
  {
    name: 'São Lourenço dos Órgãos',
    value: 'CV',
    isoCode: 'SO',
  },
  {
    name: 'Barlavento Islands',
    value: 'CV',
    isoCode: 'B',
  },
  {
    name: 'Santa Catarina do Fogo',
    value: 'CV',
    isoCode: 'CF',
  },
  {
    name: 'Brava',
    value: 'CV',
    isoCode: 'BR',
  },
  {
    name: 'Paul',
    value: 'CV',
    isoCode: 'PA',
  },
  {
    name: 'Sal',
    value: 'CV',
    isoCode: 'SL',
  },
  {
    name: 'Boa Vista',
    value: 'CV',
    isoCode: 'BV',
  },
  {
    name: 'São Filipe',
    value: 'CV',
    isoCode: 'SF',
  },
  {
    name: 'São Vicente',
    value: 'CV',
    isoCode: 'SV',
  },
  {
    name: 'Ribeira Grande',
    value: 'CV',
    isoCode: 'RG',
  },
  {
    name: 'Tarrafal de São Nicolau',
    value: 'CV',
    isoCode: 'TS',
  },
  {
    name: 'Santa Cruz',
    value: 'CV',
    isoCode: 'CR',
  },
  {
    name: 'Schleswig-Holstein',
    value: 'DE',
    isoCode: 'SH',
  },
  {
    name: 'Baden-Württemberg',
    value: 'DE',
    isoCode: 'BW',
  },
  {
    name: 'Mecklenburg-Vorpommern',
    value: 'DE',
    isoCode: 'MV',
  },
  {
    name: 'Lower Saxony',
    value: 'DE',
    isoCode: 'NI',
  },
  {
    name: 'Bavaria',
    value: 'DE',
    isoCode: 'BY',
  },
  {
    name: 'Berlin',
    value: 'DE',
    isoCode: 'BE',
  },
  {
    name: 'Saxony-Anhalt',
    value: 'DE',
    isoCode: 'ST',
  },
  {
    name: 'Brandenburg',
    value: 'DE',
    isoCode: 'BB',
  },
  {
    name: 'Bremen',
    value: 'DE',
    isoCode: 'HB',
  },
  {
    name: 'Thuringia',
    value: 'DE',
    isoCode: 'TH',
  },
  {
    name: 'Hamburg',
    value: 'DE',
    isoCode: 'HH',
  },
  {
    name: 'North Rhine-Westphalia',
    value: 'DE',
    isoCode: 'NW',
  },
  {
    name: 'Hesse',
    value: 'DE',
    isoCode: 'HE',
  },
  {
    name: 'Rhineland-Palatinate',
    value: 'DE',
    isoCode: 'RP',
  },
  {
    name: 'Saarland',
    value: 'DE',
    isoCode: 'SL',
  },
  {
    name: 'Saxony',
    value: 'DE',
    isoCode: 'SN',
  },
  {
    name: 'Mafeteng District',
    value: 'LS',
    isoCode: 'E',
  },
  {
    name: "Mohale's Hoek District",
    value: 'LS',
    isoCode: 'F',
  },
  {
    name: 'Mokhotlong District',
    value: 'LS',
    isoCode: 'J',
  },
  {
    name: "Qacha's Nek District",
    value: 'LS',
    isoCode: 'H',
  },
  {
    name: 'Leribe District',
    value: 'LS',
    isoCode: 'C',
  },
  {
    name: 'Quthing District',
    value: 'LS',
    isoCode: 'G',
  },
  {
    name: 'Maseru District',
    value: 'LS',
    isoCode: 'A',
  },
  {
    name: 'Butha-Buthe District',
    value: 'LS',
    isoCode: 'B',
  },
  {
    name: 'Berea District',
    value: 'LS',
    isoCode: 'D',
  },
  {
    name: 'Thaba-Tseka District',
    value: 'LS',
    isoCode: 'K',
  },
  {
    name: 'Montserrado County',
    value: 'LR',
    isoCode: 'MO',
  },
  {
    name: 'River Cess County',
    value: 'LR',
    isoCode: 'RI',
  },
  {
    name: 'Bong County',
    value: 'LR',
    isoCode: 'BG',
  },
  {
    name: 'Sinoe County',
    value: 'LR',
    isoCode: 'SI',
  },
  {
    name: 'Grand Cape Mount County',
    value: 'LR',
    isoCode: 'CM',
  },
  {
    name: 'Lofa County',
    value: 'LR',
    isoCode: 'LO',
  },
  {
    name: 'River Gee County',
    value: 'LR',
    isoCode: 'RG',
  },
  {
    name: 'Grand Gedeh County',
    value: 'LR',
    isoCode: 'GG',
  },
  {
    name: 'Grand Bassa County',
    value: 'LR',
    isoCode: 'GB',
  },
  {
    name: 'Bomi County',
    value: 'LR',
    isoCode: 'BM',
  },
  {
    name: 'Maryland County',
    value: 'LR',
    isoCode: 'MY',
  },
  {
    name: 'Margibi County',
    value: 'LR',
    isoCode: 'MG',
  },
  {
    name: 'Gbarpolu County',
    value: 'LR',
    isoCode: 'GP',
  },
  {
    name: 'Grand Kru County',
    value: 'LR',
    isoCode: 'GK',
  },
  {
    name: 'Nimba',
    value: 'LR',
    isoCode: 'NI',
  },
  {
    name: 'Ad Dhahirah Governorate',
    value: 'OM',
    isoCode: 'ZA',
  },
  {
    name: 'Al Batinah North Governorate',
    value: 'OM',
    isoCode: 'BS',
  },
  {
    name: 'Al Batinah South Governorate',
    value: 'OM',
    isoCode: 'BJ',
  },
  {
    name: 'Al Batinah Region',
    value: 'OM',
    isoCode: 'BA',
  },
  {
    name: 'Ash Sharqiyah Region',
    value: 'OM',
    isoCode: 'SH',
  },
  {
    name: 'Musandam Governorate',
    value: 'OM',
    isoCode: 'MU',
  },
  {
    name: 'Ash Sharqiyah North Governorate',
    value: 'OM',
    isoCode: 'SS',
  },
  {
    name: 'Ash Sharqiyah South Governorate',
    value: 'OM',
    isoCode: 'SJ',
  },
  {
    name: 'Muscat Governorate',
    value: 'OM',
    isoCode: 'MA',
  },
  {
    name: 'Al Wusta Governorate',
    value: 'OM',
    isoCode: 'WU',
  },
  {
    name: 'Dhofar Governorate',
    value: 'OM',
    isoCode: 'ZU',
  },
  {
    name: 'Ad Dakhiliyah Governorate',
    value: 'OM',
    isoCode: 'DA',
  },
  {
    name: 'Al Buraimi Governorate',
    value: 'OM',
    isoCode: 'BU',
  },
  {
    name: 'Ngamiland',
    value: 'BW',
    isoCode: 'NG',
  },
  {
    name: 'Ghanzi District',
    value: 'BW',
    isoCode: 'GH',
  },
  {
    name: 'Kgatleng District',
    value: 'BW',
    isoCode: 'KL',
  },
  {
    name: 'Southern District',
    value: 'BW',
    isoCode: 'SO',
  },
  {
    name: 'South-East District',
    value: 'BW',
    isoCode: 'SE',
  },
  {
    name: 'North-West District',
    value: 'BW',
    isoCode: 'NW',
  },
  {
    name: 'Kgalagadi District',
    value: 'BW',
    isoCode: 'KG',
  },
  {
    name: 'Central District',
    value: 'BW',
    isoCode: 'CE',
  },
  {
    name: 'North-East District',
    value: 'BW',
    isoCode: 'NE',
  },
  {
    name: 'Kweneng District',
    value: 'BW',
    isoCode: 'KW',
  },
  {
    name: 'Collines Department',
    value: 'BJ',
    isoCode: 'CO',
  },
  {
    name: 'Kouffo Department',
    value: 'BJ',
    isoCode: 'KO',
  },
  {
    name: 'Donga Department',
    value: 'BJ',
    isoCode: 'DO',
  },
  {
    name: 'Zou Department',
    value: 'BJ',
    isoCode: 'ZO',
  },
  {
    name: 'Plateau Department',
    value: 'BJ',
    isoCode: 'PL',
  },
  {
    name: 'Mono Department',
    value: 'BJ',
    isoCode: 'MO',
  },
  {
    name: 'Atakora Department',
    value: 'BJ',
    isoCode: 'AK',
  },
  {
    name: 'Alibori Department',
    value: 'BJ',
    isoCode: 'AL',
  },
  {
    name: 'Borgou Department',
    value: 'BJ',
    isoCode: 'BO',
  },
  {
    name: 'Atlantique Department',
    value: 'BJ',
    isoCode: 'AQ',
  },
  {
    name: 'Ouémé Department',
    value: 'BJ',
    isoCode: 'OU',
  },
  {
    name: 'Littoral Department',
    value: 'BJ',
    isoCode: 'LI',
  },
  {
    name: 'Machinga District',
    value: 'MW',
    isoCode: 'MH',
  },
  {
    name: 'Zomba District',
    value: 'MW',
    isoCode: 'ZO',
  },
  {
    name: 'Mwanza District',
    value: 'MW',
    isoCode: 'MW',
  },
  {
    name: 'Nsanje District',
    value: 'MW',
    isoCode: 'NS',
  },
  {
    name: 'Salima District',
    value: 'MW',
    isoCode: 'SA',
  },
  {
    name: 'Chitipa district',
    value: 'MW',
    isoCode: 'CT',
  },
  {
    name: 'Ntcheu District',
    value: 'MW',
    isoCode: 'NU',
  },
  {
    name: 'Rumphi District',
    value: 'MW',
    isoCode: 'RU',
  },
  {
    name: 'Dowa District',
    value: 'MW',
    isoCode: 'DO',
  },
  {
    name: 'Karonga District',
    value: 'MW',
    isoCode: 'KR',
  },
  {
    name: 'Central Region',
    value: 'MW',
    isoCode: 'C',
  },
  {
    name: 'Likoma District',
    value: 'MW',
    isoCode: 'LK',
  },
  {
    name: 'Kasungu District',
    value: 'MW',
    isoCode: 'KS',
  },
  {
    name: 'Nkhata Bay District',
    value: 'MW',
    isoCode: 'NB',
  },
  {
    name: 'Balaka District',
    value: 'MW',
    isoCode: 'BA',
  },
  {
    name: 'Dedza District',
    value: 'MW',
    isoCode: 'DE',
  },
  {
    name: 'Thyolo District',
    value: 'MW',
    isoCode: 'TH',
  },
  {
    name: 'Mchinji District',
    value: 'MW',
    isoCode: 'MC',
  },
  {
    name: 'Nkhotakota District',
    value: 'MW',
    isoCode: 'NK',
  },
  {
    name: 'Lilongwe District',
    value: 'MW',
    isoCode: 'LI',
  },
  {
    name: 'Blantyre District',
    value: 'MW',
    isoCode: 'BL',
  },
  {
    name: 'Mulanje District',
    value: 'MW',
    isoCode: 'MU',
  },
  {
    name: 'Mzimba District',
    value: 'MW',
    isoCode: 'MZ',
  },
  {
    name: 'Northern Region',
    value: 'MW',
    isoCode: 'N',
  },
  {
    name: 'Southern Region',
    value: 'MW',
    isoCode: 'S',
  },
  {
    name: 'Chikwawa District',
    value: 'MW',
    isoCode: 'CK',
  },
  {
    name: 'Phalombe District',
    value: 'MW',
    isoCode: 'PH',
  },
  {
    name: 'Chiradzulu District',
    value: 'MW',
    isoCode: 'CR',
  },
  {
    name: 'Mangochi District',
    value: 'MW',
    isoCode: 'MG',
  },
  {
    name: 'Ntchisi District',
    value: 'MW',
    isoCode: 'NI',
  },
  {
    name: 'Kénédougou Province',
    value: 'BF',
    isoCode: 'KEN',
  },
  {
    name: 'Namentenga Province',
    value: 'BF',
    isoCode: 'NAM',
  },
  {
    name: 'Sahel Region',
    value: 'BF',
    isoCode: '12',
  },
  {
    name: 'Centre-Ouest Region',
    value: 'BF',
    isoCode: '06',
  },
  {
    name: 'Nahouri Province',
    value: 'BF',
    isoCode: 'NAO',
  },
  {
    name: 'Passoré Province',
    value: 'BF',
    isoCode: 'PAS',
  },
  {
    name: 'Zoundwéogo Province',
    value: 'BF',
    isoCode: 'ZOU',
  },
  {
    name: 'Sissili Province',
    value: 'BF',
    isoCode: 'SIS',
  },
  {
    name: 'Banwa Province',
    value: 'BF',
    isoCode: 'BAN',
  },
  {
    name: 'Bougouriba Province',
    value: 'BF',
    isoCode: 'BGR',
  },
  {
    name: 'Gnagna Province',
    value: 'BF',
    isoCode: 'GNA',
  },
  {
    name: 'Mouhoun',
    value: 'BF',
    isoCode: 'MOU',
  },
  {
    name: 'Yagha Province',
    value: 'BF',
    isoCode: 'YAG',
  },
  {
    name: 'Plateau-Central Region',
    value: 'BF',
    isoCode: '11',
  },
  {
    name: 'Sanmatenga Province',
    value: 'BF',
    isoCode: 'SMT',
  },
  {
    name: 'Centre-Nord Region',
    value: 'BF',
    isoCode: '05',
  },
  {
    name: 'Tapoa Province',
    value: 'BF',
    isoCode: 'TAP',
  },
  {
    name: 'Houet Province',
    value: 'BF',
    isoCode: 'HOU',
  },
  {
    name: 'Zondoma Province',
    value: 'BF',
    isoCode: 'ZON',
  },
  {
    name: 'Boulgou',
    value: 'BF',
    isoCode: 'BLG',
  },
  {
    name: 'Komondjari Province',
    value: 'BF',
    isoCode: 'KMD',
  },
  {
    name: 'Koulpélogo Province',
    value: 'BF',
    isoCode: 'KOP',
  },
  {
    name: 'Tuy Province',
    value: 'BF',
    isoCode: 'TUI',
  },
  {
    name: 'Ioba Province',
    value: 'BF',
    isoCode: 'IOB',
  },
  {
    name: 'Centre',
    value: 'BF',
    isoCode: '03',
  },
  {
    name: 'Sourou Province',
    value: 'BF',
    isoCode: 'SOR',
  },
  {
    name: 'Boucle du Mouhoun Region',
    value: 'BF',
    isoCode: '01',
  },
  {
    name: 'Séno Province',
    value: 'BF',
    isoCode: 'SEN',
  },
  {
    name: 'Sud-Ouest Region',
    value: 'BF',
    isoCode: '13',
  },
  {
    name: 'Oubritenga Province',
    value: 'BF',
    isoCode: 'OUB',
  },
  {
    name: 'Nayala Province',
    value: 'BF',
    isoCode: 'NAY',
  },
  {
    name: 'Gourma Province',
    value: 'BF',
    isoCode: 'GOU',
  },
  {
    name: 'Oudalan Province',
    value: 'BF',
    isoCode: 'OUD',
  },
  {
    name: 'Ziro Province',
    value: 'BF',
    isoCode: 'ZIR',
  },
  {
    name: 'Kossi Province',
    value: 'BF',
    isoCode: 'KOS',
  },
  {
    name: 'Kourwéogo Province',
    value: 'BF',
    isoCode: 'KOW',
  },
  {
    name: 'Ganzourgou Province',
    value: 'BF',
    isoCode: 'GAN',
  },
  {
    name: 'Centre-Sud Region',
    value: 'BF',
    isoCode: '07',
  },
  {
    name: 'Yatenga Province',
    value: 'BF',
    isoCode: 'YAT',
  },
  {
    name: 'Loroum Province',
    value: 'BF',
    isoCode: 'LOR',
  },
  {
    name: 'Bazèga Province',
    value: 'BF',
    isoCode: 'BAZ',
  },
  {
    name: 'Cascades Region',
    value: 'BF',
    isoCode: '02',
  },
  {
    name: 'Sanguié Province',
    value: 'BF',
    isoCode: 'SNG',
  },
  {
    name: 'Bam Province',
    value: 'BF',
    isoCode: 'BAM',
  },
  {
    name: 'Noumbiel Province',
    value: 'BF',
    isoCode: 'NOU',
  },
  {
    name: 'Kompienga Province',
    value: 'BF',
    isoCode: 'KMP',
  },
  {
    name: 'Est Region',
    value: 'BF',
    isoCode: '08',
  },
  {
    name: 'Léraba Province',
    value: 'BF',
    isoCode: 'LER',
  },
  {
    name: 'Balé Province',
    value: 'BF',
    isoCode: 'BAL',
  },
  {
    name: 'Kouritenga Province',
    value: 'BF',
    isoCode: 'KOT',
  },
  {
    name: 'Centre-Est Region',
    value: 'BF',
    isoCode: '04',
  },
  {
    name: 'Poni Province',
    value: 'BF',
    isoCode: 'PON',
  },
  {
    name: 'Nord Region, Burkina Faso',
    value: 'BF',
    isoCode: '10',
  },
  {
    name: 'Hauts-Bassins Region',
    value: 'BF',
    isoCode: '09',
  },
  {
    name: 'Soum Province',
    value: 'BF',
    isoCode: 'SOM',
  },
  {
    name: 'Comoé Province',
    value: 'BF',
    isoCode: 'COM',
  },
  {
    name: 'Kadiogo Province',
    value: 'BF',
    isoCode: 'KAD',
  },
  {
    name: 'Islamabad Capital Territory',
    value: 'PK',
    isoCode: 'IS',
  },
  {
    name: 'Gilgit-Baltistan',
    value: 'PK',
    isoCode: 'GB',
  },
  {
    name: 'Khyber Pakhtunkhwa',
    value: 'PK',
    isoCode: 'KP',
  },
  {
    name: 'Azad Kashmir',
    value: 'PK',
    isoCode: 'JK',
  },
  {
    name: 'Federally Administered Tribal Areas',
    value: 'PK',
    isoCode: 'TA',
  },
  {
    name: 'Balochistan',
    value: 'PK',
    isoCode: 'BA',
  },
  {
    name: 'Sindh',
    value: 'PK',
    isoCode: 'SD',
  },
  {
    name: 'Punjab',
    value: 'PK',
    isoCode: 'PB',
  },
  {
    name: 'Al Rayyan Municipality',
    value: 'QA',
    isoCode: 'RA',
  },
  {
    name: 'Al-Shahaniya',
    value: 'QA',
    isoCode: 'SH',
  },
  {
    name: 'Al Wakrah',
    value: 'QA',
    isoCode: 'WA',
  },
  {
    name: 'Madinat ash Shamal',
    value: 'QA',
    isoCode: 'MS',
  },
  {
    name: 'Doha',
    value: 'QA',
    isoCode: 'DA',
  },
  {
    name: 'Al Daayen',
    value: 'QA',
    isoCode: 'ZA',
  },
  {
    name: 'Al Khor',
    value: 'QA',
    isoCode: 'KH',
  },
  {
    name: 'Umm Salal Municipality',
    value: 'QA',
    isoCode: 'US',
  },
  {
    name: 'Rumonge Province',
    value: 'BI',
    isoCode: 'RM',
  },
  {
    name: 'Muyinga Province',
    value: 'BI',
    isoCode: 'MY',
  },
  {
    name: 'Mwaro Province',
    value: 'BI',
    isoCode: 'MW',
  },
  {
    name: 'Makamba Province',
    value: 'BI',
    isoCode: 'MA',
  },
  {
    name: 'Rutana Province',
    value: 'BI',
    isoCode: 'RT',
  },
  {
    name: 'Cibitoke Province',
    value: 'BI',
    isoCode: 'CI',
  },
  {
    name: 'Ruyigi Province',
    value: 'BI',
    isoCode: 'RY',
  },
  {
    name: 'Kayanza Province',
    value: 'BI',
    isoCode: 'KY',
  },
  {
    name: 'Muramvya Province',
    value: 'BI',
    isoCode: 'MU',
  },
  {
    name: 'Karuzi Province',
    value: 'BI',
    isoCode: 'KR',
  },
  {
    name: 'Kirundo Province',
    value: 'BI',
    isoCode: 'KI',
  },
  {
    name: 'Bubanza Province',
    value: 'BI',
    isoCode: 'BB',
  },
  {
    name: 'Gitega Province',
    value: 'BI',
    isoCode: 'GI',
  },
  {
    name: 'Bujumbura Mairie Province',
    value: 'BI',
    isoCode: 'BM',
  },
  {
    name: 'Ngozi Province',
    value: 'BI',
    isoCode: 'NG',
  },
  {
    name: 'Bujumbura Rural Province',
    value: 'BI',
    isoCode: 'BL',
  },
  {
    name: 'Cankuzo Province',
    value: 'BI',
    isoCode: 'CA',
  },
  {
    name: 'Bururi Province',
    value: 'BI',
    isoCode: 'BR',
  },
  {
    name: 'Flores Department',
    value: 'UY',
    isoCode: 'FS',
  },
  {
    name: 'San José Department',
    value: 'UY',
    isoCode: 'SJ',
  },
  {
    name: 'Artigas Department',
    value: 'UY',
    isoCode: 'AR',
  },
  {
    name: 'Maldonado Department',
    value: 'UY',
    isoCode: 'MA',
  },
  {
    name: 'Rivera Department',
    value: 'UY',
    isoCode: 'RV',
  },
  {
    name: 'Colonia Department',
    value: 'UY',
    isoCode: 'CO',
  },
  {
    name: 'Durazno Department',
    value: 'UY',
    isoCode: 'DU',
  },
  {
    name: 'Río Negro Department',
    value: 'UY',
    isoCode: 'RN',
  },
  {
    name: 'Cerro Largo Department',
    value: 'UY',
    isoCode: 'CL',
  },
  {
    name: 'Paysandú Department',
    value: 'UY',
    isoCode: 'PA',
  },
  {
    name: 'Canelones Department',
    value: 'UY',
    isoCode: 'CA',
  },
  {
    name: 'Treinta y Tres Department',
    value: 'UY',
    isoCode: 'TT',
  },
  {
    name: 'Lavalleja Department',
    value: 'UY',
    isoCode: 'LA',
  },
  {
    name: 'Rocha Department',
    value: 'UY',
    isoCode: 'RO',
  },
  {
    name: 'Florida Department',
    value: 'UY',
    isoCode: 'FD',
  },
  {
    name: 'Montevideo Department',
    value: 'UY',
    isoCode: 'MO',
  },
  {
    name: 'Soriano Department',
    value: 'UY',
    isoCode: 'SO',
  },
  {
    name: 'Salto Department',
    value: 'UY',
    isoCode: 'SA',
  },
  {
    name: 'Tacuarembó Department',
    value: 'UY',
    isoCode: 'TA',
  },
  {
    name: 'Kafr el-Sheikh',
    value: 'EG',
    isoCode: 'KFS',
  },
  {
    name: 'Cairo',
    value: 'EG',
    isoCode: 'C',
  },
  {
    name: 'Damietta',
    value: 'EG',
    isoCode: 'DT',
  },
  {
    name: 'Aswan',
    value: 'EG',
    isoCode: 'ASN',
  },
  {
    name: 'Sohag',
    value: 'EG',
    isoCode: 'SHG',
  },
  {
    name: 'North Sinai',
    value: 'EG',
    isoCode: 'SIN',
  },
  {
    name: 'Monufia',
    value: 'EG',
    isoCode: 'MNF',
  },
  {
    name: 'Port Said',
    value: 'EG',
    isoCode: 'PTS',
  },
  {
    name: 'Beni Suef',
    value: 'EG',
    isoCode: 'BNS',
  },
  {
    name: 'Matrouh',
    value: 'EG',
    isoCode: 'MT',
  },
  {
    name: 'Qalyubia',
    value: 'EG',
    isoCode: 'KB',
  },
  {
    name: 'Suez',
    value: 'EG',
    isoCode: 'SUZ',
  },
  {
    name: 'Gharbia',
    value: 'EG',
    isoCode: 'GH',
  },
  {
    name: 'Alexandria',
    value: 'EG',
    isoCode: 'ALX',
  },
  {
    name: 'Asyut',
    value: 'EG',
    isoCode: 'AST',
  },
  {
    name: 'South Sinai',
    value: 'EG',
    isoCode: 'JS',
  },
  {
    name: 'Faiyum',
    value: 'EG',
    isoCode: 'FYM',
  },
  {
    name: 'Giza',
    value: 'EG',
    isoCode: 'GZ',
  },
  {
    name: 'Red Sea',
    value: 'EG',
    isoCode: 'BA',
  },
  {
    name: 'Beheira',
    value: 'EG',
    isoCode: 'BH',
  },
  {
    name: 'Luxor',
    value: 'EG',
    isoCode: 'LX',
  },
  {
    name: 'Minya',
    value: 'EG',
    isoCode: 'MN',
  },
  {
    name: 'Ismailia',
    value: 'EG',
    isoCode: 'IS',
  },
  {
    name: 'Dakahlia',
    value: 'EG',
    isoCode: 'DK',
  },
  {
    name: 'New Valley',
    value: 'EG',
    isoCode: 'WAD',
  },
  {
    name: 'Qena',
    value: 'EG',
    isoCode: 'KN',
  },
  {
    name: 'Sharqia',
    value: 'EG',
    isoCode: 'SHR',
  },
  {
    name: 'Agaléga',
    value: 'MU',
    isoCode: 'AG',
  },
  {
    name: 'Rodrigues',
    value: 'MU',
    isoCode: 'RO',
  },
  {
    name: 'Pamplemousses District',
    value: 'MU',
    isoCode: 'PA',
  },
  {
    name: 'Cargados Carajos',
    value: 'MU',
    isoCode: 'CC',
  },
  {
    name: 'Vacoas-Phoenix',
    value: 'MU',
    isoCode: 'VP',
  },
  {
    name: 'Moka District',
    value: 'MU',
    isoCode: 'MO',
  },
  {
    name: 'Flacq District',
    value: 'MU',
    isoCode: 'FL',
  },
  {
    name: 'Curepipe',
    value: 'MU',
    isoCode: 'CU',
  },
  {
    name: 'Port Louis',
    value: 'MU',
    isoCode: 'PU',
  },
  {
    name: 'Savanne District',
    value: 'MU',
    isoCode: 'SA',
  },
  {
    name: 'Quatre Bornes',
    value: 'MU',
    isoCode: 'QB',
  },
  {
    name: 'Rivière Noire District',
    value: 'MU',
    isoCode: 'BL',
  },
  {
    name: 'Port Louis District',
    value: 'MU',
    isoCode: 'PL',
  },
  {
    name: 'Rivière du Rempart District',
    value: 'MU',
    isoCode: 'RR',
  },
  {
    name: 'Beau Bassin-Rose Hill',
    value: 'MU',
    isoCode: 'BR',
  },
  {
    name: 'Plaines Wilhems District',
    value: 'MU',
    isoCode: 'PW',
  },
  {
    name: 'Grand Port District',
    value: 'MU',
    isoCode: 'GP',
  },
  {
    name: 'Guelmim',
    value: 'MA',
    isoCode: 'GUE',
  },
  {
    name: 'Aousserd (EH)',
    value: 'MA',
    isoCode: 'AOU',
  },
  {
    name: 'Al Hoceïma',
    value: 'MA',
    isoCode: 'HOC',
  },
  {
    name: 'Larache',
    value: 'MA',
    isoCode: 'LAR',
  },
  {
    name: 'Ouarzazate',
    value: 'MA',
    isoCode: 'OUA',
  },
  {
    name: 'Boulemane',
    value: 'MA',
    isoCode: 'BOM',
  },
  {
    name: "L'Oriental",
    value: 'MA',
    isoCode: '02',
  },
  {
    name: 'Béni Mellal',
    value: 'MA',
    isoCode: 'BEM',
  },
  {
    name: 'Chichaoua',
    value: 'MA',
    isoCode: 'CHI',
  },
  {
    name: 'Boujdour (EH)',
    value: 'MA',
    isoCode: 'BOD',
  },
  {
    name: 'Khémisset',
    value: 'MA',
    isoCode: 'KHE',
  },
  {
    name: 'Tiznit',
    value: 'MA',
    isoCode: 'TIZ',
  },
  {
    name: 'Béni Mellal-Khénifra',
    value: 'MA',
    isoCode: '05',
  },
  {
    name: 'Sidi Kacem',
    value: 'MA',
    isoCode: 'SIK',
  },
  {
    name: 'El Jadida',
    value: 'MA',
    isoCode: 'JDI',
  },
  {
    name: 'Nador',
    value: 'MA',
    isoCode: 'NAD',
  },
  {
    name: 'Settat',
    value: 'MA',
    isoCode: 'SET',
  },
  {
    name: 'Zagora',
    value: 'MA',
    isoCode: 'ZAG',
  },
  {
    name: 'Médiouna',
    value: 'MA',
    isoCode: 'MED',
  },
  {
    name: 'Berkane',
    value: 'MA',
    isoCode: 'BER',
  },
  {
    name: 'Tan-Tan (EH-partial)',
    value: 'MA',
    isoCode: 'TNT',
  },
  {
    name: 'Nouaceur',
    value: 'MA',
    isoCode: 'NOU',
  },
  {
    name: 'Marrakesh-Safi',
    value: 'MA',
    isoCode: '07',
  },
  {
    name: 'Sefrou',
    value: 'MA',
    isoCode: 'SEF',
  },
  {
    name: 'Drâa-Tafilalet',
    value: 'MA',
    isoCode: '08',
  },
  {
    name: 'El Hajeb',
    value: 'MA',
    isoCode: 'HAJ',
  },
  {
    name: 'Es-Semara (EH-partial)',
    value: 'MA',
    isoCode: 'ESM',
  },
  {
    name: 'Laâyoune (EH)',
    value: 'MA',
    isoCode: 'LAA',
  },
  {
    name: 'Inezgane-Ait Melloul',
    value: 'MA',
    isoCode: 'INE',
  },
  {
    name: 'Souss-Massa',
    value: 'MA',
    isoCode: '09',
  },
  {
    name: 'Taza',
    value: 'MA',
    isoCode: 'TAZ',
  },
  {
    name: 'Assa-Zag (EH-partial)',
    value: 'MA',
    isoCode: 'ASZ',
  },
  {
    name: 'Laâyoune-Sakia El Hamra (EH-partial)',
    value: 'MA',
    isoCode: '11',
  },
  {
    name: 'Errachidia',
    value: 'MA',
    isoCode: 'ERR',
  },
  {
    name: 'Fahs-Anjra',
    value: 'MA',
    isoCode: 'FAH',
  },
  {
    name: 'Figuig',
    value: 'MA',
    isoCode: 'FIG',
  },
  {
    name: 'Chtouka-Ait Baha',
    value: 'MA',
    isoCode: 'CHT',
  },
  {
    name: 'Casablanca-Settat',
    value: 'MA',
    isoCode: '06',
  },
  {
    name: 'Benslimane',
    value: 'MA',
    isoCode: 'BES',
  },
  {
    name: 'Guelmim-Oued Noun (EH-partial)',
    value: 'MA',
    isoCode: '10',
  },
  {
    name: 'Dakhla-Oued Ed-Dahab (EH)',
    value: 'MA',
    isoCode: '12',
  },
  {
    name: 'Jerada',
    value: 'MA',
    isoCode: 'JRA',
  },
  {
    name: 'Kénitra',
    value: 'MA',
    isoCode: 'KEN',
  },
  {
    name: 'El Kelâa des Sraghna',
    value: 'MA',
    isoCode: 'KES',
  },
  {
    name: 'Chefchaouen',
    value: 'MA',
    isoCode: 'CHE',
  },
  {
    name: 'Safi',
    value: 'MA',
    isoCode: 'SAF',
  },
  {
    name: 'Tata',
    value: 'MA',
    isoCode: 'TAT',
  },
  {
    name: 'Fès-Meknès',
    value: 'MA',
    isoCode: '03',
  },
  {
    name: 'Taroudannt',
    value: 'MA',
    isoCode: 'TAR',
  },
  {
    name: 'Moulay Yacoub',
    value: 'MA',
    isoCode: 'MOU',
  },
  {
    name: 'Essaouira',
    value: 'MA',
    isoCode: 'ESI',
  },
  {
    name: 'Khénifra',
    value: 'MA',
    isoCode: 'KHN',
  },
  {
    name: 'Tétouan',
    value: 'MA',
    isoCode: 'TET',
  },
  {
    name: 'Oued Ed-Dahab (EH)',
    value: 'MA',
    isoCode: 'OUD',
  },
  {
    name: 'Al Haouz',
    value: 'MA',
    isoCode: 'HAO',
  },
  {
    name: 'Azilal',
    value: 'MA',
    isoCode: 'AZI',
  },
  {
    name: 'Taourirt',
    value: 'MA',
    isoCode: 'TAI',
  },
  {
    name: 'Taounate',
    value: 'MA',
    isoCode: 'TAO',
  },
  {
    name: 'Tanger-Tétouan-Al Hoceïma',
    value: 'MA',
    isoCode: '01',
  },
  {
    name: 'Ifrane',
    value: 'MA',
    isoCode: 'IFR',
  },
  {
    name: 'Khouribga',
    value: 'MA',
    isoCode: 'KHO',
  },
  {
    name: 'Rabat-Salé-Kénitra',
    value: 'MA',
    isoCode: '04',
  },
  {
    name: 'Agadir-Ida-Ou-Tanane',
    value: 'MA',
    isoCode: 'AGD',
  },
  {
    name: 'Berrechid',
    value: 'MA',
    isoCode: 'BRR',
  },
  {
    name: 'Casablanca',
    value: 'MA',
    isoCode: 'CAS',
  },
  {
    name: 'Driouch',
    value: 'MA',
    isoCode: 'DRI',
  },
  {
    name: 'Fès',
    value: 'MA',
    isoCode: 'FES',
  },
  {
    name: 'Fquih Ben Salah',
    value: 'MA',
    isoCode: 'FQH',
  },
  {
    name: 'Guercif',
    value: 'MA',
    isoCode: 'GUF',
  },
  {
    name: 'Marrakech',
    value: 'MA',
    isoCode: 'MAR',
  },
  {
    name: 'M’diq-Fnideq',
    value: 'MA',
    isoCode: 'MDF',
  },
  {
    name: 'Meknès',
    value: 'MA',
    isoCode: 'MEK',
  },
  {
    name: 'Midelt',
    value: 'MA',
    isoCode: 'MID',
  },
  {
    name: 'Mohammadia',
    value: 'MA',
    isoCode: 'MOH',
  },
  {
    name: 'Oujda-Angad',
    value: 'MA',
    isoCode: 'OUJ',
  },
  {
    name: 'Ouezzane',
    value: 'MA',
    isoCode: 'OUZ',
  },
  {
    name: 'Rabat',
    value: 'MA',
    isoCode: 'RAB',
  },
  {
    name: 'Rehamna',
    value: 'MA',
    isoCode: 'REH',
  },
  {
    name: 'Salé',
    value: 'MA',
    isoCode: 'SAL',
  },
  {
    name: 'Sidi Bennour',
    value: 'MA',
    isoCode: 'SIB',
  },
  {
    name: 'Sidi Ifni',
    value: 'MA',
    isoCode: 'SIF',
  },
  {
    name: 'Skhirate-Témara',
    value: 'MA',
    isoCode: 'SKH',
  },
  {
    name: 'Tarfaya (EH-partial)',
    value: 'MA',
    isoCode: 'TAF',
  },
  {
    name: 'Tinghir',
    value: 'MA',
    isoCode: 'TIN',
  },
  {
    name: 'Tanger-Assilah',
    value: 'MA',
    isoCode: 'TNG',
  },
  {
    name: 'Youssoufia',
    value: 'MA',
    isoCode: 'YUS',
  },
  {
    name: 'Sidi Slimane',
    value: 'MA',
    isoCode: 'SIL',
  },
  {
    name: 'Cabo Delgado Province',
    value: 'MZ',
    isoCode: 'P',
  },
  {
    name: 'Zambezia Province',
    value: 'MZ',
    isoCode: 'Q',
  },
  {
    name: 'Gaza Province',
    value: 'MZ',
    isoCode: 'G',
  },
  {
    name: 'Inhambane Province',
    value: 'MZ',
    isoCode: 'I',
  },
  {
    name: 'Sofala Province',
    value: 'MZ',
    isoCode: 'S',
  },
  {
    name: 'Maputo Province',
    value: 'MZ',
    isoCode: 'L',
  },
  {
    name: 'Niassa Province',
    value: 'MZ',
    isoCode: 'A',
  },
  {
    name: 'Tete Province',
    value: 'MZ',
    isoCode: 'T',
  },
  {
    name: 'Maputo',
    value: 'MZ',
    isoCode: 'MPM',
  },
  {
    name: 'Nampula Province',
    value: 'MZ',
    isoCode: 'N',
  },
  {
    name: 'Manica Province',
    value: 'MZ',
    isoCode: 'B',
  },
  {
    name: 'Hodh Ech Chargui Region',
    value: 'MR',
    isoCode: '01',
  },
  {
    name: 'Brakna Region',
    value: 'MR',
    isoCode: '05',
  },
  {
    name: 'Tiris Zemmour Region',
    value: 'MR',
    isoCode: '11',
  },
  {
    name: 'Gorgol Region',
    value: 'MR',
    isoCode: '04',
  },
  {
    name: 'Inchiri Region',
    value: 'MR',
    isoCode: '12',
  },
  {
    name: 'Nouakchott-Nord Region',
    value: 'MR',
    isoCode: '14',
  },
  {
    name: 'Adrar Region',
    value: 'MR',
    isoCode: '07',
  },
  {
    name: 'Tagant Region',
    value: 'MR',
    isoCode: '09',
  },
  {
    name: 'Dakhlet Nouadhibou',
    value: 'MR',
    isoCode: '08',
  },
  {
    name: 'Nouakchott-Sud Region',
    value: 'MR',
    isoCode: '15',
  },
  {
    name: 'Trarza Region',
    value: 'MR',
    isoCode: '06',
  },
  {
    name: 'Assaba Region',
    value: 'MR',
    isoCode: '03',
  },
  {
    name: 'Guidimaka Region',
    value: 'MR',
    isoCode: '10',
  },
  {
    name: 'Hodh El Gharbi Region',
    value: 'MR',
    isoCode: '02',
  },
  {
    name: 'Nouakchott-Ouest Region',
    value: 'MR',
    isoCode: '13',
  },
  {
    name: 'Western Tobago',
    value: 'TT',
    isoCode: 'WTO',
  },
  {
    name: 'Couva-Tabaquite-Talparo Regional Corporation',
    value: 'TT',
    isoCode: 'CTT',
  },
  {
    name: 'Eastern Tobago',
    value: 'TT',
    isoCode: 'ETO',
  },
  {
    name: 'Rio Claro-Mayaro Regional Corporation',
    value: 'TT',
    isoCode: 'MRC',
  },
  {
    name: 'San Juan-Laventille Regional Corporation',
    value: 'TT',
    isoCode: 'SJL',
  },
  {
    name: 'Tunapuna-Piarco Regional Corporation',
    value: 'TT',
    isoCode: 'TUP',
  },
  {
    name: 'San Fernando',
    value: 'TT',
    isoCode: 'SFO',
  },
  {
    name: 'Point Fortin',
    value: 'TT',
    isoCode: 'PTF',
  },
  {
    name: 'Sangre Grande Regional Corporation',
    value: 'TT',
    isoCode: 'SGE',
  },
  {
    name: 'Arima',
    value: 'TT',
    isoCode: 'ARI',
  },
  {
    name: 'Port of Spain',
    value: 'TT',
    isoCode: 'POS',
  },
  {
    name: 'Siparia Regional Corporation',
    value: 'TT',
    isoCode: 'SIP',
  },
  {
    name: 'Penal-Debe Regional Corporation',
    value: 'TT',
    isoCode: 'PED',
  },
  {
    name: 'Chaguanas',
    value: 'TT',
    isoCode: 'CHA',
  },
  {
    name: 'Diego Martin Regional Corporation',
    value: 'TT',
    isoCode: 'DMN',
  },
  {
    name: 'Princes Town Regional Corporation',
    value: 'TT',
    isoCode: 'PRT',
  },
  {
    name: 'Mary Region',
    value: 'TM',
    isoCode: 'M',
  },
  {
    name: 'Lebap Region',
    value: 'TM',
    isoCode: 'L',
  },
  {
    name: 'Ashgabat',
    value: 'TM',
    isoCode: 'S',
  },
  {
    name: 'Balkan Region',
    value: 'TM',
    isoCode: 'B',
  },
  {
    name: 'Daşoguz Region',
    value: 'TM',
    isoCode: 'D',
  },
  {
    name: 'Ahal Region',
    value: 'TM',
    isoCode: 'A',
  },
  {
    name: 'Beni Department',
    value: 'BO',
    isoCode: 'B',
  },
  {
    name: 'Oruro Department',
    value: 'BO',
    isoCode: 'O',
  },
  {
    name: 'Santa Cruz Department',
    value: 'BO',
    isoCode: 'S',
  },
  {
    name: 'Tarija Department',
    value: 'BO',
    isoCode: 'T',
  },
  {
    name: 'Pando Department',
    value: 'BO',
    isoCode: 'N',
  },
  {
    name: 'La Paz Department',
    value: 'BO',
    isoCode: 'L',
  },
  {
    name: 'Cochabamba Department',
    value: 'BO',
    isoCode: 'C',
  },
  {
    name: 'Chuquisaca Department',
    value: 'BO',
    isoCode: 'H',
  },
  {
    name: 'Potosí Department',
    value: 'BO',
    isoCode: 'P',
  },
  {
    name: 'Saint George Parish',
    value: 'VC',
    isoCode: '04',
  },
  {
    name: 'Saint Patrick Parish',
    value: 'VC',
    isoCode: '05',
  },
  {
    name: 'Saint Andrew Parish',
    value: 'VC',
    isoCode: '02',
  },
  {
    name: 'Saint David Parish',
    value: 'VC',
    isoCode: '03',
  },
  {
    name: 'Grenadines Parish',
    value: 'VC',
    isoCode: '06',
  },
  {
    name: 'Charlotte Parish',
    value: 'VC',
    isoCode: '01',
  },
  {
    name: 'Sharjah Emirate',
    value: 'AE',
    isoCode: 'SH',
  },
  {
    name: 'Dubai',
    value: 'AE',
    isoCode: 'DU',
  },
  {
    name: 'Umm al-Quwain',
    value: 'AE',
    isoCode: 'UQ',
  },
  {
    name: 'Fujairah',
    value: 'AE',
    isoCode: 'FU',
  },
  {
    name: 'Ras al-Khaimah',
    value: 'AE',
    isoCode: 'RK',
  },
  {
    name: 'Ajman Emirate',
    value: 'AE',
    isoCode: 'AJ',
  },
  {
    name: 'Abu Dhabi Emirate',
    value: 'AE',
    isoCode: 'AZ',
  },
  {
    name: 'districts of Republican Subordination',
    value: 'TJ',
    isoCode: 'RA',
  },
  {
    name: 'Khatlon Province',
    value: 'TJ',
    isoCode: 'KT',
  },
  {
    name: 'Gorno-Badakhshan Autonomous Province',
    value: 'TJ',
    isoCode: 'GB',
  },
  {
    name: 'Sughd Province',
    value: 'TJ',
    isoCode: 'SU',
  },
  {
    name: 'Yilan',
    value: 'TW',
    isoCode: 'ILA',
  },
  {
    name: 'Penghu',
    value: 'TW',
    isoCode: 'PEN',
  },
  {
    name: 'Changhua',
    value: 'TW',
    isoCode: 'CHA',
  },
  {
    name: 'Pingtung',
    value: 'TW',
    isoCode: 'PIF',
  },
  {
    name: 'Taichung',
    value: 'TW',
    isoCode: 'TXG',
  },
  {
    name: 'Nantou',
    value: 'TW',
    isoCode: 'NAN',
  },
  {
    name: 'Chiayi',
    value: 'TW',
    isoCode: 'CYI',
  },
  {
    name: 'Taitung',
    value: 'TW',
    isoCode: 'TTT',
  },
  {
    name: 'Hualien',
    value: 'TW',
    isoCode: 'HUA',
  },
  {
    name: 'Kaohsiung',
    value: 'TW',
    isoCode: 'KHH',
  },
  {
    name: 'Miaoli',
    value: 'TW',
    isoCode: 'MIA',
  },
  {
    name: 'Kinmen',
    value: 'TW',
    isoCode: 'KIN',
  },
  {
    name: 'Yunlin',
    value: 'TW',
    isoCode: 'YUN',
  },
  {
    name: 'Hsinchu',
    value: 'TW',
    isoCode: 'HSZ',
  },
  {
    name: 'Chiayi',
    value: 'TW',
    isoCode: 'CYQ',
  },
  {
    name: 'Taoyuan',
    value: 'TW',
    isoCode: 'TAO',
  },
  {
    name: 'Lienchiang',
    value: 'TW',
    isoCode: 'LIE',
  },
  {
    name: 'Tainan',
    value: 'TW',
    isoCode: 'TNN',
  },
  {
    name: 'Taipei',
    value: 'TW',
    isoCode: 'TPE',
  },
  {
    name: 'Hsinchu',
    value: 'TW',
    isoCode: 'HSQ',
  },
  {
    name: 'Keelung',
    value: 'TW',
    isoCode: 'KEE',
  },
  {
    name: 'New Taipei',
    value: 'TW',
    isoCode: 'NWT',
  },
  {
    name: 'Northern Red Sea Region',
    value: 'ER',
    isoCode: 'SK',
  },
  {
    name: 'Anseba Region',
    value: 'ER',
    isoCode: 'AN',
  },
  {
    name: 'Maekel Region',
    value: 'ER',
    isoCode: 'MA',
  },
  {
    name: 'Debub Region',
    value: 'ER',
    isoCode: 'DU',
  },
  {
    name: 'Gash-Barka Region',
    value: 'ER',
    isoCode: 'GB',
  },
  {
    name: 'Southern Red Sea Region',
    value: 'ER',
    isoCode: 'DK',
  },
  {
    name: 'Southern Peninsula Region',
    value: 'IS',
    isoCode: '2',
  },
  {
    name: 'Capital Region',
    value: 'IS',
    isoCode: '1',
  },
  {
    name: 'Westfjords',
    value: 'IS',
    isoCode: '4',
  },
  {
    name: 'Eastern Region',
    value: 'IS',
    isoCode: '7',
  },
  {
    name: 'Southern Region',
    value: 'IS',
    isoCode: '8',
  },
  {
    name: 'Northwestern Region',
    value: 'IS',
    isoCode: '5',
  },
  {
    name: 'Western Region',
    value: 'IS',
    isoCode: '3',
  },
  {
    name: 'Northeastern Region',
    value: 'IS',
    isoCode: '6',
  },
  {
    name: 'Río Muni',
    value: 'GQ',
    isoCode: 'C',
  },
  {
    name: 'Kié-Ntem Province',
    value: 'GQ',
    isoCode: 'KN',
  },
  {
    name: 'Wele-Nzas Province',
    value: 'GQ',
    isoCode: 'WN',
  },
  {
    name: 'Litoral Province',
    value: 'GQ',
    isoCode: 'LI',
  },
  {
    name: 'Insular Region',
    value: 'GQ',
    isoCode: 'I',
  },
  {
    name: 'Bioko Sur Province',
    value: 'GQ',
    isoCode: 'BS',
  },
  {
    name: 'Annobón Province',
    value: 'GQ',
    isoCode: 'AN',
  },
  {
    name: 'Centro Sur Province',
    value: 'GQ',
    isoCode: 'CS',
  },
  {
    name: 'Bioko Norte Province',
    value: 'GQ',
    isoCode: 'BN',
  },
  {
    name: 'Chihuahua',
    value: 'MX',
    isoCode: 'CHH',
  },
  {
    name: 'Oaxaca',
    value: 'MX',
    isoCode: 'OAX',
  },
  {
    name: 'Sinaloa',
    value: 'MX',
    isoCode: 'SIN',
  },
  {
    name: 'Estado de México',
    value: 'MX',
    isoCode: 'MEX',
  },
  {
    name: 'Chiapas',
    value: 'MX',
    isoCode: 'CHP',
  },
  {
    name: 'Nuevo León',
    value: 'MX',
    isoCode: 'NLE',
  },
  {
    name: 'Durango',
    value: 'MX',
    isoCode: 'DUR',
  },
  {
    name: 'Tabasco',
    value: 'MX',
    isoCode: 'TAB',
  },
  {
    name: 'Querétaro',
    value: 'MX',
    isoCode: 'QUE',
  },
  {
    name: 'Aguascalientes',
    value: 'MX',
    isoCode: 'AGU',
  },
  {
    name: 'Baja California',
    value: 'MX',
    isoCode: 'BCN',
  },
  {
    name: 'Tlaxcala',
    value: 'MX',
    isoCode: 'TLA',
  },
  {
    name: 'Guerrero',
    value: 'MX',
    isoCode: 'GRO',
  },
  {
    name: 'Baja California Sur',
    value: 'MX',
    isoCode: 'BCS',
  },
  {
    name: 'San Luis Potosí',
    value: 'MX',
    isoCode: 'SLP',
  },
  {
    name: 'Zacatecas',
    value: 'MX',
    isoCode: 'ZAC',
  },
  {
    name: 'Tamaulipas',
    value: 'MX',
    isoCode: 'TAM',
  },
  {
    name: 'Veracruz de Ignacio de la Llave',
    value: 'MX',
    isoCode: 'VER',
  },
  {
    name: 'Morelos',
    value: 'MX',
    isoCode: 'MOR',
  },
  {
    name: 'Yucatán',
    value: 'MX',
    isoCode: 'YUC',
  },
  {
    name: 'Quintana Roo',
    value: 'MX',
    isoCode: 'ROO',
  },
  {
    name: 'Sonora',
    value: 'MX',
    isoCode: 'SON',
  },
  {
    name: 'Guanajuato',
    value: 'MX',
    isoCode: 'GUA',
  },
  {
    name: 'Hidalgo',
    value: 'MX',
    isoCode: 'HID',
  },
  {
    name: 'Coahuila de Zaragoza',
    value: 'MX',
    isoCode: 'COA',
  },
  {
    name: 'Colima',
    value: 'MX',
    isoCode: 'COL',
  },
  {
    name: 'Ciudad de México',
    value: 'MX',
    isoCode: 'CDMX',
  },
  {
    name: 'Michoacán de Ocampo',
    value: 'MX',
    isoCode: 'MIC',
  },
  {
    name: 'Campeche',
    value: 'MX',
    isoCode: 'CAM',
  },
  {
    name: 'Puebla',
    value: 'MX',
    isoCode: 'PUE',
  },
  {
    name: 'Nayarit',
    value: 'MX',
    isoCode: 'NAY',
  },
  {
    name: 'Jalisco',
    value: 'MX',
    isoCode: 'JAL',
  },
  {
    name: 'Krabi',
    value: 'TH',
    isoCode: '81',
  },
  {
    name: 'Ranong',
    value: 'TH',
    isoCode: '85',
  },
  {
    name: 'Nong Bua Lam Phu',
    value: 'TH',
    isoCode: '39',
  },
  {
    name: 'Samut Prakan',
    value: 'TH',
    isoCode: '11',
  },
  {
    name: 'Surat Thani',
    value: 'TH',
    isoCode: '84',
  },
  {
    name: 'Lamphun',
    value: 'TH',
    isoCode: '51',
  },
  {
    name: 'Nong Khai',
    value: 'TH',
    isoCode: '43',
  },
  {
    name: 'Khon Kaen',
    value: 'TH',
    isoCode: '40',
  },
  {
    name: 'Chanthaburi',
    value: 'TH',
    isoCode: '22',
  },
  {
    name: 'Saraburi',
    value: 'TH',
    isoCode: '19',
  },
  {
    name: 'Phatthalung',
    value: 'TH',
    isoCode: '93',
  },
  {
    name: 'Uttaradit',
    value: 'TH',
    isoCode: '53',
  },
  {
    name: 'Sing Buri',
    value: 'TH',
    isoCode: '17',
  },
  {
    name: 'Chiang Mai',
    value: 'TH',
    isoCode: '50',
  },
  {
    name: 'Nakhon Sawan',
    value: 'TH',
    isoCode: '60',
  },
  {
    name: 'Yala',
    value: 'TH',
    isoCode: '95',
  },
  {
    name: 'Phra Nakhon Si Ayutthaya',
    value: 'TH',
    isoCode: '14',
  },
  {
    name: 'Nonthaburi',
    value: 'TH',
    isoCode: '12',
  },
  {
    name: 'Trat',
    value: 'TH',
    isoCode: '23',
  },
  {
    name: 'Nakhon Ratchasima',
    value: 'TH',
    isoCode: '30',
  },
  {
    name: 'Chiang Rai',
    value: 'TH',
    isoCode: '57',
  },
  {
    name: 'Ratchaburi',
    value: 'TH',
    isoCode: '70',
  },
  {
    name: 'Pathum Thani',
    value: 'TH',
    isoCode: '13',
  },
  {
    name: 'Sakon Nakhon',
    value: 'TH',
    isoCode: '47',
  },
  {
    name: 'Samut Songkhram',
    value: 'TH',
    isoCode: '75',
  },
  {
    name: 'Nakhon Pathom',
    value: 'TH',
    isoCode: '73',
  },
  {
    name: 'Samut Sakhon',
    value: 'TH',
    isoCode: '74',
  },
  {
    name: 'Mae Hong Son',
    value: 'TH',
    isoCode: '58',
  },
  {
    name: 'Phitsanulok',
    value: 'TH',
    isoCode: '65',
  },
  {
    name: 'Pattaya',
    value: 'TH',
    isoCode: 'S',
  },
  {
    name: 'Prachuap Khiri Khan',
    value: 'TH',
    isoCode: '77',
  },
  {
    name: 'Loei',
    value: 'TH',
    isoCode: '42',
  },
  {
    name: 'Roi Et',
    value: 'TH',
    isoCode: '45',
  },
  {
    name: 'Kanchanaburi',
    value: 'TH',
    isoCode: '71',
  },
  {
    name: 'Ubon Ratchathani',
    value: 'TH',
    isoCode: '34',
  },
  {
    name: 'Chon Buri',
    value: 'TH',
    isoCode: '20',
  },
  {
    name: 'Phichit',
    value: 'TH',
    isoCode: '66',
  },
  {
    name: 'Phetchabun',
    value: 'TH',
    isoCode: '67',
  },
  {
    name: 'Kamphaeng Phet',
    value: 'TH',
    isoCode: '62',
  },
  {
    name: 'Maha Sarakham',
    value: 'TH',
    isoCode: '44',
  },
  {
    name: 'Rayong',
    value: 'TH',
    isoCode: '21',
  },
  {
    name: 'Ang Thong',
    value: 'TH',
    isoCode: '15',
  },
  {
    name: 'Nakhon Si Thammarat',
    value: 'TH',
    isoCode: '80',
  },
  {
    name: 'Yasothon',
    value: 'TH',
    isoCode: '35',
  },
  {
    name: 'Chai Nat',
    value: 'TH',
    isoCode: '18',
  },
  {
    name: 'Amnat Charoen',
    value: 'TH',
    isoCode: '37',
  },
  {
    name: 'Suphan Buri',
    value: 'TH',
    isoCode: '72',
  },
  {
    name: 'Tak',
    value: 'TH',
    isoCode: '63',
  },
  {
    name: 'Chumphon',
    value: 'TH',
    isoCode: '86',
  },
  {
    name: 'Udon Thani',
    value: 'TH',
    isoCode: '41',
  },
  {
    name: 'Phrae',
    value: 'TH',
    isoCode: '54',
  },
  {
    name: 'Sa Kaeo',
    value: 'TH',
    isoCode: '27',
  },
  {
    name: 'Nan',
    value: 'TH',
    isoCode: '55',
  },
  {
    name: 'Surin',
    value: 'TH',
    isoCode: '32',
  },
  {
    name: 'Phetchaburi',
    value: 'TH',
    isoCode: '76',
  },
  {
    name: 'Bueng Kan',
    value: 'TH',
    isoCode: '38',
  },
  {
    name: 'Buri Ram',
    value: 'TH',
    isoCode: '31',
  },
  {
    name: 'Nakhon Nayok',
    value: 'TH',
    isoCode: '26',
  },
  {
    name: 'Phuket',
    value: 'TH',
    isoCode: '83',
  },
  {
    name: 'Satun',
    value: 'TH',
    isoCode: '91',
  },
  {
    name: 'Phayao',
    value: 'TH',
    isoCode: '56',
  },
  {
    name: 'Songkhla',
    value: 'TH',
    isoCode: '90',
  },
  {
    name: 'Pattani',
    value: 'TH',
    isoCode: '94',
  },
  {
    name: 'Trang',
    value: 'TH',
    isoCode: '92',
  },
  {
    name: 'Prachin Buri',
    value: 'TH',
    isoCode: '25',
  },
  {
    name: 'Lop Buri',
    value: 'TH',
    isoCode: '16',
  },
  {
    name: 'Lampang',
    value: 'TH',
    isoCode: '52',
  },
  {
    name: 'Sukhothai',
    value: 'TH',
    isoCode: '64',
  },
  {
    name: 'Mukdahan',
    value: 'TH',
    isoCode: '49',
  },
  {
    name: 'Si Sa Ket',
    value: 'TH',
    isoCode: '33',
  },
  {
    name: 'Nakhon Phanom',
    value: 'TH',
    isoCode: '48',
  },
  {
    name: 'Phangnga',
    value: 'TH',
    isoCode: '82',
  },
  {
    name: 'Kalasin',
    value: 'TH',
    isoCode: '46',
  },
  {
    name: 'Uthai Thani',
    value: 'TH',
    isoCode: '61',
  },
  {
    name: 'Chachoengsao',
    value: 'TH',
    isoCode: '24',
  },
  {
    name: 'Narathiwat',
    value: 'TH',
    isoCode: '96',
  },
  {
    name: 'Bangkok',
    value: 'TH',
    isoCode: '10',
  },
  {
    name: 'Chaiyaphum',
    value: 'TH',
    isoCode: '36',
  },
  {
    name: 'Hiiu County',
    value: 'EE',
    isoCode: '39',
  },
  {
    name: 'Viljandi County',
    value: 'EE',
    isoCode: '84',
  },
  {
    name: 'Tartu County',
    value: 'EE',
    isoCode: '78',
  },
  {
    name: 'Valga County',
    value: 'EE',
    isoCode: '82',
  },
  {
    name: 'Rapla County',
    value: 'EE',
    isoCode: '70',
  },
  {
    name: 'Võru County',
    value: 'EE',
    isoCode: '86',
  },
  {
    name: 'Saare County',
    value: 'EE',
    isoCode: '74',
  },
  {
    name: 'Pärnu County',
    value: 'EE',
    isoCode: '67',
  },
  {
    name: 'Põlva County',
    value: 'EE',
    isoCode: '65',
  },
  {
    name: 'Lääne-Viru County',
    value: 'EE',
    isoCode: '59',
  },
  {
    name: 'Jõgeva County',
    value: 'EE',
    isoCode: '49',
  },
  {
    name: 'Järva County',
    value: 'EE',
    isoCode: '51',
  },
  {
    name: 'Harju County',
    value: 'EE',
    isoCode: '37',
  },
  {
    name: 'Lääne County',
    value: 'EE',
    isoCode: '57',
  },
  {
    name: 'Ida-Viru County',
    value: 'EE',
    isoCode: '44',
  },
  {
    name: 'Moyen-Chari Region',
    value: 'TD',
    isoCode: 'MC',
  },
  {
    name: 'Mayo-Kebbi Ouest Region',
    value: 'TD',
    isoCode: 'MO',
  },
  {
    name: 'Sila Region',
    value: 'TD',
    isoCode: 'SI',
  },
  {
    name: 'Hadjer-Lamis',
    value: 'TD',
    isoCode: 'HL',
  },
  {
    name: 'Borkou',
    value: 'TD',
    isoCode: 'BO',
  },
  {
    name: 'Ennedi-Est',
    value: 'TD',
    isoCode: 'EE',
  },
  {
    name: 'Guéra Region',
    value: 'TD',
    isoCode: 'GR',
  },
  {
    name: 'Lac Region',
    value: 'TD',
    isoCode: 'LC',
  },
  {
    name: 'Ennedi Region',
    value: 'TD',
    isoCode: 'EN',
  },
  {
    name: 'Tandjilé Region',
    value: 'TD',
    isoCode: 'TA',
  },
  {
    name: 'Mayo-Kebbi Est Region',
    value: 'TD',
    isoCode: 'ME',
  },
  {
    name: 'Wadi Fira Region',
    value: 'TD',
    isoCode: 'WF',
  },
  {
    name: 'Ouaddaï Region',
    value: 'TD',
    isoCode: 'OD',
  },
  {
    name: 'Bahr el Gazel',
    value: 'TD',
    isoCode: 'BG',
  },
  {
    name: 'Ennedi-Ouest',
    value: 'TD',
    isoCode: 'EO',
  },
  {
    name: 'Logone Occidental Region',
    value: 'TD',
    isoCode: 'LO',
  },
  {
    name: "N'Djamena",
    value: 'TD',
    isoCode: 'ND',
  },
  {
    name: 'Tibesti Region',
    value: 'TD',
    isoCode: 'TI',
  },
  {
    name: 'Kanem Region',
    value: 'TD',
    isoCode: 'KA',
  },
  {
    name: 'Mandoul Region',
    value: 'TD',
    isoCode: 'MA',
  },
  {
    name: 'Batha Region',
    value: 'TD',
    isoCode: 'BA',
  },
  {
    name: 'Logone Oriental Region',
    value: 'TD',
    isoCode: 'LR',
  },
  {
    name: 'Salamat Region',
    value: 'TD',
    isoCode: 'SA',
  },
  {
    name: 'Berry Islands',
    value: 'BS',
    isoCode: 'BY',
  },
  {
    name: 'Nichollstown and Berry Islands',
    value: 'BS',
    isoCode: 'NB',
  },
  {
    name: 'Green Turtle Cay',
    value: 'BS',
    isoCode: 'GT',
  },
  {
    name: 'Central Eleuthera',
    value: 'BS',
    isoCode: 'CE',
  },
  {
    name: "Governor's Harbour",
    value: 'BS',
    isoCode: 'GH',
  },
  {
    name: 'High Rock',
    value: 'BS',
    isoCode: 'HR',
  },
  {
    name: 'West Grand Bahama',
    value: 'BS',
    isoCode: 'WG',
  },
  {
    name: 'Rum Cay District',
    value: 'BS',
    isoCode: 'RC',
  },
  {
    name: 'Acklins',
    value: 'BS',
    isoCode: 'AK',
  },
  {
    name: 'North Eleuthera',
    value: 'BS',
    isoCode: 'NE',
  },
  {
    name: 'Central Abaco',
    value: 'BS',
    isoCode: 'CO',
  },
  {
    name: 'Marsh Harbour',
    value: 'BS',
    isoCode: 'MH',
  },
  {
    name: 'Black Point',
    value: 'BS',
    isoCode: 'BP',
  },
  {
    name: 'Sandy Point',
    value: 'BS',
    isoCode: 'SP',
  },
  {
    name: 'South Eleuthera',
    value: 'BS',
    isoCode: 'SE',
  },
  {
    name: 'South Abaco',
    value: 'BS',
    isoCode: 'SO',
  },
  {
    name: 'Inagua',
    value: 'BS',
    isoCode: 'IN',
  },
  {
    name: 'Long Island',
    value: 'BS',
    isoCode: 'LI',
  },
  {
    name: 'Cat Island',
    value: 'BS',
    isoCode: 'CI',
  },
  {
    name: 'Exuma',
    value: 'BS',
    isoCode: 'EX',
  },
  {
    name: 'Harbour Island',
    value: 'BS',
    isoCode: 'HI',
  },
  {
    name: 'East Grand Bahama',
    value: 'BS',
    isoCode: 'EG',
  },
  {
    name: 'Ragged Island',
    value: 'BS',
    isoCode: 'RI',
  },
  {
    name: 'North Abaco',
    value: 'BS',
    isoCode: 'NO',
  },
  {
    name: 'North Andros',
    value: 'BS',
    isoCode: 'NS',
  },
  {
    name: 'Kemps Bay',
    value: 'BS',
    isoCode: 'KB',
  },
  {
    name: 'Fresh Creek',
    value: 'BS',
    isoCode: 'FC',
  },
  {
    name: 'San Salvador and Rum Cay',
    value: 'BS',
    isoCode: 'SR',
  },
  {
    name: 'Crooked Island',
    value: 'BS',
    isoCode: 'CK',
  },
  {
    name: 'South Andros',
    value: 'BS',
    isoCode: 'SA',
  },
  {
    name: 'Rock Sound',
    value: 'BS',
    isoCode: 'RS',
  },
  {
    name: 'Hope Town',
    value: 'BS',
    isoCode: 'HT',
  },
  {
    name: 'Mangrove Cay',
    value: 'BS',
    isoCode: 'MC',
  },
  {
    name: 'Freeport',
    value: 'BS',
    isoCode: 'FP',
  },
  {
    name: 'San Salvador Island',
    value: 'BS',
    isoCode: 'SS',
  },
  {
    name: 'Acklins and Crooked Islands',
    value: 'BS',
    isoCode: 'AC',
  },
  {
    name: 'Bimini',
    value: 'BS',
    isoCode: 'BI',
  },
  {
    name: 'Spanish Wells',
    value: 'BS',
    isoCode: 'SW',
  },
  {
    name: 'Central Andros',
    value: 'BS',
    isoCode: 'CS',
  },
  {
    name: 'Grand Cay',
    value: 'BS',
    isoCode: 'GC',
  },
  {
    name: 'Mayaguana District',
    value: 'BS',
    isoCode: 'MG',
  },
  {
    name: 'New Providence',
    value: 'BS',
    isoCode: 'NP',
  },
  {
    name: 'San Juan',
    value: 'AR',
    isoCode: 'J',
  },
  {
    name: 'Santiago del Estero',
    value: 'AR',
    isoCode: 'G',
  },
  {
    name: 'San Luis',
    value: 'AR',
    isoCode: 'D',
  },
  {
    name: 'Tucumán',
    value: 'AR',
    isoCode: 'T',
  },
  {
    name: 'Corrientes',
    value: 'AR',
    isoCode: 'W',
  },
  {
    name: 'Río Negro',
    value: 'AR',
    isoCode: 'R',
  },
  {
    name: 'Chaco',
    value: 'AR',
    isoCode: 'H',
  },
  {
    name: 'Santa Fe',
    value: 'AR',
    isoCode: 'S',
  },
  {
    name: 'Córdoba',
    value: 'AR',
    isoCode: 'X',
  },
  {
    name: 'Salta',
    value: 'AR',
    isoCode: 'A',
  },
  {
    name: 'Misiones',
    value: 'AR',
    isoCode: 'N',
  },
  {
    name: 'Jujuy',
    value: 'AR',
    isoCode: 'Y',
  },
  {
    name: 'Mendoza',
    value: 'AR',
    isoCode: 'M',
  },
  {
    name: 'Catamarca',
    value: 'AR',
    isoCode: 'K',
  },
  {
    name: 'Neuquén',
    value: 'AR',
    isoCode: 'Q',
  },
  {
    name: 'Santa Cruz',
    value: 'AR',
    isoCode: 'Z',
  },
  {
    name: 'Tierra del Fuego',
    value: 'AR',
    isoCode: 'V',
  },
  {
    name: 'Chubut',
    value: 'AR',
    isoCode: 'U',
  },
  {
    name: 'Formosa',
    value: 'AR',
    isoCode: 'P',
  },
  {
    name: 'La Rioja',
    value: 'AR',
    isoCode: 'F',
  },
  {
    name: 'Entre Ríos',
    value: 'AR',
    isoCode: 'E',
  },
  {
    name: 'La Pampa',
    value: 'AR',
    isoCode: 'L',
  },
  {
    name: 'Buenos Aires',
    value: 'AR',
    isoCode: 'B',
  },
  {
    name: 'Ciudad Autónoma de Buenos Aires',
    value: 'AR',
    isoCode: 'C',
  },
  {
    name: 'Quiché Department',
    value: 'GT',
    isoCode: 'QC',
  },
  {
    name: 'Jalapa Department',
    value: 'GT',
    isoCode: 'JA',
  },
  {
    name: 'Izabal Department',
    value: 'GT',
    isoCode: 'IZ',
  },
  {
    name: 'Suchitepéquez Department',
    value: 'GT',
    isoCode: 'SU',
  },
  {
    name: 'Sololá Department',
    value: 'GT',
    isoCode: 'SO',
  },
  {
    name: 'El Progreso Department',
    value: 'GT',
    isoCode: 'PR',
  },
  {
    name: 'Totonicapán Department',
    value: 'GT',
    isoCode: 'TO',
  },
  {
    name: 'Retalhuleu Department',
    value: 'GT',
    isoCode: 'RE',
  },
  {
    name: 'Santa Rosa Department',
    value: 'GT',
    isoCode: 'SR',
  },
  {
    name: 'Chiquimula Department',
    value: 'GT',
    isoCode: 'CQ',
  },
  {
    name: 'San Marcos Department',
    value: 'GT',
    isoCode: 'SM',
  },
  {
    name: 'Quetzaltenango Department',
    value: 'GT',
    isoCode: 'QZ',
  },
  {
    name: 'Petén Department',
    value: 'GT',
    isoCode: 'PE',
  },
  {
    name: 'Huehuetenango Department',
    value: 'GT',
    isoCode: 'HU',
  },
  {
    name: 'Alta Verapaz Department',
    value: 'GT',
    isoCode: 'AV',
  },
  {
    name: 'Guatemala Department',
    value: 'GT',
    isoCode: 'GU',
  },
  {
    name: 'Jutiapa Department',
    value: 'GT',
    isoCode: 'JU',
  },
  {
    name: 'Baja Verapaz Department',
    value: 'GT',
    isoCode: 'BV',
  },
  {
    name: 'Chimaltenango Department',
    value: 'GT',
    isoCode: 'CM',
  },
  {
    name: 'Sacatepéquez Department',
    value: 'GT',
    isoCode: 'SA',
  },
  {
    name: 'Escuintla Department',
    value: 'GT',
    isoCode: 'ES',
  },
  {
    name: 'Madre de Dios',
    value: 'PE',
    isoCode: 'MDD',
  },
  {
    name: 'Huancavelica',
    value: 'PE',
    isoCode: 'HUV',
  },
  {
    name: 'Áncash',
    value: 'PE',
    isoCode: 'ANC',
  },
  {
    name: 'Arequipa',
    value: 'PE',
    isoCode: 'ARE',
  },
  {
    name: 'Puno',
    value: 'PE',
    isoCode: 'PUN',
  },
  {
    name: 'La Libertad',
    value: 'PE',
    isoCode: 'LAL',
  },
  {
    name: 'Ucayali',
    value: 'PE',
    isoCode: 'UCA',
  },
  {
    name: 'Amazonas',
    value: 'PE',
    isoCode: 'AMA',
  },
  {
    name: 'Pasco',
    value: 'PE',
    isoCode: 'PAS',
  },
  {
    name: 'Huanuco',
    value: 'PE',
    isoCode: 'HUC',
  },
  {
    name: 'Cajamarca',
    value: 'PE',
    isoCode: 'CAJ',
  },
  {
    name: 'Tumbes',
    value: 'PE',
    isoCode: 'TUM',
  },
  {
    name: 'Cusco',
    value: 'PE',
    isoCode: 'CUS',
  },
  {
    name: 'Ayacucho',
    value: 'PE',
    isoCode: 'AYA',
  },
  {
    name: 'Junín',
    value: 'PE',
    isoCode: 'JUN',
  },
  {
    name: 'San Martín',
    value: 'PE',
    isoCode: 'SAM',
  },
  {
    name: 'Lima',
    value: 'PE',
    isoCode: 'LIM',
  },
  {
    name: 'Tacna',
    value: 'PE',
    isoCode: 'TAC',
  },
  {
    name: 'Piura',
    value: 'PE',
    isoCode: 'PIU',
  },
  {
    name: 'Moquegua',
    value: 'PE',
    isoCode: 'MOQ',
  },
  {
    name: 'Apurímac',
    value: 'PE',
    isoCode: 'APU',
  },
  {
    name: 'Ica',
    value: 'PE',
    isoCode: 'ICA',
  },
  {
    name: 'Callao',
    value: 'PE',
    isoCode: 'CAL',
  },
  {
    name: 'Lambayeque',
    value: 'PE',
    isoCode: 'LAM',
  },
  {
    name: 'Loreto',
    value: 'PE',
    isoCode: 'LOR',
  },
  {
    name: 'Redonda',
    value: 'AG',
    isoCode: '11',
  },
  {
    name: 'Saint Peter Parish',
    value: 'AG',
    isoCode: '07',
  },
  {
    name: 'Saint Paul Parish',
    value: 'AG',
    isoCode: '06',
  },
  {
    name: 'Saint John Parish',
    value: 'AG',
    isoCode: '04',
  },
  {
    name: 'Saint Mary Parish',
    value: 'AG',
    isoCode: '05',
  },
  {
    name: 'Barbuda',
    value: 'AG',
    isoCode: '10',
  },
  {
    name: 'Saint George Parish',
    value: 'AG',
    isoCode: '03',
  },
  {
    name: 'Saint Philip Parish',
    value: 'AG',
    isoCode: '08',
  },
  {
    name: 'South Bačka District',
    value: 'RS',
    isoCode: '06',
  },
  {
    name: 'Pirot District',
    value: 'RS',
    isoCode: '22',
  },
  {
    name: 'South Banat District',
    value: 'RS',
    isoCode: '04',
  },
  {
    name: 'North Bačka District',
    value: 'RS',
    isoCode: '01',
  },
  {
    name: 'Jablanica District',
    value: 'RS',
    isoCode: '23',
  },
  {
    name: 'Central Banat District',
    value: 'RS',
    isoCode: '02',
  },
  {
    name: 'Bor District',
    value: 'RS',
    isoCode: '14',
  },
  {
    name: 'Toplica District',
    value: 'RS',
    isoCode: '21',
  },
  {
    name: 'Mačva District',
    value: 'RS',
    isoCode: '08',
  },
  {
    name: 'Rasina District',
    value: 'RS',
    isoCode: '19',
  },
  {
    name: 'Pčinja District',
    value: 'RS',
    isoCode: '24',
  },
  {
    name: 'Nišava District',
    value: 'RS',
    isoCode: '20',
  },
  {
    name: 'Kolubara District',
    value: 'RS',
    isoCode: '09',
  },
  {
    name: 'Raška District',
    value: 'RS',
    isoCode: '18',
  },
  {
    name: 'West Bačka District',
    value: 'RS',
    isoCode: '05',
  },
  {
    name: 'Moravica District',
    value: 'RS',
    isoCode: '17',
  },
  {
    name: 'Belgrade',
    value: 'RS',
    isoCode: '00',
  },
  {
    name: 'Zlatibor District',
    value: 'RS',
    isoCode: '16',
  },
  {
    name: 'Zaječar District',
    value: 'RS',
    isoCode: '15',
  },
  {
    name: 'Braničevo District',
    value: 'RS',
    isoCode: '11',
  },
  {
    name: 'Vojvodina',
    value: 'RS',
    isoCode: 'VO',
  },
  {
    name: 'Šumadija District',
    value: 'RS',
    isoCode: '12',
  },
  {
    name: 'North Banat District',
    value: 'RS',
    isoCode: '03',
  },
  {
    name: 'Pomoravlje District',
    value: 'RS',
    isoCode: '13',
  },
  {
    name: 'Srem District',
    value: 'RS',
    isoCode: '07',
  },
  {
    name: 'Podunavlje District',
    value: 'RS',
    isoCode: '10',
  },
  {
    name: 'Prizren District',
    value: 'XK',
    isoCode: 'XPR',
  },
  {
    name: 'Peć District',
    value: 'XK',
    isoCode: 'XPE',
  },
  {
    name: 'Uroševac District (Ferizaj)',
    value: 'XK',
    isoCode: 'XUF',
  },
  {
    name: 'Đakovica District (Gjakove)',
    value: 'XK',
    isoCode: 'XDG',
  },
  {
    name: 'Gjilan District',
    value: 'XK',
    isoCode: 'XGJ',
  },
  {
    name: 'Kosovska Mitrovica District',
    value: 'XK',
    isoCode: 'XKM',
  },
  {
    name: 'Pristina (Priştine)',
    value: 'XK',
    isoCode: 'XPI',
  },
  {
    name: 'Westmoreland Parish',
    value: 'JM',
    isoCode: '10',
  },
  {
    name: 'Saint Elizabeth Parish',
    value: 'JM',
    isoCode: '11',
  },
  {
    name: 'Saint Ann Parish',
    value: 'JM',
    isoCode: '06',
  },
  {
    name: 'Saint James Parish',
    value: 'JM',
    isoCode: '08',
  },
  {
    name: 'Saint Catherine Parish',
    value: 'JM',
    isoCode: '14',
  },
  {
    name: 'Saint Mary Parish',
    value: 'JM',
    isoCode: '05',
  },
  {
    name: 'Kingston Parish',
    value: 'JM',
    isoCode: '01',
  },
  {
    name: 'Hanover Parish',
    value: 'JM',
    isoCode: '09',
  },
  {
    name: 'Saint Thomas Parish',
    value: 'JM',
    isoCode: '03',
  },
  {
    name: 'Saint Andrew',
    value: 'JM',
    isoCode: '02',
  },
  {
    name: 'Portland Parish',
    value: 'JM',
    isoCode: '04',
  },
  {
    name: 'Clarendon Parish',
    value: 'JM',
    isoCode: '13',
  },
  {
    name: 'Manchester Parish',
    value: 'JM',
    isoCode: '12',
  },
  {
    name: 'Trelawny Parish',
    value: 'JM',
    isoCode: '07',
  },
  {
    name: 'Dennery Quarter',
    value: 'LC',
    isoCode: '05',
  },
  {
    name: 'Anse la Raye Quarter',
    value: 'LC',
    isoCode: '01',
  },
  {
    name: 'Castries Quarter',
    value: 'LC',
    isoCode: '02',
  },
  {
    name: 'Laborie Quarter',
    value: 'LC',
    isoCode: '07',
  },
  {
    name: 'Choiseul Quarter',
    value: 'LC',
    isoCode: '03',
  },
  {
    name: 'Canaries',
    value: 'LC',
    isoCode: '12',
  },
  {
    name: 'Micoud Quarter',
    value: 'LC',
    isoCode: '08',
  },
  {
    name: 'Vieux Fort Quarter',
    value: 'LC',
    isoCode: '11',
  },
  {
    name: 'Soufrière Quarter',
    value: 'LC',
    isoCode: '10',
  },
  {
    name: 'Praslin Quarter',
    value: 'LC',
    isoCode: '09',
  },
  {
    name: 'Gros Islet Quarter',
    value: 'LC',
    isoCode: '06',
  },
  {
    name: 'Dauphin Quarter',
    value: 'LC',
    isoCode: '04',
  },
  {
    name: 'Hưng Yên',
    value: 'VN',
    isoCode: '66',
  },
  {
    name: 'Đồng Tháp',
    value: 'VN',
    isoCode: '45',
  },
  {
    name: 'Bà Rịa-Vũng Tàu',
    value: 'VN',
    isoCode: '43',
  },
  {
    name: 'Thanh Hóa',
    value: 'VN',
    isoCode: '21',
  },
  {
    name: 'Kon Tum',
    value: 'VN',
    isoCode: '28',
  },
  {
    name: 'Điện Biên',
    value: 'VN',
    isoCode: '71',
  },
  {
    name: 'Vĩnh Phúc',
    value: 'VN',
    isoCode: '70',
  },
  {
    name: 'Thái Bình',
    value: 'VN',
    isoCode: '20',
  },
  {
    name: 'Quảng Nam',
    value: 'VN',
    isoCode: '27',
  },
  {
    name: 'Hậu Giang',
    value: 'VN',
    isoCode: '73',
  },
  {
    name: 'Cà Mau',
    value: 'VN',
    isoCode: '59',
  },
  {
    name: 'Hà Giang',
    value: 'VN',
    isoCode: '03',
  },
  {
    name: 'Nghệ An',
    value: 'VN',
    isoCode: '22',
  },
  {
    name: 'Tiền Giang',
    value: 'VN',
    isoCode: '46',
  },
  {
    name: 'Cao Bằng',
    value: 'VN',
    isoCode: '04',
  },
  {
    name: 'Hải Phòng',
    value: 'VN',
    isoCode: 'HP',
  },
  {
    name: 'Yên Bái',
    value: 'VN',
    isoCode: '06',
  },
  {
    name: 'Bình Dương',
    value: 'VN',
    isoCode: '57',
  },
  {
    name: 'Ninh Bình',
    value: 'VN',
    isoCode: '18',
  },
  {
    name: 'Bình Thuận',
    value: 'VN',
    isoCode: '40',
  },
  {
    name: 'Ninh Thuận',
    value: 'VN',
    isoCode: '36',
  },
  {
    name: 'Nam Định',
    value: 'VN',
    isoCode: '67',
  },
  {
    name: 'Vĩnh Long',
    value: 'VN',
    isoCode: '49',
  },
  {
    name: 'Bắc Ninh',
    value: 'VN',
    isoCode: '56',
  },
  {
    name: 'Lạng Sơn',
    value: 'VN',
    isoCode: '09',
  },
  {
    name: 'Khánh Hòa',
    value: 'VN',
    isoCode: '34',
  },
  {
    name: 'An Giang',
    value: 'VN',
    isoCode: '44',
  },
  {
    name: 'Tuyên Quang',
    value: 'VN',
    isoCode: '07',
  },
  {
    name: 'Bến Tre',
    value: 'VN',
    isoCode: '50',
  },
  {
    name: 'Bình Phước',
    value: 'VN',
    isoCode: '58',
  },
  {
    name: 'Thừa Thiên-Huế',
    value: 'VN',
    isoCode: '26',
  },
  {
    name: 'Hòa Bình',
    value: 'VN',
    isoCode: '14',
  },
  {
    name: 'Kiên Giang',
    value: 'VN',
    isoCode: '47',
  },
  {
    name: 'Phú Thọ',
    value: 'VN',
    isoCode: '68',
  },
  {
    name: 'Hà Nam',
    value: 'VN',
    isoCode: '63',
  },
  {
    name: 'Quảng Trị',
    value: 'VN',
    isoCode: '25',
  },
  {
    name: 'Bạc Liêu',
    value: 'VN',
    isoCode: '55',
  },
  {
    name: 'Trà Vinh',
    value: 'VN',
    isoCode: '51',
  },
  {
    name: 'Đà Nẵng',
    value: 'VN',
    isoCode: 'DN',
  },
  {
    name: 'Thái Nguyên',
    value: 'VN',
    isoCode: '69',
  },
  {
    name: 'Long An',
    value: 'VN',
    isoCode: '41',
  },
  {
    name: 'Quảng Bình',
    value: 'VN',
    isoCode: '24',
  },
  {
    name: 'Hà Nội',
    value: 'VN',
    isoCode: 'HN',
  },
  {
    name: 'Hồ Chí Minh',
    value: 'VN',
    isoCode: 'SG',
  },
  {
    name: 'Sơn La',
    value: 'VN',
    isoCode: '05',
  },
  {
    name: 'Gia Lai',
    value: 'VN',
    isoCode: '30',
  },
  {
    name: 'Quảng Ninh',
    value: 'VN',
    isoCode: '13',
  },
  {
    name: 'Bắc Giang',
    value: 'VN',
    isoCode: '54',
  },
  {
    name: 'Hà Tĩnh',
    value: 'VN',
    isoCode: '23',
  },
  {
    name: 'Lào Cai',
    value: 'VN',
    isoCode: '02',
  },
  {
    name: 'Lâm Đồng',
    value: 'VN',
    isoCode: '35',
  },
  {
    name: 'Sóc Trăng',
    value: 'VN',
    isoCode: '52',
  },
  {
    name: 'Đồng Nai',
    value: 'VN',
    isoCode: '39',
  },
  {
    name: 'Bắc Kạn',
    value: 'VN',
    isoCode: '53',
  },
  {
    name: 'Đắk Nông',
    value: 'VN',
    isoCode: '72',
  },
  {
    name: 'Phú Yên',
    value: 'VN',
    isoCode: '32',
  },
  {
    name: 'Lai Châu',
    value: 'VN',
    isoCode: '01',
  },
  {
    name: 'Tây Ninh',
    value: 'VN',
    isoCode: '37',
  },
  {
    name: 'Hải Dương',
    value: 'VN',
    isoCode: '61',
  },
  {
    name: 'Quảng Ngãi',
    value: 'VN',
    isoCode: '29',
  },
  {
    name: 'Đắk Lắk',
    value: 'VN',
    isoCode: '33',
  },
  {
    name: 'Bình Định',
    value: 'VN',
    isoCode: '31',
  },
  {
    name: 'Cần Thơ',
    value: 'VN',
    isoCode: 'CT',
  },
  {
    name: 'Saint Peter Basseterre Parish',
    value: 'KN',
    isoCode: '11',
  },
  {
    name: 'Nevis',
    value: 'KN',
    isoCode: 'N',
  },
  {
    name: 'Christ Church Nichola Town Parish',
    value: 'KN',
    isoCode: '01',
  },
  {
    name: 'Saint Paul Capisterre Parish',
    value: 'KN',
    isoCode: '09',
  },
  {
    name: 'Saint James Windward Parish',
    value: 'KN',
    isoCode: '05',
  },
  {
    name: 'Saint Anne Sandy Point Parish',
    value: 'KN',
    isoCode: '02',
  },
  {
    name: 'Saint George Gingerland Parish',
    value: 'KN',
    isoCode: '04',
  },
  {
    name: 'Saint Paul Charlestown Parish',
    value: 'KN',
    isoCode: '10',
  },
  {
    name: 'Saint Thomas Lowland Parish',
    value: 'KN',
    isoCode: '12',
  },
  {
    name: 'Saint John Figtree Parish',
    value: 'KN',
    isoCode: '07',
  },
  {
    name: 'Saint Kitts',
    value: 'KN',
    isoCode: 'K',
  },
  {
    name: 'Saint Thomas Middle Island Parish',
    value: 'KN',
    isoCode: '13',
  },
  {
    name: 'Trinity Palmetto Point Parish',
    value: 'KN',
    isoCode: '15',
  },
  {
    name: 'Saint Mary Cayon Parish',
    value: 'KN',
    isoCode: '08',
  },
  {
    name: 'Saint John Capisterre Parish',
    value: 'KN',
    isoCode: '06',
  },
  {
    name: 'Daegu',
    value: 'KR',
    isoCode: '27',
  },
  {
    name: 'Gyeonggi Province',
    value: 'KR',
    isoCode: '41',
  },
  {
    name: 'Incheon',
    value: 'KR',
    isoCode: '28',
  },
  {
    name: 'Seoul',
    value: 'KR',
    isoCode: '11',
  },
  {
    name: 'Daejeon',
    value: 'KR',
    isoCode: '30',
  },
  {
    name: 'North Jeolla Province',
    value: 'KR',
    isoCode: '45',
  },
  {
    name: 'Ulsan',
    value: 'KR',
    isoCode: '31',
  },
  {
    name: 'Jeju',
    value: 'KR',
    isoCode: '49',
  },
  {
    name: 'North Chungcheong Province',
    value: 'KR',
    isoCode: '43',
  },
  {
    name: 'North Gyeongsang Province',
    value: 'KR',
    isoCode: '47',
  },
  {
    name: 'South Jeolla Province',
    value: 'KR',
    isoCode: '46',
  },
  {
    name: 'South Gyeongsang Province',
    value: 'KR',
    isoCode: '48',
  },
  {
    name: 'Gwangju',
    value: 'KR',
    isoCode: '29',
  },
  {
    name: 'South Chungcheong Province',
    value: 'KR',
    isoCode: '44',
  },
  {
    name: 'Busan',
    value: 'KR',
    isoCode: '26',
  },
  {
    name: 'Sejong City',
    value: 'KR',
    isoCode: '50',
  },
  {
    name: 'Gangwon Province',
    value: 'KR',
    isoCode: '42',
  },
  {
    name: 'Saint Patrick Parish',
    value: 'GD',
    isoCode: '06',
  },
  {
    name: 'Saint George Parish',
    value: 'GD',
    isoCode: '03',
  },
  {
    name: 'Saint Andrew Parish',
    value: 'GD',
    isoCode: '01',
  },
  {
    name: 'Saint Mark Parish',
    value: 'GD',
    isoCode: '05',
  },
  {
    name: 'Carriacou and Petite Martinique',
    value: 'GD',
    isoCode: '10',
  },
  {
    name: 'Saint John Parish',
    value: 'GD',
    isoCode: '04',
  },
  {
    name: 'Saint David Parish',
    value: 'GD',
    isoCode: '02',
  },
  {
    name: 'Ghazni',
    value: 'AF',
    isoCode: 'GHA',
  },
  {
    name: 'Badghis',
    value: 'AF',
    isoCode: 'BDG',
  },
  {
    name: 'Bamyan',
    value: 'AF',
    isoCode: 'BAM',
  },
  {
    name: 'Helmand',
    value: 'AF',
    isoCode: 'HEL',
  },
  {
    name: 'Zabul',
    value: 'AF',
    isoCode: 'ZAB',
  },
  {
    name: 'Baghlan',
    value: 'AF',
    isoCode: 'BGL',
  },
  {
    name: 'Kunar',
    value: 'AF',
    isoCode: 'KNR',
  },
  {
    name: 'Paktika',
    value: 'AF',
    isoCode: 'PKA',
  },
  {
    name: 'Khost',
    value: 'AF',
    isoCode: 'KHO',
  },
  {
    name: 'Kapisa',
    value: 'AF',
    isoCode: 'KAP',
  },
  {
    name: 'Nuristan',
    value: 'AF',
    isoCode: 'NUR',
  },
  {
    name: 'Panjshir',
    value: 'AF',
    isoCode: 'PAN',
  },
  {
    name: 'Nangarhar',
    value: 'AF',
    isoCode: 'NAN',
  },
  {
    name: 'Samangan',
    value: 'AF',
    isoCode: 'SAM',
  },
  {
    name: 'Balkh',
    value: 'AF',
    isoCode: 'BAL',
  },
  {
    name: 'Sar-e Pol',
    value: 'AF',
    isoCode: 'SAR',
  },
  {
    name: 'Jowzjan',
    value: 'AF',
    isoCode: 'JOW',
  },
  {
    name: 'Herat',
    value: 'AF',
    isoCode: 'HER',
  },
  {
    name: 'Ghōr',
    value: 'AF',
    isoCode: 'GHO',
  },
  {
    name: 'Faryab',
    value: 'AF',
    isoCode: 'FYB',
  },
  {
    name: 'Kandahar',
    value: 'AF',
    isoCode: 'KAN',
  },
  {
    name: 'Laghman',
    value: 'AF',
    isoCode: 'LAG',
  },
  {
    name: 'Daykundi',
    value: 'AF',
    isoCode: 'DAY',
  },
  {
    name: 'Takhar',
    value: 'AF',
    isoCode: 'TAK',
  },
  {
    name: 'Paktia',
    value: 'AF',
    isoCode: 'PIA',
  },
  {
    name: 'Parwan',
    value: 'AF',
    isoCode: 'PAR',
  },
  {
    name: 'Nimruz',
    value: 'AF',
    isoCode: 'NIM',
  },
  {
    name: 'Logar',
    value: 'AF',
    isoCode: 'LOG',
  },
  {
    name: 'Urozgan',
    value: 'AF',
    isoCode: 'URU',
  },
  {
    name: 'Farah',
    value: 'AF',
    isoCode: 'FRA',
  },
  {
    name: 'Kunduz Province',
    value: 'AF',
    isoCode: 'KDZ',
  },
  {
    name: 'Badakhshan',
    value: 'AF',
    isoCode: 'BDS',
  },
  {
    name: 'Kabul',
    value: 'AF',
    isoCode: 'KAB',
  },
  {
    name: 'Victoria',
    value: 'AU',
    isoCode: 'VIC',
  },
  {
    name: 'South Australia',
    value: 'AU',
    isoCode: 'SA',
  },
  {
    name: 'Queensland',
    value: 'AU',
    isoCode: 'QLD',
  },
  {
    name: 'Western Australia',
    value: 'AU',
    isoCode: 'WA',
  },
  {
    name: 'Australian Capital Territory',
    value: 'AU',
    isoCode: 'ACT',
  },
  {
    name: 'Tasmania',
    value: 'AU',
    isoCode: 'TAS',
  },
  {
    name: 'New South Wales',
    value: 'AU',
    isoCode: 'NSW',
  },
  {
    name: 'Northern Territory',
    value: 'AU',
    isoCode: 'NT',
  },
  {
    name: 'Vavaʻu',
    value: 'TO',
    isoCode: '05',
  },
  {
    name: 'Tongatapu',
    value: 'TO',
    isoCode: '04',
  },
  {
    name: 'Haʻapai',
    value: 'TO',
    isoCode: '02',
  },
  {
    name: 'Niuas',
    value: 'TO',
    isoCode: '03',
  },
  {
    name: 'ʻEua',
    value: 'TO',
    isoCode: '01',
  },
  {
    name: 'Markazi',
    value: 'IR',
    isoCode: '00',
  },
  {
    name: 'Khuzestan',
    value: 'IR',
    isoCode: '06',
  },
  {
    name: 'Ilam',
    value: 'IR',
    isoCode: '16',
  },
  {
    name: 'Kermanshah',
    value: 'IR',
    isoCode: '05',
  },
  {
    name: 'Gilan',
    value: 'IR',
    isoCode: '01',
  },
  {
    name: 'Chaharmahal and Bakhtiari',
    value: 'IR',
    isoCode: '14',
  },
  {
    name: 'Qom',
    value: 'IR',
    isoCode: '25',
  },
  {
    name: 'Isfahan',
    value: 'IR',
    isoCode: '10',
  },
  {
    name: 'West Azarbaijan',
    value: 'IR',
    isoCode: '04',
  },
  {
    name: 'Zanjan',
    value: 'IR',
    isoCode: '19',
  },
  {
    name: 'Kohgiluyeh and Boyer-Ahmad',
    value: 'IR',
    isoCode: '17',
  },
  {
    name: 'Razavi Khorasan',
    value: 'IR',
    isoCode: '09',
  },
  {
    name: 'Lorestan',
    value: 'IR',
    isoCode: '15',
  },
  {
    name: 'Alborz',
    value: 'IR',
    isoCode: '30',
  },
  {
    name: 'South Khorasan',
    value: 'IR',
    isoCode: '29',
  },
  {
    name: 'Sistan and Baluchestan',
    value: 'IR',
    isoCode: '11',
  },
  {
    name: 'Bushehr',
    value: 'IR',
    isoCode: '18',
  },
  {
    name: 'Golestan',
    value: 'IR',
    isoCode: '27',
  },
  {
    name: 'Ardabil',
    value: 'IR',
    isoCode: '24',
  },
  {
    name: 'Kurdistan',
    value: 'IR',
    isoCode: '12',
  },
  {
    name: 'Yazd',
    value: 'IR',
    isoCode: '21',
  },
  {
    name: 'Hormozgan',
    value: 'IR',
    isoCode: '22',
  },
  {
    name: 'Mazandaran',
    value: 'IR',
    isoCode: '02',
  },
  {
    name: 'Fars',
    value: 'IR',
    isoCode: '07',
  },
  {
    name: 'Semnan',
    value: 'IR',
    isoCode: '20',
  },
  {
    name: 'Qazvin',
    value: 'IR',
    isoCode: '26',
  },
  {
    name: 'North Khorasan',
    value: 'IR',
    isoCode: '28',
  },
  {
    name: 'Kerman',
    value: 'IR',
    isoCode: '08',
  },
  {
    name: 'East Azerbaijan',
    value: 'IR',
    isoCode: '03',
  },
  {
    name: 'Tehran',
    value: 'IR',
    isoCode: '23',
  },
  {
    name: 'Hamadan',
    value: 'IR',
    isoCode: '13',
  },
  {
    name: 'Niutao Island Council',
    value: 'TV',
    isoCode: 'NIT',
  },
  {
    name: 'Nanumanga',
    value: 'TV',
    isoCode: 'NMG',
  },
  {
    name: 'Nui',
    value: 'TV',
    isoCode: 'NUI',
  },
  {
    name: 'Nanumea',
    value: 'TV',
    isoCode: 'NMA',
  },
  {
    name: 'Vaitupu',
    value: 'TV',
    isoCode: 'VAI',
  },
  {
    name: 'Funafuti',
    value: 'TV',
    isoCode: 'FUN',
  },
  {
    name: 'Nukufetau',
    value: 'TV',
    isoCode: 'NKF',
  },
  {
    name: 'Nukulaelae',
    value: 'TV',
    isoCode: 'NKL',
  },
  {
    name: 'Dhi Qar Governorate',
    value: 'IQ',
    isoCode: 'DQ',
  },
  {
    name: 'Babylon Governorate',
    value: 'IQ',
    isoCode: 'BB',
  },
  {
    name: 'Al-Qādisiyyah Governorate',
    value: 'IQ',
    isoCode: 'QA',
  },
  {
    name: 'Karbala Governorate',
    value: 'IQ',
    isoCode: 'KA',
  },
  {
    name: 'Al Muthanna Governorate',
    value: 'IQ',
    isoCode: 'MU',
  },
  {
    name: 'Baghdad Governorate',
    value: 'IQ',
    isoCode: 'BG',
  },
  {
    name: 'Basra Governorate',
    value: 'IQ',
    isoCode: 'BA',
  },
  {
    name: 'Saladin Governorate',
    value: 'IQ',
    isoCode: 'SD',
  },
  {
    name: 'Najaf Governorate',
    value: 'IQ',
    isoCode: 'NA',
  },
  {
    name: 'Nineveh Governorate',
    value: 'IQ',
    isoCode: 'NI',
  },
  {
    name: 'Al Anbar Governorate',
    value: 'IQ',
    isoCode: 'AN',
  },
  {
    name: 'Diyala Governorate',
    value: 'IQ',
    isoCode: 'DI',
  },
  {
    name: 'Maysan Governorate',
    value: 'IQ',
    isoCode: 'MA',
  },
  {
    name: 'Dohuk Governorate',
    value: 'IQ',
    isoCode: 'DA',
  },
  {
    name: 'Erbil Governorate',
    value: 'IQ',
    isoCode: 'AR',
  },
  {
    name: 'Sulaymaniyah Governorate',
    value: 'IQ',
    isoCode: 'SU',
  },
  {
    name: 'Wasit Governorate',
    value: 'IQ',
    isoCode: 'WA',
  },
  {
    name: 'Kirkuk Governorate',
    value: 'IQ',
    isoCode: 'KI',
  },
  {
    name: 'Svay Rieng',
    value: 'KH',
    isoCode: '20',
  },
  {
    name: 'Preah Vihear',
    value: 'KH',
    isoCode: '13',
  },
  {
    name: 'Prey Veng',
    value: 'KH',
    isoCode: '14',
  },
  {
    name: 'Takeo',
    value: 'KH',
    isoCode: '21',
  },
  {
    name: 'Battambang',
    value: 'KH',
    isoCode: '2',
  },
  {
    name: 'Pursat',
    value: 'KH',
    isoCode: '15',
  },
  {
    name: 'Kep',
    value: 'KH',
    isoCode: '23',
  },
  {
    name: 'Kampong Chhnang',
    value: 'KH',
    isoCode: '4',
  },
  {
    name: 'Pailin',
    value: 'KH',
    isoCode: '24',
  },
  {
    name: 'Kampot',
    value: 'KH',
    isoCode: '7',
  },
  {
    name: 'Koh Kong',
    value: 'KH',
    isoCode: '9',
  },
  {
    name: 'Kandal',
    value: 'KH',
    isoCode: '8',
  },
  {
    name: 'Banteay Meanchey',
    value: 'KH',
    isoCode: '1',
  },
  {
    name: 'Mondulkiri',
    value: 'KH',
    isoCode: '11',
  },
  {
    name: 'Kratie',
    value: 'KH',
    isoCode: '10',
  },
  {
    name: 'Oddar Meanchey',
    value: 'KH',
    isoCode: '22',
  },
  {
    name: 'Kampong Speu',
    value: 'KH',
    isoCode: '5',
  },
  {
    name: 'Sihanoukville',
    value: 'KH',
    isoCode: '18',
  },
  {
    name: 'Ratanakiri',
    value: 'KH',
    isoCode: '16',
  },
  {
    name: 'Kampong Cham',
    value: 'KH',
    isoCode: '3',
  },
  {
    name: 'Siem Reap',
    value: 'KH',
    isoCode: '17',
  },
  {
    name: 'Stung Treng',
    value: 'KH',
    isoCode: '19',
  },
  {
    name: 'Phnom Penh',
    value: 'KH',
    isoCode: '12',
  },
  {
    name: 'Tai Po District',
    value: 'KH',
    isoCode: 'NTP',
  },
  {
    name: 'Kampong Thom',
    value: 'KH',
    isoCode: '6',
  },
  {
    name: 'North Hamgyong Province',
    value: 'KP',
    isoCode: '09',
  },
  {
    name: 'Ryanggang Province',
    value: 'KP',
    isoCode: '10',
  },
  {
    name: 'South Pyongan Province',
    value: 'KP',
    isoCode: '02',
  },
  {
    name: 'Chagang Province',
    value: 'KP',
    isoCode: '04',
  },
  {
    name: 'Kangwon Province',
    value: 'KP',
    isoCode: '07',
  },
  {
    name: 'South Hamgyong Province',
    value: 'KP',
    isoCode: '08',
  },
  {
    name: 'Rason',
    value: 'KP',
    isoCode: '13',
  },
  {
    name: 'North Pyongan Province',
    value: 'KP',
    isoCode: '03',
  },
  {
    name: 'South Hwanghae Province',
    value: 'KP',
    isoCode: '05',
  },
  {
    name: 'North Hwanghae Province',
    value: 'KP',
    isoCode: '06',
  },
  {
    name: 'Pyongyang',
    value: 'KP',
    isoCode: '01',
  },
  {
    name: 'Meghalaya',
    value: 'IN',
    isoCode: 'ML',
  },
  {
    name: 'Haryana',
    value: 'IN',
    isoCode: 'HR',
  },
  {
    name: 'Maharashtra',
    value: 'IN',
    isoCode: 'MH',
  },
  {
    name: 'Goa',
    value: 'IN',
    isoCode: 'GA',
  },
  {
    name: 'Manipur',
    value: 'IN',
    isoCode: 'MN',
  },
  {
    name: 'Puducherry',
    value: 'IN',
    isoCode: 'PY',
  },
  {
    name: 'Telangana',
    value: 'IN',
    isoCode: 'TG',
  },
  {
    name: 'Odisha',
    value: 'IN',
    isoCode: 'OR',
  },
  {
    name: 'Rajasthan',
    value: 'IN',
    isoCode: 'RJ',
  },
  {
    name: 'Punjab',
    value: 'IN',
    isoCode: 'PB',
  },
  {
    name: 'Uttarakhand',
    value: 'IN',
    isoCode: 'UT',
  },
  {
    name: 'Andhra Pradesh',
    value: 'IN',
    isoCode: 'AP',
  },
  {
    name: 'Nagaland',
    value: 'IN',
    isoCode: 'NL',
  },
  {
    name: 'Lakshadweep',
    value: 'IN',
    isoCode: 'LD',
  },
  {
    name: 'Himachal Pradesh',
    value: 'IN',
    isoCode: 'HP',
  },
  {
    name: 'Delhi',
    value: 'IN',
    isoCode: 'DL',
  },
  {
    name: 'Uttar Pradesh',
    value: 'IN',
    isoCode: 'UP',
  },
  {
    name: 'Andaman and Nicobar Islands',
    value: 'IN',
    isoCode: 'AN',
  },
  {
    name: 'Arunachal Pradesh',
    value: 'IN',
    isoCode: 'AR',
  },
  {
    name: 'Jharkhand',
    value: 'IN',
    isoCode: 'JH',
  },
  {
    name: 'Karnataka',
    value: 'IN',
    isoCode: 'KA',
  },
  {
    name: 'Assam',
    value: 'IN',
    isoCode: 'AS',
  },
  {
    name: 'Kerala',
    value: 'IN',
    isoCode: 'KL',
  },
  {
    name: 'Jammu and Kashmir',
    value: 'IN',
    isoCode: 'JK',
  },
  {
    name: 'Gujarat',
    value: 'IN',
    isoCode: 'GJ',
  },
  {
    name: 'Chandigarh',
    value: 'IN',
    isoCode: 'CH',
  },
  {
    name: 'Dadra and Nagar Haveli and Daman and Diu',
    value: 'IN',
    isoCode: 'DH',
  },
  {
    name: 'Sikkim',
    value: 'IN',
    isoCode: 'SK',
  },
  {
    name: 'Tamil Nadu',
    value: 'IN',
    isoCode: 'TN',
  },
  {
    name: 'Mizoram',
    value: 'IN',
    isoCode: 'MZ',
  },
  {
    name: 'Bihar',
    value: 'IN',
    isoCode: 'BR',
  },
  {
    name: 'Tripura',
    value: 'IN',
    isoCode: 'TR',
  },
  {
    name: 'Madhya Pradesh',
    value: 'IN',
    isoCode: 'MP',
  },
  {
    name: 'Chhattisgarh',
    value: 'IN',
    isoCode: 'CT',
  },
  {
    name: 'Ladakh',
    value: 'IN',
    isoCode: 'LA',
  },
  {
    name: 'West Bengal',
    value: 'IN',
    isoCode: 'WB',
  },
  {
    name: 'Choluteca Department',
    value: 'HN',
    isoCode: 'CH',
  },
  {
    name: 'Comayagua Department',
    value: 'HN',
    isoCode: 'CM',
  },
  {
    name: 'El Paraíso Department',
    value: 'HN',
    isoCode: 'EP',
  },
  {
    name: 'Intibucá Department',
    value: 'HN',
    isoCode: 'IN',
  },
  {
    name: 'Bay Islands Department',
    value: 'HN',
    isoCode: 'IB',
  },
  {
    name: 'Cortés Department',
    value: 'HN',
    isoCode: 'CR',
  },
  {
    name: 'Atlántida Department',
    value: 'HN',
    isoCode: 'AT',
  },
  {
    name: 'Gracias a Dios Department',
    value: 'HN',
    isoCode: 'GD',
  },
  {
    name: 'Copán Department',
    value: 'HN',
    isoCode: 'CP',
  },
  {
    name: 'Olancho Department',
    value: 'HN',
    isoCode: 'OL',
  },
  {
    name: 'Colón Department',
    value: 'HN',
    isoCode: 'CL',
  },
  {
    name: 'Francisco Morazán Department',
    value: 'HN',
    isoCode: 'FM',
  },
  {
    name: 'Santa Bárbara Department',
    value: 'HN',
    isoCode: 'SB',
  },
  {
    name: 'Lempira Department',
    value: 'HN',
    isoCode: 'LE',
  },
  {
    name: 'Valle Department',
    value: 'HN',
    isoCode: 'VA',
  },
  {
    name: 'Ocotepeque Department',
    value: 'HN',
    isoCode: 'OC',
  },
  {
    name: 'Yoro Department',
    value: 'HN',
    isoCode: 'YO',
  },
  {
    name: 'La Paz Department',
    value: 'HN',
    isoCode: 'LP',
  },
  {
    name: 'Northland Region',
    value: 'NZ',
    isoCode: 'NTL',
  },
  {
    name: 'Manawatu-Wanganui Region',
    value: 'NZ',
    isoCode: 'MWT',
  },
  {
    name: 'Waikato Region',
    value: 'NZ',
    isoCode: 'WKO',
  },
  {
    name: 'Otago Region',
    value: 'NZ',
    isoCode: 'OTA',
  },
  {
    name: 'Marlborough Region',
    value: 'NZ',
    isoCode: 'MBH',
  },
  {
    name: 'West Coast Region',
    value: 'NZ',
    isoCode: 'WTC',
  },
  {
    name: 'Wellington Region',
    value: 'NZ',
    isoCode: 'WGN',
  },
  {
    name: 'Canterbury Region',
    value: 'NZ',
    isoCode: 'CAN',
  },
  {
    name: 'Chatham Islands',
    value: 'NZ',
    isoCode: 'CIT',
  },
  {
    name: 'Gisborne District',
    value: 'NZ',
    isoCode: 'GIS',
  },
  {
    name: 'Taranaki Region',
    value: 'NZ',
    isoCode: 'TKI',
  },
  {
    name: 'Nelson Region',
    value: 'NZ',
    isoCode: 'NSN',
  },
  {
    name: 'Southland Region',
    value: 'NZ',
    isoCode: 'STL',
  },
  {
    name: 'Auckland Region',
    value: 'NZ',
    isoCode: 'AUK',
  },
  {
    name: 'Tasman District',
    value: 'NZ',
    isoCode: 'TAS',
  },
  {
    name: 'Bay of Plenty Region',
    value: 'NZ',
    isoCode: 'BOP',
  },
  {
    name: "Hawke's Bay Region",
    value: 'NZ',
    isoCode: 'HKB',
  },
  {
    name: 'Saint John Parish',
    value: 'DM',
    isoCode: '05',
  },
  {
    name: 'Saint Mark Parish',
    value: 'DM',
    isoCode: '08',
  },
  {
    name: 'Saint David Parish',
    value: 'DM',
    isoCode: '03',
  },
  {
    name: 'Saint George Parish',
    value: 'DM',
    isoCode: '04',
  },
  {
    name: 'Saint Patrick Parish',
    value: 'DM',
    isoCode: '09',
  },
  {
    name: 'Saint Peter Parish',
    value: 'DM',
    isoCode: '11',
  },
  {
    name: 'Saint Andrew Parish',
    value: 'DM',
    isoCode: '02',
  },
  {
    name: 'Saint Luke Parish',
    value: 'DM',
    isoCode: '07',
  },
  {
    name: 'Saint Paul Parish',
    value: 'DM',
    isoCode: '10',
  },
  {
    name: 'Saint Joseph Parish',
    value: 'DM',
    isoCode: '06',
  },
  {
    name: 'El Seibo Province',
    value: 'DO',
    isoCode: '08',
  },
  {
    name: 'La Romana Province',
    value: 'DO',
    isoCode: '12',
  },
  {
    name: 'Sánchez Ramírez Province',
    value: 'DO',
    isoCode: '24',
  },
  {
    name: 'Hermanas Mirabal Province',
    value: 'DO',
    isoCode: '19',
  },
  {
    name: 'Barahona Province',
    value: 'DO',
    isoCode: '04',
  },
  {
    name: 'San Cristóbal Province',
    value: 'DO',
    isoCode: '21',
  },
  {
    name: 'Puerto Plata Province',
    value: 'DO',
    isoCode: '18',
  },
  {
    name: 'Santo Domingo Province',
    value: 'DO',
    isoCode: '32',
  },
  {
    name: 'María Trinidad Sánchez Province',
    value: 'DO',
    isoCode: '14',
  },
  {
    name: 'Distrito Nacional',
    value: 'DO',
    isoCode: '01',
  },
  {
    name: 'Peravia Province',
    value: 'DO',
    isoCode: '17',
  },
  {
    name: 'Independencia',
    value: 'DO',
    isoCode: '10',
  },
  {
    name: 'San Juan Province',
    value: 'DO',
    isoCode: '22',
  },
  {
    name: 'Monseñor Nouel Province',
    value: 'DO',
    isoCode: '28',
  },
  {
    name: 'Santiago Rodríguez Province',
    value: 'DO',
    isoCode: '26',
  },
  {
    name: 'Pedernales Province',
    value: 'DO',
    isoCode: '16',
  },
  {
    name: 'Espaillat Province',
    value: 'DO',
    isoCode: '09',
  },
  {
    name: 'Samaná Province',
    value: 'DO',
    isoCode: '20',
  },
  {
    name: 'Valverde Province',
    value: 'DO',
    isoCode: '27',
  },
  {
    name: 'Baoruco Province',
    value: 'DO',
    isoCode: '03',
  },
  {
    name: 'Hato Mayor Province',
    value: 'DO',
    isoCode: '30',
  },
  {
    name: 'Dajabón Province',
    value: 'DO',
    isoCode: '05',
  },
  {
    name: 'Santiago Province',
    value: 'DO',
    isoCode: '25',
  },
  {
    name: 'La Altagracia Province',
    value: 'DO',
    isoCode: '11',
  },
  {
    name: 'San Pedro de Macorís',
    value: 'DO',
    isoCode: '23',
  },
  {
    name: 'Monte Plata Province',
    value: 'DO',
    isoCode: '29',
  },
  {
    name: 'San José de Ocoa Province',
    value: 'DO',
    isoCode: '31',
  },
  {
    name: 'Duarte Province',
    value: 'DO',
    isoCode: '06',
  },
  {
    name: 'Azua Province',
    value: 'DO',
    isoCode: '02',
  },
  {
    name: 'Monte Cristi Province',
    value: 'DO',
    isoCode: '15',
  },
  {
    name: 'La Vega Province',
    value: 'DO',
    isoCode: '13',
  },
  {
    name: 'Nord',
    value: 'HT',
    isoCode: 'ND',
  },
  {
    name: 'Nippes',
    value: 'HT',
    isoCode: 'NI',
  },
  {
    name: "Grand'Anse",
    value: 'HT',
    isoCode: 'GA',
  },
  {
    name: 'Ouest',
    value: 'HT',
    isoCode: 'OU',
  },
  {
    name: 'Nord-Est',
    value: 'HT',
    isoCode: 'NE',
  },
  {
    name: 'Sud',
    value: 'HT',
    isoCode: 'SD',
  },
  {
    name: 'Artibonite',
    value: 'HT',
    isoCode: 'AR',
  },
  {
    name: 'Sud-Est',
    value: 'HT',
    isoCode: 'SE',
  },
  {
    name: 'Centre',
    value: 'HT',
    isoCode: 'CE',
  },
  {
    name: 'Nord-Ouest',
    value: 'HT',
    isoCode: 'NO',
  },
  {
    name: 'San Vicente Department',
    value: 'SV',
    isoCode: 'SV',
  },
  {
    name: 'Santa Ana Department',
    value: 'SV',
    isoCode: 'SA',
  },
  {
    name: 'Usulután Department',
    value: 'SV',
    isoCode: 'US',
  },
  {
    name: 'Morazán Department',
    value: 'SV',
    isoCode: 'MO',
  },
  {
    name: 'Chalatenango Department',
    value: 'SV',
    isoCode: 'CH',
  },
  {
    name: 'Cabañas Department',
    value: 'SV',
    isoCode: 'CA',
  },
  {
    name: 'San Salvador Department',
    value: 'SV',
    isoCode: 'SS',
  },
  {
    name: 'La Libertad Department',
    value: 'SV',
    isoCode: 'LI',
  },
  {
    name: 'San Miguel Department',
    value: 'SV',
    isoCode: 'SM',
  },
  {
    name: 'La Paz Department',
    value: 'SV',
    isoCode: 'PA',
  },
  {
    name: 'Cuscatlán Department',
    value: 'SV',
    isoCode: 'CU',
  },
  {
    name: 'La Unión Department',
    value: 'SV',
    isoCode: 'UN',
  },
  {
    name: 'Ahuachapán Department',
    value: 'SV',
    isoCode: 'AH',
  },
  {
    name: 'Sonsonate Department',
    value: 'SV',
    isoCode: 'SO',
  },
  {
    name: 'Braslovče Municipality',
    value: 'SI',
    isoCode: '151',
  },
  {
    name: 'Lenart Municipality',
    value: 'SI',
    isoCode: '058',
  },
  {
    name: 'Oplotnica',
    value: 'SI',
    isoCode: '171',
  },
  {
    name: 'Velike Lašče Municipality',
    value: 'SI',
    isoCode: '134',
  },
  {
    name: 'Hajdina Municipality',
    value: 'SI',
    isoCode: '159',
  },
  {
    name: 'Podčetrtek Municipality',
    value: 'SI',
    isoCode: '092',
  },
  {
    name: 'Cankova Municipality',
    value: 'SI',
    isoCode: '152',
  },
  {
    name: 'Vitanje Municipality',
    value: 'SI',
    isoCode: '137',
  },
  {
    name: 'Sežana Municipality',
    value: 'SI',
    isoCode: '111',
  },
  {
    name: 'Kidričevo Municipality',
    value: 'SI',
    isoCode: '045',
  },
  {
    name: 'Črenšovci Municipality',
    value: 'SI',
    isoCode: '015',
  },
  {
    name: 'Idrija Municipality',
    value: 'SI',
    isoCode: '036',
  },
  {
    name: 'Trnovska Vas Municipality',
    value: 'SI',
    isoCode: '185',
  },
  {
    name: 'Vodice Municipality',
    value: 'SI',
    isoCode: '138',
  },
  {
    name: 'Ravne na Koroškem Municipality',
    value: 'SI',
    isoCode: '103',
  },
  {
    name: 'Lovrenc na Pohorju Municipality',
    value: 'SI',
    isoCode: '167',
  },
  {
    name: 'Majšperk Municipality',
    value: 'SI',
    isoCode: '069',
  },
  {
    name: 'Loški Potok Municipality',
    value: 'SI',
    isoCode: '066',
  },
  {
    name: 'Domžale Municipality',
    value: 'SI',
    isoCode: '023',
  },
  {
    name: 'Rečica ob Savinji Municipality',
    value: 'SI',
    isoCode: '209',
  },
  {
    name: 'Podlehnik Municipality',
    value: 'SI',
    isoCode: '172',
  },
  {
    name: 'Cerknica Municipality',
    value: 'SI',
    isoCode: '013',
  },
  {
    name: 'Vransko Municipality',
    value: 'SI',
    isoCode: '189',
  },
  {
    name: 'Sveta Ana Municipality',
    value: 'SI',
    isoCode: '181',
  },
  {
    name: 'Brezovica Municipality',
    value: 'SI',
    isoCode: '008',
  },
  {
    name: 'Benedikt Municipality',
    value: 'SI',
    isoCode: '148',
  },
  {
    name: 'Divača Municipality',
    value: 'SI',
    isoCode: '019',
  },
  {
    name: 'Moravče Municipality',
    value: 'SI',
    isoCode: '077',
  },
  {
    name: 'Slovenj Gradec City Municipality',
    value: 'SI',
    isoCode: '112',
  },
  {
    name: 'Škocjan Municipality',
    value: 'SI',
    isoCode: '121',
  },
  {
    name: 'Šentjur Municipality',
    value: 'SI',
    isoCode: '120',
  },
  {
    name: 'Pesnica Municipality',
    value: 'SI',
    isoCode: '089',
  },
  {
    name: 'Dol pri Ljubljani Municipality',
    value: 'SI',
    isoCode: '022',
  },
  {
    name: 'Loška Dolina Municipality',
    value: 'SI',
    isoCode: '065',
  },
  {
    name: 'Hoče–Slivnica Municipality',
    value: 'SI',
    isoCode: '160',
  },
  {
    name: 'Cerkvenjak Municipality',
    value: 'SI',
    isoCode: '153',
  },
  {
    name: 'Naklo Municipality',
    value: 'SI',
    isoCode: '082',
  },
  {
    name: 'Cerkno Municipality',
    value: 'SI',
    isoCode: '014',
  },
  {
    name: 'Bistrica ob Sotli Municipality',
    value: 'SI',
    isoCode: '149',
  },
  {
    name: 'Kamnik Municipality',
    value: 'SI',
    isoCode: '043',
  },
  {
    name: 'Bovec Municipality',
    value: 'SI',
    isoCode: '006',
  },
  {
    name: 'Zavrč Municipality',
    value: 'SI',
    isoCode: '143',
  },
  {
    name: 'Ajdovščina Municipality',
    value: 'SI',
    isoCode: '001',
  },
  {
    name: 'Pivka Municipality',
    value: 'SI',
    isoCode: '091',
  },
  {
    name: 'Štore Municipality',
    value: 'SI',
    isoCode: '127',
  },
  {
    name: 'Kozje Municipality',
    value: 'SI',
    isoCode: '051',
  },
  {
    name: 'Municipality of Škofljica',
    value: 'SI',
    isoCode: '123',
  },
  {
    name: 'Prebold Municipality',
    value: 'SI',
    isoCode: '174',
  },
  {
    name: 'Dobrovnik Municipality',
    value: 'SI',
    isoCode: '156',
  },
  {
    name: 'Mozirje Municipality',
    value: 'SI',
    isoCode: '079',
  },
  {
    name: 'City Municipality of Celje',
    value: 'SI',
    isoCode: '011',
  },
  {
    name: 'Žiri Municipality',
    value: 'SI',
    isoCode: '147',
  },
  {
    name: 'Horjul Municipality',
    value: 'SI',
    isoCode: '162',
  },
  {
    name: 'Tabor Municipality',
    value: 'SI',
    isoCode: '184',
  },
  {
    name: 'Radeče Municipality',
    value: 'SI',
    isoCode: '099',
  },
  {
    name: 'Vipava Municipality',
    value: 'SI',
    isoCode: '136',
  },
  {
    name: 'Kungota',
    value: 'SI',
    isoCode: '055',
  },
  {
    name: 'Slovenske Konjice Municipality',
    value: 'SI',
    isoCode: '114',
  },
  {
    name: 'Osilnica Municipality',
    value: 'SI',
    isoCode: '088',
  },
  {
    name: 'Borovnica Municipality',
    value: 'SI',
    isoCode: '005',
  },
  {
    name: 'Piran Municipality',
    value: 'SI',
    isoCode: '090',
  },
  {
    name: 'Bled Municipality',
    value: 'SI',
    isoCode: '003',
  },
  {
    name: 'Jezersko Municipality',
    value: 'SI',
    isoCode: '163',
  },
  {
    name: 'Rače–Fram Municipality',
    value: 'SI',
    isoCode: '098',
  },
  {
    name: 'Nova Gorica City Municipality',
    value: 'SI',
    isoCode: '084',
  },
  {
    name: 'Razkrižje Municipality',
    value: 'SI',
    isoCode: '176',
  },
  {
    name: 'Ribnica na Pohorju Municipality',
    value: 'SI',
    isoCode: '177',
  },
  {
    name: 'Muta Municipality',
    value: 'SI',
    isoCode: '081',
  },
  {
    name: 'Rogatec Municipality',
    value: 'SI',
    isoCode: '107',
  },
  {
    name: 'Gorišnica Municipality',
    value: 'SI',
    isoCode: '028',
  },
  {
    name: 'Kuzma Municipality',
    value: 'SI',
    isoCode: '056',
  },
  {
    name: 'Mislinja Municipality',
    value: 'SI',
    isoCode: '076',
  },
  {
    name: 'Duplek Municipality',
    value: 'SI',
    isoCode: '026',
  },
  {
    name: 'Trebnje Municipality',
    value: 'SI',
    isoCode: '130',
  },
  {
    name: 'Brežice Municipality',
    value: 'SI',
    isoCode: '009',
  },
  {
    name: 'Dobrepolje Municipality',
    value: 'SI',
    isoCode: '020',
  },
  {
    name: 'Grad Municipality',
    value: 'SI',
    isoCode: '158',
  },
  {
    name: 'Moravske Toplice Municipality',
    value: 'SI',
    isoCode: '078',
  },
  {
    name: 'Luče Municipality',
    value: 'SI',
    isoCode: '067',
  },
  {
    name: 'Miren–Kostanjevica Municipality',
    value: 'SI',
    isoCode: '075',
  },
  {
    name: 'Ormož Municipality',
    value: 'SI',
    isoCode: '087',
  },
  {
    name: 'Šalovci Municipality',
    value: 'SI',
    isoCode: '033',
  },
  {
    name: 'Miklavž na Dravskem Polju Municipality',
    value: 'SI',
    isoCode: '169',
  },
  {
    name: 'Makole Municipality',
    value: 'SI',
    isoCode: '198',
  },
  {
    name: 'Lendava Municipality',
    value: 'SI',
    isoCode: '059',
  },
  {
    name: 'Vuzenica Municipality',
    value: 'SI',
    isoCode: '141',
  },
  {
    name: 'Kanal ob Soči Municipality',
    value: 'SI',
    isoCode: '044',
  },
  {
    name: 'Ptuj City Municipality',
    value: 'SI',
    isoCode: '096',
  },
  {
    name: 'Sveti Andraž v Slovenskih Goricah Municipality',
    value: 'SI',
    isoCode: '182',
  },
  {
    name: 'Selnica ob Dravi Municipality',
    value: 'SI',
    isoCode: '178',
  },
  {
    name: 'Radovljica Municipality',
    value: 'SI',
    isoCode: '102',
  },
  {
    name: 'Črna na Koroškem Municipality',
    value: 'SI',
    isoCode: '016',
  },
  {
    name: 'Rogaška Slatina Municipality',
    value: 'SI',
    isoCode: '106',
  },
  {
    name: 'Podvelka Municipality',
    value: 'SI',
    isoCode: '093',
  },
  {
    name: 'Ribnica Municipality',
    value: 'SI',
    isoCode: '104',
  },
  {
    name: 'City Municipality of Novo Mesto',
    value: 'SI',
    isoCode: '085',
  },
  {
    name: 'Mirna Peč Municipality',
    value: 'SI',
    isoCode: '170',
  },
  {
    name: 'Križevci Municipality',
    value: 'SI',
    isoCode: '166',
  },
  {
    name: 'Poljčane Municipality',
    value: 'SI',
    isoCode: '200',
  },
  {
    name: 'Brda Municipality',
    value: 'SI',
    isoCode: '007',
  },
  {
    name: 'Šentjernej Municipality',
    value: 'SI',
    isoCode: '119',
  },
  {
    name: 'Maribor City Municipality',
    value: 'SI',
    isoCode: '070',
  },
  {
    name: 'Kobarid Municipality',
    value: 'SI',
    isoCode: '046',
  },
  {
    name: 'Markovci Municipality',
    value: 'SI',
    isoCode: '168',
  },
  {
    name: 'Vojnik Municipality',
    value: 'SI',
    isoCode: '139',
  },
  {
    name: 'Trbovlje Municipality',
    value: 'SI',
    isoCode: '129',
  },
  {
    name: 'Tolmin Municipality',
    value: 'SI',
    isoCode: '128',
  },
  {
    name: 'Šoštanj Municipality',
    value: 'SI',
    isoCode: '126',
  },
  {
    name: 'Žetale Municipality',
    value: 'SI',
    isoCode: '191',
  },
  {
    name: 'Tržič Municipality',
    value: 'SI',
    isoCode: '131',
  },
  {
    name: 'Turnišče Municipality',
    value: 'SI',
    isoCode: '132',
  },
  {
    name: 'Dobrna Municipality',
    value: 'SI',
    isoCode: '155',
  },
  {
    name: 'Renče–Vogrsko Municipality',
    value: 'SI',
    isoCode: '201',
  },
  {
    name: 'Kostanjevica na Krki Municipality',
    value: 'SI',
    isoCode: '197',
  },
  {
    name: 'Sveti Jurij ob Ščavnici Municipality',
    value: 'SI',
    isoCode: '116',
  },
  {
    name: 'Železniki Municipality',
    value: 'SI',
    isoCode: '146',
  },
  {
    name: 'Veržej Municipality',
    value: 'SI',
    isoCode: '188',
  },
  {
    name: 'Žalec Municipality',
    value: 'SI',
    isoCode: '190',
  },
  {
    name: 'Starše Municipality',
    value: 'SI',
    isoCode: '115',
  },
  {
    name: 'Sveta Trojica v Slovenskih Goricah Municipality',
    value: 'SI',
    isoCode: '204',
  },
  {
    name: 'Solčava Municipality',
    value: 'SI',
    isoCode: '180',
  },
  {
    name: 'Vrhnika Municipality',
    value: 'SI',
    isoCode: '140',
  },
  {
    name: 'Središče ob Dravi',
    value: 'SI',
    isoCode: '202',
  },
  {
    name: 'Rogašovci Municipality',
    value: 'SI',
    isoCode: '105',
  },
  {
    name: 'Mežica Municipality',
    value: 'SI',
    isoCode: '074',
  },
  {
    name: 'Juršinci Municipality',
    value: 'SI',
    isoCode: '042',
  },
  {
    name: 'Velika Polana Municipality',
    value: 'SI',
    isoCode: '187',
  },
  {
    name: 'Sevnica Municipality',
    value: 'SI',
    isoCode: '110',
  },
  {
    name: 'Zagorje ob Savi Municipality',
    value: 'SI',
    isoCode: '142',
  },
  {
    name: 'Ljubljana City Municipality',
    value: 'SI',
    isoCode: '061',
  },
  {
    name: 'Gornji Petrovci Municipality',
    value: 'SI',
    isoCode: '031',
  },
  {
    name: 'Polzela Municipality',
    value: 'SI',
    isoCode: '173',
  },
  {
    name: 'Sveti Tomaž Municipality',
    value: 'SI',
    isoCode: '205',
  },
  {
    name: 'Prevalje Municipality',
    value: 'SI',
    isoCode: '175',
  },
  {
    name: 'Radlje ob Dravi Municipality',
    value: 'SI',
    isoCode: '101',
  },
  {
    name: 'Žirovnica Municipality',
    value: 'SI',
    isoCode: '192',
  },
  {
    name: 'Sodražica Municipality',
    value: 'SI',
    isoCode: '179',
  },
  {
    name: 'Bloke Municipality',
    value: 'SI',
    isoCode: '150',
  },
  {
    name: 'Šmartno pri Litiji Municipality',
    value: 'SI',
    isoCode: '194',
  },
  {
    name: 'Ruše Municipality',
    value: 'SI',
    isoCode: '108',
  },
  {
    name: 'Dolenjske Toplice Municipality',
    value: 'SI',
    isoCode: '157',
  },
  {
    name: 'Bohinj Municipality',
    value: 'SI',
    isoCode: '004',
  },
  {
    name: 'Komenda Municipality',
    value: 'SI',
    isoCode: '164',
  },
  {
    name: 'Gorje Municipality',
    value: 'SI',
    isoCode: '207',
  },
  {
    name: 'Šmarje pri Jelšah Municipality',
    value: 'SI',
    isoCode: '124',
  },
  {
    name: 'Ig Municipality',
    value: 'SI',
    isoCode: '037',
  },
  {
    name: 'Kranj City Municipality',
    value: 'SI',
    isoCode: '052',
  },
  {
    name: 'Puconci Municipality',
    value: 'SI',
    isoCode: '097',
  },
  {
    name: 'Šmarješke Toplice Municipality',
    value: 'SI',
    isoCode: '206',
  },
  {
    name: 'Dornava Municipality',
    value: 'SI',
    isoCode: '024',
  },
  {
    name: 'Črnomelj Municipality',
    value: 'SI',
    isoCode: '017',
  },
  {
    name: 'Radenci Municipality',
    value: 'SI',
    isoCode: '100',
  },
  {
    name: 'Gorenja Vas–Poljane Municipality',
    value: 'SI',
    isoCode: '027',
  },
  {
    name: 'Ljubno Municipality',
    value: 'SI',
    isoCode: '062',
  },
  {
    name: 'Dobje Municipality',
    value: 'SI',
    isoCode: '154',
  },
  {
    name: 'Šmartno ob Paki Municipality',
    value: 'SI',
    isoCode: '125',
  },
  {
    name: 'Mokronog–Trebelno Municipality',
    value: 'SI',
    isoCode: '199',
  },
  {
    name: 'Mirna Municipality',
    value: 'SI',
    isoCode: '212',
  },
  {
    name: 'Šenčur Municipality',
    value: 'SI',
    isoCode: '117',
  },
  {
    name: 'Videm Municipality',
    value: 'SI',
    isoCode: '135',
  },
  {
    name: 'Beltinci Municipality',
    value: 'SI',
    isoCode: '002',
  },
  {
    name: 'Lukovica Municipality',
    value: 'SI',
    isoCode: '068',
  },
  {
    name: 'Preddvor Municipality',
    value: 'SI',
    isoCode: '095',
  },
  {
    name: 'Destrnik Municipality',
    value: 'SI',
    isoCode: '018',
  },
  {
    name: 'Ivančna Gorica Municipality',
    value: 'SI',
    isoCode: '039',
  },
  {
    name: 'Log–Dragomer Municipality',
    value: 'SI',
    isoCode: '208',
  },
  {
    name: 'Žužemberk Municipality',
    value: 'SI',
    isoCode: '193',
  },
  {
    name: 'Dobrova–Polhov Gradec Municipality',
    value: 'SI',
    isoCode: '021',
  },
  {
    name: 'Municipality of Cirkulane',
    value: 'SI',
    isoCode: '196',
  },
  {
    name: 'Cerklje na Gorenjskem Municipality',
    value: 'SI',
    isoCode: '012',
  },
  {
    name: 'Šentrupert Municipality',
    value: 'SI',
    isoCode: '211',
  },
  {
    name: 'Tišina Municipality',
    value: 'SI',
    isoCode: '010',
  },
  {
    name: 'Murska Sobota City Municipality',
    value: 'SI',
    isoCode: '080',
  },
  {
    name: 'Municipality of Krško',
    value: 'SI',
    isoCode: '054',
  },
  {
    name: 'Komen Municipality',
    value: 'SI',
    isoCode: '049',
  },
  {
    name: 'Škofja Loka Municipality',
    value: 'SI',
    isoCode: '122',
  },
  {
    name: 'Šempeter–Vrtojba Municipality',
    value: 'SI',
    isoCode: '183',
  },
  {
    name: 'Municipality of Apače',
    value: 'SI',
    isoCode: '195',
  },
  {
    name: 'Koper City Municipality',
    value: 'SI',
    isoCode: '050',
  },
  {
    name: 'Odranci Municipality',
    value: 'SI',
    isoCode: '086',
  },
  {
    name: 'Hrpelje–Kozina Municipality',
    value: 'SI',
    isoCode: '035',
  },
  {
    name: 'Izola Municipality',
    value: 'SI',
    isoCode: '040',
  },
  {
    name: 'Metlika Municipality',
    value: 'SI',
    isoCode: '073',
  },
  {
    name: 'Šentilj Municipality',
    value: 'SI',
    isoCode: '118',
  },
  {
    name: 'Kobilje Municipality',
    value: 'SI',
    isoCode: '047',
  },
  {
    name: 'Ankaran Municipality',
    value: 'SI',
    isoCode: '213',
  },
  {
    name: 'Hodoš Municipality',
    value: 'SI',
    isoCode: '161',
  },
  {
    name: 'Sveti Jurij v Slovenskih Goricah Municipality',
    value: 'SI',
    isoCode: '210',
  },
  {
    name: 'Nazarje Municipality',
    value: 'SI',
    isoCode: '083',
  },
  {
    name: 'Postojna Municipality',
    value: 'SI',
    isoCode: '094',
  },
  {
    name: 'Kostel Municipality',
    value: 'SI',
    isoCode: '165',
  },
  {
    name: 'Slovenska Bistrica Municipality',
    value: 'SI',
    isoCode: '113',
  },
  {
    name: 'Straža Municipality',
    value: 'SI',
    isoCode: '203',
  },
  {
    name: 'Trzin Municipality',
    value: 'SI',
    isoCode: '186',
  },
  {
    name: 'Kočevje Municipality',
    value: 'SI',
    isoCode: '048',
  },
  {
    name: 'Grosuplje Municipality',
    value: 'SI',
    isoCode: '032',
  },
  {
    name: 'Jesenice Municipality',
    value: 'SI',
    isoCode: '041',
  },
  {
    name: 'Laško Municipality',
    value: 'SI',
    isoCode: '057',
  },
  {
    name: 'Gornji Grad Municipality',
    value: 'SI',
    isoCode: '030',
  },
  {
    name: 'Kranjska Gora Municipality',
    value: 'SI',
    isoCode: '053',
  },
  {
    name: 'Hrastnik Municipality',
    value: 'SI',
    isoCode: '034',
  },
  {
    name: 'Zreče Municipality',
    value: 'SI',
    isoCode: '144',
  },
  {
    name: 'Gornja Radgona Municipality',
    value: 'SI',
    isoCode: '029',
  },
  {
    name: 'Municipality of Ilirska Bistrica',
    value: 'SI',
    isoCode: '038',
  },
  {
    name: 'Dravograd Municipality',
    value: 'SI',
    isoCode: '025',
  },
  {
    name: 'Semič Municipality',
    value: 'SI',
    isoCode: '109',
  },
  {
    name: 'Litija Municipality',
    value: 'SI',
    isoCode: '060',
  },
  {
    name: 'Mengeš Municipality',
    value: 'SI',
    isoCode: '072',
  },
  {
    name: 'Medvode Municipality',
    value: 'SI',
    isoCode: '071',
  },
  {
    name: 'Logatec Municipality',
    value: 'SI',
    isoCode: '064',
  },
  {
    name: 'Ljutomer Municipality',
    value: 'SI',
    isoCode: '063',
  },
  {
    name: 'Banská Bystrica Region',
    value: 'SK',
    isoCode: 'BC',
  },
  {
    name: 'Košice Region',
    value: 'SK',
    isoCode: 'KI',
  },
  {
    name: 'Prešov Region',
    value: 'SK',
    isoCode: 'PV',
  },
  {
    name: 'Trnava Region',
    value: 'SK',
    isoCode: 'TA',
  },
  {
    name: 'Bratislava Region',
    value: 'SK',
    isoCode: 'BL',
  },
  {
    name: 'Nitra Region',
    value: 'SK',
    isoCode: 'NI',
  },
  {
    name: 'Trenčín Region',
    value: 'SK',
    isoCode: 'TC',
  },
  {
    name: 'Žilina Region',
    value: 'SK',
    isoCode: 'ZI',
  },
  {
    name: 'Cimișlia District',
    value: 'MD',
    isoCode: 'CM',
  },
  {
    name: 'Orhei District',
    value: 'MD',
    isoCode: 'OR',
  },
  {
    name: 'Bender Municipality',
    value: 'MD',
    isoCode: 'BD',
  },
  {
    name: 'Nisporeni District',
    value: 'MD',
    isoCode: 'NI',
  },
  {
    name: 'Sîngerei District',
    value: 'MD',
    isoCode: 'SI',
  },
  {
    name: 'Căușeni District',
    value: 'MD',
    isoCode: 'CS',
  },
  {
    name: 'Călărași District',
    value: 'MD',
    isoCode: 'CL',
  },
  {
    name: 'Glodeni District',
    value: 'MD',
    isoCode: 'GL',
  },
  {
    name: 'Anenii Noi District',
    value: 'MD',
    isoCode: 'AN',
  },
  {
    name: 'Ialoveni District',
    value: 'MD',
    isoCode: 'IA',
  },
  {
    name: 'Florești District',
    value: 'MD',
    isoCode: 'FL',
  },
  {
    name: 'Telenești District',
    value: 'MD',
    isoCode: 'TE',
  },
  {
    name: 'Taraclia District',
    value: 'MD',
    isoCode: 'TA',
  },
  {
    name: 'Chișinău Municipality',
    value: 'MD',
    isoCode: 'CU',
  },
  {
    name: 'Soroca District',
    value: 'MD',
    isoCode: 'SO',
  },
  {
    name: 'Briceni District',
    value: 'MD',
    isoCode: 'BR',
  },
  {
    name: 'Rîșcani District',
    value: 'MD',
    isoCode: 'RI',
  },
  {
    name: 'Strășeni District',
    value: 'MD',
    isoCode: 'ST',
  },
  {
    name: 'Ștefan Vodă District',
    value: 'MD',
    isoCode: 'SV',
  },
  {
    name: 'Basarabeasca District',
    value: 'MD',
    isoCode: 'BS',
  },
  {
    name: 'Cantemir District',
    value: 'MD',
    isoCode: 'CT',
  },
  {
    name: 'Fălești District',
    value: 'MD',
    isoCode: 'FA',
  },
  {
    name: 'Hîncești District',
    value: 'MD',
    isoCode: 'HI',
  },
  {
    name: 'Dubăsari District',
    value: 'MD',
    isoCode: 'DU',
  },
  {
    name: 'Dondușeni District',
    value: 'MD',
    isoCode: 'DO',
  },
  {
    name: 'Gagauzia',
    value: 'MD',
    isoCode: 'GA',
  },
  {
    name: 'Ungheni District',
    value: 'MD',
    isoCode: 'UN',
  },
  {
    name: 'Edineț District',
    value: 'MD',
    isoCode: 'ED',
  },
  {
    name: 'Șoldănești District',
    value: 'MD',
    isoCode: 'SD',
  },
  {
    name: 'Ocnița District',
    value: 'MD',
    isoCode: 'OC',
  },
  {
    name: 'Criuleni District',
    value: 'MD',
    isoCode: 'CR',
  },
  {
    name: 'Cahul District',
    value: 'MD',
    isoCode: 'CA',
  },
  {
    name: 'Drochia District',
    value: 'MD',
    isoCode: 'DR',
  },
  {
    name: 'Bălți Municipality',
    value: 'MD',
    isoCode: 'BA',
  },
  {
    name: 'Rezina District',
    value: 'MD',
    isoCode: 'RE',
  },
  {
    name: 'Transnistria autonomous territorial unit',
    value: 'MD',
    isoCode: 'SN',
  },
  {
    name: 'Salacgrīva Municipality',
    value: 'LV',
    isoCode: '086',
  },
  {
    name: 'Vecumnieki Municipality',
    value: 'LV',
    isoCode: '105',
  },
  {
    name: 'Naukšēni Municipality',
    value: 'LV',
    isoCode: '064',
  },
  {
    name: 'Ilūkste Municipality',
    value: 'LV',
    isoCode: '036',
  },
  {
    name: 'Gulbene Municipality',
    value: 'LV',
    isoCode: '033',
  },
  {
    name: 'Līvāni Municipality',
    value: 'LV',
    isoCode: '056',
  },
  {
    name: 'Salaspils Municipality',
    value: 'LV',
    isoCode: '087',
  },
  {
    name: 'Ventspils Municipality',
    value: 'LV',
    isoCode: '106',
  },
  {
    name: 'Rundāle Municipality',
    value: 'LV',
    isoCode: '083',
  },
  {
    name: 'Pļaviņas Municipality',
    value: 'LV',
    isoCode: '072',
  },
  {
    name: 'Vārkava Municipality',
    value: 'LV',
    isoCode: '103',
  },
  {
    name: 'Jaunpiebalga Municipality',
    value: 'LV',
    isoCode: '039',
  },
  {
    name: 'Sēja Municipality',
    value: 'LV',
    isoCode: '090',
  },
  {
    name: 'Tukums Municipality',
    value: 'LV',
    isoCode: '099',
  },
  {
    name: 'Cibla Municipality',
    value: 'LV',
    isoCode: '023',
  },
  {
    name: 'Burtnieki Municipality',
    value: 'LV',
    isoCode: '019',
  },
  {
    name: 'Ķegums Municipality',
    value: 'LV',
    isoCode: '051',
  },
  {
    name: 'Krustpils Municipality',
    value: 'LV',
    isoCode: '049',
  },
  {
    name: 'Cesvaine Municipality',
    value: 'LV',
    isoCode: '021',
  },
  {
    name: 'Skrīveri Municipality',
    value: 'LV',
    isoCode: '092',
  },
  {
    name: 'Ogre Municipality',
    value: 'LV',
    isoCode: '067',
  },
  {
    name: 'Olaine Municipality',
    value: 'LV',
    isoCode: '068',
  },
  {
    name: 'Limbaži Municipality',
    value: 'LV',
    isoCode: '054',
  },
  {
    name: 'Lubāna Municipality',
    value: 'LV',
    isoCode: '057',
  },
  {
    name: 'Kandava Municipality',
    value: 'LV',
    isoCode: '043',
  },
  {
    name: 'Ventspils',
    value: 'LV',
    isoCode: 'VEN',
  },
  {
    name: 'Krimulda Municipality',
    value: 'LV',
    isoCode: '048',
  },
  {
    name: 'Rugāji Municipality',
    value: 'LV',
    isoCode: '082',
  },
  {
    name: 'Jelgava Municipality',
    value: 'LV',
    isoCode: '041',
  },
  {
    name: 'Valka Municipality',
    value: 'LV',
    isoCode: '101',
  },
  {
    name: 'Rūjiena Municipality',
    value: 'LV',
    isoCode: '084',
  },
  {
    name: 'Babīte Municipality',
    value: 'LV',
    isoCode: '012',
  },
  {
    name: 'Dundaga Municipality',
    value: 'LV',
    isoCode: '027',
  },
  {
    name: 'Priekule Municipality',
    value: 'LV',
    isoCode: '074',
  },
  {
    name: 'Zilupe Municipality',
    value: 'LV',
    isoCode: '110',
  },
  {
    name: 'Varakļāni Municipality',
    value: 'LV',
    isoCode: '102',
  },
  {
    name: 'Nereta Municipality',
    value: 'LV',
    isoCode: '065',
  },
  {
    name: 'Madona Municipality',
    value: 'LV',
    isoCode: '059',
  },
  {
    name: 'Sala Municipality',
    value: 'LV',
    isoCode: '085',
  },
  {
    name: 'Ķekava Municipality',
    value: 'LV',
    isoCode: '052',
  },
  {
    name: 'Nīca Municipality',
    value: 'LV',
    isoCode: '066',
  },
  {
    name: 'Dobele Municipality',
    value: 'LV',
    isoCode: '026',
  },
  {
    name: 'Jēkabpils Municipality',
    value: 'LV',
    isoCode: '042',
  },
  {
    name: 'Saldus Municipality',
    value: 'LV',
    isoCode: '088',
  },
  {
    name: 'Roja Municipality',
    value: 'LV',
    isoCode: '079',
  },
  {
    name: 'Iecava Municipality',
    value: 'LV',
    isoCode: '034',
  },
  {
    name: 'Ozolnieki Municipality',
    value: 'LV',
    isoCode: '069',
  },
  {
    name: 'Saulkrasti Municipality',
    value: 'LV',
    isoCode: '089',
  },
  {
    name: 'Ērgļi Municipality',
    value: 'LV',
    isoCode: '030',
  },
  {
    name: 'Aglona Municipality',
    value: 'LV',
    isoCode: '001',
  },
  {
    name: 'Jūrmala',
    value: 'LV',
    isoCode: 'JUR',
  },
  {
    name: 'Skrunda Municipality',
    value: 'LV',
    isoCode: '093',
  },
  {
    name: 'Engure Municipality',
    value: 'LV',
    isoCode: '029',
  },
  {
    name: 'Inčukalns Municipality',
    value: 'LV',
    isoCode: '037',
  },
  {
    name: 'Mārupe Municipality',
    value: 'LV',
    isoCode: '062',
  },
  {
    name: 'Mērsrags Municipality',
    value: 'LV',
    isoCode: '063',
  },
  {
    name: 'Koknese Municipality',
    value: 'LV',
    isoCode: '046',
  },
  {
    name: 'Kārsava Municipality',
    value: 'LV',
    isoCode: '044',
  },
  {
    name: 'Carnikava Municipality',
    value: 'LV',
    isoCode: '020',
  },
  {
    name: 'Rēzekne Municipality',
    value: 'LV',
    isoCode: '077',
  },
  {
    name: 'Viesīte Municipality',
    value: 'LV',
    isoCode: '107',
  },
  {
    name: 'Ape Municipality',
    value: 'LV',
    isoCode: '009',
  },
  {
    name: 'Durbe Municipality',
    value: 'LV',
    isoCode: '028',
  },
  {
    name: 'Talsi Municipality',
    value: 'LV',
    isoCode: '097',
  },
  {
    name: 'Liepāja',
    value: 'LV',
    isoCode: 'LPX',
  },
  {
    name: 'Mālpils Municipality',
    value: 'LV',
    isoCode: '061',
  },
  {
    name: 'Smiltene Municipality',
    value: 'LV',
    isoCode: '094',
  },
  {
    name: 'Daugavpils',
    value: 'LV',
    isoCode: 'DGV',
  },
  {
    name: 'Jēkabpils',
    value: 'LV',
    isoCode: 'JKB',
  },
  {
    name: 'Bauska Municipality',
    value: 'LV',
    isoCode: '016',
  },
  {
    name: 'Vecpiebalga Municipality',
    value: 'LV',
    isoCode: '104',
  },
  {
    name: 'Pāvilosta Municipality',
    value: 'LV',
    isoCode: '071',
  },
  {
    name: 'Brocēni Municipality',
    value: 'LV',
    isoCode: '018',
  },
  {
    name: 'Cēsis Municipality',
    value: 'LV',
    isoCode: '022',
  },
  {
    name: 'Grobiņa Municipality',
    value: 'LV',
    isoCode: '032',
  },
  {
    name: 'Beverīna Municipality',
    value: 'LV',
    isoCode: '017',
  },
  {
    name: 'Aizkraukle Municipality',
    value: 'LV',
    isoCode: '002',
  },
  {
    name: 'Valmiera',
    value: 'LV',
    isoCode: 'VMR',
  },
  {
    name: 'Krāslava Municipality',
    value: 'LV',
    isoCode: '047',
  },
  {
    name: 'Jaunjelgava Municipality',
    value: 'LV',
    isoCode: '038',
  },
  {
    name: 'Sigulda Municipality',
    value: 'LV',
    isoCode: '091',
  },
  {
    name: 'Viļaka Municipality',
    value: 'LV',
    isoCode: '108',
  },
  {
    name: 'Stopiņi Municipality',
    value: 'LV',
    isoCode: '095',
  },
  {
    name: 'Rauna Municipality',
    value: 'LV',
    isoCode: '076',
  },
  {
    name: 'Tērvete Municipality',
    value: 'LV',
    isoCode: '098',
  },
  {
    name: 'Auce Municipality',
    value: 'LV',
    isoCode: '010',
  },
  {
    name: 'Baldone Municipality',
    value: 'LV',
    isoCode: '013',
  },
  {
    name: 'Preiļi Municipality',
    value: 'LV',
    isoCode: '073',
  },
  {
    name: 'Aloja Municipality',
    value: 'LV',
    isoCode: '005',
  },
  {
    name: 'Alsunga Municipality',
    value: 'LV',
    isoCode: '006',
  },
  {
    name: 'Viļāni Municipality',
    value: 'LV',
    isoCode: '109',
  },
  {
    name: 'Alūksne Municipality',
    value: 'LV',
    isoCode: '007',
  },
  {
    name: 'Līgatne Municipality',
    value: 'LV',
    isoCode: '055',
  },
  {
    name: 'Jaunpils Municipality',
    value: 'LV',
    isoCode: '040',
  },
  {
    name: 'Kuldīga Municipality',
    value: 'LV',
    isoCode: '050',
  },
  {
    name: 'Riga',
    value: 'LV',
    isoCode: 'RIX',
  },
  {
    name: 'Daugavpils Municipality',
    value: 'LV',
    isoCode: '025',
  },
  {
    name: 'Ropaži Municipality',
    value: 'LV',
    isoCode: '080',
  },
  {
    name: 'Strenči Municipality',
    value: 'LV',
    isoCode: '096',
  },
  {
    name: 'Kocēni Municipality',
    value: 'LV',
    isoCode: '045',
  },
  {
    name: 'Aizpute Municipality',
    value: 'LV',
    isoCode: '003',
  },
  {
    name: 'Amata Municipality',
    value: 'LV',
    isoCode: '008',
  },
  {
    name: 'Baltinava Municipality',
    value: 'LV',
    isoCode: '014',
  },
  {
    name: 'Aknīste Municipality',
    value: 'LV',
    isoCode: '004',
  },
  {
    name: 'Jelgava',
    value: 'LV',
    isoCode: 'JEL',
  },
  {
    name: 'Ludza Municipality',
    value: 'LV',
    isoCode: '058',
  },
  {
    name: 'Riebiņi Municipality',
    value: 'LV',
    isoCode: '078',
  },
  {
    name: 'Rucava Municipality',
    value: 'LV',
    isoCode: '081',
  },
  {
    name: 'Dagda Municipality',
    value: 'LV',
    isoCode: '024',
  },
  {
    name: 'Balvi Municipality',
    value: 'LV',
    isoCode: '015',
  },
  {
    name: 'Priekuļi Municipality',
    value: 'LV',
    isoCode: '075',
  },
  {
    name: 'Pārgauja Municipality',
    value: 'LV',
    isoCode: '070',
  },
  {
    name: 'Vaiņode Municipality',
    value: 'LV',
    isoCode: '100',
  },
  {
    name: 'Rēzekne',
    value: 'LV',
    isoCode: 'REZ',
  },
  {
    name: 'Garkalne Municipality',
    value: 'LV',
    isoCode: '031',
  },
  {
    name: 'Ikšķile Municipality',
    value: 'LV',
    isoCode: '035',
  },
  {
    name: 'Lielvārde Municipality',
    value: 'LV',
    isoCode: '053',
  },
  {
    name: 'Mazsalaca Municipality',
    value: 'LV',
    isoCode: '060',
  },
  {
    name: 'Viqueque Municipality',
    value: 'TL',
    isoCode: 'VI',
  },
  {
    name: 'Liquiçá Municipality',
    value: 'TL',
    isoCode: 'LI',
  },
  {
    name: 'Ermera District',
    value: 'TL',
    isoCode: 'ER',
  },
  {
    name: 'Manatuto District',
    value: 'TL',
    isoCode: 'MT',
  },
  {
    name: 'Ainaro Municipality',
    value: 'TL',
    isoCode: 'AN',
  },
  {
    name: 'Manufahi Municipality',
    value: 'TL',
    isoCode: 'MF',
  },
  {
    name: 'Aileu municipality',
    value: 'TL',
    isoCode: 'AL',
  },
  {
    name: 'Baucau Municipality',
    value: 'TL',
    isoCode: 'BA',
  },
  {
    name: 'Cova Lima Municipality',
    value: 'TL',
    isoCode: 'CO',
  },
  {
    name: 'Lautém Municipality',
    value: 'TL',
    isoCode: 'LA',
  },
  {
    name: 'Dili municipality',
    value: 'TL',
    isoCode: 'DI',
  },
  {
    name: 'Bobonaro Municipality',
    value: 'TL',
    isoCode: 'BO',
  },
  {
    name: 'Peleliu',
    value: 'PW',
    isoCode: '350',
  },
  {
    name: 'Ngardmau',
    value: 'PW',
    isoCode: '222',
  },
  {
    name: 'Airai',
    value: 'PW',
    isoCode: '004',
  },
  {
    name: 'Hatohobei',
    value: 'PW',
    isoCode: '050',
  },
  {
    name: 'Melekeok',
    value: 'PW',
    isoCode: '212',
  },
  {
    name: 'Ngatpang',
    value: 'PW',
    isoCode: '224',
  },
  {
    name: 'Koror',
    value: 'PW',
    isoCode: '150',
  },
  {
    name: 'Ngarchelong',
    value: 'PW',
    isoCode: '218',
  },
  {
    name: 'Ngiwal',
    value: 'PW',
    isoCode: '228',
  },
  {
    name: 'Sonsorol',
    value: 'PW',
    isoCode: '370',
  },
  {
    name: 'Ngchesar',
    value: 'PW',
    isoCode: '226',
  },
  {
    name: 'Ngaraard',
    value: 'PW',
    isoCode: '214',
  },
  {
    name: 'Angaur',
    value: 'PW',
    isoCode: '010',
  },
  {
    name: 'Kayangel',
    value: 'PW',
    isoCode: '100',
  },
  {
    name: 'Aimeliik',
    value: 'PW',
    isoCode: '002',
  },
  {
    name: 'Ngeremlengui',
    value: 'PW',
    isoCode: '227',
  },
  {
    name: 'Břeclav',
    value: 'CZ',
    isoCode: '644',
  },
  {
    name: 'Český Krumlov',
    value: 'CZ',
    isoCode: '312',
  },
  {
    name: 'Plzeň-město',
    value: 'CZ',
    isoCode: '323',
  },
  {
    name: 'Brno-venkov',
    value: 'CZ',
    isoCode: '643',
  },
  {
    name: 'Příbram',
    value: 'CZ',
    isoCode: '20B',
  },
  {
    name: 'Pardubice',
    value: 'CZ',
    isoCode: '532',
  },
  {
    name: 'Nový Jičín',
    value: 'CZ',
    isoCode: '804',
  },
  {
    name: 'Náchod',
    value: 'CZ',
    isoCode: '523',
  },
  {
    name: 'Prostějov',
    value: 'CZ',
    isoCode: '713',
  },
  {
    name: 'Zlínský kraj',
    value: 'CZ',
    isoCode: '72',
  },
  {
    name: 'Chomutov',
    value: 'CZ',
    isoCode: '422',
  },
  {
    name: 'Středočeský kraj',
    value: 'CZ',
    isoCode: '20',
  },
  {
    name: 'České Budějovice',
    value: 'CZ',
    isoCode: '311',
  },
  {
    name: 'Rakovník',
    value: 'CZ',
    isoCode: '20C',
  },
  {
    name: 'Frýdek-Místek',
    value: 'CZ',
    isoCode: '802',
  },
  {
    name: 'Písek',
    value: 'CZ',
    isoCode: '314',
  },
  {
    name: 'Hodonín',
    value: 'CZ',
    isoCode: '645',
  },
  {
    name: 'Zlín',
    value: 'CZ',
    isoCode: '724',
  },
  {
    name: 'Plzeň-sever',
    value: 'CZ',
    isoCode: '325',
  },
  {
    name: 'Tábor',
    value: 'CZ',
    isoCode: '317',
  },
  {
    name: 'Brno-město',
    value: 'CZ',
    isoCode: '642',
  },
  {
    name: 'Svitavy',
    value: 'CZ',
    isoCode: '533',
  },
  {
    name: 'Vsetín',
    value: 'CZ',
    isoCode: '723',
  },
  {
    name: 'Cheb',
    value: 'CZ',
    isoCode: '411',
  },
  {
    name: 'Olomouc',
    value: 'CZ',
    isoCode: '712',
  },
  {
    name: 'Kraj Vysočina',
    value: 'CZ',
    isoCode: '63',
  },
  {
    name: 'Ústecký kraj',
    value: 'CZ',
    isoCode: '42',
  },
  {
    name: 'Prachatice',
    value: 'CZ',
    isoCode: '315',
  },
  {
    name: 'Trutnov',
    value: 'CZ',
    isoCode: '525',
  },
  {
    name: 'Hradec Králové',
    value: 'CZ',
    isoCode: '521',
  },
  {
    name: 'Karlovarský kraj',
    value: 'CZ',
    isoCode: '41',
  },
  {
    name: 'Nymburk',
    value: 'CZ',
    isoCode: '208',
  },
  {
    name: 'Rokycany',
    value: 'CZ',
    isoCode: '326',
  },
  {
    name: 'Ostrava-město',
    value: 'CZ',
    isoCode: '806',
  },
  {
    name: 'Karviná',
    value: 'CZ',
    isoCode: '803',
  },
  {
    name: 'Pardubický kraj',
    value: 'CZ',
    isoCode: '53',
  },
  {
    name: 'Olomoucký kraj',
    value: 'CZ',
    isoCode: '71',
  },
  {
    name: 'Liberec',
    value: 'CZ',
    isoCode: '513',
  },
  {
    name: 'Klatovy',
    value: 'CZ',
    isoCode: '322',
  },
  {
    name: 'Uherské Hradiště',
    value: 'CZ',
    isoCode: '722',
  },
  {
    name: 'Kroměříž',
    value: 'CZ',
    isoCode: '721',
  },
  {
    name: 'Sokolov',
    value: 'CZ',
    isoCode: '413',
  },
  {
    name: 'Semily',
    value: 'CZ',
    isoCode: '514',
  },
  {
    name: 'Třebíč',
    value: 'CZ',
    isoCode: '634',
  },
  {
    name: 'Praha, Hlavní město',
    value: 'CZ',
    isoCode: '10',
  },
  {
    name: 'Ústí nad Labem',
    value: 'CZ',
    isoCode: '427',
  },
  {
    name: 'Moravskoslezský kraj',
    value: 'CZ',
    isoCode: '80',
  },
  {
    name: 'Liberecký kraj',
    value: 'CZ',
    isoCode: '51',
  },
  {
    name: 'Jihomoravský kraj',
    value: 'CZ',
    isoCode: '64',
  },
  {
    name: 'Karlovy Vary',
    value: 'CZ',
    isoCode: '412',
  },
  {
    name: 'Litoměřice',
    value: 'CZ',
    isoCode: '423',
  },
  {
    name: 'Praha-východ',
    value: 'CZ',
    isoCode: '209',
  },
  {
    name: 'Plzeňský kraj',
    value: 'CZ',
    isoCode: '32',
  },
  {
    name: 'Plzeň-jih',
    value: 'CZ',
    isoCode: '324',
  },
  {
    name: 'Děčín',
    value: 'CZ',
    isoCode: '421',
  },
  {
    name: 'Havlíčkův Brod',
    value: 'CZ',
    isoCode: '631',
  },
  {
    name: 'Jablonec nad Nisou',
    value: 'CZ',
    isoCode: '512',
  },
  {
    name: 'Jihlava',
    value: 'CZ',
    isoCode: '632',
  },
  {
    name: 'Královéhradecký kraj',
    value: 'CZ',
    isoCode: '52',
  },
  {
    name: 'Blansko',
    value: 'CZ',
    isoCode: '641',
  },
  {
    name: 'Louny',
    value: 'CZ',
    isoCode: '424',
  },
  {
    name: 'Kolín',
    value: 'CZ',
    isoCode: '204',
  },
  {
    name: 'Praha-západ',
    value: 'CZ',
    isoCode: '20A',
  },
  {
    name: 'Beroun',
    value: 'CZ',
    isoCode: '202',
  },
  {
    name: 'Teplice',
    value: 'CZ',
    isoCode: '426',
  },
  {
    name: 'Vyškov',
    value: 'CZ',
    isoCode: '646',
  },
  {
    name: 'Opava',
    value: 'CZ',
    isoCode: '805',
  },
  {
    name: 'Jindřichův Hradec',
    value: 'CZ',
    isoCode: '313',
  },
  {
    name: 'Jeseník',
    value: 'CZ',
    isoCode: '711',
  },
  {
    name: 'Přerov',
    value: 'CZ',
    isoCode: '714',
  },
  {
    name: 'Benešov',
    value: 'CZ',
    isoCode: '201',
  },
  {
    name: 'Strakonice',
    value: 'CZ',
    isoCode: '316',
  },
  {
    name: 'Most',
    value: 'CZ',
    isoCode: '425',
  },
  {
    name: 'Znojmo',
    value: 'CZ',
    isoCode: '647',
  },
  {
    name: 'Kladno',
    value: 'CZ',
    isoCode: '203',
  },
  {
    name: 'Česká Lípa',
    value: 'CZ',
    isoCode: '511',
  },
  {
    name: 'Chrudim',
    value: 'CZ',
    isoCode: '531',
  },
  {
    name: 'Rychnov nad Kněžnou',
    value: 'CZ',
    isoCode: '524',
  },
  {
    name: 'Mělník',
    value: 'CZ',
    isoCode: '206',
  },
  {
    name: 'Jihočeský kraj',
    value: 'CZ',
    isoCode: '31',
  },
  {
    name: 'Jičín',
    value: 'CZ',
    isoCode: '522',
  },
  {
    name: 'Domažlice',
    value: 'CZ',
    isoCode: '321',
  },
  {
    name: 'Šumperk',
    value: 'CZ',
    isoCode: '715',
  },
  {
    name: 'Mladá Boleslav',
    value: 'CZ',
    isoCode: '207',
  },
  {
    name: 'Bruntál',
    value: 'CZ',
    isoCode: '801',
  },
  {
    name: 'Pelhřimov',
    value: 'CZ',
    isoCode: '633',
  },
  {
    name: 'Tachov',
    value: 'CZ',
    isoCode: '327',
  },
  {
    name: 'Ústí nad Orlicí',
    value: 'CZ',
    isoCode: '534',
  },
  {
    name: 'Žďár nad Sázavou',
    value: 'CZ',
    isoCode: '635',
  },
  {
    name: 'Kutná Hora',
    value: 'CZ',
    isoCode: '205',
  },
  {
    name: 'North East Community Development Council',
    value: 'SG',
    isoCode: '02',
  },
  {
    name: 'South East Community Development Council',
    value: 'SG',
    isoCode: '04',
  },
  {
    name: 'Central Singapore Community Development Council',
    value: 'SG',
    isoCode: '01',
  },
  {
    name: 'South West Community Development Council',
    value: 'SG',
    isoCode: '05',
  },
  {
    name: 'North West Community Development Council',
    value: 'SG',
    isoCode: '03',
  },
  {
    name: 'Ewa District',
    value: 'NR',
    isoCode: '09',
  },
  {
    name: 'Uaboe District',
    value: 'NR',
    isoCode: '13',
  },
  {
    name: 'Aiwo District',
    value: 'NR',
    isoCode: '01',
  },
  {
    name: 'Meneng District',
    value: 'NR',
    isoCode: '11',
  },
  {
    name: 'Anabar District',
    value: 'NR',
    isoCode: '02',
  },
  {
    name: 'Nibok District',
    value: 'NR',
    isoCode: '12',
  },
  {
    name: 'Baiti District',
    value: 'NR',
    isoCode: '05',
  },
  {
    name: 'Ijuw District',
    value: 'NR',
    isoCode: '10',
  },
  {
    name: 'Buada District',
    value: 'NR',
    isoCode: '07',
  },
  {
    name: 'Anibare District',
    value: 'NR',
    isoCode: '04',
  },
  {
    name: 'Yaren District',
    value: 'NR',
    isoCode: '14',
  },
  {
    name: 'Boe District',
    value: 'NR',
    isoCode: '06',
  },
  {
    name: 'Denigomodu District',
    value: 'NR',
    isoCode: '08',
  },
  {
    name: 'Anetan District',
    value: 'NR',
    isoCode: '03',
  },
  {
    name: 'Zhytomyrska oblast',
    value: 'UA',
    isoCode: '18',
  },
  {
    name: 'Vinnytska oblast',
    value: 'UA',
    isoCode: '05',
  },
  {
    name: 'Zakarpatska Oblast',
    value: 'UA',
    isoCode: '21',
  },
  {
    name: 'Kyivska oblast',
    value: 'UA',
    isoCode: '32',
  },
  {
    name: 'Lvivska oblast',
    value: 'UA',
    isoCode: '46',
  },
  {
    name: 'Luhanska oblast',
    value: 'UA',
    isoCode: '09',
  },
  {
    name: 'Ternopilska oblast',
    value: 'UA',
    isoCode: '61',
  },
  {
    name: 'Dnipropetrovska oblast',
    value: 'UA',
    isoCode: '12',
  },
  {
    name: 'Kyiv',
    value: 'UA',
    isoCode: '30',
  },
  {
    name: 'Kirovohradska oblast',
    value: 'UA',
    isoCode: '35',
  },
  {
    name: 'Chernivetska oblast',
    value: 'UA',
    isoCode: '77',
  },
  {
    name: 'Mykolaivska oblast',
    value: 'UA',
    isoCode: '48',
  },
  {
    name: 'Cherkaska oblast',
    value: 'UA',
    isoCode: '71',
  },
  {
    name: 'Khmelnytska oblast',
    value: 'UA',
    isoCode: '68',
  },
  {
    name: 'Ivano-Frankivska oblast',
    value: 'UA',
    isoCode: '26',
  },
  {
    name: 'Rivnenska oblast',
    value: 'UA',
    isoCode: '56',
  },
  {
    name: 'Khersonska oblast',
    value: 'UA',
    isoCode: '65',
  },
  {
    name: 'Sumska oblast',
    value: 'UA',
    isoCode: '59',
  },
  {
    name: 'Kharkivska oblast',
    value: 'UA',
    isoCode: '63',
  },
  {
    name: 'Zaporizka oblast',
    value: 'UA',
    isoCode: '23',
  },
  {
    name: 'Odeska oblast',
    value: 'UA',
    isoCode: '51',
  },
  {
    name: 'Autonomous Republic of Crimea',
    value: 'UA',
    isoCode: '43',
  },
  {
    name: 'Volynska oblast',
    value: 'UA',
    isoCode: '07',
  },
  {
    name: 'Donetska oblast',
    value: 'UA',
    isoCode: '14',
  },
  {
    name: 'Chernihivska oblast',
    value: 'UA',
    isoCode: '74',
  },
  {
    name: 'Poltavska oblast',
    value: 'UA',
    isoCode: '53',
  },
  {
    name: 'Gabrovo Province',
    value: 'BG',
    isoCode: '07',
  },
  {
    name: 'Smolyan Province',
    value: 'BG',
    isoCode: '21',
  },
  {
    name: 'Pernik Province',
    value: 'BG',
    isoCode: '14',
  },
  {
    name: 'Montana Province',
    value: 'BG',
    isoCode: '12',
  },
  {
    name: 'Vidin Province',
    value: 'BG',
    isoCode: '05',
  },
  {
    name: 'Razgrad Province',
    value: 'BG',
    isoCode: '17',
  },
  {
    name: 'Blagoevgrad Province',
    value: 'BG',
    isoCode: '01',
  },
  {
    name: 'Sliven Province',
    value: 'BG',
    isoCode: '20',
  },
  {
    name: 'Plovdiv Province',
    value: 'BG',
    isoCode: '16',
  },
  {
    name: 'Kardzhali Province',
    value: 'BG',
    isoCode: '09',
  },
  {
    name: 'Kyustendil Province',
    value: 'BG',
    isoCode: '10',
  },
  {
    name: 'Haskovo Province',
    value: 'BG',
    isoCode: '26',
  },
  {
    name: 'Sofia City Province',
    value: 'BG',
    isoCode: '22',
  },
  {
    name: 'Pleven Province',
    value: 'BG',
    isoCode: '15',
  },
  {
    name: 'Stara Zagora Province',
    value: 'BG',
    isoCode: '24',
  },
  {
    name: 'Silistra Province',
    value: 'BG',
    isoCode: '19',
  },
  {
    name: 'Veliko Tarnovo Province',
    value: 'BG',
    isoCode: '04',
  },
  {
    name: 'Lovech Province',
    value: 'BG',
    isoCode: '11',
  },
  {
    name: 'Vratsa Province',
    value: 'BG',
    isoCode: '06',
  },
  {
    name: 'Pazardzhik Province',
    value: 'BG',
    isoCode: '13',
  },
  {
    name: 'Ruse Province',
    value: 'BG',
    isoCode: '18',
  },
  {
    name: 'Targovishte Province',
    value: 'BG',
    isoCode: '25',
  },
  {
    name: 'Burgas Province',
    value: 'BG',
    isoCode: '02',
  },
  {
    name: 'Yambol Province',
    value: 'BG',
    isoCode: '28',
  },
  {
    name: 'Varna Province',
    value: 'BG',
    isoCode: '03',
  },
  {
    name: 'Dobrich Province',
    value: 'BG',
    isoCode: '08',
  },
  {
    name: 'Sofia Province',
    value: 'BG',
    isoCode: '23',
  },
  {
    name: 'Shumen',
    value: 'BG',
    isoCode: '27',
  },
  {
    name: 'Suceava County',
    value: 'RO',
    isoCode: 'SV',
  },
  {
    name: 'Hunedoara County',
    value: 'RO',
    isoCode: 'HD',
  },
  {
    name: 'Arges',
    value: 'RO',
    isoCode: 'AG',
  },
  {
    name: 'Bihor County',
    value: 'RO',
    isoCode: 'BH',
  },
  {
    name: 'Alba',
    value: 'RO',
    isoCode: 'AB',
  },
  {
    name: 'Ilfov County',
    value: 'RO',
    isoCode: 'IF',
  },
  {
    name: 'Giurgiu County',
    value: 'RO',
    isoCode: 'GR',
  },
  {
    name: 'Tulcea County',
    value: 'RO',
    isoCode: 'TL',
  },
  {
    name: 'Teleorman County',
    value: 'RO',
    isoCode: 'TR',
  },
  {
    name: 'Prahova County',
    value: 'RO',
    isoCode: 'PH',
  },
  {
    name: 'Bucharest',
    value: 'RO',
    isoCode: 'B',
  },
  {
    name: 'Neamț County',
    value: 'RO',
    isoCode: 'NT',
  },
  {
    name: 'Călărași County',
    value: 'RO',
    isoCode: 'CL',
  },
  {
    name: 'Bistrița-Năsăud County',
    value: 'RO',
    isoCode: 'BN',
  },
  {
    name: 'Cluj County',
    value: 'RO',
    isoCode: 'CJ',
  },
  {
    name: 'Iași County',
    value: 'RO',
    isoCode: 'IS',
  },
  {
    name: 'Braila',
    value: 'RO',
    isoCode: 'BR',
  },
  {
    name: 'Constanța County',
    value: 'RO',
    isoCode: 'CT',
  },
  {
    name: 'Olt County',
    value: 'RO',
    isoCode: 'OT',
  },
  {
    name: 'Arad County',
    value: 'RO',
    isoCode: 'AR',
  },
  {
    name: 'Botoșani County',
    value: 'RO',
    isoCode: 'BT',
  },
  {
    name: 'Sălaj County',
    value: 'RO',
    isoCode: 'SJ',
  },
  {
    name: 'Dolj County',
    value: 'RO',
    isoCode: 'DJ',
  },
  {
    name: 'Ialomița County',
    value: 'RO',
    isoCode: 'IL',
  },
  {
    name: 'Bacău County',
    value: 'RO',
    isoCode: 'BC',
  },
  {
    name: 'Dâmbovița County',
    value: 'RO',
    isoCode: 'DB',
  },
  {
    name: 'Satu Mare County',
    value: 'RO',
    isoCode: 'SM',
  },
  {
    name: 'Galați County',
    value: 'RO',
    isoCode: 'GL',
  },
  {
    name: 'Timiș County',
    value: 'RO',
    isoCode: 'TM',
  },
  {
    name: 'Harghita County',
    value: 'RO',
    isoCode: 'HR',
  },
  {
    name: 'Gorj County',
    value: 'RO',
    isoCode: 'GJ',
  },
  {
    name: 'Mehedinți County',
    value: 'RO',
    isoCode: 'MH',
  },
  {
    name: 'Vaslui County',
    value: 'RO',
    isoCode: 'VS',
  },
  {
    name: 'Caraș-Severin County',
    value: 'RO',
    isoCode: 'CS',
  },
  {
    name: 'Covasna County',
    value: 'RO',
    isoCode: 'CV',
  },
  {
    name: 'Sibiu County',
    value: 'RO',
    isoCode: 'SB',
  },
  {
    name: 'Buzău County',
    value: 'RO',
    isoCode: 'BZ',
  },
  {
    name: 'Vâlcea County',
    value: 'RO',
    isoCode: 'VL',
  },
  {
    name: 'Vrancea County',
    value: 'RO',
    isoCode: 'VN',
  },
  {
    name: 'Brașov County',
    value: 'RO',
    isoCode: 'BV',
  },
  {
    name: 'Maramureș County',
    value: 'RO',
    isoCode: 'MM',
  },
  {
    name: 'Mureș County',
    value: 'RO',
    isoCode: 'MS',
  },
  {
    name: 'Aiga-i-le-Tai',
    value: 'WS',
    isoCode: 'AL',
  },
  {
    name: "Satupa'itea",
    value: 'WS',
    isoCode: 'SA',
  },
  {
    name: "A'ana",
    value: 'WS',
    isoCode: 'AA',
  },
  {
    name: "Fa'asaleleaga",
    value: 'WS',
    isoCode: 'FA',
  },
  {
    name: 'Atua',
    value: 'WS',
    isoCode: 'AT',
  },
  {
    name: 'Vaisigano',
    value: 'WS',
    isoCode: 'VS',
  },
  {
    name: 'Palauli',
    value: 'WS',
    isoCode: 'PA',
  },
  {
    name: "Va'a-o-Fonoti",
    value: 'WS',
    isoCode: 'VF',
  },
  {
    name: "Gaga'emauga",
    value: 'WS',
    isoCode: 'GE',
  },
  {
    name: 'Tuamasaga',
    value: 'WS',
    isoCode: 'TU',
  },
  {
    name: "Gaga'ifomauga",
    value: 'WS',
    isoCode: 'GI',
  },
  {
    name: 'Torba',
    value: 'VU',
    isoCode: 'TOB',
  },
  {
    name: 'Penama',
    value: 'VU',
    isoCode: 'PAM',
  },
  {
    name: 'Shefa',
    value: 'VU',
    isoCode: 'SEE',
  },
  {
    name: 'Malampa',
    value: 'VU',
    isoCode: 'MAP',
  },
  {
    name: 'Sanma',
    value: 'VU',
    isoCode: 'SAM',
  },
  {
    name: 'Tafea',
    value: 'VU',
    isoCode: 'TAE',
  },
  {
    name: 'Honiara',
    value: 'SB',
    isoCode: 'CT',
  },
  {
    name: 'Temotu Province',
    value: 'SB',
    isoCode: 'TE',
  },
  {
    name: 'Isabel Province',
    value: 'SB',
    isoCode: 'IS',
  },
  {
    name: 'Choiseul Province',
    value: 'SB',
    isoCode: 'CH',
  },
  {
    name: 'Makira-Ulawa Province',
    value: 'SB',
    isoCode: 'MK',
  },
  {
    name: 'Malaita Province',
    value: 'SB',
    isoCode: 'ML',
  },
  {
    name: 'Central Province',
    value: 'SB',
    isoCode: 'CE',
  },
  {
    name: 'Guadalcanal Province',
    value: 'SB',
    isoCode: 'GU',
  },
  {
    name: 'Western Province',
    value: 'SB',
    isoCode: 'WE',
  },
  {
    name: 'Rennell and Bellona Province',
    value: 'SB',
    isoCode: 'RB',
  },
  {
    name: 'Saint-Barthélemy',
    value: 'FR',
    isoCode: 'BL',
  },
  {
    name: 'Nouvelle-Aquitaine',
    value: 'FR',
    isoCode: 'NAQ',
  },
  {
    name: 'Île-de-France',
    value: 'FR',
    isoCode: 'IDF',
  },
  {
    name: 'Mayotte',
    value: 'FR',
    isoCode: '976',
  },
  {
    name: 'Auvergne-Rhône-Alpes',
    value: 'FR',
    isoCode: 'ARA',
  },
  {
    name: 'Occitanie',
    value: 'FR',
    isoCode: 'OCC',
  },
  {
    name: 'Pays-de-la-Loire',
    value: 'FR',
    isoCode: 'PDL',
  },
  {
    name: 'Normandie',
    value: 'FR',
    isoCode: 'NOR',
  },
  {
    name: 'Corse',
    value: 'FR',
    isoCode: '20R',
  },
  {
    name: 'Bretagne',
    value: 'FR',
    isoCode: 'BRE',
  },
  {
    name: 'Saint-Martin',
    value: 'FR',
    isoCode: 'MF',
  },
  {
    name: 'Wallis and Futuna',
    value: 'FR',
    isoCode: 'WF',
  },
  {
    name: 'Alsace',
    value: 'FR',
    isoCode: '6AE',
  },
  {
    name: 'Provence-Alpes-Côte-d’Azur',
    value: 'FR',
    isoCode: 'PAC',
  },
  {
    name: 'Paris',
    value: 'FR',
    isoCode: '75C',
  },
  {
    name: 'Centre-Val de Loire',
    value: 'FR',
    isoCode: 'CVL',
  },
  {
    name: 'Grand-Est',
    value: 'FR',
    isoCode: 'GES',
  },
  {
    name: 'Saint Pierre and Miquelon',
    value: 'FR',
    isoCode: 'PM',
  },
  {
    name: 'French Guiana',
    value: 'FR',
    isoCode: '973',
  },
  {
    name: 'La Réunion',
    value: 'FR',
    isoCode: '974',
  },
  {
    name: 'French Polynesia',
    value: 'FR',
    isoCode: 'PF',
  },
  {
    name: 'Bourgogne-Franche-Comté',
    value: 'FR',
    isoCode: 'BFC',
  },
  {
    name: 'Martinique',
    value: 'FR',
    isoCode: '972',
  },
  {
    name: 'Hauts-de-France',
    value: 'FR',
    isoCode: 'HDF',
  },
  {
    name: 'Guadeloupe',
    value: 'FR',
    isoCode: '971',
  },
  {
    name: 'Ain',
    value: 'FR',
    isoCode: '01',
  },
  {
    name: 'Aisne',
    value: 'FR',
    isoCode: '02',
  },
  {
    name: 'Allier',
    value: 'FR',
    isoCode: '03',
  },
  {
    name: 'Alpes-de-Haute-Provence',
    value: 'FR',
    isoCode: '04',
  },
  {
    name: 'Hautes-Alpes',
    value: 'FR',
    isoCode: '05',
  },
  {
    name: 'Alpes-Maritimes',
    value: 'FR',
    isoCode: '06',
  },
  {
    name: 'Ardèche',
    value: 'FR',
    isoCode: '07',
  },
  {
    name: 'Ardennes',
    value: 'FR',
    isoCode: '08',
  },
  {
    name: 'Ariège',
    value: 'FR',
    isoCode: '09',
  },
  {
    name: 'Aube',
    value: 'FR',
    isoCode: '10',
  },
  {
    name: 'Aude',
    value: 'FR',
    isoCode: '11',
  },
  {
    name: 'Aveyron',
    value: 'FR',
    isoCode: '12',
  },
  {
    name: 'Bouches-du-Rhône',
    value: 'FR',
    isoCode: '13',
  },
  {
    name: 'Calvados',
    value: 'FR',
    isoCode: '14',
  },
  {
    name: 'Cantal',
    value: 'FR',
    isoCode: '15',
  },
  {
    name: 'Charente',
    value: 'FR',
    isoCode: '16',
  },
  {
    name: 'Charente-Maritime',
    value: 'FR',
    isoCode: '17',
  },
  {
    name: 'Cher',
    value: 'FR',
    isoCode: '18',
  },
  {
    name: 'Corrèze',
    value: 'FR',
    isoCode: '19',
  },
  {
    name: "Côte-d'Or",
    value: 'FR',
    isoCode: '21',
  },
  {
    name: "Côtes-d'Armor",
    value: 'FR',
    isoCode: '22',
  },
  {
    name: 'Creuse',
    value: 'FR',
    isoCode: '23',
  },
  {
    name: 'Dordogne',
    value: 'FR',
    isoCode: '24',
  },
  {
    name: 'Doubs',
    value: 'FR',
    isoCode: '25',
  },
  {
    name: 'Drôme',
    value: 'FR',
    isoCode: '26',
  },
  {
    name: 'Eure',
    value: 'FR',
    isoCode: '27',
  },
  {
    name: 'Eure-et-Loir',
    value: 'FR',
    isoCode: '28',
  },
  {
    name: 'Finistère',
    value: 'FR',
    isoCode: '29',
  },
  {
    name: 'Corse-du-Sud',
    value: 'FR',
    isoCode: '2A',
  },
  {
    name: 'Haute-Corse',
    value: 'FR',
    isoCode: '2B',
  },
  {
    name: 'Gard',
    value: 'FR',
    isoCode: '30',
  },
  {
    name: 'Haute-Garonne',
    value: 'FR',
    isoCode: '31',
  },
  {
    name: 'Gers',
    value: 'FR',
    isoCode: '32',
  },
  {
    name: 'Gironde',
    value: 'FR',
    isoCode: '33',
  },
  {
    name: 'Hérault',
    value: 'FR',
    isoCode: '34',
  },
  {
    name: 'Ille-et-Vilaine',
    value: 'FR',
    isoCode: '35',
  },
  {
    name: 'Indre',
    value: 'FR',
    isoCode: '36',
  },
  {
    name: 'Indre-et-Loire',
    value: 'FR',
    isoCode: '37',
  },
  {
    name: 'Isère',
    value: 'FR',
    isoCode: '38',
  },
  {
    name: 'Jura',
    value: 'FR',
    isoCode: '39',
  },
  {
    name: 'Landes',
    value: 'FR',
    isoCode: '40',
  },
  {
    name: 'Loir-et-Cher',
    value: 'FR',
    isoCode: '41',
  },
  {
    name: 'Loire',
    value: 'FR',
    isoCode: '42',
  },
  {
    name: 'Haute-Loire',
    value: 'FR',
    isoCode: '43',
  },
  {
    name: 'Loire-Atlantique',
    value: 'FR',
    isoCode: '44',
  },
  {
    name: 'Loiret',
    value: 'FR',
    isoCode: '45',
  },
  {
    name: 'Lot',
    value: 'FR',
    isoCode: '46',
  },
  {
    name: 'Lot-et-Garonne',
    value: 'FR',
    isoCode: '47',
  },
  {
    name: 'Lozère',
    value: 'FR',
    isoCode: '48',
  },
  {
    name: 'Maine-et-Loire',
    value: 'FR',
    isoCode: '49',
  },
  {
    name: 'Manche',
    value: 'FR',
    isoCode: '50',
  },
  {
    name: 'Marne',
    value: 'FR',
    isoCode: '51',
  },
  {
    name: 'Haute-Marne',
    value: 'FR',
    isoCode: '52',
  },
  {
    name: 'Mayenne',
    value: 'FR',
    isoCode: '53',
  },
  {
    name: 'Meurthe-et-Moselle',
    value: 'FR',
    isoCode: '54',
  },
  {
    name: 'Meuse',
    value: 'FR',
    isoCode: '55',
  },
  {
    name: 'Morbihan',
    value: 'FR',
    isoCode: '56',
  },
  {
    name: 'Moselle',
    value: 'FR',
    isoCode: '57',
  },
  {
    name: 'Nièvre',
    value: 'FR',
    isoCode: '58',
  },
  {
    name: 'Nord',
    value: 'FR',
    isoCode: '59',
  },
  {
    name: 'Oise',
    value: 'FR',
    isoCode: '60',
  },
  {
    name: 'Orne',
    value: 'FR',
    isoCode: '61',
  },
  {
    name: 'Pas-de-Calais',
    value: 'FR',
    isoCode: '62',
  },
  {
    name: 'Puy-de-Dôme',
    value: 'FR',
    isoCode: '63',
  },
  {
    name: 'Pyrénées-Atlantiques',
    value: 'FR',
    isoCode: '64',
  },
  {
    name: 'Hautes-Pyrénées',
    value: 'FR',
    isoCode: '65',
  },
  {
    name: 'Pyrénées-Orientales',
    value: 'FR',
    isoCode: '66',
  },
  {
    name: 'Bas-Rhin',
    value: 'FR',
    isoCode: '67',
  },
  {
    name: 'Haut-Rhin',
    value: 'FR',
    isoCode: '68',
  },
  {
    name: 'Rhône',
    value: 'FR',
    isoCode: '69',
  },
  {
    name: 'Métropole de Lyon',
    value: 'FR',
    isoCode: '69M',
  },
  {
    name: 'Haute-Saône',
    value: 'FR',
    isoCode: '70',
  },
  {
    name: 'Saône-et-Loire',
    value: 'FR',
    isoCode: '71',
  },
  {
    name: 'Sarthe',
    value: 'FR',
    isoCode: '72',
  },
  {
    name: 'Savoie',
    value: 'FR',
    isoCode: '73',
  },
  {
    name: 'Haute-Savoie',
    value: 'FR',
    isoCode: '74',
  },
  {
    name: 'Seine-Maritime',
    value: 'FR',
    isoCode: '76',
  },
  {
    name: 'Seine-et-Marne',
    value: 'FR',
    isoCode: '77',
  },
  {
    name: 'Yvelines',
    value: 'FR',
    isoCode: '78',
  },
  {
    name: 'Deux-Sèvres',
    value: 'FR',
    isoCode: '79',
  },
  {
    name: 'Somme',
    value: 'FR',
    isoCode: '80',
  },
  {
    name: 'Tarn',
    value: 'FR',
    isoCode: '81',
  },
  {
    name: 'Tarn-et-Garonne',
    value: 'FR',
    isoCode: '82',
  },
  {
    name: 'Var',
    value: 'FR',
    isoCode: '83',
  },
  {
    name: 'Vaucluse',
    value: 'FR',
    isoCode: '84',
  },
  {
    name: 'Vendée',
    value: 'FR',
    isoCode: '85',
  },
  {
    name: 'Vienne',
    value: 'FR',
    isoCode: '86',
  },
  {
    name: 'Haute-Vienne',
    value: 'FR',
    isoCode: '87',
  },
  {
    name: 'Vosges',
    value: 'FR',
    isoCode: '88',
  },
  {
    name: 'Yonne',
    value: 'FR',
    isoCode: '89',
  },
  {
    name: 'Territoire de Belfort',
    value: 'FR',
    isoCode: '90',
  },
  {
    name: 'Essonne',
    value: 'FR',
    isoCode: '91',
  },
  {
    name: 'Hauts-de-Seine',
    value: 'FR',
    isoCode: '92',
  },
  {
    name: 'Seine-Saint-Denis',
    value: 'FR',
    isoCode: '93',
  },
  {
    name: 'Val-de-Marne',
    value: 'FR',
    isoCode: '94',
  },
  {
    name: "Val-d'Oise",
    value: 'FR',
    isoCode: '95',
  },
  {
    name: 'Clipperton',
    value: 'FR',
    isoCode: 'CP',
  },
  {
    name: 'French Southern and Antarctic Lands',
    value: 'FR',
    isoCode: 'TF',
  },
  {
    name: 'West New Britain Province',
    value: 'PG',
    isoCode: 'WBK',
  },
  {
    name: 'Bougainville',
    value: 'PG',
    isoCode: 'NSB',
  },
  {
    name: 'Jiwaka Province',
    value: 'PG',
    isoCode: 'JWK',
  },
  {
    name: 'Hela',
    value: 'PG',
    isoCode: 'HLA',
  },
  {
    name: 'East New Britain',
    value: 'PG',
    isoCode: 'EBR',
  },
  {
    name: 'Morobe Province',
    value: 'PG',
    isoCode: 'MPL',
  },
  {
    name: 'Sandaun Province',
    value: 'PG',
    isoCode: 'SAN',
  },
  {
    name: 'Port Moresby',
    value: 'PG',
    isoCode: 'NCD',
  },
  {
    name: 'Oro Province',
    value: 'PG',
    isoCode: 'NPP',
  },
  {
    name: 'Gulf',
    value: 'PG',
    isoCode: 'GPK',
  },
  {
    name: 'Western Highlands Province',
    value: 'PG',
    isoCode: 'WHM',
  },
  {
    name: 'New Ireland Province',
    value: 'PG',
    isoCode: 'NIK',
  },
  {
    name: 'Manus Province',
    value: 'PG',
    isoCode: 'MRL',
  },
  {
    name: 'Madang Province',
    value: 'PG',
    isoCode: 'MPM',
  },
  {
    name: 'Southern Highlands Province',
    value: 'PG',
    isoCode: 'SHM',
  },
  {
    name: 'Eastern Highlands Province',
    value: 'PG',
    isoCode: 'EHG',
  },
  {
    name: 'Chimbu Province',
    value: 'PG',
    isoCode: 'CPK',
  },
  {
    name: 'Central Province',
    value: 'PG',
    isoCode: 'CPM',
  },
  {
    name: 'Enga Province',
    value: 'PG',
    isoCode: 'EPW',
  },
  {
    name: 'Milne Bay Province',
    value: 'PG',
    isoCode: 'MBA',
  },
  {
    name: 'Western Province',
    value: 'PG',
    isoCode: 'WPD',
  },
  {
    name: 'Devonshire Parish',
    value: 'BM',
    isoCode: 'DEV',
  },
  {
    name: 'Hamilton Parish',
    value: 'BM',
    isoCode: 'HA',
  },
  {
    name: 'Paget Parish',
    value: 'BM',
    isoCode: 'PAG',
  },
  {
    name: 'Pembroke Parish',
    value: 'BM',
    isoCode: 'PEM',
  },
  {
    name: "Saint George's Parish",
    value: 'BM',
    isoCode: 'SGE',
  },
  {
    name: 'Sandys Parish',
    value: 'BM',
    isoCode: 'SAN',
  },
  {
    name: "Smith's Parish,",
    value: 'BM',
    isoCode: 'SMI',
  },
  {
    name: 'Southampton Parish',
    value: 'BM',
    isoCode: 'SOU',
  },
  {
    name: 'Warwick Parish',
    value: 'BM',
    isoCode: 'WAR',
  },
  {
    name: 'Yuen Long District',
    value: 'HK',
    isoCode: 'NYL',
  },
  {
    name: 'Tsuen Wan District',
    value: 'HK',
    isoCode: 'NTW',
  },
  {
    name: 'Sai Kung District',
    value: 'HK',
    isoCode: 'NSK',
  },
  {
    name: 'Islands District',
    value: 'HK',
    isoCode: 'NIS',
  },
  {
    name: 'Central and Western District',
    value: 'HK',
    isoCode: 'HCW',
  },
  {
    name: 'Wan Chai',
    value: 'HK',
    isoCode: 'HWC',
  },
  {
    name: 'Eastern',
    value: 'HK',
    isoCode: 'HEA',
  },
  {
    name: 'Southern',
    value: 'HK',
    isoCode: 'HSO',
  },
  {
    name: 'Yau Tsim Mong',
    value: 'HK',
    isoCode: 'KYT',
  },
  {
    name: 'Sham Shui Po',
    value: 'HK',
    isoCode: 'KSS',
  },
  {
    name: 'Kowloon City',
    value: 'HK',
    isoCode: 'KKC',
  },
  {
    name: 'Wong Tai Sin',
    value: 'HK',
    isoCode: 'KWT',
  },
  {
    name: 'Kwun Tong',
    value: 'HK',
    isoCode: 'KKT',
  },
  {
    name: 'Kwai Tsing',
    value: 'HK',
    isoCode: 'NKT',
  },
  {
    name: 'Tuen Mun',
    value: 'HK',
    isoCode: 'NTM',
  },
  {
    name: 'North',
    value: 'HK',
    isoCode: 'NNO',
  },
  {
    name: 'Sha Tin',
    value: 'HK',
    isoCode: 'NST',
  },
  {
    name: 'La Colle',
    value: 'MC',
    isoCode: 'CL',
  },
  {
    name: 'La Condamine',
    value: 'MC',
    isoCode: 'CO',
  },
  {
    name: 'Moneghetti',
    value: 'MC',
    isoCode: 'MG',
  },
]
